(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4429],{

/***/ 71913:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shape-of-you",
      function () {
        return __webpack_require__(41139);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 52266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/SGL-CRT.749a7c37.jpg","height":1747,"width":2479,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAGAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAdEAACAgEFAAAAAAAAAAAAAAABAgADEwQhMUHw/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/EABURAQEAAAAAAAAAAAAAAAAAAAAB/9oADAMBAAIRAxEAPwClJqacjLhAWtzsByPdRERCv//Z"});

/***/ }),

/***/ 78253:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/SharePage.087e522a.png","height":1117,"width":1728,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAKlBMVEWOdGOLa1iCZlN3WUahdVJKNChtTDqVe2yfhHLMs5zHqJepk4aGW0bBlHu9EeZdAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAK0lEQVR4nAXBiQEAEAwEwb28BP23a4aiM/HCVt9CjtaJOBjWihkg/c5+0gcQqwDJzALP3wAAAABJRU5ErkJggg=="});

/***/ }),

/***/ 95060:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/jel.c91ee675.png","height":156,"width":197,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAAJFBMVEVHcEzHnkjXtmfetTHFmDzSq1DcsGm5jDu9jEW6llO+mEq5j0Ewv5sSAAAACnRSTlMAdlMCZdQHsyeiILEIGgAAAAlwSFlzAAALEwAACxMBAJqcGAAAACtJREFUeJwlxscBACAIwMAAipT997V9csHEwRVsnugERmWWcK/7CWt9icDYDzUAiwaiqCUAAAAASUVORK5CYII="});

/***/ }),

/***/ 99749:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/made-in-india.5c8b4029.png","height":23,"width":35,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAWlBMVEXJdQT4xmT4oQi8awP//f/lmh4UhSwAaSQAeynmkguRm8O/0/fi2uT///9xs3AAaCfo4OcUiCsFeypkqXNHjGVto4MGfyfntG69i0rFkT+3fjV+uofboEHR0+JUzQSzAAAAE3RSTlPT/NTG/M277eBm+/v5x6a63c28MGYoNQAAAAlwSFlzAAALEwAACxMBAJqcGAAAADNJREFUeJxjYGJgZgViTgZGGSlJRnEJVgZeFh4ubhZZAQY+aVERYWERYQY2MXYOQSF+NgAm3wIDabtAuwAAAABJRU5ErkJggg=="});

/***/ }),

/***/ 94661:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/nekl_s.b5b5c9a1.png","height":61,"width":61,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAALVBMVEWviTxHcEzGmT7TrFG6jD/YtmW+mVTBk0zavGrmwnXrwWrHo0XCk0zUrVm8lEQzawzfAAAADnRSTlMBAGLSpFmuIl8NBlcpgN00qfAAAAAJcEhZcwAACxMAAAsTAQCanBgAAAA1SURBVHicLYnJEQAgDALBeB/pv1yJ4/JYGECCAXAmOYqmFbKbSvJafelS8xQmctYR2e3pcwEe+wDLF/cEWAAAAABJRU5ErkJggg=="});

/***/ }),

/***/ 77981:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EI": function() { return /* binding */ trackAddShippingInfo; },
/* harmony export */   "Mk": function() { return /* binding */ trackViewItemList; },
/* harmony export */   "Ye": function() { return /* binding */ GA4_ITEM_BRAND; },
/* harmony export */   "fT": function() { return /* binding */ formatCartItemsForGA4; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29815);
/**
 * Google Analytics 4 Event Tracking Utilities
 * Reference: https://developers.google.com/analytics/devguides/collection/ga4/reference/events
 */ 
/**
 * Common GA4 item brand constant
 */ var GA4_ITEM_BRAND = "Senco";
/**
 * Format cart items for GA4 ecommerce tracking
 */ var formatCartItemsForGA4 = function(items) {
    return items.map(function(item) {
        var ref, ref1, ref2;
        return {
            item_id: String(item.id),
            item_name: item.name || item.product_name,
            item_brand: GA4_ITEM_BRAND,
            item_category: ((ref = item.data) === null || ref === void 0 ? void 0 : ref.type) ? (ref1 = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(item.data.type).reverse()[0]) === null || ref1 === void 0 ? void 0 : ref1.name_en : undefined,
            item_variant: ((ref2 = item.data) === null || ref2 === void 0 ? void 0 : ref2.purity) || undefined,
            price: item.price || item.product_price,
            quantity: 1
        };
    });
};
/**
 * Track add_shipping_info event
 * Triggered when user adds shipping information (address) during checkout or in profile
 *
 * @param params - Event parameters including cart value, items, and shipping info
 */ var trackAddShippingInfo = function(params) {
    try {
        if ( false || !window.dataLayer) {
            return;
        }
        // Clear previous ecommerce data
        window.dataLayer.push({
            ecommerce: null
        });
        // Push add_shipping_info event
        window.dataLayer.push({
            event: "add_shipping_info",
            ecommerce: {
                currency: params.currency || "INR",
                value: params.value,
                coupon: params.coupon || undefined,
                shipping_tier: params.shipping_tier || "Standard",
                items: params.items
            }
        });
        ;
    } catch (error) {
        ;
    }
};
/**
 * Track view_item_list event
 * Triggered when user views a list of items (category page, search results, etc.)
 *
 * @param params - Event parameters including list ID, name, and items
 */ var trackViewItemList = function(params) {
    try {
        if ( false || !window.dataLayer) {
            return;
        }
        // Clear previous ecommerce data
        window.dataLayer.push({
            ecommerce: null
        });
        // Push view_item_list event
        window.dataLayer.push({
            event: "view_item_list",
            ecommerce: {
                item_list_id: params.item_list_id,
                item_list_name: params.item_list_name,
                items: params.items
            }
        });
        ;
    } catch (error) {
        ;
    }
};


/***/ }),

/***/ 41139:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ shape_of_you; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/assets/images/logoabout.png
/* harmony default export */ var logoabout = ({"src":"/_next/static/media/logoabout.89b50e2a.png","height":90,"width":318,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAGFBMVEX9+Pj////98/T////43+D////3293219goaXIpAAAACHRSTlMFWCIypkfj0n7jeoUAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAXSURBVHicY2BlZGRiAAFGJkZmJnY2FgAA+gAkdR8HWgAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./src/assets/images/SENCO-SHAPE-OF-YOU-FULL_2.gif
/* harmony default export */ var SENCO_SHAPE_OF_YOU_FULL_2 = ({"src":"/_next/static/media/SENCO-SHAPE-OF-YOU-FULL_2.0c592d16.gif","height":648,"width":1080});
// EXTERNAL MODULE: ./src/store/slices/auth.ts
var auth = __webpack_require__(40034);
// EXTERNAL MODULE: ./src/store/slices/shapeOfYou.ts
var shapeOfYou = __webpack_require__(89700);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/assets/images/WalkthroughScreen.png
/* harmony default export */ var WalkthroughScreen = ({"src":"/_next/static/media/WalkthroughScreen.2e0fe256.png","height":1117,"width":1728,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAPFBMVEV6Oix6MCaxf2+7p5GrUkaYMi6Yd1uniWysmYGwWU2zk3eEUT2NSzmxmH7CtaXSzcGHZlCodVi0lYN+X0rxpxyeAAAACXBIWXMAAAsTAAALEwEAmpwYAAAALklEQVR4nA3BBwIAEAwEsOtCa/P/v5JAc1o3NwL3tCMIGKLu+ITNiE7BZNNapTwZwwERfH0eAQAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./src/assets/images/WalkthroughScreen2n.png
/* harmony default export */ var WalkthroughScreen2n = ({"src":"/_next/static/media/WalkthroughScreen2n.5de088aa.png","height":1117,"width":1728,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAP1BMVEV8NSWvdmGvk3uISDfBsJ2wn4qhhGmMa1KygnOvUUWPJyV3QS+QdlylWUZdFhLU0MWXOzK6YE+ZNTJ+X0p1RjHPSuz5AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAMElEQVR4nAXBhwGAIBAAsftKUUDB/Wc1oWUpJw2q3qIKuLdXjAuXvvuswZJn2KfxAxYyARedjnAtAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./src/assets/images/senco-shap-scree.png
/* harmony default export */ var senco_shap_scree = ({"src":"/_next/static/media/senco-shap-scree.60b92cd2.png","height":129,"width":205,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAIVBMVEXVMThHcEzaSU7ZRkzYPkT43+DTKzLULzbSJSv78PDdWF55YLSoAAAACnRSTlOYAAP5/QuBpFIvqKG1JwAAAAlwSFlzAAALEwAACxMBAJqcGAAAACdJREFUeJwlw4cJADAMAzCvpOP/g1uIQJB0iiJI1k+MtXFHw3bi9AMLKgCeXSzLBAAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./src/assets/images/shapesenco.png
/* harmony default export */ var shapesenco = ({"src":"/_next/static/media/shapesenco.4894485f.png","height":50,"width":178,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAHlBMVEWPKzPQKTDaSE2LGCWLGCWOGSbYQEaLGCV4Eh5HcExzzxg3AAAACnRSTlMdCthTXVeoRy4APzWtXAAAAAlwSFlzAAALEwAACxMBAJqcGAAAABpJREFUeJxjYGdhZuBkZGRkYGZg5WBgYmIDAAH6ADUaORoUAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./src/assets/images/WelcomeScreen_dek.png
/* harmony default export */ var WelcomeScreen_dek = ({"src":"/_next/static/media/WelcomeScreen_dek.ba415eb0.png","height":1117,"width":1728,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAACVBMVEUvCwhBFA5cMyc10m60AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGklEQVR4nGNgYGBiYmRgZGRAZjAygmkIDwEAAsMAF3FYAU4AAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/assets/images/windown.png
/* harmony default export */ var windown = ({"src":"/_next/static/media/windown.6ced4ab4.png","height":746,"width":508,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAMAAAAGL8UJAAAAP1BMVEW+sJ9HcEzHu6m0qZq6r59iWVWak4gCdYxHbXw7M1m0qZlDRFxdfNVVk5Izh422q5uQioObpp15npmMfn9fUWJ25dKvAAAAD3RSTlP8APz8joqam6nZcHAJnIPBsFPmAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAMUlEQVR4nGNgYBJgZWRgYhLiY2RgZhBiZ2TgZxDkAJO8IBFhTh4gW0CEm4GLhYWNFQAa3QE4e9caBAAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./src/assets/images/spl.png
/* harmony default export */ var spl = ({"src":"/_next/static/media/spl.0a884fa4.png","height":396,"width":351,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAMAAAAC2hU0AAAAM1BMVEVHcEz////ZR03dYGT////ZRUv77Oz////////////MERX////////////aTVP////////RFxMVAAAAEXRSTlMAOVoELPoJXFBuCpRES+G2f+6IOoEAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAzSURBVHicTcHHAYAwDACxM+4phP2nhScSuatlGWI9axuPhK0ujkTKTFANfvT6KIzb3QcvKmUBHJnKtFcAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/assets/images/Face_Upload_Info.png
/* harmony default export */ var Face_Upload_Info = ({"src":"/_next/static/media/Face_Upload_Info.8db4eb60.png","height":1117,"width":1728,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAJ1BMVEWQc2CEaFWUaVGUemp3WUZtTTpKNCifg3LOs6Kpk4bEpZOGXEfBlHvRIUBSAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAK0lEQVR4nA3GtwEAIAzAMKeSwv/3giYRWKZ5IMc2wH9aaQQx1SkgfaeuygMOFwCt40CTMgAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./src/assets/images/decktoFace.png
/* harmony default export */ var decktoFace = ({"src":"/_next/static/media/decktoFace.633c7771.png","height":1241,"width":1920,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAD1BMVEVQSERJQDxoWVKQZU6xlII77iz3AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAJElEQVR4nB2JgQkAMAyDNN3/Ny8tBCKKgNjB5K4wJwsv2zVp+wMXAChr2SdOAAAAAElFTkSuQmCC"});
// EXTERNAL MODULE: ./src/assets/images/SharePage.png
var SharePage = __webpack_require__(78253);
;// CONCATENATED MODULE: ./src/assets/images/logo-left.png
/* harmony default export */ var logo_left = ({"src":"/_next/static/media/logo-left.bd85035b.png","height":101,"width":353,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAG1BMVEX//v7YQkjaSE7////////XQEZHcEz////bUlc0snTVAAAACXRSTlNYBt8gRqcANi8DZCerAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGElEQVR4nGNgYWBgZmNkZARSDOwcTEysAAFWACwtzPd8AAAAAElFTkSuQmCC"});
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(71911);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 14 modules
var swiper_react = __webpack_require__(88494);
// EXTERNAL MODULE: ./src/api/http-client.ts
var http_client = __webpack_require__(55642);
// EXTERNAL MODULE: ./src/api/endpoints.ts
var endpoints = __webpack_require__(3557);
// EXTERNAL MODULE: ./src/styles/shap_of_you.module.scss
var shap_of_you_module = __webpack_require__(53084);
var shap_of_you_module_default = /*#__PURE__*/__webpack_require__.n(shap_of_you_module);
;// CONCATENATED MODULE: ./src/assets/images/shap-main-senco.png
/* harmony default export */ var shap_main_senco = ({"src":"/_next/static/media/shap-main-senco.239f9d8c.png","height":67,"width":106,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAIVBMVEXVMzrYQkjZUldHcEz77e7UMDb88/PULjXSJCvdWmDYQ0lzYqJ4AAAACXRSTlOZ9QIADYMuolNuugxoAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAJ0lEQVR4nCXDgQ0AIAgDsLmBOP4/WKJNCpI7REJSTOGrA9s9E+vpvAv0AJrY9P5yAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./src/components/shape-of-you-mobile/SplashScreen.tsx






var SplashScreen = function(param) {
    var navigateToStep = param.navigateToStep, _autoNavigateDelay = param.autoNavigateDelay, autoNavigateDelay = _autoNavigateDelay === void 0 ? 5000 : _autoNavigateDelay;
    // Auto-navigate to walkthrough after delay
    (0,react.useEffect)(function() {
        var timer = setTimeout(function() {
            navigateToStep("walkthrough");
        }, autoNavigateDelay);
        return function() {
            return clearTimeout(timer);
        };
    }, [
        navigateToStep,
        autoNavigateDelay
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "d-md-none w-100",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (shap_of_you_module_default()).mobile_view_shap,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (shap_of_you_module_default()).shapeOfYou,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (shap_of_you_module_default()).content,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (shap_of_you_module_default()).title,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: SENCO_SHAPE_OF_YOU_FULL_2,
                                alt: "Shape of You Logo"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (shap_of_you_module_default()).byLine,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: shap_main_senco,
                                alt: "Senco Gold & Diamonds",
                                className: (shap_of_you_module_default()).logo
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var shape_of_you_mobile_SplashScreen = (SplashScreen);

;// CONCATENATED MODULE: ./src/assets/images/shap-img1.png
/* harmony default export */ var shap_img1 = ({"src":"/_next/static/media/shap-img1.f8797bdd.png","height":852,"width":393,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAICAMAAADp7a43AAAAM1BMVEWqVEdsUT6CQzOugmSreFvCdWGeHyWhODWOYE2nYFKdfWCZcViBFRtdAAV1QTDVyK+tjnOSqOxDAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAK0lEQVR4nAXBCQIAIAQAwRVS0fH/1zZDiiw05bHMLuE66c6mVw2YbRC08wERLwDYs1UIhQAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./src/assets/images/shap-img2.png
/* harmony default export */ var shap_img2 = ({"src":"/_next/static/media/shap-img2.441bb14b.png","height":852,"width":393,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAICAMAAADp7a43AAAANlBMVEVwUDy7d16zgmuhGyCdVkObPjWreVqLZU6igmiXfGCcRjyPLyzMgW1uBAlrIhyOJCVuKCbOwKlqgJKVAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAKklEQVR4nAXBhwEAIAjAsIKAuPX/Z02o0EglaRoPl1DKlEUZ59J9V0yMDw7VAMpFzfyxAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./src/components/shape-of-you-mobile/WalkthroughScreen.tsx












var WalkthroughScreen_WalkthroughScreen = function(param) {
    var navigateToStep = param.navigateToStep, isAuthenticated = param.isAuthenticated;
    var ref = (0,react.useState)(false), loading = ref[0], setLoading = ref[1];
    // Handle "Get Started" button click with consent checking
    var handleGetStarted = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setLoading(true);
                        _ctx.prev = 1;
                        if (!isAuthenticated) {
                            _ctx.next = 9;
                            break;
                        }
                        _ctx.next = 5;
                        return http_client/* default.get */.Z.get(endpoints/* default.auth.getConsentForm */.Z.auth.getConsentForm());
                    case 5:
                        data = _ctx.sent.data;
                        if (data.statusText === "accepted") {
                            ;
                            navigateToStep("welcome");
                        } else {
                            // Scenario 2: Consent rejected - show TC screen
                            navigateToStep("tc");
                        }
                        _ctx.next = 10;
                        break;
                    case 9:
                        {
                            // Scenario 3: User is NOT authenticated - go to TC without API call
                            navigateToStep("tc");
                        }
                    case 10:
                        _ctx.next = 16;
                        break;
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](1);
                        ;
                        // If API fails, show TC screen anyway
                        navigateToStep("tc");
                    case 16:
                        _ctx.prev = 16;
                        setLoading(false);
                        return _ctx.finish(16);
                    case 19:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    12,
                    16,
                    19
                ]
            ]);
        }));
        return function handleGetStarted() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "d-md-none w-100",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (shap_of_you_module_default()).wrapper_slider,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* Swiper */.tq, {
                spaceBetween: 0,
                pagination: {
                    clickable: true
                },
                modules: [
                    swiper_esm/* Pagination */.tl
                ],
                className: "mySwiper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (shap_of_you_module_default()).swiperSlide,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (shap_of_you_module_default()).slide,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: (shap_of_you_module_default()).bgImage,
                                        src: shap_img1,
                                        alt: "Scan Your Face"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (shap_of_you_module_default()).overlay_n,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                children: "Scan Your Face"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Upload or take a photo of your face"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (shap_of_you_module_default()).swiperSlide,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (shap_of_you_module_default()).slide,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: (shap_of_you_module_default()).bgImage,
                                        src: shap_img2,
                                        alt: "Live Analysis"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (shap_of_you_module_default()).overlay_n,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                children: "Live Analysis"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Get instant analysis of your face type"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (shap_of_you_module_default()).swiperSlide,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (shap_of_you_module_default()).banner1,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: (shap_of_you_module_default()).bgImage,
                                        src: shap_img1,
                                        alt: ""
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (shap_of_you_module_default()).overlay_n,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                children: "The Shape of You"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Discover your face shape and shop jewellery made for you."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                className: (shap_of_you_module_default()).primaryBtn,
                                                onClick: handleGetStarted,
                                                disabled: loading,
                                                style: loading ? {
                                                    background: "#d3d3d3",
                                                    color: "#888",
                                                    cursor: "not-allowed",
                                                    opacity: 0.6
                                                } : {},
                                                children: loading ? "Loading..." : "Get Started"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                className: (shap_of_you_module_default()).secondaryBtn,
                                                onClick: function() {
                                                    return navigateToStep("about");
                                                },
                                                children: "Know More"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var shape_of_you_mobile_WalkthroughScreen = (WalkthroughScreen_WalkthroughScreen);

;// CONCATENATED MODULE: ./src/components/shape-of-you-mobile/AboutScreen.tsx









var AboutScreen = function(param) {
    var navigateToStep = param.navigateToStep, isAuthenticated = param.isAuthenticated;
    var ref = (0,react.useState)(false), loading = ref[0], setLoading = ref[1];
    // Handle "Start Experience" button click with consent checking
    var handleStartExperience = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setLoading(true);
                        _ctx.prev = 1;
                        if (!isAuthenticated) {
                            _ctx.next = 9;
                            break;
                        }
                        _ctx.next = 5;
                        return http_client/* default.get */.Z.get(endpoints/* default.auth.getConsentForm */.Z.auth.getConsentForm());
                    case 5:
                        data = _ctx.sent.data;
                        if (data.statusText === "accepted") {
                            ;
                            navigateToStep("welcome");
                        } else {
                            // Scenario 2: Consent rejected - show TC screen
                            navigateToStep("tc");
                        }
                        _ctx.next = 10;
                        break;
                    case 9:
                        {
                            // Scenario 3: User is NOT authenticated - go to TC without API call
                            navigateToStep("tc");
                        }
                    case 10:
                        _ctx.next = 16;
                        break;
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](1);
                        ;
                        // If API fails, show TC screen anyway
                        navigateToStep("tc");
                    case 16:
                        _ctx.prev = 16;
                        setLoading(false);
                        return _ctx.finish(16);
                    case 19:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    12,
                    16,
                    19
                ]
            ]);
        }));
        return function handleStartExperience() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "d-md-none w-100",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (shap_of_you_module_default()).wrapper_about,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (shap_of_you_module_default()).wrapper_sec,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                            className: (shap_of_you_module_default()).header,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: shapesenco,
                                alt: "Logo"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (shap_of_you_module_default()).videoCard,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("video", {
                                width: "100%",
                                height: "auto",
                                controls: true,
                                autoPlay: false,
                                muted: true,
                                loop: true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                        src: "https://sencowebfiles.s3.ap-south-1.amazonaws.com/website/files/Shape_Of_You_Story_6.mp4",
                                        type: "video/mp4"
                                    }),
                                    "Your browser does not support the video tag."
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (shap_of_you_module_default()).content,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    children: "Jewellery That Matches Your Face Shape"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Every face tells its own story, and the jewellery you wear should reflect that individuality. Understanding the shape of your face is the key to selecting pieces that not only complement your natural features but elevate them with effortless elegance. With Shape of You, Senco's innovative expert styling approach, you can now discover jewellery designs tailored to your unique contours and personality. From earrings that refine angles to necklaces that balance proportions, each recommendation is chosen with intention. Because the perfect jewellery does more than accessorise - it highlights confidence, enhances beauty, and above all, celebrates you."
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (shap_of_you_module_default()).cta_btn_container,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: (shap_of_you_module_default()).ctaBtn,
                        onClick: handleStartExperience,
                        disabled: loading,
                        style: loading ? {
                            background: "#d3d3d3",
                            color: "#888",
                            cursor: "not-allowed",
                            opacity: 0.6
                        } : {},
                        children: loading ? "Loading..." : "Start Experience →"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var shape_of_you_mobile_AboutScreen = (AboutScreen);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/components/shape-of-you-mobile/TermsConditionsScreen.tsx






var TermsConditionsScreen = function(param) {
    var navigateToStep = param.navigateToStep, isAuthenticated = param.isAuthenticated, logStep = param.logStep;
    var ref = (0,react.useState)(false), loading = ref[0], setLoading = ref[1];
    var ref1 = (0,react.useState)(false), hasScrolledToEnd = ref1[0], setHasScrolledToEnd = ref1[1];
    var contentRef = (0,react.useRef)(null);
    // Check if user has scrolled to the bottom
    (0,react.useEffect)(function() {
        var handleScroll = function() {
            if (contentRef.current) {
                var _current = contentRef.current, scrollTop = _current.scrollTop, scrollHeight = _current.scrollHeight, clientHeight = _current.clientHeight;
                // Check if scrolled to bottom (with 10px threshold for better UX)
                if (scrollTop + clientHeight >= scrollHeight - 10) {
                    setHasScrolledToEnd(true);
                }
            }
        };
        var contentElement = contentRef.current;
        if (contentElement) {
            contentElement.addEventListener("scroll", handleScroll);
            // Check initial scroll position in case content is already at bottom
            handleScroll();
        }
        return function() {
            if (contentElement) {
                contentElement.removeEventListener("scroll", handleScroll);
            }
        };
    }, []);
    // Handle "Agree and Proceed" button click
    var handleAgreeAndProceed = function() {
        setLoading(true);
        // Save consent acceptance to localStorage for all users
        // The API call will be made after login (in VerifyOtpScreen)
        localStorage.setItem("pendingConsentAcceptance", "true");
        // Log consent accept (non-blocking)
        if (logStep) {
            logStep("consent_accepted");
        }
        navigateToStep("welcome");
        setLoading(false);
    };
    // Handle "Don't Agree" button click
    var handleDontAgree = function() {
        // Log consent denied (non-blocking)
        if (logStep) {
            logStep("consent_rejected");
        }
        navigateToStep("permissionDenied");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "d-md-none w-100",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (shap_of_you_module_default()).wrapper_tc,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (shap_of_you_module_default()).wrapper_sec,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                            className: (shap_of_you_module_default()).header,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: shapesenco,
                                alt: "Logo"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (shap_of_you_module_default()).content,
                            ref: contentRef,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    children: "CONSENT NOTICE"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        "Senco Gold Limited (hereinafter referred to as “Company”, “We”, “Us”, or “Our”), incorporated under the Companies Act, 1956 (CIN: L36911WB1994PLC064637), with its registered office located at Diamond Prestige, 41A A.J.C. Bose Road, 10th Floor, Unit No. 1001, Kolkata – 700017, West Bengal, India, respects the privacy of any person who accesses or uses Our Website/Application (hereinafter referred to as “You” or “Your”) and is committed to protecting your Digital Personal Data. This notice applies to the processing of Personal Data collected in digital form or any non-digital form which is digitised subsequently.",
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        "In order to comply with the Digital Personal Data Protection Act, 2023 (“DPDP Act”) and the rules framed thereunder and to nurture Our association, we would be collecting and processing Your Digital Personal Data. For this data collection and its processing, we need Your explicit consent.",
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        "The purpose of processing Your Digital Personal Data is to support the services provided by the Company or its affiliates to You (please visit Our website for a list of services offered by the Company) or to facilitate Your interactions with the Company in roles, including but not limited to, an employee or vendor/supplier. There may be instances where Your Digital Personal Data needs to be shared with regulators, business associates, or payment gateways, resulting in Your data being transferred beyond Company’s control. This sharing may also be necessitated now or in future as per the requirement and in accordance with the applicable laws/regulations in India, as may be amended from time to time.",
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        "You reserve the right to file a complaint with the Company regarding any grievances arising from the processing of Your Digital Personal Data, which shall be directed to the Grievance Officer, as detailed in Our Policy. Should the grievance remain unresolved through Our grievance redressal mechanism, You further retain the right to approach the Data Protection Board of India with a complaint, as outlined in the provisions of the DPDP Act.",
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        "All the capitalised terms used in this Consent Notice shall have the same meaning assigned to them as in Company’s Policy. (“Policy”).",
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (shap_of_you_module_default()).heading,
                                    children: "Declaration of Understanding - Data Processing Policies:"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            children: "1"
                                        }),
                                        ". I understand that my Digital Personal Data may be collected only with my valid consent, and that it may be processed only in accordance with the Policy."
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            children: "2"
                                        }),
                                        ". I agree to provide the following information to Company during registration on our App/ Website or usage of our App/ Website or both, as and when necessary, including, but not limited to:"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    className: (shap_of_you_module_default()).list_two_liv,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                    className: "pb-2 d-block",
                                                    children: "Your information:"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                    className: (shap_of_you_module_default()).list_two_liv,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Name"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Gender"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Occupation"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Education"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Address"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Financial information"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Identity proof such as PAN Card, AADHAR Card, Voter ID card etc."
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Previous purchase history from Us"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Consumer durables owned"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                    className: "pb-2 pt-2 d-block",
                                                    children: "Communication details:"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                    className: (shap_of_you_module_default()).list_two_liv,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Email address"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Phone number"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Postal address"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Any other contact information"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                    className: "pb-2 pt-2 d-block",
                                                    children: "Device information:"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                    className: (shap_of_you_module_default()).list_two_liv,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Operating system"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Operating system providing advertising ID"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "IP address"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Date and time of every user request"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Your usage information with Our devices placed at Our office"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Your internet protocol address"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                    className: "pb-2 pt-2 d-block",
                                                    children: "Behavioural patterns:"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                    className: (shap_of_you_module_default()).list_two_liv,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Your active seconds and minutes in Our work database"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Your search history in Our device located at Our office"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Sharing a product or inspiration to social media sites"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Other interactions and dialogues during interactive search"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                    className: "pb-2 pt-2 d-block",
                                                    children: "Non-personal information (THIS TYPE OF INFORMATION DOES NOT IDENTIFY YOU PERSONALLY)"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                    className: (shap_of_you_module_default()).list_two_liv,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "The pages you visit"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Links you click"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Advertisements you view"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Number of times you access Our page"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Your opinion on Our services, products, features that We offer"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Operating system"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Browser type"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Internet service provider"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Aggregate user data"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Software and hardware attributes"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Number of clicks"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        " ",
                                        "If You communicate with Us, by, for example, email or letter, any information provided in such communication may be collected and stored by Us."
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            children: "3"
                                        }),
                                        ". Specifically, You understand that Your Digital Personal Data may be processed for any or all of the following purposes, as may be applicable:"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "ps-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "(i) Facilitating personnel management, including verification, compensation management (such as bank details for salary disbursement), performance management, compliance with legal obligations, health and safety management, training and development, and internal communications."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "(ii) Fulfilling customer orders placed, including but not limited to, managing payment transactions, coordinating shipping logistics, and facilitating the delivery of goods."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "(iii) Facilitating communication regarding order confirmations, invoices, and receipts for purchases made both online and offline."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "(iv) Communicating updates pertaining to the status of orders or delivery schedules."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "(v) Managing inquiries, complaints, or requests for assistance."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "(vi) Disseminating newsletters and promotional communications regarding upcoming events, sales, and the introduction of new products."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "(vii) Soliciting customer feedback through surveys and rating mechanisms."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "(viii) Enrolling in loyalty or rewards programs and thereby tracking points or rewards accumulated through purchases made both online and offline."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "(ix) Complying with applicable legal obligations, including but not limited to tax reporting, audit requirements, or responses to requests from law enforcement authorities."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "(x) Analysing market trends, conducting market research, and improving overall business strategies, utilizing information gathered from both online and offline sales."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "(xi) Detecting and preventing fraudulent transactions or unauthorized access to customer accounts, thereby safeguarding both the customer and the brand across all sales channels."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "(xii) Sharing information with third-party service providers for limited purposes of operational and logistical functions to complete the order."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "(xiii) Facilitating linking of customer accounts with social media platforms for the purpose of sharing purchases or promotional materials, whether derived from online or offline transactions."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "(xiv) Facilitating effective communication, assessing service quality, and managing supply chain operations for purposes related to the business relationship, including but not limited to entering into and managing agreements, evaluating supplier qualifications, processing payments, and ensuring compliance with contractual obligations."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "(xv) To build up marketing profiles."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "(xvi) Aiding strategic development, data collection, and business analytics."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "(xvii) Managing our relationship with advertisers and other partners."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "(xviii) Any other grounds as per applicable law."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            children: "4"
                                        }),
                                        ". I understand that I have certain rights that I enjoy as a data principal over my Digital Personal Data, in relation to its collection, use and processing. These rights, inter alia, relate to confirmation and access, correction and erasure, objection of processing, grievance redressal and withdrawal of consent. These rights are available to me in the manner set out in the Policy."
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            children: "5"
                                        }),
                                        ". I agree that am of lawful age to contract as per applicable laws and I have read and understood the processing requirement with respect to my Digital Personal Data as listed above and provide my free, specific, informed, unconditional and unambiguous consent to the above by signing on the space provided below."
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            children: "6"
                                        }),
                                        ". I understand that I have the right to withdraw my consent at any time in the manner specified under the Policy. If I need to withdraw my consent with respect to usage of my Digital Personal Data under Company’s purview, excluding data which has already been shared with the authorities, regulators or business associates and outside the control of the Company at that time, I will inform the Company through the",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/account/profile",
                                            style: {
                                                color: "rgb(147, 16, 29)"
                                            },
                                            children: "Consent Withdrawal Form"
                                        }),
                                        " ",
                                        "as provided on the Website.",
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            children: "7"
                                        }),
                                        ". I understand that this withdrawal of consent will be implemented as soon as practicable. I also confirm that the Company, while accepting my request for withdrawal of consent, will be allowed to keep such Digital Personal Data as required by the applicable laws and regulations for history and record keeping purposes for a specified period of time.",
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            children: "8"
                                        }),
                                        ". By clicking on “I agree to consent to the processing of my Digital Personal Data” below, I signify agreement to the processing and sharing of my Digital Personal Data with the Company now and in future in order to allow the Company to conduct business or sharing information with business associates or authorities as may be required under different regulations, laws and statues of India and outside India, or with such third parties/vendors, as may be applicable and amended from time to time."
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-100",
                                    style: {
                                        paddingBottom: "50px"
                                    }
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (shap_of_you_module_default()).cta_btn_container,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            className: (shap_of_you_module_default()).ctaBtn,
                            onClick: handleAgreeAndProceed,
                            disabled: loading || !hasScrolledToEnd,
                            style: loading || !hasScrolledToEnd ? {
                                background: "#d3d3d3",
                                color: "#888",
                                cursor: "not-allowed",
                                opacity: 0.6
                            } : {},
                            children: [
                                loading ? "Processing..." : "Agree and Proceed",
                                " →"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: (shap_of_you_module_default()).ctaBtn1,
                            onClick: handleDontAgree,
                            disabled: loading || !hasScrolledToEnd,
                            style: !hasScrolledToEnd || loading ? {
                                background: "#d3d3d3",
                                color: "#888",
                                cursor: "not-allowed",
                                opacity: 0.6
                            } : {},
                            children: "Don't Agree"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var shape_of_you_mobile_TermsConditionsScreen = (TermsConditionsScreen);

;// CONCATENATED MODULE: ./src/assets/images/WelcomeScreen.png
/* harmony default export */ var WelcomeScreen = ({"src":"/_next/static/media/WelcomeScreen.5f48a2e5.png","height":852,"width":393,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAICAMAAADp7a43AAAACVBMVEUzCghDFg5eLyD/EzG0AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAFUlEQVR4nGNgYmRgYEAmGIEUCKMCAAHsABH3ueCxAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./src/assets/images/SOYLockUp.png
/* harmony default export */ var SOYLockUp = ({"src":"/_next/static/media/SOYLockUp.6ae3449f.png","height":215,"width":223,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAM1BMVEVHcEz//f7//////PzZRkz//////////v7++/v////XP0X////////YQUf////+/v7ZQ0l+PpOKAAAAEHRSTlMAHlQobl7sOTIUKkeADZBOOTw7jAAAAAlwSFlzAAALEwAACxMBAJqcGAAAADpJREFUeJxFxjkSgDAMA0DJt5MA/v9rGSq2WohoFrUhLnHLKSjJVDbiYPsTDk+Ucjd+l5mtL2tmDHgBK9UBOuDd3MEAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/components/shape-of-you-mobile/WelcomeScreen.tsx






var WelcomeScreen_WelcomeScreen = function(param) {
    var navigateToStep = param.navigateToStep;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "d-md-none w-100",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (shap_of_you_module_default()).mobile_view_shap_welcome,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (shap_of_you_module_default()).bgImage,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: WelcomeScreen,
                        alt: "Welcome Screen"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (shap_of_you_module_default()).shapeOfYou,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (shap_of_you_module_default()).content,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (shap_of_you_module_default()).title,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: SOYLockUp,
                                    alt: "Shape of You Logo"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: (shap_of_you_module_default()).ctaBtn,
                                onClick: function() {
                                    return navigateToStep("uploadOrScan");
                                },
                                children: "Start Experience →"
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var shape_of_you_mobile_WelcomeScreen = (WelcomeScreen_WelcomeScreen);

;// CONCATENATED MODULE: ./src/components/shape-of-you-mobile/UploadOrScanScreen.tsx






var UploadOrScanScreen = function(param) {
    var navigateToStep = param.navigateToStep, onImageSelect = param.onImageSelect;
    var fileInputRef = (0,react.useRef)(null);
    // Handle file selection (same as GalleryPermissionScreen)
    var handleFileChange = function(event) {
        var ref;
        var file = (ref = event.target.files) === null || ref === void 0 ? void 0 : ref[0];
        if (file) {
            var reader = new FileReader();
            reader.onloadend = function() {
                var base64String = reader.result;
                if (onImageSelect) {
                    onImageSelect(base64String);
                }
            };
            reader.readAsDataURL(file);
        }
    };
    // Handle upload button click - check localStorage first
    var handleUploadClick = function() {
        var galleryPermission = localStorage.getItem("galleryPermissionGranted");
        if (galleryPermission === "true") {
            var // Permission already granted - directly trigger file input
            ref;
            (ref = fileInputRef.current) === null || ref === void 0 ? void 0 : ref.click();
        } else {
            // Permission not granted - navigate to permission screen
            navigateToStep("galleryPermission");
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "d-md-none w-100",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (shap_of_you_module_default()).mobile_view_shap_welcome_one,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (shap_of_you_module_default()).bgImage,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: WelcomeScreen,
                        alt: "Welcome Screen"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (shap_of_you_module_default()).shapeOfYou,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (shap_of_you_module_default()).content,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (shap_of_you_module_default()).title,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: SOYLockUp,
                                    alt: "Shape of You Logo"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                ref: fileInputRef,
                                type: "file",
                                accept: "image/*",
                                style: {
                                    display: "none"
                                },
                                onChange: handleFileChange
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                className: (shap_of_you_module_default()).ctaBtn,
                                onClick: handleUploadClick,
                                children: [
                                    "Upload your Image",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                        width: "24",
                                        height: "24",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M15 8H15.01",
                                                stroke: "white",
                                                strokeWidth: "2",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M12.5 21H6C5.20435 21 4.44129 20.6839 3.87868 20.1213C3.31607 19.5587 3 18.7956 3 18V6C3 5.20435 3.31607 4.44129 3.87868 3.87868C4.44129 3.31607 5.20435 3 6 3H18C18.7956 3 19.5587 3.31607 20.1213 3.87868C20.6839 4.44129 21 5.20435 21 6V12.5",
                                                stroke: "white",
                                                strokeWidth: "2",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M3 16.0001L8 11.0001C8.928 10.1071 10.072 10.1071 11 11.0001L14.5 14.5001",
                                                stroke: "white",
                                                strokeWidth: "2",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M14 13.9999L15 12.9999C15.679 12.3469 16.473 12.1709 17.214 12.4739",
                                                stroke: "white",
                                                strokeWidth: "2",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M19 22V16",
                                                stroke: "white",
                                                strokeWidth: "2",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M22 19L19 16L16 19",
                                                stroke: "white",
                                                strokeWidth: "2",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (shap_of_you_module_default()).or,
                                children: "OR"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                className: (shap_of_you_module_default()).ctaBtn,
                                onClick: function() {
                                    return navigateToStep("cameraPermission");
                                },
                                children: [
                                    "Scan Face",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                        width: "24",
                                        height: "24",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M7 3H5C3.89543 3 3 3.89543 3 5V7",
                                                stroke: "white",
                                                strokeWidth: "2",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M17 3H19C20.1046 3 21 3.89543 21 5V7",
                                                stroke: "white",
                                                strokeWidth: "2",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M15 9V11",
                                                stroke: "white",
                                                strokeWidth: "2",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M9 9V11",
                                                stroke: "white",
                                                strokeWidth: "2",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M9 15C9 15 10 16 12 16C14 16 15 15 15 15",
                                                stroke: "white",
                                                strokeWidth: "2",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M7 21H5C3.89543 21 3 20.1046 3 19V17",
                                                stroke: "white",
                                                strokeWidth: "2",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M17 21H19C20.1046 21 21 20.1046 21 19V17",
                                                stroke: "white",
                                                strokeWidth: "2",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var shape_of_you_mobile_UploadOrScanScreen = (UploadOrScanScreen);

;// CONCATENATED MODULE: ./src/assets/images/win.png
/* harmony default export */ var win = ({"src":"/_next/static/media/win.1a4b0f95.png","height":254,"width":173,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAMAAAAGL8UJAAAARVBMVEW+r55HcEzAtaK0qZrJvKpkWla6r5+Zkoc8MVi0qZk+QFpeUWJWlpVsjd4Dc4szh45GbXy2q5uQioJ4npqLfH6Wp5yfpp12zuX0AAAAEXRSTlP8APz9/YuRndh0bfycCZuCqH0qW3AAAAAJcEhZcwAACxMAAAsTAQCanBgAAAA0SURBVHicY2BgEmJlZGBhEeZnZGBmEOZjZBBkEBMAkaI8QBEmEQ5eBkEmIW4uBk42NnZWAB9MAV9QDI4GAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./src/components/shape-of-you-mobile/PermissionDeniedScreen.tsx










var PermissionDeniedScreen = function(param) {
    var isAuthenticated = param.isAuthenticated, onExit = param.onExit;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(false), loading = ref[0], setLoading = ref[1];
    // Handle "Restart Experience" button click with consent checking
    var handleRestartExperience = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setLoading(true);
                        _ctx.prev = 1;
                        if (!isAuthenticated) {
                            _ctx.next = 9;
                            break;
                        }
                        _ctx.next = 5;
                        return http_client/* default.get */.Z.get(endpoints/* default.auth.getConsentForm */.Z.auth.getConsentForm());
                    case 5:
                        data = _ctx.sent.data;
                        if (data.statusText === "accepted") {
                            ;
                            localStorage.setItem("pendingNavigation", "welcome");
                            if (onExit) {
                                onExit(); // Exit PhotoCaptureFlow, main page will handle navigation
                            }
                        } else {
                            // Scenario 2: Consent rejected - show TC screen
                            localStorage.setItem("pendingNavigation", "tc");
                            if (onExit) {
                                onExit(); // Exit PhotoCaptureFlow, main page will handle navigation
                            }
                        }
                        _ctx.next = 10;
                        break;
                    case 9:
                        {
                            // Scenario 3: User is NOT authenticated - go to TC without API call
                            localStorage.setItem("pendingNavigation", "tc");
                            if (onExit) {
                                onExit(); // Exit PhotoCaptureFlow, main page will handle navigation
                            }
                        }
                    case 10:
                        _ctx.next = 17;
                        break;
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](1);
                        ;
                        // If API fails, show TC screen anyway
                        localStorage.setItem("pendingNavigation", "tc");
                        if (onExit) {
                            onExit();
                        }
                    case 17:
                        _ctx.prev = 17;
                        setLoading(false);
                        return _ctx.finish(17);
                    case 20:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    12,
                    17,
                    20
                ]
            ]);
        }));
        return function handleRestartExperience() {
            return _ref.apply(this, arguments);
        };
    }();
    // Handle "Close Window" button click
    var handleCloseWindow = function() {
        router.push("/");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "d-md-none w-100",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (shap_of_you_module_default()).wrapper_Permission,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: win,
                    alt: "Exit",
                    className: (shap_of_you_module_default()).image
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                    children: [
                        "Permission ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        " Denied"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "Oops! We need your permission to bring this experience to life."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    className: (shap_of_you_module_default()).restartBtn,
                    onClick: handleRestartExperience,
                    disabled: loading,
                    style: loading ? {
                        background: "#d3d3d3",
                        color: "#888",
                        cursor: "not-allowed",
                        opacity: 0.6
                    } : {},
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (shap_of_you_module_default()).icon,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                width: "24",
                                height: "24",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M5.46257 4.43262C7.21556 2.91688 9.5007 2 12 2C17.5228 2 22 6.47715 22 12C22 14.1361 21.3302 16.1158 20.1892 17.7406L17 12H20C20 7.58172 16.4183 4 12 4C9.84982 4 7.89777 4.84827 6.46023 6.22842L5.46257 4.43262ZM18.5374 19.5674C16.7844 21.0831 14.4993 22 12 22C6.47715 22 2 17.5228 2 12C2 9.86386 2.66979 7.88416 3.8108 6.25944L7 12H4C4 16.4183 7.58172 20 12 20C14.1502 20 16.1022 19.1517 17.5398 17.7716L18.5374 19.5674Z",
                                    fill: loading ? "#888" : "white"
                                })
                            })
                        }),
                        loading ? "Loading..." : "Restart Experience"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: (shap_of_you_module_default()).closeBtn,
                    onClick: handleCloseWindow,
                    disabled: loading,
                    children: "✕ Close Window"
                })
            ]
        })
    });
};
/* harmony default export */ var shape_of_you_mobile_PermissionDeniedScreen = (PermissionDeniedScreen);

;// CONCATENATED MODULE: ./src/components/shape-of-you-mobile/ImageNotPermittedScreen.tsx



var ImageNotPermittedScreen = function(param) {
    var navigateToStep = param.navigateToStep, errorMessage = param.errorMessage, onRetry = param.onRetry, capturedImage = param.capturedImage;
    var handleReupload = function() {
        if (onRetry) {
            onRetry();
        } else {
            navigateToStep("uploadOrScan");
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "d-block d-md-none w-100",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (shap_of_you_module_default()).image_error_screen,
            style: capturedImage ? {
                backgroundImage: "url(".concat(capturedImage, ")")
            } : undefined,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (shap_of_you_module_default()).error_content,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (shap_of_you_module_default()).error_box,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                className: (shap_of_you_module_default()).warning_icon,
                                width: "40",
                                height: "40",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M12 9V13M12 17H12.01M10.29 3.86L1.82 18C1.64537 18.3024 1.55296 18.6453 1.55199 18.9945C1.55101 19.3437 1.64151 19.6871 1.81445 19.9905C1.98738 20.2939 2.23675 20.5467 2.53773 20.7239C2.83871 20.901 3.18082 20.9962 3.53 21H20.47C20.8192 20.9962 21.1613 20.901 21.4623 20.7239C21.7633 20.5467 22.0126 20.2939 22.1856 19.9905C22.3585 19.6871 22.449 19.3437 22.448 18.9945C22.447 18.6453 22.3546 18.3024 22.18 18L13.71 3.86C13.5317 3.56611 13.2807 3.32312 12.9812 3.15448C12.6817 2.98585 12.3437 2.89725 12 2.89725C11.6563 2.89725 11.3183 2.98585 11.0188 3.15448C10.7193 3.32312 10.4683 3.56611 10.29 3.86Z",
                                    stroke: "#C9302C",
                                    strokeWidth: "2",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: (shap_of_you_module_default()).error_title,
                                children: "Image Upload Error"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (shap_of_you_module_default()).error_message,
                                children: errorMessage || "Please upload an image where the face is clearly visible and properly lit."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        className: (shap_of_you_module_default()).reupload_btn,
                        onClick: handleReupload,
                        children: [
                            "Reupload Image",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                width: "24",
                                height: "24",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M4 16L8.586 11.414C8.96106 11.0391 9.46967 10.8284 10 10.8284C10.5303 10.8284 11.0389 11.0391 11.414 11.414L16 16M14 14L15.586 12.414C15.9611 12.0391 16.4697 11.8284 17 11.8284C17.5303 11.8284 18.0389 12.0391 18.414 12.414L20 14M14 8H14.01M6 20H18C18.5304 20 19.0391 19.7893 19.4142 19.4142C19.7893 19.0391 20 18.5304 20 18V6C20 5.46957 19.7893 4.96086 19.4142 4.58579C19.0391 4.21071 18.5304 4 18 4H6C5.46957 4 4.96086 4.21071 4.58579 4.58579C4.21071 4.96086 4 5.46957 4 6V18C4 18.5304 4.21071 19.0391 4.58579 19.4142C4.96086 19.7893 5.46957 20 6 20Z",
                                    stroke: "white",
                                    strokeWidth: "2",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var shape_of_you_mobile_ImageNotPermittedScreen = (ImageNotPermittedScreen);

// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Spinner.js
var Spinner = __webpack_require__(36968);
// EXTERNAL MODULE: ./src/store/slices/cart.ts
var cart = __webpack_require__(45066);
// EXTERNAL MODULE: ./src/store/slices/wishlist.ts
var wishlist = __webpack_require__(78271);
// EXTERNAL MODULE: ./src/store/index.ts + 1 modules
var store = __webpack_require__(89936);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.js + 1 modules
var react_toastify_esm = __webpack_require__(40782);
// EXTERNAL MODULE: ./src/lib/fpixel.ts
var fpixel = __webpack_require__(50634);
// EXTERNAL MODULE: ./src/lib/unbxd.ts
var unbxd = __webpack_require__(22236);
// EXTERNAL MODULE: ./src/lib/ga4.ts
var ga4 = __webpack_require__(77981);
;// CONCATENATED MODULE: ./src/components/shape-of-you-mobile/CartModal.tsx


















var CartModal = function(param) {
    var isOpen = param.isOpen, setIsOpen = param.setIsOpen;
    var router = (0,next_router.useRouter)();
    var dispatch = (0,store/* useAppDispatch */.T)();
    var cartState = (0,es/* useSelector */.v9)(cart/* selectCart */.KY);
    var wishlistState = (0,es/* useSelector */.v9)(wishlist/* selectWishlist */.jq);
    var authState = (0,es/* useSelector */.v9)(auth/* selectAuth */.Hz);
    var ref = (0,react.useState)(null), removingId = ref[0], setRemovingId = ref[1];
    var ref1 = (0,react.useState)(null), wishlistLoadingId = ref1[0], setWishlistLoadingId = ref1[1];
    var ref2 = (0,react.useState)(null), addOneMoreLoadingId = ref2[0], setAddOneMoreLoadingId = ref2[1];
    var handleContinueShopping = function() {
        setIsOpen(false);
    };
    var handleProceedToCheckout = function() {
        setIsOpen(false);
        router.push("/cart");
    };
    var handleRemove = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(item) {
            var ref, ref1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setRemovingId(item.id);
                        _ctx.prev = 1;
                        ;
                        _ctx.next = 5;
                        return http_client/* default.delete */.Z["delete"](endpoints/* default.cart.remove */.Z.cart.remove(item.id));
                    case 5:
                        _ctx.next = 7;
                        return dispatch((0,cart/* fetchCartItems */.Vw)());
                    case 7:
                        react_toastify_esm/* toast.info */.Am.info("Item removed from cart");
                        (0,unbxd/* unbxdCusEngTrackEvent */.$z)("Remove from cart ", {
                            source: "web",
                            platform: "senco",
                            prid: (ref = item.data) === null || ref === void 0 ? void 0 : ref.product_id,
                            variant_id: item.identifier,
                            image: item.product_image || item.image,
                            prqt: 1,
                            product_name: ((ref1 = item.product) === null || ref1 === void 0 ? void 0 : ref1.title) || item.product_name || item.name,
                            amount: item.product_discounted_price || item.product_price || item.price,
                            product_url: "".concat(window.location.origin, "/jewellery/").concat(item.slug)
                        });
                        _ctx.next = 14;
                        break;
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](1);
                        react_toastify_esm/* toast.error */.Am.error("Failed to remove item");
                    case 14:
                        _ctx.prev = 14;
                        setRemovingId(null);
                        return _ctx.finish(14);
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    11,
                    14,
                    17
                ]
            ]);
        }));
        return function handleRemove(item) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleAddOneMore = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(item) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(addOneMoreLoadingId === item.id)) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        setAddOneMoreLoadingId(item.id);
                        _ctx.prev = 3;
                        ;
                        _ctx.next = 7;
                        return http_client/* default.post */.Z.post(endpoints/* default.cart.add */.Z.cart.add(), {
                            type: "product",
                            identifier: item.identifier
                        });
                    case 7:
                        _ctx.next = 9;
                        return dispatch((0,cart/* fetchCartItems */.Vw)());
                    case 9:
                        (0,fpixel/* fbqTrackEvent */.dK)("CustomizeProduct");
                        window.dataLayer.push({
                            ecommerce: null
                        });
                        window.dataLayer.push({
                            event: "add_to_cart",
                            ecommerce: {
                                currency: "INR",
                                value: item.product_discounted_price || item.product_price || item.price || 0,
                                items: [
                                    {
                                        item_id: ((ref = item.data) === null || ref === void 0 ? void 0 : ref.product_id) || ((ref1 = item.product) === null || ref1 === void 0 ? void 0 : ref1.sku) || item.sku || "",
                                        item_name: ((ref2 = item.product) === null || ref2 === void 0 ? void 0 : ref2.title) || item.product_name || item.name,
                                        item_brand: ga4/* GA4_ITEM_BRAND */.Ye,
                                        item_category: ((ref3 = item.product) === null || ref3 === void 0 ? void 0 : ref3.category) || "",
                                        item_variant: ((ref4 = item.data) === null || ref4 === void 0 ? void 0 : ref4.purity) || ((ref5 = item.product) === null || ref5 === void 0 ? void 0 : ref5.purity) || ((ref6 = item.product) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.purities) === null || ref7 === void 0 ? void 0 : ref7[0]) || item.identifier,
                                        price: item.product_discounted_price || item.product_price || item.price || 0,
                                        quantity: 1
                                    }, 
                                ]
                            }
                        });
                        (0,unbxd/* unbxdCusEngTrackEvent */.$z)("Add to cart ", {
                            source: "web",
                            platform: "senco",
                            prid: (ref8 = item.data) === null || ref8 === void 0 ? void 0 : ref8.product_id,
                            variant_id: item.identifier,
                            image: item.product_image || item.image,
                            prqt: 1,
                            product_name: ((ref9 = item.product) === null || ref9 === void 0 ? void 0 : ref9.title) || item.product_name || item.name,
                            amount: item.product_discounted_price || item.product_price || item.price,
                            product_url: "".concat(window.location.origin, "/jewellery/").concat(item.slug),
                            discounted_price: item.product_discounted_price || 0,
                            stock_availability: 1
                        });
                        _ctx.next = 19;
                        break;
                    case 15:
                        _ctx.prev = 15;
                        _ctx.t0 = _ctx["catch"](3);
                        ;
                        if (_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref10 = _ctx.t0.response) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.data) === null || ref11 === void 0 ? void 0 : ref11.message) {
                            (0,react_toastify_esm/* toast */.Am)(_ctx.t0.response.data.message, {
                                type: "error",
                                toastId: "add-one-more-error"
                            });
                        }
                    case 19:
                        setAddOneMoreLoadingId(null);
                    case 20:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    3,
                    15
                ]
            ]);
        }));
        return function handleAddOneMore(item) {
            return _ref.apply(this, arguments);
        };
    }();
    var isInWishlist = function(item) {
        var ref;
        var productId = (ref = item.data) === null || ref === void 0 ? void 0 : ref.product_id;
        return wishlistState.items.some(function(v) {
            return v.id == productId;
        });
    };
    var handleWishlist = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(item) {
            var ref, productId, ref1, ref2;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        if (!(wishlistLoadingId === item.id)) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 3:
                        if (authState.user) {
                            _ctx.next = 6;
                            break;
                        }
                        dispatch(auth/* authActions.setIsModalOpen */.YV.setIsModalOpen(true));
                        return _ctx.abrupt("return");
                    case 6:
                        productId = (ref = item.data) === null || ref === void 0 ? void 0 : ref.product_id;
                        setWishlistLoadingId(item.id);
                        _ctx.prev = 8;
                        if (!isInWishlist(item)) {
                            _ctx.next = 20;
                            break;
                        }
                        if (confirm("Are you sure you want to remove this product from wishlist?")) {
                            _ctx.next = 13;
                            break;
                        }
                        setWishlistLoadingId(null);
                        return _ctx.abrupt("return");
                    case 13:
                        _ctx.next = 15;
                        return http_client/* default.post */.Z.post(endpoints/* default.wishlist.remove */.Z.wishlist.remove(), {
                            product_id: productId,
                            user_id: authState.user.id
                        });
                    case 15:
                        _ctx.next = 17;
                        return dispatch((0,wishlist/* fetchWishlistItems */.nf)(authState.user.id));
                    case 17:
                        (0,react_toastify_esm/* toast */.Am)("Item removed from wishlist", {
                            type: "success",
                            toastId: "wishlist-remove-success"
                        });
                        _ctx.next = 26;
                        break;
                    case 20:
                        _ctx.next = 22;
                        return http_client/* default.post */.Z.post(endpoints/* default.wishlist.add */.Z.wishlist.add(), {
                            product_id: productId,
                            user_id: authState.user.id
                        });
                    case 22:
                        _ctx.next = 24;
                        return dispatch((0,wishlist/* fetchWishlistItems */.nf)(authState.user.id));
                    case 24:
                        (0,react_toastify_esm/* toast */.Am)("Item added to wishlist", {
                            type: "success",
                            toastId: "wishlist-add-success"
                        });
                        if (window.smartech) {
                            ;
                            (0,unbxd/* unbxdCusEngTrackEvent */.$z)("Add to wishlist ", {
                                source: "web",
                                platform: "senco",
                                prid: (ref1 = item.data) === null || ref1 === void 0 ? void 0 : ref1.product_id,
                                variant_id: item.identifier,
                                image: item.product_image || item.image,
                                prqt: 1,
                                product_name: ((ref2 = item.product) === null || ref2 === void 0 ? void 0 : ref2.title) || item.product_name || item.name,
                                amount: item.product_price || item.price,
                                product_url: "".concat(window.location.origin, "/jewellery/").concat(item.slug),
                                discounted_price: item.product_discounted_price || 0,
                                stock_availability: 1
                            });
                        }
                    case 26:
                        _ctx.next = 30;
                        break;
                    case 28:
                        _ctx.prev = 28;
                        _ctx.t0 = _ctx["catch"](8);
                    case 30:
                        setWishlistLoadingId(null);
                    case 31:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    8,
                    28
                ]
            ]);
        }));
        return function handleWishlist(item) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (shap_of_you_module_default()).modal_pro_mobile_cart,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "".concat((shap_of_you_module_default()).overlay, " ").concat(isOpen ? (shap_of_you_module_default()).show : ""),
            onClick: function() {
                return setIsOpen(false);
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: (shap_of_you_module_default()).closeBtn,
                    onClick: function() {
                        return setIsOpen(false);
                    },
                    children: "✕"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "".concat((shap_of_you_module_default()).modal, " ").concat(isOpen ? (shap_of_you_module_default()).open : ""),
                    onClick: function(e) {
                        return e.stopPropagation();
                    },
                    style: {
                        display: "flex",
                        flexDirection: "column"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (shap_of_you_module_default()).header,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: "Cart Page"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (shap_of_you_module_default()).wrapper_card_desktop,
                            children: cartState.items_loading && removingId === null && addOneMoreLoadingId === null ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (shap_of_you_module_default()).loading,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                                    animation: "border",
                                    role: "status"
                                })
                            }) : cartState.items.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (shap_of_you_module_default()).empty,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Your cart is empty"
                                })
                            }) : cartState.items.map(function(item) {
                                var ref, ref1;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (shap_of_you_module_default()).item,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (shap_of_you_module_default()).row,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (shap_of_you_module_default()).imageBox,
                                                    children: item.product_image || item.image ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: item.product_image || item.image,
                                                        alt: "product"
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (shap_of_you_module_default()).imagePlaceholder
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (shap_of_you_module_default()).details,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: (shap_of_you_module_default()).title,
                                                            children: ((ref = item.product) === null || ref === void 0 ? void 0 : ref.title) || item.product_name || item.name
                                                        }),
                                                        item.data.purity && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            className: (shap_of_you_module_default()).meta,
                                                            children: [
                                                                "Purity: ",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: item.data.purity
                                                                })
                                                            ]
                                                        }),
                                                        item.diamond_shape && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            className: (shap_of_you_module_default()).meta,
                                                            children: [
                                                                "Diamond Shape: ",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: item.diamond_shape
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            className: (shap_of_you_module_default()).price,
                                                            children: [
                                                                "₹",
                                                                " ",
                                                                (item.product_discounted_price || item.product_price || item.price || 0).toLocaleString("en-IN")
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (shap_of_you_module_default()).mobile_actions_row,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    className: (shap_of_you_module_default()).mobile_icon_btn,
                                                    onClick: function() {
                                                        return handleWishlist(item);
                                                    },
                                                    disabled: wishlistLoadingId === item.id,
                                                    title: isInWishlist(item) ? "Remove from Wishlist" : "Add to Wishlist",
                                                    children: wishlistLoadingId === item.id ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                                                        animation: "border",
                                                        size: "sm"
                                                    }) : isInWishlist(item) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                        className: "bi bi-heart-fill",
                                                        style: {
                                                            color: "#FF1933"
                                                        }
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                        className: "bi bi-heart"
                                                    })
                                                }),
                                                ((ref1 = item.data) === null || ref1 === void 0 ? void 0 : ref1.is_limited_stock) == 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    onClick: function() {
                                                        return handleAddOneMore(item);
                                                    },
                                                    disabled: addOneMoreLoadingId === item.id,
                                                    className: (shap_of_you_module_default()).mobile_add_btn,
                                                    children: addOneMoreLoadingId === item.id ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                                                        animation: "border",
                                                        size: "sm"
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                className: "bi bi-plus-lg"
                                                            }),
                                                            " Add More"
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    onClick: function() {
                                                        return handleRemove(item);
                                                    },
                                                    disabled: removingId === item.id,
                                                    className: "".concat((shap_of_you_module_default()).mobile_icon_btn, " ").concat((shap_of_you_module_default()).mobile_remove_btn),
                                                    title: "Remove from cart",
                                                    children: removingId === item.id ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                                                        animation: "border",
                                                        size: "sm"
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                        className: "bi bi-trash"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }, item.id);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (shap_of_you_module_default()).footer1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    onClick: handleContinueShopping,
                                    className: "".concat((shap_of_you_module_default()).button, " ").concat((shap_of_you_module_default()).continueBtn),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                            width: "16",
                                            height: "16",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M19 12H5",
                                                    stroke: "#262121",
                                                    strokeWidth: "2",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M12 5L5 12L12 19",
                                                    stroke: "#262121",
                                                    strokeWidth: "2",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round"
                                                })
                                            ]
                                        }),
                                        "Continue Shopping"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    onClick: handleProceedToCheckout,
                                    className: "".concat((shap_of_you_module_default()).button, " ").concat((shap_of_you_module_default()).checkoutBtn),
                                    children: [
                                        "Proceed to Checkout",
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                            width: "16",
                                            height: "16",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M5 12H19",
                                                    stroke: "white",
                                                    strokeWidth: "2",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M12 5L19 12L12 19",
                                                    stroke: "white",
                                                    strokeWidth: "2",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var shape_of_you_mobile_CartModal = (CartModal);

;// CONCATENATED MODULE: ./src/components/shape-of-you-mobile/GalleryPermissionScreen.tsx


var GalleryPermissionScreen = function(param) {
    var navigateToStep = param.navigateToStep, onImageSelect = param.onImageSelect, logStep = param.logStep;
    var fileInputRef = (0,react.useRef)(null);
    // Check if gallery permission is already granted on mount
    (0,react.useEffect)(function() {
        var galleryPermission = localStorage.getItem("galleryPermissionGranted");
        if (galleryPermission === "true") {
            // Permission already granted - log it
            if (logStep) {
                logStep("gallery_permission_granted");
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Trigger file input when OK is clicked
    var handleOkClick = function() {
        var // Trigger file input
        ref;
        // Store permission in localStorage
        localStorage.setItem("galleryPermissionGranted", "true");
        // Log gallery permission granted (non-blocking)
        if (logStep) {
            logStep("gallery_permission_granted");
        }
        (ref = fileInputRef.current) === null || ref === void 0 ? void 0 : ref.click();
    };
    // Handle Don't Allow click
    var handleDontAllow = function() {
        // Log gallery permission denied (non-blocking)
        if (logStep) {
            logStep("gallery_permission_denied", {
                error_message: "User denied gallery permission"
            });
        }
        // Navigate to permission denied page
        navigateToStep("permissionDenied");
    };
    // Handle file selection
    var handleFileChange = function(event) {
        var ref;
        var file = (ref = event.target.files) === null || ref === void 0 ? void 0 : ref[0];
        if (file && onImageSelect) {
            var reader = new FileReader();
            reader.onloadend = function() {
                var base64String = reader.result;
                onImageSelect(base64String);
            };
            reader.readAsDataURL(file);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "d-md-none w-100",
        style: {
            backgroundColor: "transparent",
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "20px",
            fontFamily: "Sweet Sans Pro Regular"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            style: {
                backgroundColor: "transparent",
                borderRadius: "20px",
                padding: "20px",
                textAlign: "left",
                maxWidth: "300px",
                boxShadow: "0 4px 20px rgba(0,0,0,0.1)"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    style: {
                        fontSize: "18px",
                        fontWeight: "400",
                        marginBottom: "8px",
                        color: "#000"
                    },
                    children: "“Senco Gold” Would Like to Access Your Photos"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    style: {
                        fontSize: "13px",
                        color: "#666",
                        marginBottom: "20px",
                        lineHeight: "1.4"
                    },
                    children: "This app requires access to your gallery"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        display: "flex",
                        gap: "10px",
                        justifyContent: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            onClick: handleDontAllow,
                            style: {
                                flex: 1,
                                padding: "9px 10px",
                                backgroundColor: "#f0f0f0",
                                border: "none",
                                borderRadius: "20px",
                                fontSize: "15px",
                                fontWeight: "500",
                                color: "#333",
                                cursor: "pointer",
                                fontFamily: "Sweet Sans Pro Regular"
                            },
                            children: "Don't Allow"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            onClick: handleOkClick,
                            style: {
                                flex: 1,
                                padding: "9px 10px",
                                backgroundColor: "#007AFF",
                                border: "none",
                                borderRadius: "20px",
                                fontSize: "15px",
                                fontWeight: "500",
                                color: "white",
                                cursor: "pointer",
                                fontFamily: "Sweet Sans Pro Regular"
                            },
                            children: "OK"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                    ref: fileInputRef,
                    type: "file",
                    accept: "image/*",
                    style: {
                        display: "none"
                    },
                    onChange: handleFileChange
                })
            ]
        })
    });
};
/* harmony default export */ var shape_of_you_mobile_GalleryPermissionScreen = (GalleryPermissionScreen);

;// CONCATENATED MODULE: ./src/assets/images/image_sha.png
/* harmony default export */ var image_sha = ({"src":"/_next/static/media/image_sha.bccb99c2.png","height":852,"width":393,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAICAMAAADp7a43AAAAMFBMVEXOt6m8nYuZY0dLNSmegXCHWT2ca1NXQTUkGROBalvDrJ64gWB9aV3XwLKUeGd7Tzgbk02uAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAKUlEQVR4nAXBhwEAIAjAsLIEnP9/a0JXNfYsSR2G69jcWEKogAsHmfABD+kArWdKJykAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/components/shape-of-you-mobile/FaceResultScreen.tsx





var FaceResultScreen = function(param) {
    var navigateToStep = param.navigateToStep, isAuthenticated = param.isAuthenticated, faceShape = param.faceShape, complexion = param.complexion, capturedImage = param.capturedImage, captureMethod = param.captureMethod, onReupload = param.onReupload, onExploreJewellery = param.onExploreJewellery;
    var ref = (0,react.useState)(true), isExpanded = ref[0], setIsExpanded = ref[1];
    var toggleExpand = function() {
        setIsExpanded(!isExpanded);
    };
    var handleExploreClick = function() {
        // If we have onExploreJewellery callback from PhotoCaptureFlow, use it
        if (onExploreJewellery) {
            onExploreJewellery();
        } else {
            // Fallback: If user is already logged in, go directly to productView
            // Otherwise, go to login screen
            if (isAuthenticated) {
                navigateToStep("productView");
            } else {
                navigateToStep("login");
            }
        }
    };
    var handleReuploadClick = function() {
        // If we have onReupload callback from PhotoCaptureFlow, use it
        if (onReupload) {
            onReupload();
        } else {
            // Fallback: navigate to uploadOrScan
            navigateToStep("uploadOrScan");
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "d-md-none w-100",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (shap_of_you_module_default()).wrapper_reupload,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (shap_of_you_module_default()).image,
                    children: capturedImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: capturedImage,
                        alt: "Result",
                        className: (shap_of_you_module_default()).bg
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: image_sha,
                        alt: "Result",
                        className: (shap_of_you_module_default()).bg
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (shap_of_you_module_default()).faceInfoCard,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (shap_of_you_module_default()).toggleButton,
                            onClick: toggleExpand,
                            style: {
                                cursor: "pointer"
                            },
                            children: !isExpanded ? // Up arrow SVG (collapsed state)
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (shap_of_you_module_default()).svg_mark,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                    width: "18",
                                    height: "14",
                                    viewBox: "0 0 18 14",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M2.96094 5.5L8.80471 1.5L14.6485 5.5",
                                            stroke: "white",
                                            strokeOpacity: "0.31",
                                            strokeWidth: "3",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M1.5 12.25L8.80471 7.25L16.1094 12.25",
                                            stroke: "white",
                                            strokeWidth: "3",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round"
                                        })
                                    ]
                                })
                            }) : // Down arrow SVG (expanded state)
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                width: "173",
                                height: "36",
                                viewBox: "0 0 173 36",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("foreignObject", {
                                        x: "-6",
                                        y: "-5.99998",
                                        width: "185",
                                        height: "48",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            style: {
                                                backdropFilter: "blur(3px)",
                                                clipPath: "url(#bgblur_0_4559_2381_clip_path)",
                                                height: "100%",
                                                width: "100%"
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                        "data-figma-bg-blur-radius": "6",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M92.4653 20L86.4998 24L80.5343 20",
                                                stroke: "white",
                                                strokeOpacity: "0.31",
                                                strokeWidth: "3",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M93.957 13.25L86.5001 18.25L79.0432 13.25",
                                                stroke: "white",
                                                strokeWidth: "3",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                                            id: "bgblur_0_4559_2381_clip_path",
                                            transform: "translate(6 5.99998)",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M173 24C173 30.6274 167.627 36 161 36L12 36C5.37259 36 4.69686e-07 30.6274 1.04907e-06 24L2.09815e-06 12C2.67753e-06 5.37258 5.37259 4.69686e-07 12 1.04907e-06L161 1.40751e-05C167.627 1.46545e-05 173 5.3726 173 12L173 24Z"
                                            })
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "".concat((shap_of_you_module_default()).faceInfoContentContainer, " ").concat(isExpanded ? (shap_of_you_module_default()).expanded : (shap_of_you_module_default()).collapsed),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (shap_of_you_module_default()).faceInfoContent,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (shap_of_you_module_default()).faceInfoLeft,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (shap_of_you_module_default()).faceTypeValue,
                                                    children: faceShape || "Unknown"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (shap_of_you_module_default()).faceTypeLabel,
                                                    children: "Face Type"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (shap_of_you_module_default()).faceInfoDivider
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (shap_of_you_module_default()).faceInfoRight,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (shap_of_you_module_default()).skinToneValue,
                                                    children: complexion || "Unknown"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (shap_of_you_module_default()).skinToneLabel,
                                                    children: "Skin Tone"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (shap_of_you_module_default()).faceTypeDescription,
                                    children: faceShape && function() {
                                        var descriptions = {
                                            Heart: "Accentuate your delicate chin with elegant drops and dangles that add softness and refined symmetry.",
                                            Oblong: "Enhance your face with voluminous chandeliers and full drops that add width and harmonious balance.",
                                            Triangle: "Featuring an elegant taper from forehead to chin, bold drop styles add volume where it's needed most.",
                                            Oval: "Perfectly proportioned and endlessly versatile, every jewellery style, from contemporary to statement, complements you beautifully.",
                                            Round: "Celebrate your soft curves with striking, angular jewellery that adds beautiful contrast and definition.",
                                            Square: "Balance your strong jawline with fluid drops and pear-shaped designs that soften your look with effortless elegance."
                                        };
                                        var _faceShape;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                                    children: [
                                                        "Your Face Shape is ",
                                                        faceShape
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                (_faceShape = descriptions[faceShape]) !== null && _faceShape !== void 0 ? _faceShape : "".concat(faceShape, " faces are balanced and versatile")
                                            ]
                                        });
                                    }()
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (shap_of_you_module_default()).actions,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: (shap_of_you_module_default()).explore,
                            onClick: handleExploreClick,
                            children: "Explore Jewellery →"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            className: (shap_of_you_module_default()).reupload,
                            onClick: handleReuploadClick,
                            children: [
                                captureMethod === "scan" ? "Rescan" : "Reupload Image",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: captureMethod === "scan" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "bi bi-arrow-clockwise"
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                        width: "24",
                                        height: "24",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M15 8H15.01",
                                                stroke: "#262121",
                                                strokeWidth: "2",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M12.5 21H6C5.20435 21 4.44129 20.6839 3.87868 20.1213C3.31607 19.5587 3 18.7956 3 18V6C3 5.20435 3.31607 4.44129 3.87868 3.87868C4.44129 3.31607 5.20435 3 6 3H18C18.7956 3 19.5587 3.31607 20.1213 3.87868C20.6839 4.44129 21 5.20435 21 6V12.5",
                                                stroke: "#262121",
                                                strokeWidth: "2",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M3 15.9998L8 10.9998C8.928 10.1068 10.072 10.1068 11 10.9998L14.5 14.4998",
                                                stroke: "#262121",
                                                strokeWidth: "2",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M14 13.9999L15 12.9999C15.679 12.3469 16.473 12.1709 17.214 12.4739",
                                                stroke: "#262121",
                                                strokeWidth: "2",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M19 22V16",
                                                stroke: "#262121",
                                                strokeWidth: "2",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M22 19L19 16L16 19",
                                                stroke: "#262121",
                                                strokeWidth: "2",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var shape_of_you_mobile_FaceResultScreen = (FaceResultScreen);

;// CONCATENATED MODULE: ./src/components/shape-of-you-mobile/CameraPermissionScreen.tsx




var CameraPermissionScreen = function(param) {
    var navigateToStep = param.navigateToStep, logStep = param.logStep;
    var ref = (0,react.useState)(false), isRequesting = ref[0], setIsRequesting = ref[1];
    var ref1 = (0,react.useState)(true), isChecking = ref1[0], setIsChecking = ref1[1];
    // Check if camera permission is already granted on mount
    (0,react.useEffect)(function() {
        checkCameraPermission();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var checkCameraPermission = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var permissionStatus, persisted, cameraPermission;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setIsChecking(true);
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return navigator.permissions.query({
                            name: "camera"
                        });
                    case 4:
                        permissionStatus = _ctx.sent;
                        if (!(permissionStatus.state === "granted")) {
                            _ctx.next = 15;
                            break;
                        }
                        persisted = localStorage.getItem("cameraPermissionGranted");
                        if (!(persisted === "true")) {
                            _ctx.next = 11;
                            break;
                        }
                        if (logStep) {
                            logStep("camera_permission_granted");
                        }
                        navigateToStep("faceScanning");
                        return _ctx.abrupt("return");
                    case 11:
                        // Browser granted but app flag missing -> show dialog so user can confirm
                        setIsChecking(false);
                        return _ctx.abrupt("return");
                    case 15:
                        if (!(permissionStatus.state === "prompt")) {
                            _ctx.next = 20;
                            break;
                        }
                        // Need to request permission via modal
                        setIsChecking(false);
                        return _ctx.abrupt("return");
                    case 20:
                        if (!(permissionStatus.state === "denied")) {
                            _ctx.next = 24;
                            break;
                        }
                        // Previously denied
                        if (logStep) {
                            logStep("camera_permission_denied", {
                                error_message: "Browser camera permission denied"
                            });
                        }
                        navigateToStep("permissionDenied");
                        return _ctx.abrupt("return");
                    case 24:
                        _ctx.next = 29;
                        break;
                    case 26:
                        _ctx.prev = 26;
                        _ctx.t0 = _ctx["catch"](1);
                        ;
                    case 29:
                        cameraPermission = localStorage.getItem("cameraPermissionGranted");
                        if (!(cameraPermission === "true")) {
                            _ctx.next = 34;
                            break;
                        }
                        if (logStep) {
                            logStep("camera_permission_granted");
                        }
                        navigateToStep("faceScanning");
                        return _ctx.abrupt("return");
                    case 34:
                        // Permission not granted, show the dialog
                        setIsChecking(false);
                    case 35:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    26
                ]
            ]);
        }));
        return function checkCameraPermission() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleOkClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var stream;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setIsRequesting(true);
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return navigator.mediaDevices.getUserMedia({
                            video: {
                                facingMode: "user"
                            }
                        });
                    case 4:
                        stream = _ctx.sent;
                        // Permission granted! Stop the stream and save to localStorage
                        stream.getTracks().forEach(function(track) {
                            return track.stop();
                        });
                        localStorage.setItem("cameraPermissionGranted", "true");
                        // Log camera permission granted (non-blocking)
                        if (logStep) {
                            logStep("camera_permission_granted");
                        }
                        // Navigate to face scanning screen
                        navigateToStep("faceScanning");
                        _ctx.next = 16;
                        break;
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](1);
                        ;
                        // Log camera permission denied (non-blocking)
                        if (logStep) {
                            logStep("camera_permission_denied", {
                                error_message: "User denied camera permission"
                            });
                        }
                        // Permission denied - navigate to permission denied screen
                        navigateToStep("permissionDenied");
                    case 16:
                        _ctx.prev = 16;
                        setIsRequesting(false);
                        return _ctx.finish(16);
                    case 19:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    11,
                    16,
                    19
                ]
            ]);
        }));
        return function handleOkClick() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleDontAllow = function() {
        // Log camera permission denied (non-blocking)
        if (logStep) {
            logStep("camera_permission_denied", {
                error_message: "User chose not to allow camera permission"
            });
        }
        // Navigate to permission denied page
        navigateToStep("permissionDenied");
    };
    // Show nothing while checking permission (seamless transition)
    if (isChecking) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "d-md-none w-100",
        style: {
            background: "linear-gradient(180deg, #5e0000 0%, #5e0000 100%)",
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "20px",
            fontFamily: "Sweet Sans Pro Regular"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            style: {
                backgroundColor: "white",
                borderRadius: "20px",
                padding: "20px",
                textAlign: "left",
                maxWidth: "300px",
                boxShadow: "0 4px 20px rgba(0,0,0,0.3)"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    style: {
                        fontSize: "18px",
                        fontWeight: "400",
                        marginBottom: "8px",
                        color: "#000",
                        fontFamily: "Sweet Sans Pro Regular"
                    },
                    children: "“Senco Gold” Would Like To Access Your Camera"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    style: {
                        fontSize: "13px",
                        color: "#666",
                        marginBottom: "20px",
                        lineHeight: "1.4"
                    },
                    children: "This app requires access to camera"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        display: "flex",
                        gap: "10px",
                        justifyContent: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            onClick: handleDontAllow,
                            disabled: isRequesting,
                            style: {
                                flex: 1,
                                padding: "9px 10px",
                                backgroundColor: "#f0f0f0",
                                border: "none",
                                borderRadius: "20px",
                                fontSize: "15px",
                                fontWeight: "500",
                                color: "#333",
                                cursor: isRequesting ? "not-allowed" : "pointer",
                                opacity: isRequesting ? 0.6 : 1,
                                fontFamily: "Sweet Sans Pro Regular"
                            },
                            children: "Don't Allow"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            onClick: handleOkClick,
                            disabled: isRequesting,
                            style: {
                                flex: 1,
                                padding: "9px 10px",
                                backgroundColor: "#007AFF",
                                border: "none",
                                borderRadius: "20px",
                                fontSize: "15px",
                                fontWeight: "500",
                                color: "white",
                                cursor: isRequesting ? "not-allowed" : "pointer",
                                opacity: isRequesting ? 0.6 : 1,
                                fontFamily: "Sweet Sans Pro Regular"
                            },
                            children: isRequesting ? "Requesting..." : "OK"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var shape_of_you_mobile_CameraPermissionScreen = (CameraPermissionScreen);

// EXTERNAL MODULE: ./node_modules/react-webcam/dist/react-webcam.js
var react_webcam = __webpack_require__(64970);
var react_webcam_default = /*#__PURE__*/__webpack_require__.n(react_webcam);
;// CONCATENATED MODULE: ./src/components/shape-of-you-mobile/FaceScanningScreen.tsx





var FaceScanningScreen = function(param) {
    var navigateToStep = param.navigateToStep, onCapture = param.onCapture;
    var ref = (0,react.useState)(false), isCameraReady = ref[0], setIsCameraReady = ref[1];
    var ref1 = (0,react.useState)(null), capturedImage = ref1[0], setCapturedImage = ref1[1];
    var webcamRef = (0,react.useRef)(null);
    // Camera ready callback
    var handleCameraReady = function() {
        setIsCameraReady(true);
    };
    // Handle camera error
    var handleCameraError = function(error) {
        ;
        react_toastify_esm/* toast.error */.Am.error("Failed to access camera. Please check permissions.");
        // Navigate to permission denied screen
        navigateToStep("permissionDenied");
    };
    // Capture face from webcam
    var captureFace = (0,react.useCallback)(function() {
        if (webcamRef.current) {
            var imageSrc = webcamRef.current.getScreenshot();
            if (imageSrc && onCapture) {
                // Immediately freeze to captured image
                setCapturedImage(imageSrc);
                onCapture(imageSrc);
            } else {
                react_toastify_esm/* toast.error */.Am.error("Failed to capture image. Please try again.");
            }
        }
    }, [
        webcamRef,
        onCapture
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "d-md-none w-100",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (shap_of_you_module_default()).wrapper_face,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (shap_of_you_module_default()).image,
                    style: {
                        position: "relative"
                    },
                    children: [
                        !isCameraReady && !capturedImage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                backgroundColor: "rgba(0, 0, 0, 0.9)",
                                zIndex: 10
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                style: {
                                    textAlign: "center",
                                    color: "#fff"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "spinner-border text-light mb-3",
                                        role: "status",
                                        style: {
                                            width: "3rem",
                                            height: "3rem"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "visually-hidden",
                                            children: "Accessing camera..."
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        style: {
                                            fontSize: "1rem",
                                            fontWeight: "bold"
                                        },
                                        children: "Accessing your camera..."
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((react_webcam_default()), {
                            ref: webcamRef,
                            audio: false,
                            mirrored: true,
                            screenshotFormat: "image/jpeg",
                            videoConstraints: {
                                facingMode: "user",
                                width: {
                                    ideal: 640,
                                    min: 480
                                },
                                height: {
                                    ideal: 480,
                                    min: 360
                                },
                                aspectRatio: {
                                    ideal: 4 / 3
                                }
                            },
                            onUserMedia: handleCameraReady,
                            onUserMediaError: handleCameraError,
                            style: {
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                                objectPosition: "center center",
                                display: capturedImage ? "none" : "block"
                            }
                        }),
                        capturedImage && // eslint-disable-next-line @next/next/no-img-element
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: capturedImage,
                            alt: "Captured face",
                            style: {
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                                objectPosition: "center center",
                                zIndex: 1
                            }
                        }),
                        isCameraReady && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                    style: {
                                        height: "100%",
                                        width: "100%",
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        pointerEvents: "none",
                                        zIndex: 1
                                    },
                                    viewBox: "0 0 393 852",
                                    preserveAspectRatio: "xMidYMid slice",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("foreignObject", {
                                            x: "0",
                                            y: "0",
                                            width: "0",
                                            height: "0",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                style: {
                                                    backdropFilter: "blur(16px)",
                                                    clipPath: "url(#bgblur_0_4001_2030_clip_path)",
                                                    height: "100%",
                                                    width: "100%"
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M393 852H0V0H393V852ZM196.5 131C105.649 131 32 223.539 32 337.691C32.0001 394.192 50.0459 445.397 79.2871 482.707C85.431 493.711 91.4999 508.552 91.5 522.741C91.5 549.682 87.5 570.881 70.5 584.572C56.9001 595.525 32.8334 612.396 22.5 619.462V710L371.5 709.559V623.438C358.554 618.579 316.931 600.825 312 584.572C307.07 568.32 302.779 548.063 302 534.225C301.321 522.156 302.967 500.569 316.667 478.839C318.693 476.117 320.661 473.326 322.568 470.47C322.874 470.08 323.185 469.691 323.5 469.302H323.346C346.866 433.554 361 387.697 361 337.691C361 223.539 287.351 131 196.5 131Z",
                                            fill: "#000000",
                                            fillOpacity: "0.75"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M197 131C287.851 131 361.5 223.68 361.5 338.007C361.5 388.089 347.366 434.016 323.846 469.819H324C323.685 470.209 323.374 470.598 323.068 470.989C321.161 473.85 319.193 476.644 317.167 479.37C303.467 501.133 301.821 522.753 302.5 534.84C303.279 548.7 307.57 568.988 312.5 585.265C317.43 601.543 360.054 619.017 373 623.883V710H23V620.209C33.3333 613.131 57.4 596.235 71 585.265C88 571.553 92 550.322 92 523.34C92 509.129 85.9311 494.265 79.7871 483.244C50.5458 445.877 32.5 394.594 32.5 338.007C32.5 223.68 106.149 131 197 131Z",
                                            stroke: "white",
                                            strokeWidth: "4",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round",
                                            strokeDasharray: "12 12"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                                                id: "bgblur_0_4001_2030_clip_path",
                                                transform: "translate(0 0)",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M393 852H0V0H393V852ZM196.5 131C105.649 131 32 223.539 32 337.691C32.0001 394.192 50.0459 445.397 79.2871 482.707C85.431 493.711 91.4999 508.552 91.5 522.741C91.5 549.682 87.5 570.881 70.5 584.572C56.9001 595.525 32.8334 612.396 22.5 619.462V710L371.5 709.559V623.438C358.554 618.579 316.931 600.825 312 584.572C307.07 568.32 302.779 548.063 302 534.225C301.321 522.156 302.967 500.569 316.667 478.839C318.693 476.117 320.661 473.326 322.568 470.47C322.874 470.08 323.185 469.691 323.5 469.302H323.346C346.866 433.554 361 387.697 361 337.691C361 223.539 287.351 131 196.5 131Z"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        position: "absolute",
                                        top: "50px",
                                        left: "49%",
                                        transform: "translateX(-49%)",
                                        color: "#fff",
                                        textAlign: "center",
                                        fontSize: "15px",
                                        // fontWeight: "600",
                                        zIndex: 4,
                                        fontFamily: "Sweet Sans Pro Regular",
                                        backgroundColor: "transparent",
                                        padding: "10px 20px",
                                        borderRadius: "25px",
                                        // backdropFilter: "blur(10px)",
                                        // border: "1px solid rgba(255, 255, 255, 0.2)",
                                        whiteSpace: "nowrap"
                                    },
                                    children: "Position your face in the outline"
                                })
                            ]
                        })
                    ]
                }),
                isCameraReady && !capturedImage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        position: "absolute",
                        bottom: "40px",
                        left: "50%",
                        transform: "translateX(-50%)",
                        zIndex: 5,
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        padding: "0 20px"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        onClick: captureFace,
                        style: {
                            minWidth: "290px",
                            width: "100%",
                            maxWidth: "100%",
                            background: "rgba(210, 35, 42, 1)",
                            color: "#fff",
                            border: "none",
                            padding: "16px",
                            borderRadius: "40px",
                            fontSize: "20px",
                            fontFamily: "Sweet Sans Pro Medium",
                            cursor: "pointer"
                        },
                        onTouchStart: function(e) {
                            e.currentTarget.style.transform = "scale(0.95)";
                        },
                        onTouchEnd: function(e) {
                            e.currentTarget.style.transform = "scale(1)";
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                className: "me-2",
                                width: "28",
                                height: "28",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M7 3H5C3.89543 3 3 3.89543 3 5V7",
                                        stroke: "white",
                                        strokeWidth: "2.5",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M17 3H19C20.1046 3 21 3.89543 21 5V7",
                                        stroke: "white",
                                        strokeWidth: "2.5",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M15 9V11",
                                        stroke: "white",
                                        strokeWidth: "2.5",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M9 9V11",
                                        stroke: "white",
                                        strokeWidth: "2.5",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M9 15C9 15 10 16 12 16C14 16 15 15 15 15",
                                        stroke: "white",
                                        strokeWidth: "2.5",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M7 21H5C3.89543 21 3 20.1046 3 19V17",
                                        stroke: "white",
                                        strokeWidth: "2.5",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M17 21H19C20.1046 21 21 20.1046 21 19V17",
                                        stroke: "white",
                                        strokeWidth: "2.5",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "Scan Face"
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var shape_of_you_mobile_FaceScanningScreen = (FaceScanningScreen);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82175);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var yup_es = __webpack_require__(74231);
// EXTERNAL MODULE: ./src/utils/regex.ts
var regex = __webpack_require__(1233);
;// CONCATENATED MODULE: ./src/components/shape-of-you-mobile/LoginScreen.tsx
















var LoginScreen = function(param) {
    var navigateToStep = param.navigateToStep, authData = param.authData, logStep = param.logStep;
    var ref = (0,react.useState)(false), sendOtpLoading = ref[0], setSendOtpLoading = ref[1];
    // Login Formik
    var loginFormik = (0,formik_esm/* useFormik */.TA)({
        initialValues: {
            mobile: authData.mobileNumber || ""
        },
        validationSchema: yup_es/* object */.Ry({
            mobile: yup_es/* string */.Z_().matches(regex/* phoneRegExp */.O, "Mobile number is not valid").test("len", "Mobile number needs to be exactly 10 digits", function(val) {
                return (val === null || val === void 0 ? void 0 : val.toString().length) === 10;
            }).required("Mobile is required")
        }),
        onSubmit: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values) {
                var apiEndpoint, requestPayload, data, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            setSendOtpLoading(true);
                            apiEndpoint = endpoints/* default.auth.loginSendOtp */.Z.auth.loginSendOtp();
                            requestPayload = {
                                mobile: values.mobile
                            };
                            _ctx.prev = 3;
                            _ctx.next = 6;
                            return http_client/* default.post */.Z.post(apiEndpoint, requestPayload);
                        case 6:
                            data = _ctx.sent.data;
                            // Log successful OTP send (non-blocking)
                            if (logStep) {
                                logStep("signup_otp_sent", {
                                    api_endpoint: apiEndpoint,
                                    request_payload: requestPayload,
                                    response_status: 200,
                                    response_payload: {
                                        otp_uuid: data.otp_uuid
                                    },
                                    success_message: data.message
                                });
                            }
                            // Success - mobile exists, user can login
                            authData.setOtpUid(data.otp_uuid);
                            authData.setMobileNumber(values.mobile);
                            authData.setAuthFlow("login");
                            (0,react_toastify_esm/* toast */.Am)(data.message, {
                                type: "success",
                                toastId: "auth-otp-success"
                            });
                            navigateToStep("verifyOtp");
                            _ctx.next = 20;
                            break;
                        case 15:
                            _ctx.prev = 15;
                            _ctx.t0 = _ctx["catch"](3);
                            ;
                            // Log API error (non-blocking)
                            if (logStep) {
                                ;
                                logStep("signup_otp_sent", {
                                    api_endpoint: apiEndpoint,
                                    request_payload: requestPayload,
                                    response_status: ((ref3 = _ctx.t0.response) === null || ref3 === void 0 ? void 0 : ref3.status) || 500,
                                    error_message: ((ref4 = _ctx.t0.response) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.data) === null || ref5 === void 0 ? void 0 : ref5.message) || "Failed to send OTP",
                                    error_code: ((ref6 = _ctx.t0.response) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.status) === null || ref7 === void 0 ? void 0 : ref7.toString()) || "500"
                                });
                            }
                            // Check if error is "Mobile number does not exist"
                            if (((ref = _ctx.t0.response) === null || ref === void 0 ? void 0 : ref.status) === 400 && ((ref1 = _ctx.t0.response) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.data) === null || ref2 === void 0 ? void 0 : ref2.message) === "Mobile number does not exist") {
                                // Mobile doesn't exist - navigate to signup
                                authData.setMobileNumber(values.mobile);
                                authData.setAuthFlow("register");
                                authData.setRegisterData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, authData.registerData), {
                                    mobile: values.mobile
                                }));
                                (0,react_toastify_esm/* toast */.Am)("Mobile number not registered. Please sign up.", {
                                    type: "info",
                                    toastId: "auth-signup-required"
                                });
                                navigateToStep("signup");
                            } else {
                                ;
                                // Other errors
                                if ((ref8 = _ctx.t0.response) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.data) === null || ref9 === void 0 ? void 0 : ref9.message) {
                                    (0,react_toastify_esm/* toast */.Am)(_ctx.t0.response.data.message, {
                                        type: "error",
                                        toastId: "auth-otp-error"
                                    });
                                } else {
                                    (0,react_toastify_esm/* toast */.Am)("Something went wrong! Try again!", {
                                        type: "error",
                                        toastId: "auth-otp-error"
                                    });
                                }
                            }
                        case 20:
                            setSendOtpLoading(false);
                        case 21:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        3,
                        15
                    ]
                ]);
            }));
            return function(values) {
                return _ref.apply(this, arguments);
            };
        }()
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "d-md-none w-100",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (shap_of_you_module_default()).loginWrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (shap_of_you_module_default()).bgImage,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: WelcomeScreen,
                        alt: "Welcome Screen"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (shap_of_you_module_default()).hero,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (shap_of_you_module_default()).logo,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: SOYLockUp,
                            alt: "Shape of You Logo"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (shap_of_you_module_default()).card,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            children: "Login"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "Enter your phone number"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                            onSubmit: loginFormik.handleSubmit,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (shap_of_you_module_default()).inputBox,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            width: "24",
                                            height: "24",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M5 4H9L11 9L8.5 10.5C9.57096 12.6715 11.3285 14.429 13.5 15.5L15 13L20 15V19C20 19.5304 19.7893 20.0391 19.4142 20.4142C19.0391 20.7893 18.5304 21 18 21C14.0993 20.763 10.4202 19.1065 7.65683 16.3432C4.8935 13.5798 3.23705 9.90074 3 6C3 5.46957 3.21071 4.96086 3.58579 4.58579C3.96086 4.21071 4.46957 4 5 4Z",
                                                stroke: "#262121",
                                                strokeWidth: "2",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "tel",
                                            placeholder: "Phone Number",
                                            maxLength: 10,
                                            value: loginFormik.values.mobile,
                                            onChange: function(e) {
                                                var value = e.target.value.replace(/\D/g, "");
                                                loginFormik.setFieldValue("mobile", value);
                                            },
                                            onBlur: loginFormik.handleBlur
                                        })
                                    ]
                                }),
                                loginFormik.touched.mobile && loginFormik.errors.mobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                    className: "text-danger",
                                    style: {
                                        display: "block",
                                        marginTop: "5px",
                                        textAlign: "center"
                                    },
                                    children: loginFormik.errors.mobile
                                }) : null,
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    className: (shap_of_you_module_default()).btn,
                                    type: "submit",
                                    disabled: sendOtpLoading || !loginFormik.isValid || !loginFormik.values.mobile || loginFormik.values.mobile.length !== 10,
                                    style: sendOtpLoading || !loginFormik.isValid || !loginFormik.values.mobile || loginFormik.values.mobile.length !== 10 ? {
                                        background: "#d3d3d3",
                                        color: "#888",
                                        cursor: "not-allowed",
                                        opacity: 0.6
                                    } : {
                                        background: "#C9302C",
                                        color: "white",
                                        cursor: "pointer"
                                    },
                                    children: [
                                        sendOtpLoading ? "Sending..." : "Proceed",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "→"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var shape_of_you_mobile_LoginScreen = (LoginScreen);

;// CONCATENATED MODULE: ./src/components/shape-of-you-mobile/SignupScreen.tsx











var SignupScreen = function(param) {
    var navigateToStep = param.navigateToStep, authData = param.authData, logStep = param.logStep;
    var ref = (0,react.useState)(false), sendOtpLoading = ref[0], setSendOtpLoading = ref[1];
    // Register Formik
    var registerFormik = (0,formik_esm/* useFormik */.TA)({
        initialValues: {
            firstName: authData.registerData.firstName || "",
            lastName: authData.registerData.lastName || "",
            email: authData.registerData.email || "",
            mobile: authData.mobileNumber || authData.registerData.mobile || "",
            pincode: authData.registerData.pincode || ""
        },
        validationSchema: yup_es/* object */.Ry({
            firstName: yup_es/* string */.Z_().trim().required("First name is required"),
            lastName: yup_es/* string */.Z_().trim().required("Last name is required"),
            email: yup_es/* string */.Z_().required("Email is required").email("Email is invalid"),
            mobile: yup_es/* string */.Z_().matches(regex/* phoneRegExp */.O, "Mobile number is not valid").test("len", "Mobile number needs to be exactly 10 digits", function(val) {
                return (val === null || val === void 0 ? void 0 : val.toString().length) === 10;
            }).required("Mobile is required"),
            pincode: yup_es/* string */.Z_().required("Pincode is required").matches(/^\d{6}$/, "Invalid pincode. Must be a 6-digit number")
        }),
        onSubmit: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values) {
                var apiEndpoint, requestPayload, data, ref, ref1, ref2, ref3, ref4, ref5, ref6;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            setSendOtpLoading(true);
                            apiEndpoint = endpoints/* default.auth.sendOtp */.Z.auth.sendOtp();
                            requestPayload = {
                                mobile: values.mobile,
                                email: values.email,
                                pincode: values.pincode
                            };
                            _ctx.prev = 3;
                            _ctx.next = 6;
                            return http_client/* default.post */.Z.post(apiEndpoint, requestPayload);
                        case 6:
                            data = _ctx.sent.data;
                            // Log successful OTP send (non-blocking)
                            if (logStep) {
                                logStep("signup_otp_sent", {
                                    api_endpoint: apiEndpoint,
                                    request_payload: requestPayload,
                                    response_status: 200,
                                    response_payload: {
                                        otp_uuid: data.otp_uuid
                                    },
                                    success_message: data.message
                                });
                            }
                            // Success - OTP sent for registration
                            authData.setOtpUid(data.otp_uuid);
                            authData.setMobileNumber(values.mobile);
                            authData.setAuthFlow("register");
                            authData.setRegisterData({
                                firstName: values.firstName,
                                lastName: values.lastName,
                                email: values.email,
                                mobile: values.mobile,
                                pincode: values.pincode
                            });
                            (0,react_toastify_esm/* toast */.Am)(data.message, {
                                type: "success",
                                toastId: "auth-otp-success"
                            });
                            navigateToStep("verifyOtp");
                            _ctx.next = 21;
                            break;
                        case 16:
                            _ctx.prev = 16;
                            _ctx.t0 = _ctx["catch"](3);
                            ;
                            // Log API error (non-blocking)
                            if (logStep) {
                                ;
                                logStep("signup_otp_sent", {
                                    api_endpoint: apiEndpoint,
                                    request_payload: requestPayload,
                                    response_status: ((ref2 = _ctx.t0.response) === null || ref2 === void 0 ? void 0 : ref2.status) || 500,
                                    error_message: ((ref3 = _ctx.t0.response) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.data) === null || ref4 === void 0 ? void 0 : ref4.message) || "Failed to send OTP",
                                    error_code: ((ref5 = _ctx.t0.response) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.status) === null || ref6 === void 0 ? void 0 : ref6.toString()) || "500"
                                });
                            }
                            if ((ref = _ctx.t0.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.message) {
                                (0,react_toastify_esm/* toast */.Am)(_ctx.t0.response.data.message, {
                                    type: "error",
                                    toastId: "auth-otp-error"
                                });
                            } else {
                                (0,react_toastify_esm/* toast */.Am)("Something went wrong! Try again!", {
                                    type: "error",
                                    toastId: "auth-otp-error"
                                });
                            }
                        case 21:
                            setSendOtpLoading(false);
                        case 22:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        3,
                        16
                    ]
                ]);
            }));
            return function(values) {
                return _ref.apply(this, arguments);
            };
        }()
    });
    // Update mobile number in formik when it comes from authData
    (0,react.useEffect)(function() {
        if (authData.mobileNumber && !registerFormik.values.mobile) {
            registerFormik.setFieldValue("mobile", authData.mobileNumber);
        }
    }, [
        authData.mobileNumber
    ]);
    var isFormComplete = registerFormik.values.firstName && registerFormik.values.lastName && registerFormik.values.email && registerFormik.values.mobile && registerFormik.values.pincode && registerFormik.isValid;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "d-md-none w-100",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (shap_of_you_module_default()).wrappersignup,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    children: "Enter Your Details"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "Let us get to know you better"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    className: (shap_of_you_module_default()).form,
                    onSubmit: registerFormik.handleSubmit,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (shap_of_you_module_default()).inputBox,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                            width: "24",
                                            height: "24",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                                    clipPath: "url(#clip0_4001_1148)",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M8 7C8 8.06087 8.42143 9.07828 9.17157 9.82843C9.92172 10.5786 10.9391 11 12 11C13.0609 11 14.0783 10.5786 14.8284 9.82843C15.5786 9.07828 16 8.06087 16 7C16 5.93913 15.5786 4.92172 14.8284 4.17157C14.0783 3.42143 13.0609 3 12 3C10.9391 3 9.92172 3.42143 9.17157 4.17157C8.42143 4.92172 8 5.93913 8 7Z",
                                                            stroke: "#262121",
                                                            strokeWidth: "2",
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M6 21V19C6 17.9391 6.42143 16.9217 7.17157 16.1716C7.92172 15.4214 8.93913 15 10 15H14C15.0609 15 16.0783 15.4214 16.8284 16.1716C17.5786 16.9217 18 17.9391 18 19V21",
                                                            stroke: "#262121",
                                                            strokeWidth: "2",
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                                                        id: "clip0_4001_1148",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                                            width: "24",
                                                            height: "24",
                                                            fill: "white"
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "text",
                                            placeholder: "First Name",
                                            value: registerFormik.values.firstName,
                                            onChange: function(e) {
                                                return registerFormik.setFieldValue("firstName", e.target.value);
                                            },
                                            onBlur: registerFormik.handleBlur
                                        })
                                    ]
                                }),
                                registerFormik.touched.firstName && registerFormik.errors.firstName ? /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                    className: "text-danger",
                                    style: {
                                        display: "block",
                                        marginTop: "5px"
                                    },
                                    children: registerFormik.errors.firstName
                                }) : null,
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (shap_of_you_module_default()).inputBox,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                            width: "24",
                                            height: "24",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                                    clipPath: "url(#clip0_4001_1149)",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M8 7C8 8.06087 8.42143 9.07828 9.17157 9.82843C9.92172 10.5786 10.9391 11 12 11C13.0609 11 14.0783 10.5786 14.8284 9.82843C15.5786 9.07828 16 8.06087 16 7C16 5.93913 15.5786 4.92172 14.8284 4.17157C14.0783 3.42143 13.0609 3 12 3C10.9391 3 9.92172 3.42143 9.17157 4.17157C8.42143 4.92172 8 5.93913 8 7Z",
                                                            stroke: "#262121",
                                                            strokeWidth: "2",
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M6 21V19C6 17.9391 6.42143 16.9217 7.17157 16.1716C7.92172 15.4214 8.93913 15 10 15H14C15.0609 15 16.0783 15.4214 16.8284 16.1716C17.5786 16.9217 18 17.9391 18 19V21",
                                                            stroke: "#262121",
                                                            strokeWidth: "2",
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                                                        id: "clip0_4001_1149",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                                            width: "24",
                                                            height: "24",
                                                            fill: "white"
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "text",
                                            placeholder: "Last Name",
                                            value: registerFormik.values.lastName,
                                            onChange: function(e) {
                                                return registerFormik.setFieldValue("lastName", e.target.value);
                                            },
                                            onBlur: registerFormik.handleBlur
                                        })
                                    ]
                                }),
                                registerFormik.touched.lastName && registerFormik.errors.lastName ? /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                    className: "text-danger",
                                    style: {
                                        display: "block",
                                        marginTop: "5px"
                                    },
                                    children: registerFormik.errors.lastName
                                }) : null,
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat((shap_of_you_module_default()).inputBox, " ").concat((shap_of_you_module_default()).disabled),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            width: "24",
                                            height: "24",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M5 4H9L11 9L8.5 10.5C9.57096 12.6715 11.3285 14.429 13.5 15.5L15 13L20 15V19C20 19.5304 19.7893 20.0391 19.4142 20.4142C19.0391 20.7893 18.5304 21 18 21C14.0993 20.763 10.4202 19.1065 7.65683 16.3432C4.8935 13.5798 3.23705 9.90074 3 6C3 5.46957 3.21071 4.96086 3.58579 4.58579C3.96086 4.21071 4.46957 4 5 4Z",
                                                stroke: "#858585",
                                                strokeWidth: "2",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "+91"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (shap_of_you_module_default()).divider
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "text",
                                            value: registerFormik.values.mobile,
                                            disabled: true
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (shap_of_you_module_default()).inputBox,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                            width: "24",
                                            height: "24",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M3 7C3 6.46957 3.21071 5.96086 3.58579 5.58579C3.96086 5.21071 4.46957 5 5 5H19C19.5304 5 20.0391 5.21071 20.4142 5.58579C20.7893 5.96086 21 6.46957 21 7V17C21 17.5304 20.7893 18.0391 20.4142 18.4142C20.0391 18.7893 19.5304 19 19 19H5C4.46957 19 3.96086 18.7893 3.58579 18.4142C3.21071 18.0391 3 17.5304 3 17V7Z",
                                                    stroke: "#262121",
                                                    strokeWidth: "2",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M3 7L12 13L21 7",
                                                    stroke: "#262121",
                                                    strokeWidth: "2",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "email",
                                            placeholder: "E-Mail ID",
                                            value: registerFormik.values.email,
                                            onChange: function(e) {
                                                return registerFormik.setFieldValue("email", e.target.value);
                                            },
                                            onBlur: registerFormik.handleBlur
                                        })
                                    ]
                                }),
                                registerFormik.touched.email && registerFormik.errors.email ? /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                    className: "text-danger",
                                    style: {
                                        display: "block",
                                        marginTop: "5px"
                                    },
                                    children: registerFormik.errors.email
                                }) : null,
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (shap_of_you_module_default()).inputBox,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                            width: "24",
                                            height: "24",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M9 12C9 12.7956 9.31607 13.5587 9.87868 14.1213C10.4413 14.6839 11.2044 15 12 15C12.7956 15 13.5587 14.6839 14.1213 14.1213C14.6839 13.5587 15 12.7956 15 12C15 11.2044 14.6839 10.4413 14.1213 9.87868C13.5587 9.31607 12.7956 9 12 9C11.2044 9 10.4413 9.31607 9.87868 9.87868C9.31607 10.4413 9 11.2044 9 12Z",
                                                    stroke: "#262121",
                                                    strokeWidth: "2",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12Z",
                                                    stroke: "#262121",
                                                    strokeWidth: "2",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M12 2V4",
                                                    stroke: "#262121",
                                                    strokeWidth: "2",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M12 20V22",
                                                    stroke: "#262121",
                                                    strokeWidth: "2",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M20 12H22",
                                                    stroke: "#262121",
                                                    strokeWidth: "2",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M2 12H4",
                                                    stroke: "#262121",
                                                    strokeWidth: "2",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "number",
                                            placeholder: "Pincode",
                                            maxLength: 6,
                                            value: registerFormik.values.pincode,
                                            onChange: function(e) {
                                                var value = e.target.value.replace(/\D/g, "");
                                                if (value.length <= 6) {
                                                    registerFormik.setFieldValue("pincode", value);
                                                }
                                            },
                                            onBlur: registerFormik.handleBlur
                                        })
                                    ]
                                }),
                                registerFormik.touched.pincode && registerFormik.errors.pincode ? /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                    className: "text-danger",
                                    style: {
                                        display: "block",
                                        marginTop: "5px"
                                    },
                                    children: registerFormik.errors.pincode
                                }) : null,
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    style: {
                                        textAlign: "center",
                                        marginTop: "16px",
                                        marginBottom: "0",
                                        fontSize: "14px",
                                        color: "#262121"
                                    },
                                    children: [
                                        "Already a registered user?",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            onClick: function() {
                                                return navigateToStep("login");
                                            },
                                            style: {
                                                color: "#C9302C",
                                                cursor: "pointer",
                                                fontWeight: 600
                                            },
                                            children: "Login"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            className: (shap_of_you_module_default()).btn,
                            type: "submit",
                            disabled: sendOtpLoading || !isFormComplete,
                            style: sendOtpLoading || !isFormComplete ? {
                                background: "#d3d3d3",
                                color: "#888",
                                cursor: "not-allowed",
                                opacity: 0.6
                            } : {
                                background: "#C9302C",
                                color: "white",
                                cursor: "pointer"
                            },
                            children: [
                                sendOtpLoading ? "Sending..." : "Send OTP",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "→"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var shape_of_you_mobile_SignupScreen = (SignupScreen);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/cookies-next/lib/index.js
var lib = __webpack_require__(47041);
// EXTERNAL MODULE: ./src/lib/tryOnTracking.ts
var tryOnTracking = __webpack_require__(68763);
// EXTERNAL MODULE: ./node_modules/moment-timezone/index.js
var moment_timezone = __webpack_require__(80008);
var moment_timezone_default = /*#__PURE__*/__webpack_require__.n(moment_timezone);
;// CONCATENATED MODULE: ./src/components/shape-of-you-mobile/VerifyOtpScreen.tsx






















var RESEND_OTP_INTERVAL_SECONDS = 30;
var VerifyOtpScreen = function(param) {
    var navigateToStep = param.navigateToStep, authData = param.authData, onAuthComplete = param.onAuthComplete, logStep = param.logStep;
    var dispatch = (0,store/* useAppDispatch */.T)();
    var ref = (0,react.useState)(false), loading = ref[0], setLoading = ref[1];
    var ref1 = (0,react.useState)(false), sendOtpLoading = ref1[0], setSendOtpLoading = ref1[1];
    var ref2 = (0,react.useState)(RESEND_OTP_INTERVAL_SECONDS), resendTimeout = ref2[0], setResendTimeout = ref2[1];
    var ref3 = (0,react.useState)([
        "",
        "",
        "",
        "",
        "",
        ""
    ]), otpValues = ref3[0], setOtpValues = ref3[1];
    var ref4 = (0,react.useState)("idle"), verificationStatus = ref4[0], setVerificationStatus = ref4[1];
    var ref5 = (0,react.useState)(null), accessToken = ref5[0], setAccessToken = ref5[1];
    var currentDate = moment_timezone_default()().format("DD-MM-YYYY");
    var isOtpComplete = otpValues.every(function(val) {
        return val !== "";
    });
    // Countdown timer for resend OTP
    (0,react.useEffect)(function() {
        if (resendTimeout > 0) {
            var timer = setInterval(function() {
                setResendTimeout(resendTimeout - 1);
            }, 1000);
            return function() {
                return clearInterval(timer);
            };
        }
    }, [
        resendTimeout
    ]);
    // OTP Formik
    var otpFormik = (0,formik_esm/* useFormik */.TA)({
        initialValues: {
            otp: ""
        },
        validationSchema: yup_es/* object */.Ry({
            otp: yup_es/* string */.Z_().required("OTP is required").min(6, "Must be exactly 6 digits").max(6, "Must be exactly 6 digits").matches(/^\d{6}$/, "OTP must be 6 digits")
        }),
        onSubmit: function() {}
    });
    // Step 1: Verify OTP (without navigating)
    var handleVerifyOtp = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var otpString, apiEndpoint, requestPayload, data, apiEndpoint1, requestPayload1, data1, ref, ref1, ref2, ref3, ref4, ref5, stepName, ref6, ref7;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setVerificationStatus("verifying");
                        setLoading(true);
                        _ctx.prev = 2;
                        otpString = otpValues.join("");
                        if (!(authData.authFlow === "login")) {
                            _ctx.next = 17;
                            break;
                        }
                        apiEndpoint = endpoints/* default.auth.loginVerifyOtp */.Z.auth.loginVerifyOtp();
                        requestPayload = {
                            mobile: authData.mobileNumber,
                            otp: otpString,
                            otp_uuid: authData.otpUid
                        };
                        _ctx.next = 9;
                        return http_client/* default.post */.Z.post(apiEndpoint, requestPayload);
                    case 9:
                        data = _ctx.sent.data;
                        // Log successful login (non-blocking)
                        if (logStep) {
                            logStep("signup_login_success", {
                                api_endpoint: apiEndpoint,
                                request_payload: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, requestPayload), {
                                    otp: "******"
                                }),
                                response_status: 200,
                                response_payload: {
                                    access_token: "[token]"
                                },
                                success_message: "Login successful"
                            });
                            // Also log generic login/register success
                            logStep("signup_login_success", {
                                api_endpoint: apiEndpoint,
                                response_status: 200,
                                success_message: "Login successful"
                            });
                        }
                        // Store access token and set verified status
                        setAccessToken(data === null || data === void 0 ? void 0 : data.access_token);
                        setVerificationStatus("verified");
                        _ctx.next = 15;
                        return handleAutoLogin(data === null || data === void 0 ? void 0 : data.access_token);
                    case 15:
                        _ctx.next = 29;
                        break;
                    case 17:
                        apiEndpoint1 = endpoints/* default.auth.signup */.Z.auth.signup();
                        requestPayload1 = {
                            name: "".concat(authData.registerData.firstName, " ").concat(authData.registerData.lastName),
                            mobile: authData.mobileNumber,
                            email: authData.registerData.email,
                            pincode: authData.registerData.pincode,
                            otp: otpString,
                            otp_uuid: authData.otpUid,
                            source: "shape_of_you"
                        };
                        _ctx.next = 21;
                        return http_client/* default.post */.Z.post(apiEndpoint1, requestPayload1);
                    case 21:
                        data1 = _ctx.sent.data;
                        // Log successful registration (non-blocking)
                        if (logStep) {
                            logStep("signup_register_success", {
                                api_endpoint: apiEndpoint1,
                                request_payload: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, requestPayload1), {
                                    otp: "******"
                                }),
                                response_status: 200,
                                response_payload: {
                                    access_token: "[token]"
                                },
                                success_message: "Registration successful"
                            });
                            // Also log generic login/register success
                            logStep("signup_register_success", {
                                api_endpoint: apiEndpoint1,
                                response_status: 200,
                                success_message: "Registration successful"
                            });
                        }
                        // Track registration events
                        if (window.Moengage) {
                            window.Moengage.track_event("Registration Completed", {
                                mobile: authData.mobileNumber,
                                platform: "website"
                            });
                        }
                        if (window.smartech) {
                            (0,unbxd/* unbxdCusEngTrackUser */.nV)({
                                "pk^mobile": authData.mobileNumber,
                                NAME: "".concat(authData.registerData.firstName, " ").concat(authData.registerData.lastName),
                                email: authData.registerData.email,
                                PINCODE: authData.registerData.pincode,
                                SENCO_USER: "yes",
                                REGISTRATION_DATE_SENCO: currentDate
                            });
                            window.smartech("identify", authData.mobileNumber);
                            setTimeout(function() {
                                (0,unbxd/* unbxdCusEngTrackEvent */.$z)("Registration", {
                                    source: "web",
                                    platform: "senco"
                                });
                            }, 200);
                        }
                        // Store access token and set verified status
                        setAccessToken(data1.access_token);
                        setVerificationStatus("verified");
                        _ctx.next = 29;
                        return handleAutoLogin(data1.access_token);
                    case 29:
                        _ctx.next = 36;
                        break;
                    case 31:
                        _ctx.prev = 31;
                        _ctx.t0 = _ctx["catch"](2);
                        ;
                        // Log API error (non-blocking)
                        if (logStep) {
                            ;
                            stepName = authData.authFlow === "login" ? "signup_login_success" : "signup_register_success";
                            logStep(stepName, {
                                api_endpoint: authData.authFlow === "login" ? endpoints/* default.auth.loginVerifyOtp */.Z.auth.loginVerifyOtp() : endpoints/* default.auth.signup */.Z.auth.signup(),
                                response_status: ((ref1 = _ctx.t0.response) === null || ref1 === void 0 ? void 0 : ref1.status) || 500,
                                error_message: ((ref2 = _ctx.t0.response) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : ref3.message) || "OTP verification failed",
                                error_code: ((ref4 = _ctx.t0.response) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.status) === null || ref5 === void 0 ? void 0 : ref5.toString()) || "500"
                            });
                        }
                        // Check if error is "OTP does not match"
                        if (((ref = _ctx.t0.response) === null || ref === void 0 ? void 0 : ref.status) === 400) {
                            setVerificationStatus("error");
                        } else {
                            ;
                            setVerificationStatus("error");
                            if ((ref6 = _ctx.t0.response) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.data) === null || ref7 === void 0 ? void 0 : ref7.message) {
                                (0,react_toastify_esm/* toast */.Am)(_ctx.t0.response.data.message, {
                                    type: "error",
                                    toastId: "auth-otp-error"
                                });
                            } else {
                                (0,react_toastify_esm/* toast */.Am)("Something went wrong! Try again!", {
                                    type: "error",
                                    toastId: "auth-otp-error"
                                });
                            }
                        }
                    case 36:
                        setLoading(false);
                    case 37:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    31
                ]
            ]);
        }));
        return function handleVerifyOtp() {
            return _ref.apply(this, arguments);
        };
    }();
    // Auto-login after successful registration/login
    var handleAutoLogin = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(token) {
            var ref, user, pendingConsent;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        (0,lib.setCookies)("token", token, {
                            path: "/"
                        });
                        _ctx.next = 4;
                        return dispatch((0,auth/* fetchAuthUser */.zA)());
                    case 4:
                        ref = _ctx.sent;
                        user = ref.payload;
                        (0,react_toastify_esm/* toast */.Am)("Welcome ".concat(user.name), {
                            type: "success",
                            toastId: "auth-login-success"
                        });
                        if (window.Moengage) {
                            window.Moengage.track_event("Login", {
                                mobile: user.mobile
                            });
                            window.Moengage.add_first_name(user.name);
                            window.Moengage.add_mobile(user.mobile);
                            window.Moengage.add_unique_user_id(user.uuid);
                            if (user.email) {
                                window.Moengage.add_email(user.email);
                            }
                        }
                        if (window.smartech) {
                            (0,unbxd/* unbxdCusEngTrackUser */.nV)({
                                "pk^mobile": user === null || user === void 0 ? void 0 : user.mobile,
                                SENCO_USER: "yes"
                            });
                            window.smartech("identify", user === null || user === void 0 ? void 0 : user.mobile);
                            (0,unbxd/* unbxdCusEngTrackEvent */.$z)("Sign in ", {
                                source: "web",
                                platform: "senco"
                            });
                        }
                        dispatch((0,cart/* fetchCartItems */.Vw)());
                        dispatch((0,wishlist/* fetchWishlistItems */.nf)(user.id));
                        (0,tryOnTracking/* initTryOnTracking */.j)(user.id);
                        pendingConsent = localStorage.getItem("pendingConsentAcceptance");
                        if (!(pendingConsent === "true")) {
                            _ctx.next = 24;
                            break;
                        }
                        _ctx.prev = 14;
                        _ctx.next = 17;
                        return http_client/* default.post */.Z.post(endpoints/* default.auth.updateConsentForm */.Z.auth.updateConsentForm(), {
                            status: "accept"
                        });
                    case 17:
                        // Clear the localStorage flag
                        localStorage.removeItem("pendingConsentAcceptance");
                        ;
                        _ctx.next = 24;
                        break;
                    case 21:
                        _ctx.prev = 21;
                        _ctx.t0 = _ctx["catch"](14);
                        ;
                    case 24:
                        // Call parent completion handler or fallback to navigation
                        if (onAuthComplete) {
                            onAuthComplete();
                        } else {
                            // Fallback: Navigate to product view after successful login
                            navigateToStep("productView");
                        }
                        _ctx.next = 31;
                        break;
                    case 27:
                        _ctx.prev = 27;
                        _ctx.t1 = _ctx["catch"](0);
                        ;
                        (0,react_toastify_esm/* toast */.Am)("Login successful but failed to fetch user data", {
                            type: "warning",
                            toastId: "auth-warning"
                        });
                    case 31:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    27
                ],
                [
                    14,
                    21
                ]
            ]);
        }));
        return function handleAutoLogin(token) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleOtpChange = function(index, value) {
        if (value.length <= 1 && /^\d*$/.test(value)) {
            var newOtpValues = (0,_to_consumable_array/* default */.Z)(otpValues);
            newOtpValues[index] = value;
            setOtpValues(newOtpValues);
            // Reset verification status when user modifies OTP
            if (verificationStatus === "error" || verificationStatus === "verified") {
                setVerificationStatus("idle");
            }
            // Update formik value
            var otpString = newOtpValues.join("");
            otpFormik.setFieldValue("otp", otpString, false);
            // Auto-focus next input
            if (value && index < 5) {
                var nextInput = document.getElementById("otp-".concat(index + 1));
                nextInput === null || nextInput === void 0 ? void 0 : nextInput.focus();
            }
        }
    };
    var handleOtpKeyDown = function(index, e) {
        if (e.key === "Backspace" && !otpValues[index] && index > 0) {
            var prevInput = document.getElementById("otp-".concat(index - 1));
            prevInput === null || prevInput === void 0 ? void 0 : prevInput.focus();
        }
    };
    // Handle resend OTP
    var handleResendOtp = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var apiEndpoint, requestPayload, data, ref, ref1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(resendTimeout > 0)) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        setSendOtpLoading(true);
                        _ctx.prev = 3;
                        ;
                        ;
                        if (authData.authFlow === "login") {
                            apiEndpoint = endpoints/* default.auth.loginSendOtp */.Z.auth.loginSendOtp();
                            requestPayload = {
                                mobile: authData.mobileNumber
                            };
                        } else {
                            // Register flow - use the same endpoint as SignupScreen
                            apiEndpoint = endpoints/* default.auth.sendOtp */.Z.auth.sendOtp();
                            requestPayload = {
                                mobile: authData.mobileNumber,
                                email: authData.registerData.email,
                                pincode: authData.registerData.pincode
                            };
                        }
                        _ctx.next = 9;
                        return http_client/* default.post */.Z.post(apiEndpoint, requestPayload);
                    case 9:
                        data = _ctx.sent.data;
                        (0,react_toastify_esm/* toast */.Am)(data.message || "OTP resent successfully", {
                            type: "success",
                            toastId: "auth-otp-resend-success"
                        });
                        // Reset timer
                        setResendTimeout(RESEND_OTP_INTERVAL_SECONDS);
                        _ctx.next = 18;
                        break;
                    case 14:
                        _ctx.prev = 14;
                        _ctx.t0 = _ctx["catch"](3);
                        ;
                        if ((ref = _ctx.t0.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.message) {
                            (0,react_toastify_esm/* toast */.Am)(_ctx.t0.response.data.message, {
                                type: "error",
                                toastId: "auth-otp-resend-error"
                            });
                        } else {
                            (0,react_toastify_esm/* toast */.Am)("Failed to resend OTP. Please try again!", {
                                type: "error",
                                toastId: "auth-otp-resend-error"
                            });
                        }
                    case 18:
                        setSendOtpLoading(false);
                    case 19:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    3,
                    14
                ]
            ]);
        }));
        return function handleResendOtp() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "d-md-none w-100",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "".concat((shap_of_you_module_default()).wrappersignup, " ").concat((shap_of_you_module_default()).wrappersignup_otp),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (shap_of_you_module_default()).max_h,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            style: {
                                color: "#d61f26",
                                fontSize: "40px",
                                marginBottom: "6px",
                                fontFamily: "daisihill"
                            },
                            children: "Verify OTP"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            style: {
                                color: "#444",
                                fontSize: "14px",
                                marginBottom: "40px"
                            },
                            children: "OTP has been sent to your phone number"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                            onSubmit: otpFormik.handleSubmit,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        display: "flex",
                                        gap: "8px",
                                        justifyContent: "center",
                                        marginBottom: "40px"
                                    },
                                    children: [
                                        0,
                                        1,
                                        2,
                                        3,
                                        4,
                                        5
                                    ].map(function(index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            id: "otp-".concat(index),
                                            type: "number",
                                            maxLength: 1,
                                            value: otpValues[index],
                                            onChange: function(e) {
                                                return handleOtpChange(index, e.target.value);
                                            },
                                            onKeyDown: function(e) {
                                                return handleOtpKeyDown(index, e);
                                            },
                                            style: {
                                                width: "48px",
                                                height: "56px",
                                                border: verificationStatus === "error" ? "2px solid #dc3545" : // ? "2px solid #28a745"
                                                "1px solid #a09c9c",
                                                backgroundColor: verificationStatus === "error" ? "#ffe6e6" : // ? "#e6f7e6"
                                                "white",
                                                borderRadius: "8px",
                                                textAlign: "center",
                                                fontSize: "22px",
                                                fontWeight: "600",
                                                color: "#262121",
                                                flex: "0 0 auto"
                                            }
                                        }, index);
                                    })
                                }),
                                verificationStatus === "error" && /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                    className: "text-danger",
                                    style: {
                                        display: "block",
                                        marginTop: "-30px",
                                        marginBottom: "10px",
                                        textAlign: "left",
                                        fontSize: "14px",
                                        fontWeight: "600",
                                        color: "#dc3545"
                                    },
                                    children: "Error! OTP incorrect"
                                }),
                                otpFormik.touched.otp && otpFormik.errors.otp ? /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                    className: "text-danger",
                                    style: {
                                        display: "block",
                                        marginTop: "10px",
                                        marginBottom: "10px",
                                        textAlign: "center"
                                    },
                                    children: otpFormik.errors.otp
                                }) : null,
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    style: {
                                        marginTop: "20px",
                                        fontSize: "14px",
                                        fontFamily: "Sweet Sans Pro Regular"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            style: {
                                                marginBottom: "5px",
                                                fontSize: "12px",
                                                color: resendTimeout > 0 ? "#666" : "#ccc",
                                                fontFamily: "Sweet Sans Pro Regular"
                                            },
                                            children: [
                                                "(OTP Timer ",
                                                resendTimeout > 0 ? "".concat(resendTimeout, "s") : "over",
                                                ")"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            style: {
                                                color: "#999",
                                                marginRight: "5px"
                                            },
                                            children: "Didn't get an OTP?"
                                        }),
                                        resendTimeout > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            style: {
                                                color: "#ccc",
                                                cursor: "not-allowed"
                                            },
                                            children: "Resend OTP"
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                            onClick: handleResendOtp,
                                            disabled: sendOtpLoading,
                                            style: {
                                                background: "transparent",
                                                border: "none",
                                                color: "#007bff",
                                                fontSize: "14px",
                                                textDecoration: "underline",
                                                cursor: sendOtpLoading ? "not-allowed" : "pointer",
                                                fontFamily: "Sweet Sans Pro Medium",
                                                padding: 0
                                            },
                                            children: [
                                                "Resend OTP",
                                                " ",
                                                sendOtpLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                                                    animation: "border",
                                                    size: "sm"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (shap_of_you_module_default()).btn_nn,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            style: {
                                background: "transparent",
                                border: "none",
                                color: "#262121",
                                fontSize: "20px",
                                textDecoration: "none",
                                cursor: "pointer",
                                marginBottom: "20px",
                                display: "flex",
                                alignItems: "center",
                                gap: "5px",
                                margin: "0 auto 20px",
                                fontFamily: "Sweet Sans Pro Medium"
                            },
                            onClick: function() {
                                return navigateToStep("login");
                            },
                            children: [
                                "Edit Phone Number",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                    width: "24",
                                    height: "24",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M16.4249 4.60509L17.4149 3.6151C18.2351 2.79497 19.5648 2.79497 20.3849 3.6151C21.205 4.43524 21.205 5.76493 20.3849 6.58507L19.3949 7.57506M16.4249 4.60509L9.76558 11.2644C9.25807 11.772 8.89804 12.4078 8.72397 13.1041L8 16L10.8959 15.276C11.5922 15.102 12.228 14.7419 12.7356 14.2344L19.3949 7.57506M16.4249 4.60509L19.3949 7.57506",
                                            stroke: "#262121",
                                            strokeWidth: "2",
                                            strokeLinejoin: "round"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M18.9999 13.5C18.9999 16.7875 18.9999 18.4312 18.092 19.5376C17.9258 19.7401 17.7401 19.9258 17.5375 20.092C16.4312 21 14.7874 21 11.4999 21H11C7.22876 21 5.34316 21 4.17159 19.8284C3.00003 18.6569 3 16.7712 3 13V12.5C3 9.21252 3 7.56879 3.90794 6.46244C4.07417 6.2599 4.2599 6.07417 4.46244 5.90794C5.56879 5 7.21252 5 10.5 5",
                                            stroke: "#262121",
                                            strokeWidth: "2",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            className: (shap_of_you_module_default()).btn,
                            onClick: function(e) {
                                e.preventDefault();
                                if (isOtpComplete && !loading) {
                                    handleVerifyOtp();
                                }
                            },
                            disabled: loading || !isOtpComplete,
                            style: loading || !isOtpComplete ? {
                                marginTop: "20px",
                                background: "#d3d3d3",
                                width: "100%",
                                display: "block",
                                color: "#888",
                                fontSize: "20px",
                                fontFamily: "Sweet Sans Pro Medium",
                                cursor: "not-allowed",
                                opacity: 0.6
                            } : {
                                marginTop: "20px",
                                background: "#C9302C",
                                width: "100%",
                                display: "block",
                                color: "white",
                                fontSize: "20px",
                                fontFamily: "Sweet Sans Pro Medium",
                                cursor: "pointer"
                            },
                            children: [
                                loading ? "Submitting..." : "Submit",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "→"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var shape_of_you_mobile_VerifyOtpScreen = (VerifyOtpScreen);

;// CONCATENATED MODULE: ./src/components/shape-of-you-mobile/FilterViewScreen.tsx







var FilterViewScreen = function(param) {
    var navigateToStep = param.navigateToStep, filter = param.filter, setFilter = param.setFilter, activeTab = param.activeTab;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var ref8 = (0,react.useState)("Price"), selectedTab = ref8[0], setSelectedTab = ref8[1];
    var ref9 = (0,react.useState)({
        metal: [],
        occasions: [],
        priceRange: null,
        priceMin: null,
        priceMax: null
    }), filterSheet = ref9[0], setFilterSheet = ref9[1];
    var categoryState = (0,es/* useSelector */.v9)(function(state) {
        return state.category;
    });
    // Price options matching Product.tsx
    var priceOptions = [
        {
            label: "Below ₹ 10,000",
            min: null,
            max: 10000
        },
        {
            label: "₹ 10,000 – ₹ 20,000",
            min: 10000,
            max: 20000
        },
        {
            label: "₹ 30,000 – ₹ 40,000",
            min: 30000,
            max: 40000
        },
        {
            label: "₹ 40,000 – ₹ 50,000",
            min: 40000,
            max: 50000
        },
        {
            label: "₹ 50,000 – ₹ 1,00,000",
            min: 50000,
            max: 100000
        }, 
    ];
    // Sync filterSheet with filter when component mounts or filter changes
    (0,react.useEffect)(function() {
        setFilterSheet({
            metal: filter.metal || [],
            occasions: filter.occasions || [],
            priceRange: filter.priceRange || null,
            priceMin: filter.priceMin || null,
            priceMax: filter.priceMax || null
        });
    }, [
        filter
    ]);
    // Handle filter changes in the sheet (temporary state)
    var handleSheetFilterChange = function(filterType, value) {
        setFilterSheet(function(prev) {
            if (filterType === "price") {
                var _Math, _Math1;
                var label = value.label;
                var currentSelected = prev.priceRange ? prev.priceRange.split("|") : [];
                var newSelected = currentSelected.includes(label) ? currentSelected.filter(function(r) {
                    return r !== label;
                }) : (0,_to_consumable_array/* default */.Z)(currentSelected).concat([
                    label
                ]);
                // Compute merged min/max from all selected ranges
                var selectedOptions = priceOptions.filter(function(opt) {
                    return newSelected.includes(opt.label);
                });
                var hasNullMin = selectedOptions.some(function(opt) {
                    return opt.min === null;
                });
                var mins = selectedOptions.map(function(opt) {
                    return opt.min;
                }).filter(function(m) {
                    return m !== null;
                });
                var maxes = selectedOptions.map(function(opt) {
                    return opt.max;
                });
                var priceMin = selectedOptions.length === 0 ? null : hasNullMin ? null : mins.length > 0 ? (_Math = Math).min.apply(_Math, (0,_to_consumable_array/* default */.Z)(mins)) : null;
                var priceMax = maxes.length > 0 ? (_Math1 = Math).max.apply(_Math1, (0,_to_consumable_array/* default */.Z)(maxes)) : null;
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                    priceRange: newSelected.length > 0 ? newSelected.join("|") : null,
                    priceMin: priceMin,
                    priceMax: priceMax
                });
            } else if (filterType === "metal") {
                // For purity filter
                var metals = (prev === null || prev === void 0 ? void 0 : prev.metal) || [];
                if (metals.includes(value)) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                        metal: metals.filter(function(m) {
                            return m !== value;
                        })
                    });
                } else {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                        metal: (0,_to_consumable_array/* default */.Z)(metals).concat([
                            value
                        ])
                    });
                }
            } else if (filterType === "occasion") {
                // For occasion filter
                var occasions = (prev === null || prev === void 0 ? void 0 : prev.occasions) || [];
                if (occasions.includes(value)) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                        occasions: occasions.filter(function(m) {
                            return m !== value;
                        })
                    });
                } else {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                        occasions: (0,_to_consumable_array/* default */.Z)(occasions).concat([
                            value
                        ])
                    });
                }
            }
            return prev;
        });
    };
    // Apply filters and navigate back
    var handleApplyFilter = function() {
        setFilter(filterSheet);
        navigateToStep("productView");
    };
    // Clear all filters
    var handleClearFilters = function() {
        var clearedSheet = {
            metal: [],
            occasions: [],
            priceRange: null,
            priceMin: null,
            priceMax: null
        };
        setFilterSheet(clearedSheet);
    };
    var handleBackToProduct = function() {
        navigateToStep("productView");
    };
    // Check icon component
    var CheckIcon = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            width: "12",
            height: "12",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20 6L9 17L4 12",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "d-md-none w-100",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (shap_of_you_module_default()).filterWrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "w-100",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (shap_of_you_module_default()).header,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                children: [
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (shap_of_you_module_default()).backArrow,
                                        onClick: handleBackToProduct,
                                        children: "←"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                        style: {
                                            margin: "0 10px"
                                        },
                                        width: "30",
                                        height: "30",
                                        viewBox: "0 0 36 36",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M6 15C6 15.7956 6.31607 16.5587 6.87868 17.1213C7.44129 17.6839 8.20435 18 9 18C9.79565 18 10.5587 17.6839 11.1213 17.1213C11.6839 16.5587 12 15.7956 12 15C12 14.2044 11.6839 13.4413 11.1213 12.8787C10.5587 12.3161 9.79565 12 9 12C8.20435 12 7.44129 12.3161 6.87868 12.8787C6.31607 13.4413 6 14.2044 6 15Z",
                                                stroke: "#262121",
                                                strokeWidth: "3",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M9 6V12",
                                                stroke: "#262121",
                                                strokeWidth: "3",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M9 18V30",
                                                stroke: "#262121",
                                                strokeWidth: "3",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M15 24C15 24.7956 15.3161 25.5587 15.8787 26.1213C16.4413 26.6839 17.2044 27 18 27C18.7956 27 19.5587 26.6839 20.1213 26.1213C20.6839 25.5587 21 24.7956 21 24C21 23.2044 20.6839 22.4413 20.1213 21.8787C19.5587 21.3161 18.7956 21 18 21C17.2044 21 16.4413 21.3161 15.8787 21.8787C15.3161 22.4413 15 23.2044 15 24Z",
                                                stroke: "#262121",
                                                strokeWidth: "3",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M18 6V21",
                                                stroke: "#262121",
                                                strokeWidth: "3",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M18 27V30",
                                                stroke: "#262121",
                                                strokeWidth: "3",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M24 10.5C24 11.2956 24.3161 12.0587 24.8787 12.6213C25.4413 13.1839 26.2044 13.5 27 13.5C27.7956 13.5 28.5587 13.1839 29.1213 12.6213C29.6839 12.0587 30 11.2956 30 10.5C30 9.70435 29.6839 8.94129 29.1213 8.37868C28.5587 7.81607 27.7956 7.5 27 7.5C26.2044 7.5 25.4413 7.81607 24.8787 8.37868C24.3161 8.94129 24 9.70435 24 10.5Z",
                                                stroke: "#262121",
                                                strokeWidth: "3",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M27 6V7.5",
                                                stroke: "#262121",
                                                strokeWidth: "3",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M27 13.5V30",
                                                stroke: "#262121",
                                                strokeWidth: "3",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            })
                                        ]
                                    }),
                                    "Filter By"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (shap_of_you_module_default()).tabs,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: "".concat((shap_of_you_module_default()).tab, " ").concat(selectedTab === "Price" ? (shap_of_you_module_default()).active : ""),
                                    onClick: function() {
                                        return setSelectedTab("Price");
                                    },
                                    children: "Price"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: "".concat((shap_of_you_module_default()).tab, " ").concat(selectedTab === "Purity" ? (shap_of_you_module_default()).active : ""),
                                    onClick: function() {
                                        return setSelectedTab("Purity");
                                    },
                                    children: "Purity"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: "".concat((shap_of_you_module_default()).tab, " ").concat(selectedTab === "Occassion" ? (shap_of_you_module_default()).active : ""),
                                    onClick: function() {
                                        return setSelectedTab("Occassion");
                                    },
                                    children: "Occassion"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (shap_of_you_module_default()).content,
                            children: [
                                selectedTab === "Price" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (shap_of_you_module_default()).options,
                                    children: priceOptions.map(function(option) {
                                        var selectedRanges = (filterSheet === null || filterSheet === void 0 ? void 0 : filterSheet.priceRange) ? filterSheet.priceRange.split("|") : [];
                                        var isChecked = selectedRanges.includes(option.label);
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                            className: (shap_of_you_module_default()).optionItem,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    style: {
                                                        fontWeight: isChecked ? "bold" : "normal"
                                                    },
                                                    children: option.label
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "checkbox",
                                                    name: "price",
                                                    checked: isChecked,
                                                    onChange: function() {
                                                        return handleSheetFilterChange("price", option);
                                                    },
                                                    style: {
                                                        display: "none"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (shap_of_you_module_default()).checkbox,
                                                    style: {
                                                        borderRadius: "50%",
                                                        border: "1px solid #ccc",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        width: "16px",
                                                        height: "16px"
                                                    },
                                                    children: isChecked && /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckIcon, {})
                                                })
                                            ]
                                        }, option.label);
                                    })
                                }),
                                selectedTab === "Purity" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (shap_of_you_module_default()).options,
                                    children: [
                                        (ref = categoryState.similarFilters) === null || ref === void 0 ? void 0 : (ref1 = ref.purities) === null || ref1 === void 0 ? void 0 : ref1.map(function(purity, index) {
                                            var ref;
                                            var isChecked = (filterSheet === null || filterSheet === void 0 ? void 0 : (ref = filterSheet.metal) === null || ref === void 0 ? void 0 : ref.includes(purity)) || false;
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                className: (shap_of_you_module_default()).optionItem,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        style: {
                                                            fontWeight: isChecked ? "bold" : "normal"
                                                        },
                                                        children: purity
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        type: "checkbox",
                                                        name: "purity",
                                                        checked: isChecked,
                                                        onChange: function() {
                                                            return handleSheetFilterChange("metal", purity);
                                                        },
                                                        style: {
                                                            display: "none"
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (shap_of_you_module_default()).checkbox,
                                                        style: {
                                                            borderRadius: "50%",
                                                            border: "1px solid #ccc",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            width: "16px",
                                                            height: "16px"
                                                        },
                                                        children: isChecked && /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckIcon, {})
                                                    })
                                                ]
                                            }, index);
                                        }),
                                        (!((ref2 = categoryState.similarFilters) === null || ref2 === void 0 ? void 0 : ref2.purities) || ((ref3 = categoryState.similarFilters) === null || ref3 === void 0 ? void 0 : ref3.purities.length) === 0) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (shap_of_you_module_default()).placeholder,
                                            children: [
                                                "No purity options available for ",
                                                activeTab
                                            ]
                                        })
                                    ]
                                }),
                                selectedTab === "Occassion" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (shap_of_you_module_default()).options,
                                    children: [
                                        (ref4 = categoryState.similarFilters) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.occasions) === null || ref5 === void 0 ? void 0 : ref5.map(function(occasion, index) {
                                            var ref;
                                            var isChecked = (filterSheet === null || filterSheet === void 0 ? void 0 : (ref = filterSheet.occasions) === null || ref === void 0 ? void 0 : ref.includes(occasion.name)) || false;
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                className: (shap_of_you_module_default()).optionItem,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        style: {
                                                            fontWeight: isChecked ? "bold" : "normal"
                                                        },
                                                        children: occasion.name
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        type: "checkbox",
                                                        name: "occasion",
                                                        checked: isChecked,
                                                        onChange: function() {
                                                            return handleSheetFilterChange("occasion", occasion.name);
                                                        },
                                                        style: {
                                                            display: "none"
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (shap_of_you_module_default()).checkbox,
                                                        style: {
                                                            borderRadius: "50%",
                                                            border: "1px solid #ccc",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            width: "16px",
                                                            height: "16px"
                                                        },
                                                        children: isChecked && /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckIcon, {})
                                                    })
                                                ]
                                            }, index);
                                        }),
                                        (!((ref6 = categoryState.similarFilters) === null || ref6 === void 0 ? void 0 : ref6.occasions) || ((ref7 = categoryState.similarFilters) === null || ref7 === void 0 ? void 0 : ref7.occasions.length) === 0) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (shap_of_you_module_default()).placeholder,
                                            children: [
                                                "No occasion options available for ",
                                                activeTab
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (shap_of_you_module_default()).footer,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: (shap_of_you_module_default()).clearBtn,
                            onClick: handleClearFilters,
                            children: "Clear Selection"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            className: (shap_of_you_module_default()).applyBtn,
                            onClick: handleApplyFilter,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                    style: {
                                        marginRight: "10px"
                                    },
                                    width: "17",
                                    height: "13",
                                    viewBox: "0 0 17 13",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M16.2637 1.41406L6.36328 11.3135L0.707031 5.65625L1.41406 4.94922L6.36426 9.89941L15.5566 0.707031L16.2637 1.41406Z",
                                        fill: "#262121",
                                        stroke: "white"
                                    })
                                }),
                                "Apply"
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var shape_of_you_mobile_FilterViewScreen = (FilterViewScreen);

// EXTERNAL MODULE: ./src/utils/constants.ts
var constants = __webpack_require__(13135);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(30933);
// EXTERNAL MODULE: ./node_modules/swiper/modules/pagination/pagination.min.css
var pagination_min = __webpack_require__(68770);
;// CONCATENATED MODULE: ./src/assets/images/ProductPage_Default_Selection.png
/* harmony default export */ var ProductPage_Default_Selection = ({"src":"/_next/static/media/ProductPage_Default_Selection.7a97a16e.png","height":852,"width":393,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAICAMAAADp7a43AAAAMFBMVEU0MS9hWFSXgm9WRDqRYkZLNCmba1NwTjyBaluokH1/al6ziFebdEONdWUlGxckFxEkOra1AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAKUlEQVR4nBXBhw0AIAzAsHRS9v/fImzqniJaGOYZqOdgr9lproqJCN8DESkArCp+d/YAAAAASUVORK5CYII="});
// EXTERNAL MODULE: ./src/assets/images/nekl_s.png
var nekl_s = __webpack_require__(94661);
// EXTERNAL MODULE: ./src/store/slices/category.ts
var category = __webpack_require__(10328);
// EXTERNAL MODULE: ./src/assets/images/jel.png
var jel = __webpack_require__(95060);
;// CONCATENATED MODULE: ./src/assets/images/icons/filter-icon.svg
/* harmony default export */ var filter_icon = ({"src":"/_next/static/media/filter-icon.e070b838.svg","height":24,"width":24});
;// CONCATENATED MODULE: ./src/components/shape-of-you-mobile/LiveCameraPermissionModal.tsx




var LiveCameraPermissionModal = function(param) {
    var isOpen = param.isOpen, onPermissionGranted = param.onPermissionGranted, onPermissionDenied = param.onPermissionDenied, logStep = param.logStep;
    var ref = (0,react.useState)(false), isRequesting = ref[0], setIsRequesting = ref[1];
    var handleOkClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var stream;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setIsRequesting(true);
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return navigator.mediaDevices.getUserMedia({
                            video: {
                                facingMode: "user"
                            }
                        });
                    case 4:
                        stream = _ctx.sent;
                        // Permission granted! Stop the stream and save to localStorage
                        stream.getTracks().forEach(function(track) {
                            return track.stop();
                        });
                        localStorage.setItem("cameraPermissionGranted", "true");
                        // Log camera permission granted (non-blocking)
                        if (logStep) {
                            logStep("camera_permission_granted");
                        }
                        // Call the onPermissionGranted callback
                        onPermissionGranted();
                        _ctx.next = 16;
                        break;
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](1);
                        ;
                        // Log camera permission denied (non-blocking)
                        if (logStep) {
                            logStep("camera_permission_denied", {
                                error_message: "User denied camera permission"
                            });
                        }
                        // Permission denied - call onPermissionDenied
                        onPermissionDenied();
                    case 16:
                        _ctx.prev = 16;
                        setIsRequesting(false);
                        return _ctx.finish(16);
                    case 19:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    11,
                    16,
                    19
                ]
            ]);
        }));
        return function handleOkClick() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleDontAllow = function() {
        // Log camera permission denied (non-blocking)
        if (logStep) {
            logStep("camera_permission_denied", {
                error_message: "User chose not to allow camera permission"
            });
        }
        // Call the onPermissionDenied callback
        onPermissionDenied();
    };
    if (!isOpen) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "d-md-none",
        style: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 2000,
            background: "rgba(0,0,0,0.6)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "20px",
            fontFamily: "Sweet Sans Pro Regular"
        },
        role: "dialog",
        "aria-modal": "true",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            style: {
                backgroundColor: "white",
                borderRadius: "20px",
                padding: "20px",
                textAlign: "left",
                maxWidth: "300px",
                boxShadow: "0 4px 20px rgba(0,0,0,0.3)"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    style: {
                        fontSize: "18px",
                        fontWeight: "400",
                        marginBottom: "8px",
                        color: "#000",
                        fontFamily: "Sweet Sans Pro Regular"
                    },
                    children: "“Senco Gold” Would Like To Access Your Camera"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    style: {
                        fontSize: "13px",
                        color: "#666",
                        marginBottom: "20px",
                        lineHeight: "1.4"
                    },
                    children: "This app requires access to camera"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        display: "flex",
                        gap: "10px",
                        justifyContent: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            onClick: handleDontAllow,
                            disabled: isRequesting,
                            style: {
                                flex: 1,
                                padding: "9px 10px",
                                backgroundColor: "#f0f0f0",
                                border: "none",
                                borderRadius: "20px",
                                fontSize: "15px",
                                fontWeight: "500",
                                color: "#333",
                                cursor: isRequesting ? "not-allowed" : "pointer",
                                opacity: isRequesting ? 0.6 : 1,
                                fontFamily: "Sweet Sans Pro Regular"
                            },
                            children: "Don't Allow"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            onClick: handleOkClick,
                            disabled: isRequesting,
                            style: {
                                flex: 1,
                                padding: "9px 10px",
                                backgroundColor: "#007AFF",
                                border: "none",
                                borderRadius: "20px",
                                fontSize: "15px",
                                fontWeight: "500",
                                color: "white",
                                cursor: isRequesting ? "not-allowed" : "pointer",
                                opacity: isRequesting ? 0.6 : 1,
                                fontFamily: "Sweet Sans Pro Regular"
                            },
                            children: isRequesting ? "Requesting..." : "OK"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var shape_of_you_mobile_LiveCameraPermissionModal = (LiveCameraPermissionModal);

;// CONCATENATED MODULE: ./src/components/shape-of-you-mobile/ProductViewScreen.tsx































var ProductViewScreen = function(param) {
    var navigateToStep = param.navigateToStep, filter = param.filter, logStep = param.logStep;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    var dispatch = (0,store/* useAppDispatch */.T)();
    var router = (0,next_router.useRouter)();
    var ref11 = (0,es/* useSelector */.v9)(shapeOfYou/* selectShapeOfYou */.Tk), recommendations = ref11.recommendations, capturedImage = ref11.capturedImage;
    var categoryState = (0,es/* useSelector */.v9)(function(state) {
        return state.category;
    });
    var cartState = (0,es/* useSelector */.v9)(cart/* selectCart */.KY);
    var authState = (0,es/* useSelector */.v9)(auth/* selectAuth */.Hz);
    var ref12 = (0,react.useState)("Necklace"), activeCategory = ref12[0], setActiveCategory = ref12[1];
    var ref13 = (0,react.useState)(false), loading = ref13[0], setLoading = ref13[1];
    var ref14 = (0,react.useState)([]), productIds = ref14[0], setProductIds = ref14[1];
    var ref15 = (0,react.useState)([]), availableCategories = ref15[0], setAvailableCategories = ref15[1];
    var ref16 = (0,react.useState)(""), selected = ref16[0], setSelected = ref16[1];
    // Virtual try-on image state
    var ref17 = (0,react.useState)(null), virtualTryOnImage = ref17[0], setVirtualTryOnImage = ref17[1];
    var ref18 = (0,react.useState)(false), isGeneratingImage = ref18[0], setIsGeneratingImage = ref18[1];
    // Track selected products per category
    var ref19 = (0,react.useState)(null), selectedEarringId = ref19[0], setSelectedEarringId = ref19[1];
    var ref20 = (0,react.useState)(null), selectedNecklaceId = ref20[0], setSelectedNecklaceId = ref20[1];
    // Live mode state
    var ref21 = (0,react.useState)(false), isLiveMode = ref21[0], setIsLiveMode = ref21[1];
    var liveModeIframeRef = (0,react.useRef)(null);
    // Bump this to force a re-sync of the iframe when selection changes
    var ref22 = (0,react.useState)(0), liveModeSyncSeq = ref22[0], setLiveModeSyncSeq = ref22[1];
    var swiperRef = (0,react.useRef)(null);
    // Cart action loading state
    var ref23 = (0,react.useState)(false), cartActionLoading = ref23[0], setCartActionLoading = ref23[1];
    var ref24 = (0,react.useState)(false), showAddedSuccess = ref24[0], setShowAddedSuccess = ref24[1];
    // Live mode camera permission state
    var ref25 = (0,react.useState)(false), showCameraPermissionModal = ref25[0], setShowCameraPermissionModal = ref25[1];
    var ref26 = (0,react.useState)(false), cameraPermissionChecked = ref26[0], setCameraPermissionChecked = ref26[1];
    // Call image augmentation API (following Product.tsx pattern)
    var callImageAPI = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(earringId, necklaceId) {
            var earringProductId, necklaceProductId, requestBody, response;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (capturedImage) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        earringProductId = earringId !== undefined ? earringId : selectedEarringId;
                        necklaceProductId = necklaceId !== undefined ? necklaceId : selectedNecklaceId;
                        if (!(!earringProductId && !necklaceProductId)) {
                            _ctx.next = 6;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 6:
                        setIsGeneratingImage(true);
                        _ctx.prev = 7;
                        requestBody = {
                            image_data: capturedImage
                        };
                        // Add earring product ID if available
                        if (earringProductId) {
                            requestBody.earring_product_id = earringProductId;
                        }
                        // Add necklace product ID if available
                        if (necklaceProductId) {
                            requestBody.necklace_product_id = necklaceProductId;
                        }
                        _ctx.next = 13;
                        return http_client/* default.post */.Z.post(endpoints/* default.shape_of_you.image */.Z.shape_of_you.image(), requestBody);
                    case 13:
                        response = _ctx.sent;
                        // Set the virtual try-on image from the API response
                        if (response.data.success && response.data.image) {
                            setVirtualTryOnImage(response.data.image);
                            dispatch(shapeOfYou/* shapeOfYouActions.setVirtualTryOnImage */.r1.setVirtualTryOnImage(response.data.image));
                        }
                        _ctx.next = 22;
                        break;
                    case 17:
                        _ctx.prev = 17;
                        _ctx.t0 = _ctx["catch"](7);
                        react_toastify_esm/* toast.error */.Am.error("Error updating virtual try-on image");
                        setVirtualTryOnImage(null);
                        dispatch(shapeOfYou/* shapeOfYouActions.setVirtualTryOnImage */.r1.setVirtualTryOnImage(null));
                    case 22:
                        _ctx.prev = 22;
                        setIsGeneratingImage(false);
                        return _ctx.finish(22);
                    case 25:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    7,
                    17,
                    22,
                    25
                ]
            ]);
        }));
        return function(earringId, necklaceId) {
            return _ref.apply(this, arguments);
        };
    }(), [
        capturedImage,
        selectedEarringId,
        selectedNecklaceId,
        dispatch
    ]);
    // Stable ref so the fetch effect can call callImageAPI without it being a dep
    var callImageAPIRef = (0,react.useRef)(callImageAPI);
    callImageAPIRef.current = callImageAPI;
    var products = ((ref = categoryState.similarProducts) === null || ref === void 0 ? void 0 : ref.data) || [];
    // Get product SKUs for selected products (matching desktop Product.tsx pattern)
    var getSelectedProductSkusByCategory = function() {
        var earringItems = [];
        var necklaceItems = [];
        if (selectedEarringId) {
            var earringProduct = products.find(function(p) {
                return String(p.id) === String(selectedEarringId) || String(p.product_id) === String(selectedEarringId) || String(p.sku) === String(selectedEarringId);
            });
            var sku = String((earringProduct === null || earringProduct === void 0 ? void 0 : earringProduct.sku) || selectedEarringId).trim();
            if (sku && sku !== "undefined" && sku !== "null") {
                earringItems.push({
                    productId: sku
                });
            }
        }
        if (selectedNecklaceId) {
            var necklaceProduct = products.find(function(p) {
                return String(p.id) === String(selectedNecklaceId) || String(p.product_id) === String(selectedNecklaceId) || String(p.sku) === String(selectedNecklaceId);
            });
            var sku1 = String((necklaceProduct === null || necklaceProduct === void 0 ? void 0 : necklaceProduct.sku) || selectedNecklaceId).trim();
            if (sku1 && sku1 !== "undefined" && sku1 !== "null") {
                necklaceItems.push({
                    productId: sku1
                });
            }
        }
        return {
            earringItems: earringItems,
            necklaceItems: necklaceItems
        };
    };
    var getLiveModeTargetOrigin = function() {
        var ref;
        var src = (ref = liveModeIframeRef.current) === null || ref === void 0 ? void 0 : ref.src;
        if (!src) return "https://jewel-aug.adamastech.org";
        try {
            return new URL(src).origin;
        } catch (e) {
            return "https://jewel-aug.adamastech.org";
        }
    };
    // Helper function to send product to iframe with retry (matching desktop Product.tsx)
    var sendProductToIframe = function(sku, category) {
        var clearOtherCategory = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, otherCategoryHadValue = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
        var ref;
        var iframeWin = (ref = liveModeIframeRef.current) === null || ref === void 0 ? void 0 : ref.contentWindow;
        if (!iframeWin) {
            ;
            return;
        }
        var targetOrigin = getLiveModeTargetOrigin();
        var sendMessage = function() {
            iframeWin.postMessage({
                type: "overlay-products",
                category: category,
                items: [
                    {
                        productId: sku
                    }
                ]
            }, targetOrigin);
            ;
            if (clearOtherCategory && otherCategoryHadValue) {
                var otherCategory = category === "EARRING" ? "NECKLACE" : "EARRING";
                iframeWin.postMessage({
                    type: "overlay-products",
                    category: otherCategory,
                    items: []
                }, targetOrigin);
                ;
            }
        };
        // Send once — postMessage is synchronous & reliable when iframe is loaded
        sendMessage();
    };
    // Determine available categories from recommendations
    (0,react.useEffect)(function() {
        if (recommendations) {
            var categories = Object.keys(recommendations).filter(function(key) {
                return key === "Earring" || key === "Necklace";
            });
            setAvailableCategories(categories);
            // Set initial active category if not already set
            if (categories.length > 0 && !categories.includes(activeCategory)) {
                setActiveCategory(categories[0]);
            }
        }
    }, [
        recommendations,
        activeCategory
    ]);
    // Fetch product IDs when category changes (following Product.tsx pattern)
    (0,react.useEffect)(function() {
        var cancelled = false;
        var fetchProductIds = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var categoryData, requestBody, response, ids, ref, ref1, result, fetchedProducts, firstProduct, firstId;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (!(!recommendations || !activeCategory)) {
                                _ctx.next = 2;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 2:
                            categoryData = recommendations[activeCategory];
                            if (categoryData) {
                                _ctx.next = 5;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 5:
                            // Show loading immediately when category changes (prevents "No products available" flash)
                            setLoading(true);
                            setProductIds([]);
                            _ctx.prev = 7;
                            requestBody = {
                                mode: activeCategory
                            };
                            _ctx.next = 11;
                            return http_client/* default.post */.Z.post(endpoints/* default.shape_of_you.products */.Z.shape_of_you.products(), requestBody);
                        case 11:
                            response = _ctx.sent;
                            if (!cancelled) {
                                _ctx.next = 14;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 14:
                            if (!(response && response.data && response.data.product_ids)) {
                                _ctx.next = 29;
                                break;
                            }
                            ids = response.data.product_ids;
                            setProductIds(ids);
                            if (!(ids.length > 0)) {
                                _ctx.next = 29;
                                break;
                            }
                            ;
                            _ctx.next = 21;
                            return dispatch((0,category/* fetchSimilarProducts */.sy)({
                                query: (0,_object_spread/* default */.Z)({
                                    skus: ids,
                                    size: ids.length
                                }, filter)
                            }));
                        case 21:
                            result = _ctx.sent;
                            if (!cancelled) {
                                _ctx.next = 24;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 24:
                            // Fetch filter options (non-blocking)
                            dispatch((0,category/* fetchSimilarProductFilters */.RI)({
                                query: (0,_object_spread/* default */.Z)({
                                    skus: ids,
                                    size: ids.length
                                }, filter)
                            }));
                            fetchedProducts = ((ref = result) === null || ref === void 0 ? void 0 : (ref1 = ref.payload) === null || ref1 === void 0 ? void 0 : ref1.data) || [];
                            firstProduct = fetchedProducts[0];
                            // Only proceed with selection if a real product was found
                            if (firstProduct) {
                                firstId = String(firstProduct.sku || firstProduct.id || firstProduct.product_id);
                                // Auto-select first product
                                setSelected(firstId);
                                // Update category-specific ID and call image API only when a
                                // matching product exists (firstId === product.sku in the swiper)
                                if (activeCategory === "Earring") {
                                    setSelectedEarringId(firstId);
                                    if (capturedImage) {
                                        callImageAPIRef.current(firstId, null);
                                    }
                                } else if (activeCategory === "Necklace") {
                                    setSelectedNecklaceId(firstId);
                                    if (capturedImage) {
                                        callImageAPIRef.current(null, firstId);
                                    }
                                }
                            }
                            // Center the first item in swiper after it's initialized
                            setTimeout(function() {
                                if (swiperRef.current) {
                                    try {
                                        var ref;
                                        var swiper = swiperRef.current;
                                        if ((ref = swiper.params) === null || ref === void 0 ? void 0 : ref.loop) {
                                            swiper.slideToLoop(0, 0);
                                        } else {
                                            swiper.slideTo(0, 0);
                                        }
                                    } catch (error) {
                                    // Swiper not ready yet, ignore
                                    }
                                }
                            }, 200);
                        case 29:
                            _ctx.next = 34;
                            break;
                        case 31:
                            _ctx.prev = 31;
                            _ctx.t0 = _ctx["catch"](7);
                            if (!cancelled) {
                                react_toastify_esm/* toast.error */.Am.error("Failed to load products");
                                setProductIds([]);
                            }
                        case 34:
                            _ctx.prev = 34;
                            if (!cancelled) {
                                // Increase loader time slightly so product display gets time to render properly
                                setTimeout(function() {
                                    if (!cancelled) setLoading(false);
                                }, 1500);
                            }
                            return _ctx.finish(34);
                        case 37:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        7,
                        31,
                        34,
                        37
                    ]
                ]);
            }));
            return function fetchProductIds() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchProductIds();
        return function() {
            cancelled = true;
        };
    }, [
        activeCategory,
        recommendations,
        dispatch,
        filter,
        capturedImage
    ]);
    // Send product data to iframe when live mode is active (matching desktop Product.tsx)
    (0,react.useEffect)(function() {
        var ref;
        if (!isLiveMode || !liveModeIframeRef.current) return;
        var sendProductDataOnce = function() {
            var ref;
            var iframeWin = (ref = liveModeIframeRef.current) === null || ref === void 0 ? void 0 : ref.contentWindow;
            if (!iframeWin) return false;
            var ref1 = getSelectedProductSkusByCategory(), earringItems = ref1.earringItems, necklaceItems = ref1.necklaceItems;
            var targetOrigin = getLiveModeTargetOrigin();
            if (earringItems.length > 0) {
                iframeWin.postMessage({
                    type: "overlay-products",
                    category: "EARRING",
                    items: earringItems
                }, targetOrigin);
                ;
            } else {
                iframeWin.postMessage({
                    type: "overlay-products",
                    category: "EARRING",
                    items: []
                }, targetOrigin);
            }
            if (necklaceItems.length > 0) {
                iframeWin.postMessage({
                    type: "overlay-products",
                    category: "NECKLACE",
                    items: necklaceItems
                }, targetOrigin);
                ;
            } else {
                iframeWin.postMessage({
                    type: "overlay-products",
                    category: "NECKLACE",
                    items: []
                }, targetOrigin);
            }
            return true;
        };
        var retryTimeout = null;
        var sendWithRetry = function() {
            if (retryTimeout) {
                clearTimeout(retryTimeout);
                retryTimeout = null;
            }
            sendProductDataOnce();
            // Single safety retry after 1s in case the first message was missed
            retryTimeout = setTimeout(function() {
                sendProductDataOnce();
                retryTimeout = null;
            }, 1000);
        };
        var iframe = liveModeIframeRef.current;
        if (((ref = iframe.contentDocument) === null || ref === void 0 ? void 0 : ref.readyState) === "complete") {
            sendWithRetry();
        } else {
            var onLoad = function() {
                setTimeout(function() {
                    sendWithRetry();
                }, 300);
            };
            iframe.addEventListener("load", onLoad, {
                once: true
            });
        }
        return function() {
            if (retryTimeout) {
                clearTimeout(retryTimeout);
                retryTimeout = null;
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isLiveMode,
        selectedEarringId,
        selectedNecklaceId,
        products,
        liveModeSyncSeq, 
    ]);
    // Get selected product details
    var selectedProduct = products.find(function(p) {
        return String(p.id) === String(selected) || String(p.product_id) === String(selected) || String(p.sku) === String(selected);
    });
    // Check if selected product is in cart
    var cartItem = (0,react.useMemo)(function() {
        return selectedProduct ? cartState.items.find(function(v) {
            var ref;
            return v.identifier == ((ref = selectedProduct.priceId) === null || ref === void 0 ? void 0 : ref.toString()) || "";
        }) || null : null;
    }, [
        cartState.items,
        selectedProduct
    ]);
    // Handle category tab click (matching desktop handleTabClick pattern)
    var handleCategoryClick = function(category) {
        setActiveCategory(category);
        setSelected(""); // Reset selection when switching categories
        setVirtualTryOnImage(null); // Clear virtual try-on image when switching tabs
        dispatch(shapeOfYou/* shapeOfYouActions.setVirtualTryOnImage */.r1.setVirtualTryOnImage(null));
        // Clear product IDs so first product of new tab will be set by the products effect
        setSelectedEarringId(null);
        setSelectedNecklaceId(null);
    };
    // Handle product selection and call image API
    var handleProductSelect = function(product, productId, index) {
        setSelected(productId);
        // Log product selection (non-blocking)
        if (logStep) {
            var ref;
            logStep("product_selected", {
                success_message: "Product selected successfully",
                success_code: "200",
                response_status: 200,
                request_payload: {
                    action: "product_click",
                    product_id: productId,
                    category: activeCategory,
                    index: index
                },
                response_payload: {
                    product_id: productId,
                    product_sku: (product === null || product === void 0 ? void 0 : product.sku) || null,
                    product_title: (product === null || product === void 0 ? void 0 : product.title) || (product === null || product === void 0 ? void 0 : product.slug) || null,
                    product_price: (product === null || product === void 0 ? void 0 : product.price) || null,
                    product_category: activeCategory,
                    product_image: (product === null || product === void 0 ? void 0 : product.image) || (product === null || product === void 0 ? void 0 : (ref = product.images) === null || ref === void 0 ? void 0 : ref[0]) || null,
                    has_fast_delivery: (product === null || product === void 0 ? void 0 : product.fastDelivery) || false,
                    is_trending: (product === null || product === void 0 ? void 0 : product.trending) || false,
                    is_new_arrival: (product === null || product === void 0 ? void 0 : product.new_arrival) || false,
                    selection_index: index
                }
            });
        }
        // Slide to the selected item to center it
        if (swiperRef.current) {
            try {
                var ref1;
                var swiper = swiperRef.current;
                if ((ref1 = swiper.params) === null || ref1 === void 0 ? void 0 : ref1.loop) {
                    swiper.slideToLoop(index, 300);
                } else {
                    swiper.slideTo(index, 300);
                }
            } catch (error) {
            // Swiper not ready, ignore
            }
        }
        // Determine which ID to update and whether to clear the other category
        var clearOtherCategory = false;
        var otherCategoryHadValue = false;
        if (activeCategory === "Earring") {
            setSelectedEarringId(productId);
            if (selectedNecklaceId) {
                setSelectedNecklaceId(null);
                clearOtherCategory = true;
                otherCategoryHadValue = true;
            }
            // Call image API with ONLY earring ID
            if (capturedImage) {
                callImageAPI(productId, null);
            }
        } else if (activeCategory === "Necklace") {
            setSelectedNecklaceId(productId);
            if (selectedEarringId) {
                setSelectedEarringId(null);
                clearOtherCategory = true;
                otherCategoryHadValue = true;
            }
            // Call image API with ONLY necklace ID
            if (capturedImage) {
                callImageAPI(null, productId);
            }
        }
        // Get the product SKU
        var sku = String(product.sku || productId).trim();
        // Send to iframe FIRST if in live mode (matching desktop Product.tsx)
        if (isLiveMode && sku && sku !== "undefined" && sku !== "null") {
            var category = activeCategory === "Earring" ? "EARRING" : "NECKLACE";
            sendProductToIframe(sku, category, clearOtherCategory, otherCategoryHadValue);
            // Also trigger useEffect sync as backup
            setLiveModeSyncSeq(function(s) {
                return s + 1;
            });
        }
    };
    // Check camera permission and toggle live mode
    var handleLiveModeToggle = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var permissionStatus, persisted;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!isLiveMode) {
                            _ctx.next = 3;
                            break;
                        }
                        setIsLiveMode(false);
                        return _ctx.abrupt("return");
                    case 3:
                        _ctx.prev = 3;
                        _ctx.next = 6;
                        return navigator.permissions.query({
                            name: "camera"
                        });
                    case 6:
                        permissionStatus = _ctx.sent;
                        if (permissionStatus.state === "granted") {
                            persisted = localStorage.getItem("cameraPermissionGranted");
                            if (persisted === "true") {
                                setIsLiveMode(true);
                            } else {
                                // Browser granted but our app flag not set yet - show modal to confirm
                                setShowCameraPermissionModal(true);
                            }
                        } else if (permissionStatus.state === "prompt") {
                            // User hasn't made a decision yet - show modal to request
                            setShowCameraPermissionModal(true);
                        } else if (permissionStatus.state === "denied") {
                            // User has previously denied permission
                            react_toastify_esm/* toast.error */.Am.error("Camera permission denied. Please enable it in your browser settings.");
                        }
                        _ctx.next = 14;
                        break;
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](3);
                        ;
                        setShowCameraPermissionModal(true);
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    3,
                    10
                ]
            ]);
        }));
        return function handleLiveModeToggle() {
            return _ref.apply(this, arguments);
        };
    }();
    // Handle camera permission allowed
    var handleCameraPermissionAllowed = function() {
        setShowCameraPermissionModal(false);
        setIsLiveMode(true);
        react_toastify_esm/* toast.success */.Am.success("Camera access granted. Live View enabled.");
    };
    // Handle camera permission denied
    var handleCameraPermissionDenied = function() {
        setShowCameraPermissionModal(false);
        setIsLiveMode(false);
        react_toastify_esm/* toast.error */.Am.error("Camera permission denied. Switched back to Photo mode.");
    };
    // Add to cart function
    var addToCart = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var redirect, ref, ref1, _args = arguments;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        redirect = _args.length > 0 && _args[0] !== void 0 ? _args[0] : false;
                        if (selectedProduct) {
                            _ctx.next = 4;
                            break;
                        }
                        react_toastify_esm/* toast.error */.Am.error("Please select a product first");
                        return _ctx.abrupt("return");
                    case 4:
                        if (authState.user) {
                            _ctx.next = 7;
                            break;
                        }
                        dispatch(auth/* authActions.setIsModalOpen */.YV.setIsModalOpen(true));
                        return _ctx.abrupt("return");
                    case 7:
                        setCartActionLoading(true);
                        _ctx.prev = 8;
                        ;
                        _ctx.next = 12;
                        return http_client/* default.post */.Z.post(endpoints/* default.cart.add */.Z.cart.add(), {
                            is_solitaire: false,
                            type: "product",
                            identifier: selectedProduct.priceId
                        });
                    case 12:
                        _ctx.next = 14;
                        return dispatch((0,cart/* fetchCartItems */.Vw)());
                    case 14:
                        // Show success state momentarily
                        setCartActionLoading(false);
                        setShowAddedSuccess(true);
                        // Hide success state after 1.5 seconds
                        setTimeout(function() {
                            setShowAddedSuccess(false);
                        }, 1500);
                        react_toastify_esm/* toast.success */.Am.success("Item added to cart");
                        window.dataLayer.push({
                            ecommerce: null
                        });
                        window.dataLayer.push({
                            event: "add_to_cart",
                            ecommerce: {
                                currency: "INR",
                                value: selectedProduct.price,
                                items: [
                                    {
                                        item_id: selectedProduct.id || selectedProduct.product_id || selectedProduct.sku,
                                        item_name: selectedProduct.title || selectedProduct.slug,
                                        item_brand: ga4/* GA4_ITEM_BRAND */.Ye,
                                        item_category: activeCategory,
                                        item_variant: selectedProduct.purity || ((ref = selectedProduct.purities) === null || ref === void 0 ? void 0 : ref[0]) || selectedProduct.priceId,
                                        price: selectedProduct.price,
                                        quantity: 1
                                    }, 
                                ]
                            }
                        });
                        (0,unbxd/* unbxdCusEngTrackEvent */.$z)("Add to cart ", {
                            source: "web",
                            platform: "senco",
                            prid: selectedProduct.id || selectedProduct.product_id,
                            variant_id: selectedProduct.priceId,
                            image_url: selectedProduct.image || selectedProduct.images && selectedProduct.images[0],
                            prqt: 1,
                            product_name: selectedProduct.title || selectedProduct.slug,
                            category: activeCategory || "",
                            brand: constants/* BRAND_NAME */.R,
                            amount: selectedProduct.price,
                            product_url: "".concat(window.location.origin, "/jewellery/").concat(selectedProduct.slug),
                            discounted_price: selectedProduct.discounted_price || 0,
                            stock_availability: 1
                        });
                        // Log product added to cart (non-blocking)
                        if (logStep) {
                            logStep("product_added_to_cart", {
                                api_endpoint: endpoints/* default.cart.add */.Z.cart.add(),
                                request_payload: {
                                    is_solitaire: false,
                                    type: "product",
                                    identifier: selectedProduct.priceId
                                },
                                response_status: 200,
                                success_message: "Item added to cart successfully",
                                response_payload: {
                                    product_id: selectedProduct.id || selectedProduct.product_id,
                                    product_sku: selectedProduct.sku,
                                    product_title: selectedProduct.title || selectedProduct.slug,
                                    product_price: selectedProduct.price,
                                    category: activeCategory
                                }
                            });
                            // Also log session completed (Shape of You flow completed successfully)
                            logStep("session_completed", {
                                success_message: "Shape of You session completed - Product added to cart",
                                success_code: "SESSION_COMPLETED",
                                response_status: 200,
                                request_payload: {
                                    completion_action: "add_to_cart",
                                    session_stage: "product_view"
                                },
                                response_payload: {
                                    completion_type: "product_added_to_cart",
                                    product_id: selectedProduct.id || selectedProduct.product_id,
                                    product_sku: selectedProduct.sku,
                                    product_title: selectedProduct.title || selectedProduct.slug,
                                    product_price: selectedProduct.price,
                                    product_category: activeCategory,
                                    cart_item_identifier: selectedProduct.priceId,
                                    completed_at: new Date().toISOString()
                                }
                            });
                        }
                        if (redirect) {
                            router.push("/cart");
                        }
                        _ctx.next = 30;
                        break;
                    case 25:
                        _ctx.prev = 25;
                        _ctx.t0 = _ctx["catch"](8);
                        ;
                        if (Number(_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref1 = _ctx.t0.response) === null || ref1 === void 0 ? void 0 : ref1.status) === 400) {
                            react_toastify_esm/* toast.error */.Am.error("Something went wrong! Refreshing the page!");
                            window.location.reload();
                        } else {
                            react_toastify_esm/* toast.error */.Am.error("Failed to add item to cart");
                        }
                        setCartActionLoading(false);
                    case 30:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    8,
                    25
                ]
            ]);
        }));
        return function addToCart() {
            return _ref.apply(this, arguments);
        };
    }();
    // Remove from cart function
    var removeFromCart = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (confirm("Are you sure you want to remove this item from cart?")) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        setCartActionLoading(true);
                        _ctx.prev = 3;
                        _ctx.next = 6;
                        return http_client/* default.delete */.Z["delete"](endpoints/* default.cart.remove */.Z.cart.remove(cartItem === null || cartItem === void 0 ? void 0 : cartItem.id));
                    case 6:
                        _ctx.next = 8;
                        return dispatch((0,cart/* fetchCartItems */.Vw)());
                    case 8:
                        react_toastify_esm/* toast.info */.Am.info("Item removed from cart");
                        _ctx.next = 14;
                        break;
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](3);
                        react_toastify_esm/* toast.error */.Am.error("Failed to remove item from cart");
                    case 14:
                        _ctx.prev = 14;
                        setCartActionLoading(false);
                        return _ctx.finish(14);
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    3,
                    11,
                    14,
                    17
                ]
            ]);
        }));
        return function removeFromCart() {
            return _ref.apply(this, arguments);
        };
    }();
    // Check if any filters are active
    var hasActiveFilters = function() {
        return filter.metal && filter.metal.length > 0 || filter.occasions && filter.occasions.length > 0 || filter.priceMin !== null || filter.priceMax !== null || filter.priceRange !== null;
    };
    // Get image source with fallback
    var getImageSrc = function(product) {
        if (!product) return nekl_s/* default.src */.Z.src;
        if (product.image && typeof product.image === "string") {
            return product.image;
        }
        if (product.images && Array.isArray(product.images) && product.images.length > 0) {
            if (typeof product.images[0] === "string") {
                return product.images[0];
            } else if (product.images[0] && product.images[0].url) {
                return product.images[0].url;
            }
        }
        if (product.image_url) return product.image_url;
        if (product.primary_image) return product.primary_image;
        if (product.thumbnail) return product.thumbnail;
        return nekl_s/* default.src */.Z.src;
    };
    var ref27 = (0,react.useState)(false), isOpen = ref27[0], setIsOpen = ref27[1];
    var ref28 = (0,react.useState)(false), isCartOpen = ref28[0], setIsCartOpen = ref28[1];
    var ref29 = (0,react.useState)(true), isPanelExpanded = ref29[0], setIsPanelExpanded = ref29[1];
    (0,react.useEffect)(function() {
        document.body.style.overflow = isOpen || isCartOpen ? "hidden" : "auto";
        return function() {
            document.body.style.overflow = "auto";
        };
    }, [
        isOpen,
        isCartOpen
    ]);
    var ref30 = (0,react.useState)("description"), activeTab = ref30[0], setActiveTab = ref30[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "d-md-none w-100",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (shap_of_you_module_default()).container,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (shap_of_you_module_default()).image_main,
                            children: [
                                isLiveMode ? // Show Live Mode iframe
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        position: "relative",
                                        width: "100%",
                                        height: "100%"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                        ref: liveModeIframeRef,
                                        id: "live-mode-frame",
                                        src: "https://jewel-aug.adamastech.org/shape-of-you/overlay-preview-alt",
                                        title: "Live Mode Overlay",
                                        allow: "camera; microphone; autoplay",
                                        style: {
                                            width: "100%",
                                            height: "100%",
                                            border: "none",
                                            background: "transparent",
                                            display: "block",
                                            pointerEvents: "none"
                                        }
                                    })
                                }) : virtualTryOnImage ? // Show virtual try-on image if available
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: virtualTryOnImage,
                                    alt: "Virtual Try-On",
                                    className: (shap_of_you_module_default()).bgImage,
                                    layout: "fill",
                                    objectFit: "cover",
                                    unoptimized: true
                                }) : capturedImage ? // Show captured image
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: capturedImage,
                                    alt: "Your Photo",
                                    className: (shap_of_you_module_default()).bgImage,
                                    layout: "fill",
                                    objectFit: "cover",
                                    unoptimized: true
                                }) : // Fallback to default image
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: ProductPage_Default_Selection,
                                    alt: "Background",
                                    className: (shap_of_you_module_default()).bgImage
                                }),
                                isGeneratingImage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        position: "absolute",
                                        inset: 0,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        background: "rgba(0, 0, 0, 0.4)",
                                        zIndex: 5
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        style: {
                                            textAlign: "center",
                                            color: "#fff"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                                                animation: "border",
                                                role: "status"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                style: {
                                                    marginTop: "1rem",
                                                    fontSize: "14px"
                                                },
                                                children: "Generating virtual try-on..."
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (shap_of_you_module_default()).image_gradient
                                })
                            ]
                        }),
                        !isOpen && !isCartOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (shap_of_you_module_default()).topSwitch,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: (shap_of_you_module_default()).back_page,
                                    onClick: function() {
                                        if (logStep) {
                                            logStep("product_view_back_clicked");
                                        }
                                        navigateToStep("uploadOrScan");
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "bi bi-arrow-left"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (shap_of_you_module_default())["switch"],
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: isLiveMode ? (shap_of_you_module_default()).active : (shap_of_you_module_default()).live,
                                            onClick: handleLiveModeToggle,
                                            style: {
                                                cursor: "pointer"
                                            },
                                            children: "Live View"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: !isLiveMode ? (shap_of_you_module_default()).active : (shap_of_you_module_default()).live,
                                            onClick: handleLiveModeToggle,
                                            style: {
                                                cursor: "pointer"
                                            },
                                            children: "Photo"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (shap_of_you_module_default()).cartIcon,
                                    style: {
                                        position: "relative",
                                        cursor: "pointer"
                                    },
                                    onClick: function() {
                                        return setIsCartOpen(true);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                            width: "24",
                                            height: "24",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M4 19C4 19.5304 4.21071 20.0391 4.58579 20.4142C4.96086 20.7893 5.46957 21 6 21C6.53043 21 7.03914 20.7893 7.41421 20.4142C7.78929 20.0391 8 19.5304 8 19C8 18.4696 7.78929 17.9609 7.41421 17.5858C7.03914 17.2107 6.53043 17 6 17C5.46957 17 4.96086 17.2107 4.58579 17.5858C4.21071 17.9609 4 18.4696 4 19Z",
                                                    stroke: "#262121",
                                                    strokeWidth: "2",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M15 19C15 19.5304 15.2107 20.0391 15.5858 20.4142C15.9609 20.7893 16.4696 21 17 21C17.5304 21 18.0391 20.7893 18.4142 20.4142C18.7893 20.0391 19 19.5304 19 19C19 18.4696 18.7893 17.9609 18.4142 17.5858C18.0391 17.2107 17.5304 17 17 17C16.4696 17 15.9609 17.2107 15.5858 17.5858C15.2107 17.9609 15 18.4696 15 19Z",
                                                    stroke: "#262121",
                                                    strokeWidth: "2",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M17 17H6V3H4",
                                                    stroke: "#262121",
                                                    strokeWidth: "2",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M6 5L20 6L19 13H6",
                                                    stroke: "#262121",
                                                    strokeWidth: "2",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round"
                                                })
                                            ]
                                        }),
                                        !!cartState.items.length && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            style: {
                                                position: "absolute",
                                                top: "7px",
                                                right: "7px",
                                                background: "#c91723",
                                                color: "white",
                                                borderRadius: "50%",
                                                width: "20px",
                                                height: "20px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                fontSize: "12px",
                                                fontWeight: "600"
                                            },
                                            children: cartState.items.length
                                        })
                                    ]
                                })
                            ]
                        }),
                        !isOpen && !isCartOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            onClick: function() {
                                return setIsPanelExpanded(!isPanelExpanded);
                            },
                            style: {
                                position: "absolute",
                                bottom: isPanelExpanded ? "295px" : "20px",
                                left: "50%",
                                transform: "translateX(-50%)",
                                cursor: "pointer",
                                zIndex: 10,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                transition: "bottom 0.4s ease"
                            },
                            children: isPanelExpanded ? // Down arrow (expanded → click to collapse)
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                width: "173",
                                height: "36",
                                viewBox: "0 0 173 36",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("foreignObject", {
                                        x: "-6",
                                        y: "-5.99998",
                                        width: "185",
                                        height: "48",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            style: {
                                                backdropFilter: "blur(3px)",
                                                clipPath: "url(#bgblur_mob_pv_clip)",
                                                height: "100%",
                                                width: "100%"
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                        "data-figma-bg-blur-radius": "6",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M92.4653 20L86.4998 24L80.5343 20",
                                                stroke: "white",
                                                strokeOpacity: "0.31",
                                                strokeWidth: "3",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M93.957 13.25L86.5001 18.25L79.0432 13.25",
                                                stroke: "white",
                                                strokeWidth: "3",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                                            id: "bgblur_mob_pv_clip",
                                            transform: "translate(6 5.99998)",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M173 24C173 30.6274 167.627 36 161 36L12 36C5.37259 36 4.69686e-07 30.6274 1.04907e-06 24L2.09815e-06 12C2.67753e-06 5.37258 5.37259 4.69686e-07 12 1.04907e-06L161 1.40751e-05C167.627 1.46545e-05 173 5.3726 173 12L173 24Z"
                                            })
                                        })
                                    })
                                ]
                            }) : // Up arrow (collapsed → click to expand)
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                width: "24",
                                height: "20",
                                viewBox: "0 0 18 14",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M2.96094 5.5L8.80471 1.5L14.6485 5.5",
                                        stroke: "white",
                                        strokeOpacity: "0.31",
                                        strokeWidth: "3",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M1.5 12.25L8.80471 7.25L16.1094 12.25",
                                        stroke: "white",
                                        strokeWidth: "3",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (shap_of_you_module_default()).priceRow,
                            style: {
                                transition: "opacity 0.4s ease, transform 0.4s ease",
                                opacity: isPanelExpanded ? 1 : 0,
                                transform: isPanelExpanded ? "translateY(0)" : "translateY(20px)",
                                pointerEvents: isPanelExpanded ? "auto" : "none"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (shap_of_you_module_default()).price_col_s,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            className: (shap_of_you_module_default()).tran_btn,
                                            onClick: function() {
                                                return selectedProduct && setIsOpen(true);
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                width: "24",
                                                height: "24",
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M12 9H12.01",
                                                        stroke: "white",
                                                        strokeWidth: "2",
                                                        strokeLinecap: "round",
                                                        strokeLinejoin: "round"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M11 12H12V16H13",
                                                        stroke: "white",
                                                        strokeWidth: "2",
                                                        strokeLinecap: "round",
                                                        strokeLinejoin: "round"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M12 3C19.2 3 21 4.8 21 12C21 19.2 19.2 21 12 21C4.8 21 3 19.2 3 12C3 4.8 4.8 3 12 3Z",
                                                        stroke: "white",
                                                        strokeWidth: "2",
                                                        strokeLinecap: "round",
                                                        strokeLinejoin: "round"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (shap_of_you_module_default()).price,
                                            children: [
                                                "₹",
                                                selectedProduct ? ((selectedProduct === null || selectedProduct === void 0 ? void 0 : (ref1 = selectedProduct.discount) === null || ref1 === void 0 ? void 0 : ref1.total) || selectedProduct.price || 0).toLocaleString("en-IN") : "0"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: (shap_of_you_module_default()).filter,
                                    onClick: function() {
                                        return navigateToStep("filterView");
                                    },
                                    style: {
                                        position: "relative"
                                    },
                                    children: [
                                        hasActiveFilters() ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: filter_icon,
                                            alt: "Filter Icon",
                                            width: 24,
                                            height: 24
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                            width: "24",
                                            height: "24",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M4 10C4 10.5304 4.21071 11.0391 4.58579 11.4142C4.96086 11.7893 5.46957 12 6 12C6.53043 12 7.03914 11.7893 7.41421 11.4142C7.78929 11.0391 8 10.5304 8 10C8 9.46957 7.78929 8.96086 7.41421 8.58579C7.03914 8.21071 6.53043 8 6 8C5.46957 8 4.96086 8.21071 4.58579 8.58579C4.21071 8.96086 4 9.46957 4 10Z",
                                                    stroke: "white",
                                                    strokeWidth: "2",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M6 4V8",
                                                    stroke: "white",
                                                    strokeWidth: "2",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M6 12V20",
                                                    stroke: "white",
                                                    strokeWidth: "2",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M10 16C10 16.5304 10.2107 17.0391 10.5858 17.4142C10.9609 17.7893 11.4696 18 12 18C12.5304 18 13.0391 17.7893 13.4142 17.4142C13.7893 17.0391 14 16.5304 14 16C14 15.4696 13.7893 14.9609 13.4142 14.5858C13.0391 14.2107 12.5304 14 12 14C11.4696 14 10.9609 14.2107 10.5858 14.5858C10.2107 14.9609 10 15.4696 10 16Z",
                                                    stroke: "white",
                                                    strokeWidth: "2",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M12 4V14",
                                                    stroke: "white",
                                                    strokeWidth: "2",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M12 18V20",
                                                    stroke: "white",
                                                    strokeWidth: "2",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M16 7C16 7.53043 16.2107 8.03914 16.5858 8.41421C16.9609 8.78929 17.4696 9 18 9C18.5304 9 19.0391 8.78929 19.4142 8.41421C19.7893 8.03914 20 7.53043 20 7C20 6.46957 19.7893 5.96086 19.4142 5.58579C19.0391 5.21071 18.5304 5 18 5C17.4696 5 16.9609 5.21071 16.5858 5.58579C16.2107 5.96086 16 6.46957 16 7Z",
                                                    stroke: "white",
                                                    strokeWidth: "2",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M18 4V5",
                                                    stroke: "white",
                                                    strokeWidth: "2",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M18 9V20",
                                                    stroke: "white",
                                                    strokeWidth: "2",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round"
                                                })
                                            ]
                                        }),
                                        "Filter"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (shap_of_you_module_default()).thumbnailRow,
                            style: {
                                transition: "opacity 0.4s ease, transform 0.4s ease",
                                opacity: isPanelExpanded ? 1 : 0,
                                transform: isPanelExpanded ? "translateY(0)" : "translateY(20px)",
                                pointerEvents: isPanelExpanded ? "auto" : "none"
                            },
                            children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    textAlign: "center",
                                    padding: "20px"
                                }
                            }) : products.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                                onSwiper: function(swiper) {
                                    swiperRef.current = swiper;
                                },
                                slidesPerView: 5,
                                centeredSlides: true,
                                loop: products.length > 5,
                                spaceBetween: 10,
                                pagination: {
                                    clickable: true
                                },
                                modules: [
                                    swiper_esm/* Pagination */.tl
                                ],
                                className: (shap_of_you_module_default()).mySwiper,
                                children: products.map(function(product, index) {
                                    var productId = String(product.sku);
                                    var isSelected = String(selected) === productId || String(selected) === String(product.id) || String(selected) === String(product.product_id);
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "".concat((shap_of_you_module_default()).slide, " ").concat(isSelected ? (shap_of_you_module_default()).selected : ""),
                                            onClick: function() {
                                                return handleProductSelect(product, productId, index);
                                            },
                                            style: {
                                                cursor: "pointer"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: getImageSrc(product),
                                                alt: product.name || "Product",
                                                width: 80,
                                                height: 80,
                                                onError: function(e) {
                                                    var target = e.target;
                                                    target.src = nekl_s/* default.src */.Z.src;
                                                }
                                            })
                                        })
                                    }, productId);
                                })
                            }, activeCategory) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    textAlign: "center",
                                    padding: "20px",
                                    color: "#fff"
                                },
                                children: "No products available"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (shap_of_you_module_default()).categoryTabs,
                            style: {
                                transition: "opacity 0.4s ease, transform 0.4s ease",
                                opacity: isPanelExpanded ? 1 : 0,
                                transform: isPanelExpanded ? "translateY(0)" : "translateY(20px)",
                                pointerEvents: isPanelExpanded ? "auto" : "none"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (shap_of_you_module_default()).tabs,
                                children: [
                                    availableCategories.includes("Earring") && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "".concat((shap_of_you_module_default()).tab, " ").concat(activeCategory === "Earring" ? (shap_of_you_module_default()).active : ""),
                                        onClick: function() {
                                            return handleCategoryClick("Earring");
                                        },
                                        children: "Earrings"
                                    }),
                                    availableCategories.includes("Necklace") && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "".concat((shap_of_you_module_default()).tab, " ").concat(activeCategory === "Necklace" ? (shap_of_you_module_default()).active : ""),
                                        onClick: function() {
                                            return handleCategoryClick("Necklace");
                                        },
                                        children: "Necklace"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (shap_of_you_module_default()).bottomBar,
                            style: {
                                transition: "opacity 0.4s ease, transform 0.4s ease",
                                opacity: isPanelExpanded ? 1 : 0,
                                transform: isPanelExpanded ? "translateY(0)" : "translateY(20px)",
                                pointerEvents: isPanelExpanded ? "auto" : "none"
                            },
                            children: [
                                showAddedSuccess ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    className: (shap_of_you_module_default()).cartBtn,
                                    disabled: true,
                                    style: {
                                        backgroundColor: "#28a745",
                                        cursor: "not-allowed"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            width: "24",
                                            height: "24",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M20 6L9 17L4 12",
                                                stroke: "white",
                                                strokeWidth: "2",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            })
                                        }),
                                        " ",
                                        "Added Successfully"
                                    ]
                                }) : cartItem ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: (shap_of_you_module_default()).cartBtn,
                                    disabled: true,
                                    style: {
                                        backgroundColor: "#22c55e",
                                        cursor: "default"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        style: {
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            gap: "8px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                width: "24",
                                                height: "24",
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M20 6L9 17L4 12",
                                                    stroke: "white",
                                                    strokeWidth: "2",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round"
                                                })
                                            }),
                                            "Added To Cart"
                                        ]
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: (shap_of_you_module_default()).cartBtn,
                                    onClick: function() {
                                        return addToCart(false);
                                    },
                                    disabled: cartActionLoading || !selectedProduct,
                                    style: {
                                        backgroundColor: cartActionLoading ? "#999" : undefined,
                                        cursor: cartActionLoading || !selectedProduct ? "not-allowed" : "pointer"
                                    },
                                    children: cartActionLoading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                                                animation: "border",
                                                size: "sm",
                                                className: "me-2"
                                            }),
                                            "Adding..."
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                width: "24",
                                                height: "24",
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M4 19C4 19.5304 4.21071 20.0391 4.58579 20.4142C4.96086 20.7893 5.46957 21 6 21C6.53043 21 7.03914 20.7893 7.41421 20.4142C7.78929 20.0391 8 19.5304 8 19C8 18.4696 7.78929 17.9609 7.41421 17.5858C7.03914 17.2107 6.53043 17 6 17C5.46957 17 4.96086 17.2107 4.58579 17.5858C4.21071 17.9609 4 18.4696 4 19Z",
                                                        stroke: "white",
                                                        strokeWidth: "2",
                                                        strokeLinecap: "round",
                                                        strokeLinejoin: "round"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M12.5 17H6V3H4",
                                                        stroke: "white",
                                                        strokeWidth: "2",
                                                        strokeLinecap: "round",
                                                        strokeLinejoin: "round"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M6 5L20 6L19.14 12.017M16.5 13H6",
                                                        stroke: "white",
                                                        strokeWidth: "2",
                                                        strokeLinecap: "round",
                                                        strokeLinejoin: "round"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M16 19H22",
                                                        stroke: "white",
                                                        strokeWidth: "2",
                                                        strokeLinecap: "round",
                                                        strokeLinejoin: "round"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M19 16V22",
                                                        stroke: "white",
                                                        strokeWidth: "2",
                                                        strokeLinecap: "round",
                                                        strokeLinejoin: "round"
                                                    })
                                                ]
                                            }),
                                            " ",
                                            "Add to Cart"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (shap_of_you_module_default()).share,
                                    onClick: function() {
                                        return navigateToStep("shareView");
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                        width: "18",
                                        height: "16",
                                        viewBox: "0 0 18 16",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M10.0002 0V4C3.42519 5.028 0.980188 10.788 0.000188363 16C-0.0368116 16.206 5.38419 10.038 10.0002 10V14L18.0002 7L10.0002 0Z",
                                            fill: "white"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (shap_of_you_module_default()).modal_pro,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "".concat((shap_of_you_module_default()).overlay, " ").concat(isOpen ? (shap_of_you_module_default()).show : ""),
                    onClick: function() {
                        return setIsOpen(false);
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: (shap_of_you_module_default()).closeBtn,
                            onClick: function() {
                                return setIsOpen(false);
                            },
                            children: "✕"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat((shap_of_you_module_default()).modal, " ").concat(isOpen ? (shap_of_you_module_default()).open : ""),
                            onClick: function(e) {
                                return e.stopPropagation();
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (shap_of_you_module_default()).contentn,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (shap_of_you_module_default()).container,
                                    children: selectedProduct ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (shap_of_you_module_default()).imageWrapper_n,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: getImageSrc(selectedProduct),
                                                    alt: selectedProduct.title || "Product",
                                                    width: 400,
                                                    height: 400,
                                                    onError: function(e) {
                                                        var target = e.target;
                                                        target.src = jel/* default.src */.Z.src;
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (shap_of_you_module_default()).content,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                        className: (shap_of_you_module_default()).title,
                                                        children: selectedProduct.title || selectedProduct.slug || "Product Details"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                                        className: (shap_of_you_module_default()).price,
                                                        style: {
                                                            display: "flex",
                                                            alignItems: "center",
                                                            gap: "8px",
                                                            flexWrap: "wrap"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                children: [
                                                                    "INR",
                                                                    " ",
                                                                    (selectedProduct === null || selectedProduct === void 0 ? void 0 : (ref2 = selectedProduct.discount) === null || ref2 === void 0 ? void 0 : ref2.total) || selectedProduct.price ? ((selectedProduct === null || selectedProduct === void 0 ? void 0 : (ref3 = selectedProduct.discount) === null || ref3 === void 0 ? void 0 : ref3.total) || selectedProduct.price).toLocaleString("en-IN") : "0"
                                                                ]
                                                            }),
                                                            (selectedProduct === null || selectedProduct === void 0 ? void 0 : (ref4 = selectedProduct.discount) === null || ref4 === void 0 ? void 0 : ref4.total) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                style: {
                                                                    textDecoration: "line-through",
                                                                    color: "#999",
                                                                    fontSize: "14px",
                                                                    fontWeight: 400
                                                                },
                                                                children: [
                                                                    "₹",
                                                                    (ref5 = selectedProduct.price) === null || ref5 === void 0 ? void 0 : ref5.toLocaleString("en-IN")
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (shap_of_you_module_default()).tabs,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "".concat((shap_of_you_module_default()).tab, " ").concat(activeTab === "description" ? (shap_of_you_module_default()).active : ""),
                                                                onClick: function() {
                                                                    return setActiveTab("description");
                                                                },
                                                                children: "Description"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "".concat((shap_of_you_module_default()).tab, " ").concat(activeTab === "details" ? (shap_of_you_module_default()).active : ""),
                                                                onClick: function() {
                                                                    return setActiveTab("details");
                                                                },
                                                                children: "Details"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "".concat((shap_of_you_module_default()).tab, " ").concat(activeTab === "price" ? (shap_of_you_module_default()).active : ""),
                                                                onClick: function() {
                                                                    return setActiveTab("price");
                                                                },
                                                                children: "Price Break-up"
                                                            })
                                                        ]
                                                    }),
                                                    activeTab === "description" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (shap_of_you_module_default()).description,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                children: (selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.title) || "Unveil your inner radiance with this beautiful jewellery piece. A perfect blend of elegance and craftsmanship."
                                                            }),
                                                            (selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.categories) && selectedProduct.categories.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                        children: "Category: "
                                                                    }),
                                                                    selectedProduct.categories.map(function(cat) {
                                                                        return cat.name;
                                                                    }).join(", ")
                                                                ]
                                                            }),
                                                            (selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.purities) && selectedProduct.purities.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                        children: "Purity: "
                                                                    }),
                                                                    selectedProduct.purities.join(", ")
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                style: {
                                                                    display: "flex",
                                                                    gap: "8px",
                                                                    flexWrap: "wrap",
                                                                    marginBottom: "12px"
                                                                },
                                                                children: [
                                                                    !!(selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.fastDelivery) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        style: {
                                                                            padding: "4px 8px",
                                                                            backgroundColor: "#28a745",
                                                                            color: "white",
                                                                            borderRadius: "4px",
                                                                            fontSize: "12px",
                                                                            fontWeight: "600"
                                                                        },
                                                                        children: "Fast Delivery"
                                                                    }),
                                                                    !!(selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.deal_of_the_day) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        style: {
                                                                            padding: "4px 8px",
                                                                            backgroundColor: "#ff6b6b",
                                                                            color: "white",
                                                                            borderRadius: "4px",
                                                                            fontSize: "12px",
                                                                            fontWeight: "600"
                                                                        },
                                                                        children: "Deal of the Day"
                                                                    }),
                                                                    !!(selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.trending) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        style: {
                                                                            padding: "4px 8px",
                                                                            backgroundColor: "#ffd93d",
                                                                            color: "#333",
                                                                            borderRadius: "4px",
                                                                            fontSize: "12px",
                                                                            fontWeight: "600"
                                                                        },
                                                                        children: "Trending"
                                                                    }),
                                                                    !!(selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.new_arrival) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        style: {
                                                                            padding: "4px 8px",
                                                                            backgroundColor: "#6c5ce7",
                                                                            color: "white",
                                                                            borderRadius: "4px",
                                                                            fontSize: "12px",
                                                                            fontWeight: "600"
                                                                        },
                                                                        children: "New Arrival"
                                                                    }),
                                                                    !!(selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.best_seller) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        style: {
                                                                            padding: "4px 8px",
                                                                            backgroundColor: "#0984e3",
                                                                            color: "white",
                                                                            borderRadius: "4px",
                                                                            fontSize: "12px",
                                                                            fontWeight: "600"
                                                                        },
                                                                        children: "Best Seller"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                className: "text-dark",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                        children: "Disclaimer:"
                                                                    }),
                                                                    " The dimension of the actual product might vary. Due to differences in photographic lighting, the colour may slightly differ."
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                className: (shap_of_you_module_default()).certificate,
                                                                children: "CERTIFICATE OF AUTHENTICITY"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                children: "Every piece of jewellery that we make is certified for authenticity by third-party laboratories like SGL, IGI, BIS and GIA."
                                                            })
                                                        ]
                                                    }),
                                                    activeTab === "details" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (shap_of_you_module_default()).description,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                className: (shap_of_you_module_default()).details_product,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                        children: "Design Code: "
                                                                    }),
                                                                    (selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.sku) || "N/A"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                className: (shap_of_you_module_default()).details_product,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                        children: "Gold Weight: "
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        children: "0.4 g (9K Gold)"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "d-none",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: (shap_of_you_module_default()).tooltip_icon_tooltip,
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: (shap_of_you_module_default()).tooltip_icon_tooltip_icon,
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                        className: "bi bi-info-circle-fill"
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: "".concat((shap_of_you_module_default()).tooltip_tooltip_container, " ").concat((shap_of_you_module_default()).tooltip_desktop_view_tool),
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                            className: (shap_of_you_module_default()).tooltip_container_main,
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                                                                        children: [
                                                                                                            " ",
                                                                                                            "In case the net weight of the actual product is less than the mentioned weight, a partial refund shall be initiated."
                                                                                                        ]
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                                                        children: "In case the net weight of the actual product is higher than the mentioned weight, we shall ask for the extra amount by sending a payment link."
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                                                        children: "The final invoice amount shall be adjusted in case there is any variation in net weight."
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        }),
                                                                                        " "
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    activeTab === "price" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (shap_of_you_module_default()).description,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                className: (shap_of_you_module_default()).price_brackup,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                        children: "Price: "
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                        style: {
                                                                            color: "#ff1933"
                                                                        },
                                                                        children: [
                                                                            "₹",
                                                                            (selectedProduct === null || selectedProduct === void 0 ? void 0 : (ref6 = selectedProduct.discount) === null || ref6 === void 0 ? void 0 : ref6.total) || (selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.price) ? ((selectedProduct === null || selectedProduct === void 0 ? void 0 : (ref7 = selectedProduct.discount) === null || ref7 === void 0 ? void 0 : ref7.total) || (selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.price)).toLocaleString("en-IN") : "0"
                                                                        ]
                                                                    }),
                                                                    (selectedProduct === null || selectedProduct === void 0 ? void 0 : (ref8 = selectedProduct.discount) === null || ref8 === void 0 ? void 0 : ref8.total) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                        style: {
                                                                            textDecoration: "line-through",
                                                                            color: "#999",
                                                                            marginLeft: "8px",
                                                                            fontSize: "14px"
                                                                        },
                                                                        children: [
                                                                            "₹",
                                                                            selectedProduct === null || selectedProduct === void 0 ? void 0 : (ref9 = selectedProduct.price) === null || ref9 === void 0 ? void 0 : ref9.toLocaleString("en-IN")
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            (selectedProduct === null || selectedProduct === void 0 ? void 0 : (ref10 = selectedProduct.discount) === null || ref10 === void 0 ? void 0 : ref10.total) && (selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.price) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                className: (shap_of_you_module_default()).price_brackup,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                        children: "You Save: "
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                        style: {
                                                                            color: "#28a745",
                                                                            fontWeight: 600
                                                                        },
                                                                        children: [
                                                                            "₹",
                                                                            (selectedProduct.price - selectedProduct.discount.total).toLocaleString("en-IN")
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            (selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.purities) && selectedProduct.purities.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                className: (shap_of_you_module_default()).price_brackup,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                        children: "Gold Purity: "
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        children: selectedProduct.purities.join(", ")
                                                                    })
                                                                ]
                                                            }),
                                                            typeof (selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.stock) !== "undefined" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                className: (shap_of_you_module_default()).price_brackup,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                        children: "Stock Status: "
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        style: {
                                                                            color: selectedProduct.stock > 0 ? "#28a745" : "#dc3545"
                                                                        },
                                                                        children: selectedProduct.stock > 0 ? "In Stock" : "Made To Order"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (shap_of_you_module_default()).bottomBar,
                                                children: showAddedSuccess ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                    className: (shap_of_you_module_default()).cartBtn,
                                                    disabled: true,
                                                    style: {
                                                        backgroundColor: "#28a745",
                                                        cursor: "not-allowed"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                            width: "24",
                                                            height: "24",
                                                            viewBox: "0 0 24 24",
                                                            fill: "none",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M20 6L9 17L4 12",
                                                                stroke: "white",
                                                                strokeWidth: "2",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round"
                                                            })
                                                        }),
                                                        " ",
                                                        "Added Successfully"
                                                    ]
                                                }) : cartItem ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    className: (shap_of_you_module_default()).cartBtn,
                                                    disabled: true,
                                                    style: {
                                                        backgroundColor: "#22c55e",
                                                        cursor: "default"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        style: {
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            gap: "8px"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                                width: "24",
                                                                height: "24",
                                                                viewBox: "0 0 24 24",
                                                                fill: "none",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                    d: "M20 6L9 17L4 12",
                                                                    stroke: "white",
                                                                    strokeWidth: "2",
                                                                    strokeLinecap: "round",
                                                                    strokeLinejoin: "round"
                                                                })
                                                            }),
                                                            "Added To Cart"
                                                        ]
                                                    })
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    className: (shap_of_you_module_default()).cartBtn,
                                                    onClick: function() {
                                                        return addToCart(false);
                                                    },
                                                    disabled: cartActionLoading || !selectedProduct,
                                                    style: {
                                                        backgroundColor: cartActionLoading ? "#999" : undefined,
                                                        cursor: cartActionLoading || !selectedProduct ? "not-allowed" : "pointer"
                                                    },
                                                    children: cartActionLoading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                                                                animation: "border",
                                                                size: "sm",
                                                                className: "me-2"
                                                            }),
                                                            "Adding..."
                                                        ]
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                                width: "24",
                                                                height: "24",
                                                                viewBox: "0 0 24 24",
                                                                fill: "none",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                        d: "M4 19C4 19.5304 4.21071 20.0391 4.58579 20.4142C4.96086 20.7893 5.46957 21 6 21C6.53043 21 7.03914 20.7893 7.41421 20.4142C7.78929 20.0391 8 19.5304 8 19C8 18.4696 7.78929 17.9609 7.41421 17.5858C7.03914 17.2107 6.53043 17 6 17C5.46957 17 4.96086 17.2107 4.58579 17.5858C4.21071 17.9609 4 18.4696 4 19Z",
                                                                        stroke: "white",
                                                                        strokeWidth: "2",
                                                                        strokeLinecap: "round",
                                                                        strokeLinejoin: "round"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                        d: "M12.5 17H6V3H4",
                                                                        stroke: "white",
                                                                        strokeWidth: "2",
                                                                        strokeLinecap: "round",
                                                                        strokeLinejoin: "round"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                        d: "M6 5L20 6L19.14 12.017M16.5 13H6",
                                                                        stroke: "white",
                                                                        strokeWidth: "2",
                                                                        strokeLinecap: "round",
                                                                        strokeLinejoin: "round"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                        d: "M16 19H22",
                                                                        stroke: "white",
                                                                        strokeWidth: "2",
                                                                        strokeLinecap: "round",
                                                                        strokeLinejoin: "round"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                        d: "M19 16V22",
                                                                        stroke: "white",
                                                                        strokeWidth: "2",
                                                                        strokeLinecap: "round",
                                                                        strokeLinejoin: "round"
                                                                    })
                                                                ]
                                                            }),
                                                            " ",
                                                            "Add to Cart"
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        style: {
                                            padding: "20px",
                                            textAlign: "center"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "No product selected"
                                        })
                                    })
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(shape_of_you_mobile_CartModal, {
                isOpen: isCartOpen,
                setIsOpen: setIsCartOpen
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(shape_of_you_mobile_LiveCameraPermissionModal, {
                isOpen: showCameraPermissionModal,
                onPermissionGranted: handleCameraPermissionAllowed,
                onPermissionDenied: handleCameraPermissionDenied,
                logStep: logStep
            })
        ]
    });
};
/* harmony default export */ var shape_of_you_mobile_ProductViewScreen = (ProductViewScreen);

;// CONCATENATED MODULE: ./src/assets/images/loshare.png
/* harmony default export */ var loshare = ({"src":"/_next/static/media/loshare.848ed91c.png","height":71,"width":73,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAM1BMVEXIEBP////cUlfUMTf//v7//v///f3//////v7WOT/////////++/v99/f+/Pz////YQkgz/6tHAAAAEHRSTlMlMv4BVRhII+6xDX+XRH1qWTXMiQAAAAlwSFlzAAALEwAACxMBAJqcGAAAADtJREFUeJwVyEkSwCAMA0EJy0uALP9/bUyfpgYYX7sMGEdH52FQZNDpkKL2/RBMn8w+tSxelRA0uuf8AS7nAVIUk3G/AAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./src/components/shape-of-you-mobile/ShareViewScreen.tsx









var ShareViewScreen = function(param) {
    var navigateToStep = param.navigateToStep, virtualTryOnImage = param.virtualTryOnImage, capturedImage = param.capturedImage, logStep = param.logStep;
    ;
    ;
    var ref = (0,react.useState)(false), hasShared = ref[0], setHasShared = ref[1];
    // Determine which image to display (same priority as ProductViewScreen)
    // Priority: virtualTryOnImage (with jewelry) > capturedImage (original) > default
    var displayImage = virtualTryOnImage || capturedImage || ProductPage_Default_Selection;
    var isBase64 = typeof displayImage === "string" && displayImage.startsWith("data:");
    // Composite the user photo with both logos using Canvas
    var compositeImageWithLogos = function(imageUrl) {
        return new Promise(function(resolve, reject) {
            var canvas = document.createElement("canvas");
            var ctx = canvas.getContext("2d");
            if (!ctx) return reject(new Error("Canvas not supported"));
            var mainImg = new window.Image();
            mainImg.crossOrigin = "anonymous";
            mainImg.onload = function() {
                canvas.width = mainImg.width;
                canvas.height = mainImg.height;
                ctx.drawImage(mainImg, 0, 0);
                var padding = canvas.width * 0.03;
                var logoHeight = canvas.height * 0.08;
                var shapeImg = new window.Image();
                shapeImg.crossOrigin = "anonymous";
                shapeImg.onload = function() {
                    // Draw Shape of You logo — top-right
                    var shapeW = shapeImg.width / shapeImg.height * logoHeight;
                    ctx.drawImage(shapeImg, canvas.width - padding - shapeW, padding, shapeW, logoHeight);
                    // Draw text — bottom center
                    var fontSize = Math.max(12, canvas.height * 0.022);
                    ctx.font = "".concat(fontSize, "px sans-serif");
                    ctx.fillStyle = "#ffffff";
                    ctx.textAlign = "center";
                    ctx.shadowColor = "rgba(0,0,0,0.6)";
                    ctx.shadowBlur = 4;
                    var lineSpacing = fontSize * 1.4;
                    var textY = canvas.height - padding - lineSpacing;
                    ctx.fillText("Shop jewellery made for your face shape", canvas.width / 2, textY);
                    ctx.fillText("www.sencogoldanddiamonds.com", canvas.width / 2, textY + lineSpacing);
                    ctx.shadowBlur = 0;
                    resolve(canvas.toDataURL("image/jpeg", 0.92));
                };
                shapeImg.onerror = function() {
                    return resolve(canvas.toDataURL("image/jpeg", 0.92));
                };
                var _src;
                shapeImg.src = (_src = loshare.src) !== null && _src !== void 0 ? _src : loshare;
            };
            mainImg.onerror = reject;
            mainImg.src = imageUrl;
        });
    };
    // Handle download functionality
    var handleDownload = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var downloadImage, composited, link;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        downloadImage = virtualTryOnImage || capturedImage;
                        if (downloadImage) {
                            _ctx.next = 5;
                            break;
                        }
                        react_toastify_esm/* toast.error */.Am.error("No image available to download");
                        return _ctx.abrupt("return");
                    case 5:
                        _ctx.next = 7;
                        return compositeImageWithLogos(downloadImage);
                    case 7:
                        composited = _ctx.sent;
                        link = document.createElement("a");
                        link.href = composited;
                        link.download = "senco-jewelry-tryon.jpg";
                        link.style.display = "none";
                        document.body.appendChild(link);
                        link.click();
                        setTimeout(function() {
                            return document.body.removeChild(link);
                        }, 100);
                        if (logStep) logStep("share_view_download_clicked");
                        react_toastify_esm/* toast.success */.Am.success("Image downloaded successfully");
                        _ctx.next = 23;
                        break;
                    case 19:
                        _ctx.prev = 19;
                        _ctx.t0 = _ctx["catch"](0);
                        ;
                        react_toastify_esm/* toast.error */.Am.error("Failed to download image. Please try again.");
                    case 23:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    19
                ]
            ]);
        }));
        return function handleDownload() {
            return _ref.apply(this, arguments);
        };
    }();
    // Handle share functionality
    var handleShare = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var composited, base64Response, blob, file, link;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        if (isBase64) {
                            _ctx.next = 4;
                            break;
                        }
                        react_toastify_esm/* toast.error */.Am.error("No image available to share");
                        return _ctx.abrupt("return");
                    case 4:
                        _ctx.next = 6;
                        return compositeImageWithLogos(displayImage);
                    case 6:
                        composited = _ctx.sent;
                        _ctx.next = 9;
                        return fetch(composited);
                    case 9:
                        base64Response = _ctx.sent;
                        _ctx.next = 12;
                        return base64Response.blob();
                    case 12:
                        blob = _ctx.sent;
                        file = new File([
                            blob
                        ], "senco-jewelry-tryon.jpg", {
                            type: "image/jpeg"
                        });
                        if (!("share" in navigator && "canShare" in navigator && navigator.canShare({
                            files: [
                                file
                            ]
                        }))) {
                            _ctx.next = 20;
                            break;
                        }
                        _ctx.next = 17;
                        return navigator.share({
                            title: "My Senco Jewellery Look",
                            text: "Check out how I look with Senco Jewellery! They suggested pieces based on my face shape —https://sencogoldanddiamonds.com/shape-of-you you should try this too!",
                            files: [
                                file
                            ]
                        });
                    case 17:
                        setHasShared(true);
                        _ctx.next = 27;
                        break;
                    case 20:
                        if (!("share" in navigator)) {
                            _ctx.next = 26;
                            break;
                        }
                        _ctx.next = 23;
                        return navigator.share({
                            title: "My Senco Jewellery Look",
                            text: "Check out how I look with Senco Jewellery! They suggested pieces based on my face shape —https://sencogoldanddiamonds.com/shape-of-you you should try this too!",
                            url: window.location.href
                        });
                    case 23:
                        setHasShared(true);
                        _ctx.next = 27;
                        break;
                    case 26:
                        {
                            link = document.createElement("a");
                            link.href = composited;
                            link.download = "senco-jewelry-tryon.jpg";
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                            react_toastify_esm/* toast.success */.Am.success("Image downloaded successfully");
                        }
                    case 27:
                        _ctx.next = 32;
                        break;
                    case 29:
                        _ctx.prev = 29;
                        _ctx.t0 = _ctx["catch"](0);
                        if (_ctx.t0.name !== "AbortError") {
                            ;
                            react_toastify_esm/* toast.error */.Am.error("Failed to share. Please try again.");
                        }
                    case 32:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    29
                ]
            ]);
        }));
        return function handleShare() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "d-md-none w-100",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (shap_of_you_module_default()).card_share,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (shap_of_you_module_default()).card,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (shap_of_you_module_default()).image_sh,
                        children: isBase64 ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: displayImage,
                            alt: "Jewelry Model",
                            className: (shap_of_you_module_default()).image,
                            width: 500,
                            height: 500,
                            unoptimized: true
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: displayImage,
                            alt: "Jewelry Model",
                            className: (shap_of_you_module_default()).image
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (shap_of_you_module_default()).topLeft,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: (shap_of_you_module_default()).backshare,
                                onClick: function() {
                                    if (logStep) {
                                        logStep("share_view_back_clicked");
                                    }
                                    navigateToStep("productView");
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: "bi bi-arrow-left"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: loshare,
                                alt: "Jewelry Model",
                                className: (shap_of_you_module_default()).image
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (shap_of_you_module_default()).bottom_sharre,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: (shap_of_you_module_default()).dwn,
                                onClick: handleDownload,
                                style: {
                                    cursor: "pointer"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: "bi bi-download"
                                })
                            }),
                            !hasShared && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    "Shop jewellery made for your face shape",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "#",
                                        children: "www.sencogoldanddiamonds.com "
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (shap_of_you_module_default()).shareWrapper,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                className: (shap_of_you_module_default()).retake,
                                onClick: function() {
                                    if (logStep) {
                                        logStep("share_view_retake_clicked");
                                    }
                                    navigateToStep("uploadOrScan");
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (shap_of_you_module_default()).icon,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            width: "18",
                                            height: "18",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M5.46257 4.43262C7.21556 2.91688 9.5007 2 12 2C17.5228 2 22 6.47715 22 12C22 14.1361 21.3302 16.1158 20.1892 17.7406L17 12H20C20 7.58172 16.4183 4 12 4C9.84982 4 7.89777 4.84827 6.46023 6.22842L5.46257 4.43262ZM18.5374 19.5674C16.7844 21.0831 14.4993 22 12 22C6.47715 22 2 17.5228 2 12C2 9.86386 2.66979 7.88416 3.8108 6.25944L7 12H4C4 16.4183 7.58172 20 12 20C14.1502 20 16.1022 19.1517 17.5398 17.7716L18.5374 19.5674Z",
                                                fill: "white"
                                            })
                                        })
                                    }),
                                    "Retake"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                className: (shap_of_you_module_default()).shareBtn,
                                onClick: handleShare,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (shap_of_you_module_default()).icon,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            width: "20",
                                            height: "18",
                                            viewBox: "0 0 20 18",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M11.0002 1V5C4.42522 6.028 1.98022 11.788 1.00022 17C0.963219 17.206 6.38422 11.038 11.0002 11V15L19.0002 8L11.0002 1Z",
                                                stroke: "white",
                                                strokeWidth: "2",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            })
                                        })
                                    }),
                                    "Share"
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var shape_of_you_mobile_ShareViewScreen = (ShareViewScreen);

;// CONCATENATED MODULE: ./src/components/shape-of-you-mobile/PhotoCaptureFlow.tsx
















var PhotoCaptureFlow = function(param) {
    var initialStep = param.initialStep, isAuthenticated = param.isAuthenticated, onComplete = param.onComplete, onExit = param.onExit, logStep = param.logStep;
    var dispatch = (0,store/* useAppDispatch */.T)();
    // Internal state management
    var ref = (0,react.useState)(initialStep), currentStep = ref[0], setCurrentStep = ref[1];
    var ref1 = (0,react.useState)(false), isLoading = ref1[0], setIsLoading = ref1[1];
    var ref2 = (0,react.useState)(null), capturedImage = ref2[0], setCapturedImage = ref2[1];
    var ref3 = (0,react.useState)("upload"), captureMethod = ref3[0], setCaptureMethod = ref3[1];
    var ref4 = (0,react.useState)({
        faceShape: "",
        complexion: "",
        undertone: ""
    }), faceData = ref4[0], setFaceData = ref4[1];
    // Internal navigation - accepts MobileStep for compatibility but only handles PhotoCaptureStep
    var navigateToStep = function(step) {
        var validSteps = [
            "uploadOrScan",
            "galleryPermission",
            "cameraPermission",
            "faceScanning",
            "permissionDenied",
            "imageNotPermitted",
            "faceResult", 
        ];
        if (validSteps.includes(step)) {
            setCurrentStep(step);
        } else {
            ;
        }
    };
    // Send image to API (following FaceScan pattern)
    var sendImageToAPI = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(base64Image) {
            var method, requestPayload, apiEndpoint, ref, data, ref1, ref2, ref3, ref4, ref5, _args = arguments;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        method = _args.length > 1 && _args[1] !== void 0 ? _args[1] : "upload";
                        setIsLoading(true);
                        requestPayload = {
                            image_data: base64Image
                        };
                        apiEndpoint = endpoints/* default.shape_of_you.profile */.Z.shape_of_you.profile();
                        _ctx.prev = 4;
                        ;
                        _ctx.next = 8;
                        return http_client/* default.post */.Z.post(apiEndpoint, requestPayload);
                    case 8:
                        data = _ctx.sent.data;
                        ;
                        // Log successful face scan with API response (non-blocking)
                        if (logStep) {
                            logStep("face_scan_uploaded", {
                                api_endpoint: apiEndpoint,
                                request_payload: {
                                    image_data: "[base64...]"
                                },
                                response_status: 200,
                                response_payload: {
                                    face_shape: data.face_shape,
                                    tone: data.tone,
                                    undertone: data.undertone
                                }
                            });
                        }
                        // Store in Redux
                        dispatch(shapeOfYou/* shapeOfYouActions.setCapturedImage */.r1.setCapturedImage(base64Image));
                        // Extract and store response data
                        setCapturedImage(base64Image);
                        setCaptureMethod(method);
                        setFaceData({
                            faceShape: ((ref = data.face_shape) === null || ref === void 0 ? void 0 : ref.label) || "",
                            complexion: (data === null || data === void 0 ? void 0 : data.tone) || "",
                            undertone: (data === null || data === void 0 ? void 0 : data.undertone) || ""
                        });
                        // Navigate to result screen
                        navigateToStep("faceResult");
                        _ctx.next = 25;
                        break;
                    case 18:
                        _ctx.prev = 18;
                        _ctx.t0 = _ctx["catch"](4);
                        ;
                        // Log API error (non-blocking)
                        if (logStep) {
                            ;
                            logStep("face_scan_uploaded_failed", {
                                api_endpoint: apiEndpoint,
                                request_payload: {
                                    image_data: "[base64...]"
                                },
                                response_status: ((ref1 = _ctx.t0.response) === null || ref1 === void 0 ? void 0 : ref1.status) || 500,
                                error_message: ((ref2 = _ctx.t0.response) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : ref3.message) || "Failed to analyze image",
                                error_code: ((ref4 = _ctx.t0.response) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.status) === null || ref5 === void 0 ? void 0 : ref5.toString()) || "500"
                            });
                        }
                        setCapturedImage(base64Image);
                        setCaptureMethod(method);
                        navigateToStep("imageNotPermitted");
                    case 25:
                        _ctx.prev = 25;
                        setIsLoading(false);
                        return _ctx.finish(25);
                    case 28:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    4,
                    18,
                    25,
                    28
                ]
            ]);
        }));
        return function sendImageToAPI(base64Image) {
            return _ref.apply(this, arguments);
        };
    }();
    // Wrapper for upload method
    var handleUploadImage = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(base64Image) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return sendImageToAPI(base64Image, "upload");
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleUploadImage(base64Image) {
            return _ref.apply(this, arguments);
        };
    }();
    // Wrapper for scan method
    var handleScanImage = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(base64Image) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return sendImageToAPI(base64Image, "scan");
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleScanImage(base64Image) {
            return _ref.apply(this, arguments);
        };
    }();
    // Handle reupload - reset state and go back to start
    var handleReupload = function() {
        setCapturedImage(null);
        setCaptureMethod("upload");
        setFaceData({
            faceShape: "",
            complexion: "",
            undertone: ""
        });
        navigateToStep("uploadOrScan");
    };
    // Handle explore jewellery - fetch recommendations then call parent onComplete
    var handleExploreJewellery = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(!faceData.faceShape || !capturedImage)) {
                            _ctx.next = 3;
                            break;
                        }
                        react_toastify_esm/* toast.error */.Am.error("No data available");
                        return _ctx.abrupt("return");
                    case 3:
                        setIsLoading(true);
                        _ctx.prev = 4;
                        _ctx.next = 7;
                        return http_client/* default.post */.Z.post(endpoints/* default.shape_of_you.run */.Z.shape_of_you.run(), {
                            complexion: faceData.complexion,
                            face_shape: faceData.faceShape,
                            tone: faceData.undertone
                        });
                    case 7:
                        data = _ctx.sent.data;
                        ;
                        // Store recommendations in Redux
                        dispatch(shapeOfYou/* shapeOfYouActions.setRecommendations */.r1.setRecommendations(data));
                        // Call parent onComplete to navigate
                        onComplete({
                            faceShape: faceData.faceShape,
                            complexion: faceData.complexion,
                            undertone: faceData.undertone,
                            capturedImage: capturedImage
                        });
                        _ctx.next = 17;
                        break;
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](4);
                        ;
                        react_toastify_esm/* toast.error */.Am.error("Failed to get recommendations. Please try again.");
                    case 17:
                        _ctx.prev = 17;
                        setIsLoading(false);
                        return _ctx.finish(17);
                    case 20:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    4,
                    13,
                    17,
                    20
                ]
            ]);
        }));
        return function handleExploreJewellery() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            currentStep === "uploadOrScan" && /*#__PURE__*/ (0,jsx_runtime.jsx)(shape_of_you_mobile_UploadOrScanScreen, {
                navigateToStep: navigateToStep,
                onImageSelect: handleUploadImage
            }),
            currentStep === "galleryPermission" && /*#__PURE__*/ (0,jsx_runtime.jsx)(shape_of_you_mobile_GalleryPermissionScreen, {
                navigateToStep: navigateToStep,
                onImageSelect: handleUploadImage,
                logStep: logStep
            }),
            currentStep === "cameraPermission" && /*#__PURE__*/ (0,jsx_runtime.jsx)(shape_of_you_mobile_CameraPermissionScreen, {
                navigateToStep: navigateToStep,
                logStep: logStep
            }),
            currentStep === "faceScanning" && /*#__PURE__*/ (0,jsx_runtime.jsx)(shape_of_you_mobile_FaceScanningScreen, {
                navigateToStep: navigateToStep,
                onCapture: handleScanImage
            }),
            currentStep === "permissionDenied" && /*#__PURE__*/ (0,jsx_runtime.jsx)(shape_of_you_mobile_PermissionDeniedScreen, {
                navigateToStep: navigateToStep,
                isAuthenticated: isAuthenticated,
                onExit: onExit
            }),
            currentStep === "faceResult" && /*#__PURE__*/ (0,jsx_runtime.jsx)(shape_of_you_mobile_FaceResultScreen, {
                navigateToStep: navigateToStep,
                isAuthenticated: isAuthenticated,
                faceShape: faceData.faceShape,
                complexion: faceData.complexion,
                capturedImage: capturedImage,
                captureMethod: captureMethod,
                onReupload: handleReupload,
                onExploreJewellery: handleExploreJewellery
            }),
            currentStep === "imageNotPermitted" && /*#__PURE__*/ (0,jsx_runtime.jsx)(shape_of_you_mobile_ImageNotPermittedScreen, {
                navigateToStep: navigateToStep,
                errorMessage: "No face detected in the image. Please try again with a clear photo showing your face.",
                onRetry: handleReupload,
                capturedImage: capturedImage
            }),
            isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100vw",
                    height: "100vh",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "rgba(0, 0, 0, 0.7)",
                    zIndex: 9999
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        textAlign: "center",
                        color: "#fff"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "spinner-border text-light mb-3",
                            role: "status",
                            style: {
                                width: "3rem",
                                height: "3rem"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "visually-hidden",
                                children: "Analyzing image..."
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            style: {
                                fontSize: "1.2rem",
                                fontWeight: "bold"
                            },
                            children: "Analyzing your image..."
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var shape_of_you_mobile_PhotoCaptureFlow = (PhotoCaptureFlow);

;// CONCATENATED MODULE: ./src/components/shape-of-you-mobile/AuthenticationFlow.tsx





var AuthenticationFlow = function(param) {
    var initialStep = param.initialStep, onComplete = param.onComplete, onExit = param.onExit, logStep = param.logStep;
    // Internal state management
    var ref = (0,react.useState)(initialStep), currentStep = ref[0], setCurrentStep = ref[1];
    var ref1 = (0,react.useState)("login"), authFlow = ref1[0], setAuthFlow = ref1[1];
    var ref2 = (0,react.useState)(""), mobileNumber = ref2[0], setMobileNumber = ref2[1];
    var ref3 = (0,react.useState)(false), otpUid = ref3[0], setOtpUid = ref3[1];
    var ref4 = (0,react.useState)({
        firstName: "",
        lastName: "",
        email: "",
        mobile: "",
        pincode: ""
    }), registerData = ref4[0], setRegisterData = ref4[1];
    // Internal navigation - accepts MobileStep for compatibility but only handles AuthStep
    var navigateToStep = function(step) {
        var validSteps = [
            "login",
            "signup",
            "verifyOtp"
        ];
        if (validSteps.includes(step)) {
            setCurrentStep(step);
        } else {
            ;
        }
    };
    // Prepare authData object for child components
    var authData = {
        authFlow: authFlow,
        setAuthFlow: setAuthFlow,
        mobileNumber: mobileNumber,
        setMobileNumber: setMobileNumber,
        otpUid: otpUid,
        setOtpUid: setOtpUid,
        registerData: registerData,
        setRegisterData: setRegisterData
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            currentStep === "login" && /*#__PURE__*/ (0,jsx_runtime.jsx)(shape_of_you_mobile_LoginScreen, {
                navigateToStep: navigateToStep,
                authData: authData,
                logStep: logStep
            }),
            currentStep === "signup" && /*#__PURE__*/ (0,jsx_runtime.jsx)(shape_of_you_mobile_SignupScreen, {
                navigateToStep: navigateToStep,
                authData: authData,
                logStep: logStep
            }),
            currentStep === "verifyOtp" && /*#__PURE__*/ (0,jsx_runtime.jsx)(shape_of_you_mobile_VerifyOtpScreen, {
                navigateToStep: navigateToStep,
                authData: authData,
                onAuthComplete: onComplete,
                logStep: logStep
            })
        ]
    });
};
/* harmony default export */ var shape_of_you_mobile_AuthenticationFlow = (AuthenticationFlow);

;// CONCATENATED MODULE: ./src/components/shape-of-you-mobile/index.ts
// Export all mobile components






















;// CONCATENATED MODULE: ./src/components/shape-of-you-desktop-new/SplashScreen.tsx






var SplashScreen_SplashScreen = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "d-none d-md-block w-100",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (shap_of_you_module_default()).desktop_view_shap,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (shap_of_you_module_default()).shapeOfYou,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (shap_of_you_module_default()).content,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (shap_of_you_module_default()).title,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: SENCO_SHAPE_OF_YOU_FULL_2,
                                alt: "Shape of You Logo"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (shap_of_you_module_default()).byLine,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: senco_shap_scree,
                                alt: "Senco Gold & Diamonds",
                                className: (shap_of_you_module_default()).logo
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var shape_of_you_desktop_new_SplashScreen = (SplashScreen_SplashScreen);

;// CONCATENATED MODULE: ./src/assets/images/WalkthroughScreen3.png
/* harmony default export */ var WalkthroughScreen3 = ({"src":"/_next/static/media/WalkthroughScreen3.cefad15d.png","height":1117,"width":1728,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAOVBMVEWxk3awjWiIOi64fGuQZkmgdFC7ooe/VEeSTjd7PSqnU0KiMy+wnXx9Kx2ILB/MyL29rpy3OzZ5LyAktoAKAAAACXBIWXMAAAsTAAALEwEAmpwYAAAALklEQVR4nAXBhQGAMBAAsXuvUIH9hyWhJNylbYwIYSk3q4Z+nbR3ageOzdE8nx8VDwEKEdPlAwAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./src/components/shape-of-you-desktop-new/WalkthroughScreen.tsx













var shape_of_you_desktop_new_WalkthroughScreen_WalkthroughScreen = function(param) {
    var navigateToStep = param.navigateToStep, isAuthenticated = param.isAuthenticated, logStep = param.logStep;
    var ref = (0,react.useState)(false), loading = ref[0], setLoading = ref[1];
    // Log intro slider viewed on mount
    (0,react.useEffect)(function() {
        if (logStep) {
            logStep("intro_slider_viewed");
        }
    }, [
        logStep
    ]);
    // Handle "Get Started" button click with consent checking (same as mobile)
    var handleGetStarted = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setLoading(true);
                        _ctx.prev = 1;
                        if (!isAuthenticated) {
                            _ctx.next = 9;
                            break;
                        }
                        _ctx.next = 5;
                        return http_client/* default.get */.Z.get(endpoints/* default.auth.getConsentForm */.Z.auth.getConsentForm());
                    case 5:
                        data = _ctx.sent.data;
                        if (data.statusText === "accepted") {
                            ;
                            navigateToStep("welcome");
                        } else {
                            // Scenario 2: Consent rejected - show TC screen
                            navigateToStep("tc");
                        }
                        _ctx.next = 10;
                        break;
                    case 9:
                        {
                            // Scenario 3: User is NOT authenticated - go to TC without API call
                            navigateToStep("tc");
                        }
                    case 10:
                        _ctx.next = 16;
                        break;
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](1);
                        ;
                        // If API fails, show TC screen anyway
                        navigateToStep("tc");
                    case 16:
                        _ctx.prev = 16;
                        setLoading(false);
                        return _ctx.finish(16);
                    case 19:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    12,
                    16,
                    19
                ]
            ]);
        }));
        return function handleGetStarted() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "d-none d-md-block w-100",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (shap_of_you_module_default()).wrapper_slider_desktop,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* Swiper */.tq, {
                spaceBetween: 0,
                navigation: false,
                // pagination={{
                //   clickable: false,
                // }}
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false
                },
                modules: [
                    swiper_esm/* Navigation */.W_,
                    swiper_esm/* Autoplay */.pt
                ],
                className: "mySwiper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (shap_of_you_module_default()).swiperSlide,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (shap_of_you_module_default()).slide,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: (shap_of_you_module_default()).bgImage,
                                        src: WalkthroughScreen,
                                        alt: "Scan Your Face"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (shap_of_you_module_default()).overlay_n,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                children: "Scan Your Face"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Upload or take a photo of your face"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (shap_of_you_module_default()).swiperSlide,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (shap_of_you_module_default()).slide,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: (shap_of_you_module_default()).bgImage,
                                        src: WalkthroughScreen2n,
                                        alt: "Live Analysis"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (shap_of_you_module_default()).overlay_n,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                children: "Live Analysis"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Get instant analysis of your face type"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (shap_of_you_module_default()).swiperSlide,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (shap_of_you_module_default()).banner1,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: (shap_of_you_module_default()).bgImage,
                                        src: WalkthroughScreen3,
                                        alt: ""
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (shap_of_you_module_default()).overlay_n,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("aside", {
                                            className: "w-100",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                    children: "The Shape of You"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "Discover your face shape and shop jewellery made for you."
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (shap_of_you_module_default()).buttonGroup,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (shap_of_you_module_default()).btn_conta,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                className: (shap_of_you_module_default()).secondaryBtn,
                                                                onClick: function() {
                                                                    return navigateToStep("about");
                                                                },
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: "Know More"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                                className: (shap_of_you_module_default()).primaryBtn,
                                                                onClick: handleGetStarted,
                                                                disabled: loading,
                                                                style: loading ? {
                                                                    background: "#d3d3d3",
                                                                    color: "#888",
                                                                    cursor: "not-allowed",
                                                                    opacity: 0.6
                                                                } : {},
                                                                children: [
                                                                    loading ? "Loading..." : "Get Started",
                                                                    " ",
                                                                    !loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                                        width: "25",
                                                                        height: "17",
                                                                        viewBox: "0 0 30 20",
                                                                        fill: "none",
                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                            d: "M0.000209928 11.0458L0 8.04596H24.2579L18.3333 2.12131L20.4546 0L30.0006 9.54596L20.4546 19.092L18.3333 16.9705L24.258 11.046L0.000209928 11.0458Z",
                                                                            fill: "white"
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var shape_of_you_desktop_new_WalkthroughScreen = (shape_of_you_desktop_new_WalkthroughScreen_WalkthroughScreen);

;// CONCATENATED MODULE: ./src/assets/images/sph-logo.png
/* harmony default export */ var sph_logo = ({"src":"/_next/static/media/sph-logo.389591b2.png","height":90,"width":320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAG1BMVEWSKDDQLDPaR02NGCWLGCXXQEaLGCV5Eh9HcExdBXVkAAAACXRSTlMhCNlaVa1HMgBxEjWkAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGklEQVR4nGNgY2Zh4GBkZGRgYWBmZ2BiYgUAAdEAMCYUjvUAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/components/shape-of-you-desktop-new/AboutScreen.tsx









var AboutScreen_AboutScreen = function(param) {
    var navigateToStep = param.navigateToStep, isAuthenticated = param.isAuthenticated, logStep = param.logStep;
    var ref = (0,react.useState)(false), loading = ref[0], setLoading = ref[1];
    // Handle "Start Experience" button click with consent checking
    var handleStartExperience = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setLoading(true);
                        // Log intro experience started
                        if (logStep) {
                            logStep("intro_experience_started");
                        }
                        _ctx.prev = 2;
                        if (!isAuthenticated) {
                            _ctx.next = 10;
                            break;
                        }
                        _ctx.next = 6;
                        return http_client/* default.get */.Z.get(endpoints/* default.auth.getConsentForm */.Z.auth.getConsentForm());
                    case 6:
                        data = _ctx.sent.data;
                        if (data.statusText === "accepted") {
                            ;
                            navigateToStep("welcome");
                        } else {
                            // Scenario 2: Consent rejected - show TC screen
                            navigateToStep("tc");
                        }
                        _ctx.next = 11;
                        break;
                    case 10:
                        {
                            // Scenario 3: User is NOT authenticated - go to TC without API call
                            navigateToStep("tc");
                        }
                    case 11:
                        _ctx.next = 17;
                        break;
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](2);
                        ;
                        // If API fails, show TC screen anyway
                        navigateToStep("tc");
                    case 17:
                        _ctx.prev = 17;
                        setLoading(false);
                        return _ctx.finish(17);
                    case 20:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    13,
                    17,
                    20
                ]
            ]);
        }));
        return function handleStartExperience() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "d-none d-md-block w-100",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            className: (shap_of_you_module_default()).experienceSectionDesktop,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "d-none d-md-block w-100",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (shap_of_you_module_default()).experienceCard,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (shap_of_you_module_default()).experienceContent,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row align-items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-7",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (shap_of_you_module_default()).videoContainer,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("video", {
                                            width: "100%",
                                            height: "auto",
                                            controls: true,
                                            autoPlay: false,
                                            muted: true,
                                            loop: true,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                                    src: "https://sencowebfiles.s3.ap-south-1.amazonaws.com/website/files/Shape_Of_You_Story_6.mp4",
                                                    type: "video/mp4"
                                                }),
                                                "Your browser does not support the video tag."
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-5",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (shap_of_you_module_default()).textContent,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (shap_of_you_module_default()).brandLogo,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: sph_logo,
                                                    alt: "Shape of You Logo"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                children: "Jewellery That Matches Your Face Shape"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Every face tells its own story, and the jewellery you wear should reflect that individuality. Understanding the shape of your face is the key to selecting pieces that not only complement your natural features but elevate them with effortless elegance. With Shape of You, Senco's innovative expert styling approach, you can now discover jewellery designs tailored to your unique contours and personality. From earrings that refine angles to necklaces that balance proportions, each recommendation is chosen with intention. Because the perfect jewellery does more than accessorise - it highlights confidence, enhances beauty, and above all, celebrates you."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                className: (shap_of_you_module_default()).ctaButton,
                                                onClick: handleStartExperience,
                                                disabled: loading,
                                                style: loading ? {
                                                    background: "#d3d3d3",
                                                    color: "#888",
                                                    cursor: "not-allowed",
                                                    opacity: 0.6
                                                } : {},
                                                children: [
                                                    loading ? "Loading..." : "Start Experience",
                                                    " ",
                                                    !loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                            width: "25",
                                                            height: "17",
                                                            viewBox: "0 0 30 20",
                                                            fill: "none",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M0.000209928 11.0458L0 8.04596H24.2579L18.3333 2.12131L20.4546 0L30.0006 9.54596L20.4546 19.092L18.3333 16.9705L24.258 11.046L0.000209928 11.0458Z",
                                                                fill: "white"
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                })
            })
        })
    });
};
/* harmony default export */ var shape_of_you_desktop_new_AboutScreen = (AboutScreen_AboutScreen);

;// CONCATENATED MODULE: ./src/components/shape-of-you-desktop-new/TermsConditionsScreen.tsx






var TermsConditionsScreen_TermsConditionsScreen = function(param) {
    var navigateToStep = param.navigateToStep, isAuthenticated = param.isAuthenticated, logStep = param.logStep;
    var ref = (0,react.useState)(false), loading = ref[0], setLoading = ref[1];
    var ref1 = (0,react.useState)(false), hasScrolledToEnd = ref1[0], setHasScrolledToEnd = ref1[1];
    var contentRef = (0,react.useRef)(null);
    // Check if user has scrolled to the bottom
    (0,react.useEffect)(function() {
        var handleScroll = function() {
            if (contentRef.current) {
                var _current = contentRef.current, scrollTop = _current.scrollTop, scrollHeight = _current.scrollHeight, clientHeight = _current.clientHeight;
                // Check if scrolled to bottom (with 10px threshold for better UX)
                if (scrollTop + clientHeight >= scrollHeight - 10) {
                    setHasScrolledToEnd(true);
                }
            }
        };
        var contentElement = contentRef.current;
        if (contentElement) {
            contentElement.addEventListener("scroll", handleScroll);
            // Check initial scroll position in case content is already at bottom
            handleScroll();
        }
        return function() {
            if (contentElement) {
                contentElement.removeEventListener("scroll", handleScroll);
            }
        };
    }, []);
    // Handle "Agree and Proceed" button click
    var handleAgreeAndProceed = function() {
        setLoading(true);
        // Save consent acceptance to localStorage for all users
        // The API call will be made after login (in VerifyOtpScreen)
        localStorage.setItem("pendingConsentAcceptance", "true");
        // Log consent accept (non-blocking) - REMOVED: consent_accepted not in valid steps list
        // if (logStep) {
        //   logStep("consent_accepted");
        // }
        navigateToStep("welcome");
        setLoading(false);
    };
    // Handle "Don't Agree" button click
    var handleDontAgree = function() {
        // Log consent denied (non-blocking) - REMOVED: consent_rejected not in valid steps list
        // if (logStep) {
        //   logStep("consent_rejected");
        // }
        navigateToStep("permissionDenied");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "d-none d-md-block w-100",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (shap_of_you_module_default()).wrapper_tc_desktop,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (shap_of_you_module_default()).wrapper_sec,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                            className: (shap_of_you_module_default()).header,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: shapesenco,
                                alt: "Logo"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (shap_of_you_module_default()).content,
                            ref: contentRef,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    children: "CONSENT NOTICE"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        "Senco Gold Limited (hereinafter referred to as “Company”, “We”, “Us”, or “Our”), incorporated under the Companies Act, 1956 (CIN: L36911WB1994PLC064637), with its registered office located at Diamond Prestige, 41A A.J.C. Bose Road, 10th Floor, Unit No. 1001, Kolkata – 700017, West Bengal, India, respects the privacy of any person who accesses or uses Our Website/Application (hereinafter referred to as “You” or “Your”) and is committed to protecting your Digital Personal Data. This notice applies to the processing of Personal Data collected in digital form or any non-digital form which is digitised subsequently.",
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        "In order to comply with the Digital Personal Data Protection Act, 2023 (“DPDP Act”) and the rules framed thereunder and to nurture Our association, we would be collecting and processing Your Digital Personal Data. For this data collection and its processing, we need Your explicit consent.",
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        "The purpose of processing Your Digital Personal Data is to support the services provided by the Company or its affiliates to You (please visit Our website for a list of services offered by the Company) or to facilitate Your interactions with the Company in roles, including but not limited to, an employee or vendor/supplier. There may be instances where Your Digital Personal Data needs to be shared with regulators, business associates, or payment gateways, resulting in Your data being transferred beyond Company’s control. This sharing may also be necessitated now or in future as per the requirement and in accordance with the applicable laws/regulations in India, as may be amended from time to time.",
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        "You reserve the right to file a complaint with the Company regarding any grievances arising from the processing of Your Digital Personal Data, which shall be directed to the Grievance Officer, as detailed in Our Policy. Should the grievance remain unresolved through Our grievance redressal mechanism, You further retain the right to approach the Data Protection Board of India with a complaint, as outlined in the provisions of the DPDP Act.",
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        "All the capitalised terms used in this Consent Notice shall have the same meaning assigned to them as in Company’s Policy. (“Policy”).",
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (shap_of_you_module_default()).heading,
                                    children: "Declaration of Understanding - Data Processing Policies:"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            children: "1"
                                        }),
                                        ". I understand that my Digital Personal Data may be collected only with my valid consent, and that it may be processed only in accordance with the Policy."
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            children: "2"
                                        }),
                                        ". I agree to provide the following information to Company during registration on our App/ Website or usage of our App/ Website or both, as and when necessary, including, but not limited to:"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    className: (shap_of_you_module_default()).list_two_liv,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                    className: "pb-2 d-block",
                                                    children: "Your information:"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                    className: (shap_of_you_module_default()).list_two_liv,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Name"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Gender"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Occupation"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Education"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Address"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Financial information"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Identity proof such as PAN Card, AADHAR Card, Voter ID card etc."
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Previous purchase history from Us"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Consumer durables owned"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                    className: "pb-2 pt-2 d-block",
                                                    children: "Communication details:"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                    className: (shap_of_you_module_default()).list_two_liv,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Email address"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Phone number"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Postal address"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Any other contact information"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                    className: "pb-2 pt-2 d-block",
                                                    children: "Device information:"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                    className: (shap_of_you_module_default()).list_two_liv,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Operating system"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Operating system providing advertising ID"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "IP address"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Date and time of every user request"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Your usage information with Our devices placed at Our office"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Your internet protocol address"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                    className: "pb-2 pt-2 d-block",
                                                    children: "Behavioural patterns:"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                    className: (shap_of_you_module_default()).list_two_liv,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Your active seconds and minutes in Our work database"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Your search history in Our device located at Our office"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Sharing a product or inspiration to social media sites"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Other interactions and dialogues during interactive search"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                    className: "pb-2 pt-2 d-block",
                                                    children: "Non-personal information (THIS TYPE OF INFORMATION DOES NOT IDENTIFY YOU PERSONALLY)"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                    className: (shap_of_you_module_default()).list_two_liv,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "The pages you visit"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Links you click"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Advertisements you view"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Number of times you access Our page"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Your opinion on Our services, products, features that We offer"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Operating system"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Browser type"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Internet service provider"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Aggregate user data"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Software and hardware attributes"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Number of clicks"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        " ",
                                        "If You communicate with Us, by, for example, email or letter, any information provided in such communication may be collected and stored by Us."
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            children: "3"
                                        }),
                                        ". Specifically, You understand that Your Digital Personal Data may be processed for any or all of the following purposes, as may be applicable:"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "ps-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "(i) Facilitating personnel management, including verification, compensation management (such as bank details for salary disbursement), performance management, compliance with legal obligations, health and safety management, training and development, and internal communications."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "(ii) Fulfilling customer orders placed, including but not limited to, managing payment transactions, coordinating shipping logistics, and facilitating the delivery of goods."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "(iii) Facilitating communication regarding order confirmations, invoices, and receipts for purchases made both online and offline."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "(iv) Communicating updates pertaining to the status of orders or delivery schedules."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "(v) Managing inquiries, complaints, or requests for assistance."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "(vi) Disseminating newsletters and promotional communications regarding upcoming events, sales, and the introduction of new products."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "(vii) Soliciting customer feedback through surveys and rating mechanisms."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "(viii) Enrolling in loyalty or rewards programs and thereby tracking points or rewards accumulated through purchases made both online and offline."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "(ix) Complying with applicable legal obligations, including but not limited to tax reporting, audit requirements, or responses to requests from law enforcement authorities."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "(x) Analysing market trends, conducting market research, and improving overall business strategies, utilizing information gathered from both online and offline sales."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "(xi) Detecting and preventing fraudulent transactions or unauthorized access to customer accounts, thereby safeguarding both the customer and the brand across all sales channels."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "(xii) Sharing information with third-party service providers for limited purposes of operational and logistical functions to complete the order."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "(xiii) Facilitating linking of customer accounts with social media platforms for the purpose of sharing purchases or promotional materials, whether derived from online or offline transactions."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "(xiv) Facilitating effective communication, assessing service quality, and managing supply chain operations for purposes related to the business relationship, including but not limited to entering into and managing agreements, evaluating supplier qualifications, processing payments, and ensuring compliance with contractual obligations."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "(xv) To build up marketing profiles."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "(xvi) Aiding strategic development, data collection, and business analytics."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "(xvii) Managing our relationship with advertisers and other partners."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "(xviii) Any other grounds as per applicable law."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            children: "4"
                                        }),
                                        ". I understand that I have certain rights that I enjoy as a data principal over my Digital Personal Data, in relation to its collection, use and processing. These rights, inter alia, relate to confirmation and access, correction and erasure, objection of processing, grievance redressal and withdrawal of consent. These rights are available to me in the manner set out in the Policy."
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            children: "5"
                                        }),
                                        ". I agree that am of lawful age to contract as per applicable laws and I have read and understood the processing requirement with respect to my Digital Personal Data as listed above and provide my free, specific, informed, unconditional and unambiguous consent to the above by signing on the space provided below."
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            children: "6"
                                        }),
                                        ". I understand that I have the right to withdraw my consent at any time in the manner specified under the Policy. If I need to withdraw my consent with respect to usage of my Digital Personal Data under Company’s purview, excluding data which has already been shared with the authorities, regulators or business associates and outside the control of the Company at that time, I will inform the Company through the",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/account/profile",
                                            style: {
                                                color: "rgb(147, 16, 29)"
                                            },
                                            children: "Consent Withdrawal Form"
                                        }),
                                        " ",
                                        "as provided on the Website.",
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            children: "7"
                                        }),
                                        ". I understand that this withdrawal of consent will be implemented as soon as practicable. I also confirm that the Company, while accepting my request for withdrawal of consent, will be allowed to keep such Digital Personal Data as required by the applicable laws and regulations for history and record keeping purposes for a specified period of time.",
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            children: "8"
                                        }),
                                        ". By clicking on “I agree to consent to the processing of my Digital Personal Data” below, I signify agreement to the processing and sharing of my Digital Personal Data with the Company now and in future in order to allow the Company to conduct business or sharing information with business associates or authorities as may be required under different regulations, laws and statues of India and outside India, or with such third parties/vendors, as may be applicable and amended from time to time."
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (shap_of_you_module_default()).cta_btn_container,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (shap_of_you_module_default()).btn_act,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: (shap_of_you_module_default()).ctaBtn1,
                                onClick: handleDontAgree,
                                disabled: loading || !hasScrolledToEnd,
                                style: !hasScrolledToEnd || loading ? {
                                    background: "#d3d3d3",
                                    color: "#888",
                                    cursor: "not-allowed",
                                    opacity: 0.6
                                } : {},
                                children: "Don't Agree"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                className: (shap_of_you_module_default()).ctaBtn,
                                onClick: handleAgreeAndProceed,
                                disabled: loading || !hasScrolledToEnd,
                                style: loading || !hasScrolledToEnd ? {
                                    background: "#d3d3d3",
                                    color: "#888",
                                    cursor: "not-allowed",
                                    opacity: 0.6
                                } : {},
                                children: [
                                    loading ? "Processing..." : "Agree and Proceed",
                                    " →"
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var shape_of_you_desktop_new_TermsConditionsScreen = (TermsConditionsScreen_TermsConditionsScreen);

;// CONCATENATED MODULE: ./src/components/shape-of-you-desktop-new/WelcomeScreen.tsx






var shape_of_you_desktop_new_WelcomeScreen_WelcomeScreen = function(param) {
    var navigateToStep = param.navigateToStep;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "d-none d-md-block w-100",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (shap_of_you_module_default()).desktop_view_shap_welcome,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (shap_of_you_module_default()).bgImage,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: WelcomeScreen_dek,
                        alt: "Welcome Screen"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (shap_of_you_module_default()).shapeOfYou,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (shap_of_you_module_default()).content,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (shap_of_you_module_default()).title,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: spl,
                                    alt: "Shape of You Logo"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (shap_of_you_module_default()).button_cont,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: (shap_of_you_module_default()).ctaBtn,
                                onClick: function() {
                                    return navigateToStep("uploadOrScan");
                                },
                                children: "Start Experience →"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var shape_of_you_desktop_new_WelcomeScreen = (shape_of_you_desktop_new_WelcomeScreen_WelcomeScreen);

// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Modal.js + 6 modules
var Modal = __webpack_require__(6212);
;// CONCATENATED MODULE: ./src/components/shape-of-you-desktop-new/GalleryPermissionScreen.tsx




var GalleryPermissionScreen_GalleryPermissionScreen = function(param) {
    var show = param.show, onHide = param.onHide, onImageSelect = param.onImageSelect, onPermissionDenied = param.onPermissionDenied, logStep = param.logStep;
    var fileInputRef = (0,react.useRef)(null);
    // Handle "Allow this time" - one-time permission
    var handleAllowThisTime = function() {
        var // Trigger file input
        ref;
        // Store permission in localStorage
        localStorage.setItem("galleryPermissionGranted", "true");
        // Log gallery permission granted (non-blocking)
        if (logStep) {
            logStep("gallery_permission_granted");
        }
        (ref = fileInputRef.current) === null || ref === void 0 ? void 0 : ref.click();
        // Close modal
        onHide();
    };
    // Handle "Allow on every visit" - persistent permission
    var handleAllowEveryVisit = function() {
        var // Trigger file input
        ref;
        // Store permission in localStorage
        localStorage.setItem("galleryPermissionGranted", "true");
        // Log gallery permission granted (non-blocking)
        if (logStep) {
            logStep("gallery_permission_granted");
        }
        (ref = fileInputRef.current) === null || ref === void 0 ? void 0 : ref.click();
        // Close modal
        onHide();
    };
    // Handle "Don't Allow"
    var handleDontAllow = function() {
        // Log gallery permission denied (non-blocking)
        if (logStep) {
            logStep("gallery_permission_denied", {
                error_message: "User denied gallery permission"
            });
        }
        // Close modal
        onHide();
        // Navigate to permission denied page
        onPermissionDenied();
    };
    // Handle file selection
    var handleFileChange = function(event) {
        var ref;
        var file = (ref = event.target.files) === null || ref === void 0 ? void 0 : ref[0];
        if (file && onImageSelect) {
            var reader = new FileReader();
            reader.onloadend = function() {
                var base64String = reader.result;
                onImageSelect(base64String);
            };
            reader.readAsDataURL(file);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                show: show,
                onHide: onHide,
                className: (shap_of_you_module_default()).custom_modal,
                centered: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Body */.Z.Body, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (shap_of_you_module_default()).modal,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                children: [
                                    "sencogoldanddiamonds.com ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    " wants to"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                className: (shap_of_you_module_default()).checkbox,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                        width: "20",
                                        height: "16",
                                        viewBox: "0 0 36 36",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M22.5 12H22.5146",
                                                stroke: "#46474C",
                                                strokeWidth: "3",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M18.75 31.5H9C7.80653 31.5 6.66193 31.0259 5.81802 30.182C4.97411 29.3381 4.5 28.1935 4.5 27V9C4.5 7.80653 4.97411 6.66193 5.81802 5.81802C6.66193 4.97411 7.80653 4.5 9 4.5H27C28.1935 4.5 29.3381 4.97411 30.182 5.81802C31.0259 6.66193 31.5 7.80653 31.5 9V18.75",
                                                stroke: "#46474C",
                                                strokeWidth: "3",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M4.5 24L12 16.5C13.392 15.1605 15.108 15.1605 16.5 16.5L21.75 21.75",
                                                stroke: "#46474C",
                                                strokeWidth: "3",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M21 21L22.5 19.5C23.5185 18.5205 24.7095 18.2565 25.821 18.711",
                                                stroke: "#46474C",
                                                strokeWidth: "3",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M28.5 33V24",
                                                stroke: "#46474C",
                                                strokeWidth: "3",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M33 28.5L28.5 24L24 28.5",
                                                stroke: "#46474C",
                                                strokeWidth: "3",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "Access your photos"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (shap_of_you_module_default()).actions,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: (shap_of_you_module_default()).primary,
                                        onClick: handleAllowThisTime,
                                        children: "Allow this time"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: (shap_of_you_module_default()).primary,
                                        onClick: handleAllowEveryVisit,
                                        children: "Allow on every visit"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: (shap_of_you_module_default()).primary,
                                        onClick: handleDontAllow,
                                        children: "Don't Allow"
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                ref: fileInputRef,
                type: "file",
                accept: "image/*",
                style: {
                    display: "none"
                },
                onChange: handleFileChange
            })
        ]
    });
};
/* harmony default export */ var shape_of_you_desktop_new_GalleryPermissionScreen = (GalleryPermissionScreen_GalleryPermissionScreen);

;// CONCATENATED MODULE: ./src/components/shape-of-you-desktop-new/CameraPermissionScreen.tsx






var CameraPermissionScreen_CameraPermissionScreen = function(param) {
    var show = param.show, onHide = param.onHide, onPermissionGranted = param.onPermissionGranted, onPermissionDenied = param.onPermissionDenied, logStep = param.logStep;
    var ref = (0,react.useState)(false), isRequesting = ref[0], setIsRequesting = ref[1];
    // Handle "Allow this time" - request camera permission
    var handleAllowThisTime = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var stream;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setIsRequesting(true);
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return navigator.mediaDevices.getUserMedia({
                            video: {
                                facingMode: "user"
                            }
                        });
                    case 4:
                        stream = _ctx.sent;
                        // Permission granted! Stop the stream and save to localStorage
                        stream.getTracks().forEach(function(track) {
                            return track.stop();
                        });
                        localStorage.setItem("cameraPermissionGranted", "true");
                        // Log camera permission granted (non-blocking)
                        if (logStep) {
                            logStep("camera_permission_granted");
                        }
                        // Close modal and trigger success callback
                        onHide();
                        onPermissionGranted();
                        _ctx.next = 18;
                        break;
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](1);
                        ;
                        // Log camera permission denied (non-blocking)
                        if (logStep) {
                            logStep("camera_permission_denied", {
                                error_message: "User denied camera permission"
                            });
                        }
                        // Close modal and trigger denied callback
                        onHide();
                        onPermissionDenied();
                    case 18:
                        _ctx.prev = 18;
                        setIsRequesting(false);
                        return _ctx.finish(18);
                    case 21:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    12,
                    18,
                    21
                ]
            ]);
        }));
        return function handleAllowThisTime() {
            return _ref.apply(this, arguments);
        };
    }();
    // Handle "Allow on every visit" - same as "Allow this time" for camera
    var handleAllowEveryVisit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return handleAllowThisTime();
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleAllowEveryVisit() {
            return _ref.apply(this, arguments);
        };
    }();
    // Handle "Don't Allow"
    var handleDontAllow = function() {
        // Log camera permission denied (non-blocking)
        if (logStep) {
            logStep("camera_permission_denied", {
                error_message: "User clicked Don't Allow"
            });
        }
        // Close modal
        onHide();
        // Navigate to permission denied page
        onPermissionDenied();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        show: show,
        onHide: onHide,
        className: (shap_of_you_module_default()).custom_modal,
        centered: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Body */.Z.Body, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (shap_of_you_module_default()).modal,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                        children: [
                            "sencogoldanddiamonds.com ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            " wants to"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        className: (shap_of_you_module_default()).checkbox,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                width: "20",
                                height: "16",
                                viewBox: "0 0 30 24",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M3 24C2.175 24 1.46875 23.7063 0.88125 23.1188C0.29375 22.5312 0 21.825 0 21V3C0 2.175 0.29375 1.46875 0.88125 0.88125C1.46875 0.29375 2.175 0 3 0H21C21.825 0 22.5312 0.29375 23.1188 0.88125C23.7063 1.46875 24 2.175 24 3V9.75L30 3.75V20.25L24 14.25V21C24 21.825 23.7063 22.5312 23.1188 23.1188C22.5312 23.7063 21.825 24 21 24H3ZM3 21H21V3H3V21Z",
                                    fill: "#46474C"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "Use your camera"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (shap_of_you_module_default()).actions,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: (shap_of_you_module_default()).primary,
                                onClick: handleAllowThisTime,
                                disabled: isRequesting,
                                children: isRequesting ? "Requesting..." : "Allow this time"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: (shap_of_you_module_default()).primary,
                                onClick: handleAllowEveryVisit,
                                disabled: isRequesting,
                                children: isRequesting ? "Requesting..." : "Allow on every visit"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: (shap_of_you_module_default()).primary,
                                onClick: handleDontAllow,
                                disabled: isRequesting,
                                children: "Don't Allow"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var shape_of_you_desktop_new_CameraPermissionScreen = (CameraPermissionScreen_CameraPermissionScreen);

;// CONCATENATED MODULE: ./src/components/shape-of-you-desktop-new/UploadOrScanScreen.tsx










var UploadOrScanScreen_UploadOrScanScreen = function(param) {
    var navigateToStep = param.navigateToStep, onImageSelect = param.onImageSelect, logStep = param.logStep;
    var ref = (0,react.useState)(false), showGalleryModal = ref[0], setShowGalleryModal = ref[1];
    var ref1 = (0,react.useState)(false), showCameraModal = ref1[0], setShowCameraModal = ref1[1];
    var fileInputRef = (0,react.useRef)(null);
    // Handle file selection (for direct upload when permission already granted)
    var handleFileChange = function(event) {
        var ref;
        var file = (ref = event.target.files) === null || ref === void 0 ? void 0 : ref[0];
        if (file) {
            var reader = new FileReader();
            reader.onloadend = function() {
                var base64String = reader.result;
                if (onImageSelect) {
                    onImageSelect(base64String);
                }
            };
            reader.readAsDataURL(file);
        }
    };
    // Handle upload button click - check localStorage first
    var handleUploadClick = function() {
        var galleryPermission = localStorage.getItem("galleryPermissionGranted");
        if (galleryPermission === "true") {
            var // Permission already granted - directly trigger file input
            ref;
            (ref = fileInputRef.current) === null || ref === void 0 ? void 0 : ref.click();
        } else {
            // Permission not granted - show gallery permission modal
            setShowGalleryModal(true);
        }
    };
    // Handle scan face button click - check browser permission AND localStorage first
    var handleScanFaceClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var permissionStatus, cameraPermission, cameraPermission1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return navigator.permissions.query({
                            name: "camera"
                        });
                    case 3:
                        permissionStatus = _ctx.sent;
                        if (permissionStatus.state === "granted") {
                            cameraPermission = localStorage.getItem("cameraPermissionGranted");
                            if (cameraPermission === "true") {
                                navigateToStep("faceScanning");
                            } else {
                                // Browser granted but app flag missing - show camera modal to confirm
                                setShowCameraModal(true);
                            }
                        } else if (permissionStatus.state === "prompt") {
                            // Need to request permission via modal
                            setShowCameraModal(true);
                        } else if (permissionStatus.state === "denied") {
                            // Previously denied
                            navigateToStep("permissionDenied");
                        }
                        _ctx.next = 11;
                        break;
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](0);
                        cameraPermission1 = localStorage.getItem("cameraPermissionGranted");
                        if (cameraPermission1 === "true") {
                            navigateToStep("faceScanning");
                        } else {
                            setShowCameraModal(true);
                        }
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7
                ]
            ]);
        }));
        return function handleScanFaceClick() {
            return _ref.apply(this, arguments);
        };
    }();
    // Handle camera permission granted
    var handleCameraPermissionGranted = function() {
        navigateToStep("faceScanning");
    };
    // Handle gallery permission denied
    var handleGalleryPermissionDenied = function() {
        navigateToStep("permissionDenied");
    };
    // Handle camera permission denied
    var handleCameraPermissionDenied = function() {
        navigateToStep("permissionDenied");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "d-none d-md-block w-100",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "".concat((shap_of_you_module_default()).desktop_view_shap_welcome, " desktop_view_shap_welcome"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (shap_of_you_module_default()).bgImage,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: WelcomeScreen_dek,
                                alt: "Welcome Screen"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (shap_of_you_module_default()).shapeOfYou,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (shap_of_you_module_default()).content,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (shap_of_you_module_default()).title,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: spl,
                                            alt: "Shape of You Logo"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    ref: fileInputRef,
                                    type: "file",
                                    accept: "image/*",
                                    style: {
                                        display: "none"
                                    },
                                    onChange: handleFileChange
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (shap_of_you_module_default()).button_cont,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                            className: (shap_of_you_module_default()).ctaBtn,
                                            onClick: handleUploadClick,
                                            children: [
                                                "Upload your Image",
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                    className: "ml-1",
                                                    width: "20",
                                                    height: "20",
                                                    viewBox: "0 0 36 36",
                                                    fill: "none",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M22.5 12H22.5146",
                                                            stroke: "white",
                                                            strokeWidth: "3",
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M18.75 31.5H9C7.80653 31.5 6.66193 31.0259 5.81802 30.182C4.97411 29.3381 4.5 28.1935 4.5 27V9C4.5 7.80653 4.97411 6.66193 5.81802 5.81802C6.66193 4.97411 7.80653 4.5 9 4.5H27C28.1935 4.5 29.3381 4.97411 30.182 5.81802C31.0259 6.66193 31.5 7.80653 31.5 9V18.75",
                                                            stroke: "white",
                                                            strokeWidth: "3",
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M4.5 24L12 16.5C13.392 15.1605 15.108 15.1605 16.5 16.5L21.75 21.75",
                                                            stroke: "white",
                                                            strokeWidth: "3",
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M21 21L22.5 19.5C23.5185 18.5205 24.7095 18.2565 25.821 18.711",
                                                            stroke: "white",
                                                            strokeWidth: "3",
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M28.5 33V24",
                                                            stroke: "white",
                                                            strokeWidth: "3",
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M33 28.5L28.5 24L24 28.5",
                                                            stroke: "white",
                                                            strokeWidth: "3",
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: "OR"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                            className: (shap_of_you_module_default()).ctaBtn,
                                            onClick: handleScanFaceClick,
                                            children: [
                                                "Scan Face",
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                    className: "ml-1",
                                                    width: "20",
                                                    height: "20",
                                                    viewBox: "0 0 36 36",
                                                    fill: "none",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M10.5 4.5H7.5C5.84314 4.5 4.5 5.84314 4.5 7.5V10.5",
                                                            stroke: "white",
                                                            strokeWidth: "3",
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M25.5 4.5H28.5C30.1569 4.5 31.5 5.84314 31.5 7.5V10.5",
                                                            stroke: "white",
                                                            strokeWidth: "3",
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M22.5 13.5V16.5",
                                                            stroke: "white",
                                                            strokeWidth: "3",
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M13.5 13.5V16.5",
                                                            stroke: "white",
                                                            strokeWidth: "3",
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M13.5 22.5C13.5 22.5 15 24 18 24C21 24 22.5 22.5 22.5 22.5",
                                                            stroke: "white",
                                                            strokeWidth: "3",
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M10.5 31.5001H7.5C5.84314 31.5001 4.5 30.157 4.5 28.5001V25.5001",
                                                            stroke: "white",
                                                            strokeWidth: "3",
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M25.5 31.5001H28.5C30.1569 31.5001 31.5 30.157 31.5 28.5001V25.5001",
                                                            stroke: "white",
                                                            strokeWidth: "3",
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(shape_of_you_desktop_new_GalleryPermissionScreen, {
                show: showGalleryModal,
                onHide: function() {
                    return setShowGalleryModal(false);
                },
                onImageSelect: onImageSelect,
                onPermissionDenied: handleGalleryPermissionDenied,
                logStep: logStep
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(shape_of_you_desktop_new_CameraPermissionScreen, {
                show: showCameraModal,
                onHide: function() {
                    return setShowCameraModal(false);
                },
                onPermissionGranted: handleCameraPermissionGranted,
                onPermissionDenied: handleCameraPermissionDenied,
                logStep: logStep
            })
        ]
    });
};
/* harmony default export */ var shape_of_you_desktop_new_UploadOrScanScreen = (UploadOrScanScreen_UploadOrScanScreen);

;// CONCATENATED MODULE: ./src/components/shape-of-you-desktop-new/PermissionDeniedScreen.tsx










var PermissionDeniedScreen_PermissionDeniedScreen = function(param) {
    var isAuthenticated = param.isAuthenticated, onExit = param.onExit;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(false), loading = ref[0], setLoading = ref[1];
    // Handle "Restart Experience" button click with consent checking
    var handleRestart = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setLoading(true);
                        _ctx.prev = 1;
                        if (!isAuthenticated) {
                            _ctx.next = 9;
                            break;
                        }
                        _ctx.next = 5;
                        return http_client/* default.get */.Z.get(endpoints/* default.auth.getConsentForm */.Z.auth.getConsentForm());
                    case 5:
                        data = _ctx.sent.data;
                        if (data.statusText === "accepted") {
                            ;
                            localStorage.setItem("pendingNavigation", "welcome");
                            if (onExit) {
                                onExit(); // Exit PhotoCaptureFlow, main page will handle navigation
                            }
                        } else {
                            // Scenario 2: Consent rejected - show TC screen
                            localStorage.setItem("pendingNavigation", "tc");
                            if (onExit) {
                                onExit(); // Exit PhotoCaptureFlow, main page will handle navigation
                            }
                        }
                        _ctx.next = 10;
                        break;
                    case 9:
                        {
                            // Scenario 3: User is NOT authenticated - go to TC without API call
                            localStorage.setItem("pendingNavigation", "tc");
                            if (onExit) {
                                onExit(); // Exit PhotoCaptureFlow, main page will handle navigation
                            }
                        }
                    case 10:
                        _ctx.next = 17;
                        break;
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](1);
                        ;
                        // If API fails, show TC screen anyway
                        localStorage.setItem("pendingNavigation", "tc");
                        if (onExit) {
                            onExit();
                        }
                    case 17:
                        _ctx.prev = 17;
                        setLoading(false);
                        return _ctx.finish(17);
                    case 20:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    12,
                    17,
                    20
                ]
            ]);
        }));
        return function handleRestart() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCloseWindow = function() {
        router.push("/");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "d-none d-md-block w-100",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (shap_of_you_module_default()).wrapper_denied_camera_access,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "row align-items-center h-100",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-md-7",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "ps-xl-5 ms-xl-5 pe-xl-5",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (shap_of_you_module_default()).illustration,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: windown,
                                        alt: "Camera Access",
                                        width: 508,
                                        height: 745
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-md-5",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (shap_of_you_module_default()).content,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        children: "Camera Access Needed"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mb-md-5 ",
                                        children: "Oops! We need your camera access to bring this experience to life."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                className: (shap_of_you_module_default()).ctaBtnp,
                                                onClick: handleRestart,
                                                disabled: loading,
                                                style: loading ? {
                                                    background: "#d3d3d3",
                                                    color: "#888",
                                                    cursor: "not-allowed",
                                                    opacity: 0.6
                                                } : {},
                                                children: [
                                                    loading ? "Loading..." : "Restart Experience",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                        className: "ms-1",
                                                        width: "20",
                                                        height: "20",
                                                        viewBox: "0 0 30 30",
                                                        fill: "none",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M5.19386 3.64893C7.82334 1.37532 11.251 0 15 0C23.2842 0 30 6.71572 30 15C30 18.2041 28.9953 21.1737 27.2838 23.6109L22.5 15H27C27 8.37258 21.6275 3 15 3C11.7747 3 8.84665 4.2724 6.69034 6.34263L5.19386 3.64893ZM24.8061 26.3511C22.1766 28.6246 18.749 30 15 30C6.71572 30 0 23.2842 0 15C0 11.7958 1.00469 8.82624 2.7162 6.38916L7.5 15H3C3 21.6275 8.37258 27 15 27C18.2253 27 21.1533 25.7276 23.3097 23.6574L24.8061 26.3511Z",
                                                            fill: loading ? "#888" : "white"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                className: (shap_of_you_module_default()).link,
                                                onClick: handleCloseWindow,
                                                disabled: loading,
                                                children: [
                                                    "Close Window",
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                        width: "20",
                                                        height: "20",
                                                        viewBox: "0 0 36 36",
                                                        fill: "none",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M27 9L9 27",
                                                                stroke: "#262121",
                                                                strokeWidth: "3",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M9 9L27 27",
                                                                stroke: "#262121",
                                                                strokeWidth: "3",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var shape_of_you_desktop_new_PermissionDeniedScreen = (PermissionDeniedScreen_PermissionDeniedScreen);

;// CONCATENATED MODULE: ./src/components/shape-of-you-desktop-new/ImageNotPermittedScreen.tsx



var ImageNotPermittedScreen_ImageNotPermittedScreen = function(param) {
    var navigateToStep = param.navigateToStep, errorMessage = param.errorMessage, onRetry = param.onRetry, capturedImage = param.capturedImage;
    var handleReupload = function() {
        if (onRetry) {
            onRetry();
        } else {
            navigateToStep("uploadOrScan");
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "d-none d-md-block w-100",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (shap_of_you_module_default()).image_error_screen,
            style: capturedImage ? {
                backgroundImage: "url(".concat(capturedImage, ")")
            } : undefined,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (shap_of_you_module_default()).error_content,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (shap_of_you_module_default()).error_box,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                className: (shap_of_you_module_default()).warning_icon,
                                width: "40",
                                height: "40",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M12 9V13M12 17H12.01M10.29 3.86L1.82 18C1.64537 18.3024 1.55296 18.6453 1.55199 18.9945C1.55101 19.3437 1.64151 19.6871 1.81445 19.9905C1.98738 20.2939 2.23675 20.5467 2.53773 20.7239C2.83871 20.901 3.18082 20.9962 3.53 21H20.47C20.8192 20.9962 21.1613 20.901 21.4623 20.7239C21.7633 20.5467 22.0126 20.2939 22.1856 19.9905C22.3585 19.6871 22.449 19.3437 22.448 18.9945C22.447 18.6453 22.3546 18.3024 22.18 18L13.71 3.86C13.5317 3.56611 13.2807 3.32312 12.9812 3.15448C12.6817 2.98585 12.3437 2.89725 12 2.89725C11.6563 2.89725 11.3183 2.98585 11.0188 3.15448C10.7193 3.32312 10.4683 3.56611 10.29 3.86Z",
                                    stroke: "#C9302C",
                                    strokeWidth: "2",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: (shap_of_you_module_default()).error_title,
                                children: "Image Upload Error"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (shap_of_you_module_default()).error_message,
                                children: errorMessage || "Please upload an image where the face is clearly visible and properly lit."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        className: (shap_of_you_module_default()).reupload_btn,
                        onClick: handleReupload,
                        children: [
                            "Reupload Image",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                width: "24",
                                height: "24",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M4 16L8.586 11.414C8.96106 11.0391 9.46967 10.8284 10 10.8284C10.5303 10.8284 11.0389 11.0391 11.414 11.414L16 16M14 14L15.586 12.414C15.9611 12.0391 16.4697 11.8284 17 11.8284C17.5303 11.8284 18.0389 12.0391 18.414 12.414L20 14M14 8H14.01M6 20H18C18.5304 20 19.0391 19.7893 19.4142 19.4142C19.7893 19.0391 20 18.5304 20 18V6C20 5.46957 19.7893 4.96086 19.4142 4.58579C19.0391 4.21071 18.5304 4 18 4H6C5.46957 4 4.96086 4.21071 4.58579 4.58579C4.21071 4.96086 4 5.46957 4 6V18C4 18.5304 4.21071 19.0391 4.58579 19.4142C4.96086 19.7893 5.46957 20 6 20Z",
                                    stroke: "white",
                                    strokeWidth: "2",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var shape_of_you_desktop_new_ImageNotPermittedScreen = (ImageNotPermittedScreen_ImageNotPermittedScreen);

;// CONCATENATED MODULE: ./src/components/shape-of-you-desktop-new/FaceResultScreen.tsx





var FaceResultScreen_FaceResultScreen = function(param) {
    var navigateToStep = param.navigateToStep, isAuthenticated = param.isAuthenticated, faceShape = param.faceShape, complexion = param.complexion, capturedImage = param.capturedImage, captureMethod = param.captureMethod, onReupload = param.onReupload, onExploreJewellery = param.onExploreJewellery, logStep = param.logStep;
    var handleExploreClick = function() {
        // Log face scan proceeded
        if (logStep) {
            logStep("face_scan_proceeded");
        }
        // If we have onExploreJewellery callback from PhotoCaptureFlow, use it
        if (onExploreJewellery) {
            onExploreJewellery();
        } else {
            // Fallback: If user is already logged in, go directly to productView
            // Otherwise, go to login screen
            if (isAuthenticated) {
                navigateToStep("productView");
            } else {
                navigateToStep("login");
            }
        }
    };
    var ref = (0,react.useState)(true), isExpanded = ref[0], setIsExpanded = ref[1];
    var toggleExpand = function() {
        setIsExpanded(!isExpanded);
    };
    var handleReuploadClick = function() {
        // If we have onReupload callback from PhotoCaptureFlow, use it
        if (onReupload) {
            onReupload();
        } else {
            // Fallback: navigate to uploadOrScan
            navigateToStep("uploadOrScan");
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "d-none d-md-block w-100",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (shap_of_you_module_default()).wrapper_reupload_desktop,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (shap_of_you_module_default()).image,
                    children: capturedImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: capturedImage,
                        alt: "Result",
                        className: (shap_of_you_module_default()).bg
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: image_sha,
                        alt: "Result",
                        className: (shap_of_you_module_default()).bg
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (shap_of_you_module_default()).faceInfoCard,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (shap_of_you_module_default()).toggleButton,
                            onClick: toggleExpand,
                            style: {
                                cursor: "pointer"
                            },
                            children: !isExpanded ? // Up arrow SVG (collapsed state)
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (shap_of_you_module_default()).svg_mark,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                    width: "18",
                                    height: "14",
                                    viewBox: "0 0 18 14",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M2.96094 5.5L8.80471 1.5L14.6485 5.5",
                                            stroke: "white",
                                            strokeOpacity: "0.31",
                                            strokeWidth: "3",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M1.5 12.25L8.80471 7.25L16.1094 12.25",
                                            stroke: "white",
                                            strokeWidth: "3",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round"
                                        })
                                    ]
                                })
                            }) : // Down arrow SVG (expanded state)
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                width: "173",
                                height: "36",
                                viewBox: "0 0 173 36",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("foreignObject", {
                                        x: "-6",
                                        y: "-5.99998",
                                        width: "185",
                                        height: "48",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            style: {
                                                backdropFilter: "blur(3px)",
                                                clipPath: "url(#bgblur_0_4559_2381_clip_path)",
                                                height: "100%",
                                                width: "100%"
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                        "data-figma-bg-blur-radius": "6",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M92.4653 20L86.4998 24L80.5343 20",
                                                stroke: "white",
                                                strokeOpacity: "0.31",
                                                strokeWidth: "3",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M93.957 13.25L86.5001 18.25L79.0432 13.25",
                                                stroke: "white",
                                                strokeWidth: "3",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                                            id: "bgblur_0_4559_2381_clip_path",
                                            transform: "translate(6 5.99998)",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M173 24C173 30.6274 167.627 36 161 36L12 36C5.37259 36 4.69686e-07 30.6274 1.04907e-06 24L2.09815e-06 12C2.67753e-06 5.37258 5.37259 4.69686e-07 12 1.04907e-06L161 1.40751e-05C167.627 1.46545e-05 173 5.3726 173 12L173 24Z"
                                            })
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "".concat((shap_of_you_module_default()).faceInfoContentContainer, " ").concat(isExpanded ? (shap_of_you_module_default()).expanded : (shap_of_you_module_default()).collapsed),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (shap_of_you_module_default()).faceInfoContent,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (shap_of_you_module_default()).faceInfoLeft,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (shap_of_you_module_default()).faceTypeValue,
                                                    children: faceShape || "Unknown"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (shap_of_you_module_default()).faceTypeLabel,
                                                    children: "Face Type"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (shap_of_you_module_default()).faceInfoDivider
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (shap_of_you_module_default()).faceInfoRight,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (shap_of_you_module_default()).skinToneValue,
                                                    children: complexion || "Unknown"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (shap_of_you_module_default()).skinToneLabel,
                                                    children: "Skin Tone"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (shap_of_you_module_default()).faceTypeDescription,
                                    children: faceShape && function() {
                                        var descriptions = {
                                            Heart: "Accentuate your delicate chin with elegant drops and dangles that add softness and refined symmetry.",
                                            Oblong: "Enhance your face with voluminous chandeliers and full drops that add width and harmonious balance.",
                                            Triangle: "Featuring an elegant taper from forehead to chin, bold drop styles add volume where it's needed most.",
                                            Oval: "Perfectly proportioned and endlessly versatile, every jewellery style, from contemporary to statement, complements you beautifully.",
                                            Round: "Celebrate your soft curves with striking, angular jewellery that adds beautiful contrast and definition.",
                                            Square: "Balance your strong jawline with fluid drops and pear-shaped designs that soften your look with effortless elegance."
                                        };
                                        var _faceShape;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                                    children: [
                                                        "Your Face Shape is ",
                                                        faceShape
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                (_faceShape = descriptions[faceShape]) !== null && _faceShape !== void 0 ? _faceShape : "".concat(faceShape, " faces are balanced and versatile")
                                            ]
                                        });
                                    }()
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (shap_of_you_module_default()).actions,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            className: (shap_of_you_module_default()).reupload,
                            onClick: handleReuploadClick,
                            children: [
                                captureMethod === "scan" ? "Rescan" : "Reupload Image",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: captureMethod === "scan" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "bi bi-arrow-clockwise"
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                        width: "24",
                                        height: "24",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M15 8H15.01",
                                                stroke: "#262121",
                                                strokeWidth: "2",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M12.5 21H6C5.20435 21 4.44129 20.6839 3.87868 20.1213C3.31607 19.5587 3 18.7956 3 18V6C3 5.20435 3.31607 4.44129 3.87868 3.87868C4.44129 3.31607 5.20435 3 6 3H18C18.7956 3 19.5587 3.31607 20.1213 3.87868C20.6839 4.44129 21 5.20435 21 6V12.5",
                                                stroke: "#262121",
                                                strokeWidth: "2",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M3 15.9998L8 10.9998C8.928 10.1068 10.072 10.1068 11 10.9998L14.5 14.4998",
                                                stroke: "#262121",
                                                strokeWidth: "2",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M14 13.9999L15 12.9999C15.679 12.3469 16.473 12.1709 17.214 12.4739",
                                                stroke: "#262121",
                                                strokeWidth: "2",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M19 22V16",
                                                stroke: "#262121",
                                                strokeWidth: "2",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M22 19L19 16L16 19",
                                                stroke: "#262121",
                                                strokeWidth: "2",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: (shap_of_you_module_default()).explore,
                            onClick: handleExploreClick,
                            children: "Explore Jewellery →"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var shape_of_you_desktop_new_FaceResultScreen = (FaceResultScreen_FaceResultScreen);

;// CONCATENATED MODULE: ./src/components/shape-of-you-desktop-new/FaceScanningScreen.tsx





var FaceScanningScreen_FaceScanningScreen = function(param) {
    var navigateToStep = param.navigateToStep, onCapture = param.onCapture, logStep = param.logStep;
    var ref = (0,react.useState)(false), isCameraReady = ref[0], setIsCameraReady = ref[1];
    var ref1 = (0,react.useState)(null), capturedImage = ref1[0], setCapturedImage = ref1[1];
    var webcamRef = (0,react.useRef)(null);
    // Camera ready callback
    var handleCameraReady = function() {
        setIsCameraReady(true);
    };
    // Handle camera error
    var handleCameraError = function(error) {
        ;
        react_toastify_esm/* toast.error */.Am.error("Failed to access camera. Please check permissions.");
        navigateToStep("permissionDenied");
    };
    // Capture face from webcam
    var captureFace = (0,react.useCallback)(function() {
        if (webcamRef.current) {
            var imageSrc = webcamRef.current.getScreenshot();
            if (imageSrc && onCapture) {
                if (logStep) {
                    logStep("face_scan_captured");
                }
                // Immediately freeze to captured image
                setCapturedImage(imageSrc);
                onCapture(imageSrc);
            } else {
                react_toastify_esm/* toast.error */.Am.error("Failed to capture image. Please try again.");
            }
        }
    }, [
        webcamRef,
        onCapture,
        logStep
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "d-none d-md-block w-100",
        style: {
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "linear-gradient(180deg, #5e0000 0%, #2d0000 100%)",
            zIndex: 9999
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (shap_of_you_module_default()).wrapper_face,
            style: {
                width: "100%",
                height: "100%",
                position: "relative",
                backgroundColor: "#000"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (shap_of_you_module_default()).image,
                    style: {
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "#000"
                    },
                    children: [
                        !isCameraReady && !capturedImage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                backgroundColor: "rgba(0, 0, 0, 0.9)",
                                zIndex: 10
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                style: {
                                    textAlign: "center",
                                    color: "#fff"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "spinner-border text-light mb-3",
                                        role: "status",
                                        style: {
                                            width: "3rem",
                                            height: "3rem"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "visually-hidden",
                                            children: "Accessing camera..."
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        style: {
                                            fontSize: "1rem",
                                            fontWeight: "bold"
                                        },
                                        children: "Accessing your camera..."
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((react_webcam_default()), {
                            ref: webcamRef,
                            audio: false,
                            mirrored: true,
                            screenshotFormat: "image/jpeg",
                            videoConstraints: {
                                facingMode: "user",
                                width: {
                                    ideal: 1280,
                                    min: 640
                                },
                                height: {
                                    ideal: 720,
                                    min: 480
                                },
                                aspectRatio: {
                                    ideal: 16 / 9
                                }
                            },
                            onUserMedia: handleCameraReady,
                            onUserMediaError: handleCameraError,
                            style: {
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                                objectPosition: "center center",
                                display: capturedImage ? "none" : "block"
                            }
                        }),
                        capturedImage && // eslint-disable-next-line @next/next/no-img-element
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: capturedImage,
                            alt: "Captured face",
                            style: {
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                                objectPosition: "center center",
                                zIndex: 1
                            }
                        }),
                        isCameraReady && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                    style: {
                                        height: "100%",
                                        width: "100%",
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        pointerEvents: "none",
                                        zIndex: 2
                                    },
                                    viewBox: "0 0 1920 1080",
                                    preserveAspectRatio: "xMidYMid slice",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                            transform: "translate(760, 0) scale(1.2)",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                fillRule: "evenodd",
                                                fill: "rgba(0, 0, 0, 0.75)",
                                                d: "M-633.333 0H966.667V900H-633.333V0ZM197 131C287.851 131 361.5 223.68 361.5 338.007C361.5 388.089 347.366 434.016 323.846 469.819H324C323.685 470.209 323.374 470.598 323.068 470.989C321.161 473.85 319.193 476.644 317.167 479.37C303.467 501.133 301.821 522.753 302.5 534.84C303.279 548.7 307.57 568.988 312.5 585.265C317.43 601.543 360.054 619.017 373 623.883V710H23V620.209C33.3333 613.131 57.4 596.235 71 585.265C88 571.553 92 550.322 92 523.34C92 509.129 85.9311 494.265 79.7871 483.244C50.5458 445.877 32.5 394.594 32.5 338.007C32.5 223.68 106.149 131 197 131Z"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            transform: "translate(760, 0) scale(1.2)",
                                            d: "M197 131C287.851 131 361.5 223.68 361.5 338.007C361.5 388.089 347.366 434.016 323.846 469.819H324C323.685 470.209 323.374 470.598 323.068 470.989C321.161 473.85 319.193 476.644 317.167 479.37C303.467 501.133 301.821 522.753 302.5 534.84C303.279 548.7 307.57 568.988 312.5 585.265C317.43 601.543 360.054 619.017 373 623.883V710H23V620.209C33.3333 613.131 57.4 596.235 71 585.265C88 571.553 92 550.322 92 523.34C92 509.129 85.9311 494.265 79.7871 483.244C50.5458 445.877 32.5 394.594 32.5 338.007C32.5 223.68 106.149 131 197 131Z",
                                            fill: "none",
                                            stroke: "white",
                                            strokeWidth: "3",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round",
                                            strokeDasharray: "15 15"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        position: "absolute",
                                        top: "0px",
                                        left: "50%",
                                        transform: "translateX(-50%)",
                                        color: "#fff",
                                        textAlign: "center",
                                        fontSize: "15px",
                                        zIndex: 4,
                                        fontFamily: "Sweet Sans Pro Regular",
                                        padding: "5px 30px",
                                        borderRadius: "30px",
                                        whiteSpace: "nowrap",
                                        backgroundColor: "transparent"
                                    },
                                    children: "Position your face in the outline"
                                })
                            ]
                        })
                    ]
                }),
                isCameraReady && !capturedImage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (shap_of_you_module_default()).button_cont_scan,
                    style: {
                        position: "absolute",
                        bottom: "20px",
                        left: "50%",
                        transform: "translateX(-50%)",
                        zIndex: 5,
                        display: "flex",
                        justifyContent: "center"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        onClick: captureFace,
                        style: {
                            minWidth: "300px",
                            background: "rgba(210, 35, 42, 1)",
                            color: "#fff",
                            border: "none",
                            padding: "9px 40px",
                            borderRadius: "50px",
                            fontSize: "18px",
                            fontFamily: "Sweet Sans Pro Medium",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "0px",
                            transition: "all 0.2s ease"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                width: "20",
                                height: "20",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M7 3H5C3.89543 3 3 3.89543 3 5V7",
                                        stroke: "white",
                                        strokeWidth: "2.5",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M17 3H19C20.1046 3 21 3.89543 21 5V7",
                                        stroke: "white",
                                        strokeWidth: "2.5",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M15 9V11",
                                        stroke: "white",
                                        strokeWidth: "2.5",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M9 9V11",
                                        stroke: "white",
                                        strokeWidth: "2.5",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M9 15C9 15 10 16 12 16C14 16 15 15 15 15",
                                        stroke: "white",
                                        strokeWidth: "2.5",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M7 21H5C3.89543 21 3 20.1046 3 19V17",
                                        stroke: "white",
                                        strokeWidth: "2.5",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M17 21H19C20.1046 21 21 20.1046 21 19V17",
                                        stroke: "white",
                                        strokeWidth: "2.5",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "Scan Face"
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var shape_of_you_desktop_new_FaceScanningScreen = (FaceScanningScreen_FaceScanningScreen);

;// CONCATENATED MODULE: ./src/components/shape-of-you-desktop-new/LoginScreen.tsx
















var LoginScreen_LoginScreen = function(param) {
    var navigateToStep = param.navigateToStep, authData = param.authData, logStep = param.logStep;
    var ref = (0,react.useState)(false), sendOtpLoading = ref[0], setSendOtpLoading = ref[1];
    // Login Formik
    var loginFormik = (0,formik_esm/* useFormik */.TA)({
        initialValues: {
            mobile: authData.mobileNumber || ""
        },
        validationSchema: yup_es/* object */.Ry({
            mobile: yup_es/* string */.Z_().matches(regex/* phoneRegExp */.O, "Mobile number is not valid").test("len", "Mobile number needs to be exactly 10 digits", function(val) {
                return (val === null || val === void 0 ? void 0 : val.toString().length) === 10;
            }).required("Mobile is required")
        }),
        onSubmit: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values) {
                var apiEndpoint, requestPayload, data, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            setSendOtpLoading(true);
                            apiEndpoint = endpoints/* default.auth.loginSendOtp */.Z.auth.loginSendOtp();
                            requestPayload = {
                                mobile: values.mobile
                            };
                            _ctx.prev = 3;
                            _ctx.next = 6;
                            return http_client/* default.post */.Z.post(apiEndpoint, requestPayload);
                        case 6:
                            data = _ctx.sent.data;
                            // Log successful OTP send (non-blocking)
                            if (logStep) {
                                logStep("signup_otp_sent", {
                                    api_endpoint: apiEndpoint,
                                    request_payload: requestPayload,
                                    response_status: 200,
                                    response_payload: {
                                        otp_uuid: data.otp_uuid
                                    },
                                    success_message: data.message
                                });
                            }
                            // Success - mobile exists, user can login
                            authData.setOtpUid(data.otp_uuid);
                            authData.setMobileNumber(values.mobile);
                            authData.setAuthFlow("login");
                            (0,react_toastify_esm/* toast */.Am)(data.message, {
                                type: "success",
                                toastId: "auth-otp-success"
                            });
                            navigateToStep("verifyOtp");
                            _ctx.next = 20;
                            break;
                        case 15:
                            _ctx.prev = 15;
                            _ctx.t0 = _ctx["catch"](3);
                            ;
                            // Log API error (non-blocking)
                            if (logStep) {
                                ;
                                logStep("signup_otp_sent", {
                                    api_endpoint: apiEndpoint,
                                    request_payload: requestPayload,
                                    response_status: ((ref3 = _ctx.t0.response) === null || ref3 === void 0 ? void 0 : ref3.status) || 500,
                                    error_message: ((ref4 = _ctx.t0.response) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.data) === null || ref5 === void 0 ? void 0 : ref5.message) || "Failed to send OTP",
                                    error_code: ((ref6 = _ctx.t0.response) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.status) === null || ref7 === void 0 ? void 0 : ref7.toString()) || "500"
                                });
                            }
                            // Check if error is "Mobile number does not exist"
                            if (((ref = _ctx.t0.response) === null || ref === void 0 ? void 0 : ref.status) === 400 && ((ref1 = _ctx.t0.response) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.data) === null || ref2 === void 0 ? void 0 : ref2.message) === "Mobile number does not exist") {
                                // Mobile doesn't exist - navigate to signup
                                authData.setMobileNumber(values.mobile);
                                authData.setAuthFlow("register");
                                authData.setRegisterData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, authData.registerData), {
                                    mobile: values.mobile
                                }));
                                (0,react_toastify_esm/* toast */.Am)("Mobile number not registered. Please sign up.", {
                                    type: "info",
                                    toastId: "auth-signup-required"
                                });
                                navigateToStep("signup");
                            } else {
                                ;
                                // Other errors
                                if ((ref8 = _ctx.t0.response) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.data) === null || ref9 === void 0 ? void 0 : ref9.message) {
                                    (0,react_toastify_esm/* toast */.Am)(_ctx.t0.response.data.message, {
                                        type: "error",
                                        toastId: "auth-otp-error"
                                    });
                                } else {
                                    (0,react_toastify_esm/* toast */.Am)("Something went wrong! Try again!", {
                                        type: "error",
                                        toastId: "auth-otp-error"
                                    });
                                }
                            }
                        case 20:
                            setSendOtpLoading(false);
                        case 21:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        3,
                        15
                    ]
                ]);
            }));
            return function(values) {
                return _ref.apply(this, arguments);
            };
        }()
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "d-none d-md-block w-100",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (shap_of_you_module_default()).Login_face_desktop,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (shap_of_you_module_default()).bgImage,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: WelcomeScreen_dek,
                        alt: "Welcome Screen"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (shap_of_you_module_default()).shapeOfYou,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-7",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (shap_of_you_module_default()).content,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (shap_of_you_module_default()).title,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: SOYLockUp,
                                                alt: "Shape of You Logo"
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-5",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (shap_of_you_module_default()).Login_container_form,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (shap_of_you_module_default()).card,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                    className: (shap_of_you_module_default()).title_m,
                                                    children: "Login"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: (shap_of_you_module_default()).subtitle,
                                                    children: "Enter your phone number"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                                    onSubmit: loginFormik.handleSubmit,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (shap_of_you_module_default()).inputBox,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                                    className: (shap_of_you_module_default()).icon,
                                                                    width: "20",
                                                                    height: "20",
                                                                    viewBox: "0 0 36 36",
                                                                    fill: "none",
                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                        d: "M7.5 6H13.5L16.5 13.5L12.75 15.75C14.3564 19.0073 16.9927 21.6436 20.25 23.25L22.5 19.5L30 22.5V28.5C30 29.2956 29.6839 30.0587 29.1213 30.6213C28.5587 31.1839 27.7956 31.5 27 31.5C21.1489 31.1444 15.6302 28.6597 11.4852 24.5148C7.34026 20.3698 4.85557 14.8511 4.5 9C4.5 8.20435 4.81607 7.44129 5.37868 6.87868C5.94129 6.31607 6.70435 6 7.5 6Z",
                                                                        stroke: "#262121",
                                                                        strokeWidth: "3",
                                                                        strokeLinecap: "round",
                                                                        strokeLinejoin: "round"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                    type: "text",
                                                                    placeholder: " Phone number",
                                                                    className: (shap_of_you_module_default()).input,
                                                                    maxLength: 10,
                                                                    value: loginFormik.values.mobile,
                                                                    onChange: function(e) {
                                                                        var value = e.target.value.replace(/\D/g, "");
                                                                        loginFormik.setFieldValue("mobile", value);
                                                                    },
                                                                    onBlur: loginFormik.handleBlur
                                                                })
                                                            ]
                                                        }),
                                                        loginFormik.touched.mobile && loginFormik.errors.mobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "text-danger",
                                                            style: {
                                                                display: "block",
                                                                marginTop: "0px",
                                                                textAlign: "left"
                                                            },
                                                            children: loginFormik.errors.mobile
                                                        }) : null,
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                            className: (shap_of_you_module_default()).button,
                                                            type: "submit",
                                                            disabled: sendOtpLoading || !loginFormik.isValid || !loginFormik.values.mobile || loginFormik.values.mobile.length !== 10,
                                                            style: sendOtpLoading || !loginFormik.isValid || !loginFormik.values.mobile || loginFormik.values.mobile.length !== 10 ? {
                                                                background: "#d3d3d3",
                                                                color: "#888",
                                                                cursor: "not-allowed",
                                                                opacity: 0.6
                                                            } : {
                                                                background: "#C9302C",
                                                                color: "white",
                                                                cursor: "pointer"
                                                            },
                                                            children: [
                                                                sendOtpLoading ? "Sending..." : "Proceed",
                                                                " ",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                                    width: "25",
                                                                    height: "17",
                                                                    viewBox: "0 0 30 20",
                                                                    fill: "none",
                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                        d: "M0.000209928 11.0458L0 8.04596H24.2579L18.3333 2.12131L20.4546 0L30.0006 9.54596L20.4546 19.092L18.3333 16.9705L24.258 11.046L0.000209928 11.0458Z",
                                                                        fill: "currentcolor"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var shape_of_you_desktop_new_LoginScreen = (LoginScreen_LoginScreen);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_array.mjs
var _to_array = __webpack_require__(59637);
;// CONCATENATED MODULE: ./src/components/shape-of-you-desktop-new/SignupScreen.tsx















var SignupScreen_SignupScreen = function(param) {
    var navigateToStep = param.navigateToStep, authData = param.authData, logStep = param.logStep;
    var ref = (0,react.useState)(false), sendOtpLoading = ref[0], setSendOtpLoading = ref[1];
    // Log signup viewed on mount
    (0,react.useEffect)(function() {
        if (logStep) {
            logStep("signup_viewed");
        }
    }, [
        logStep
    ]);
    // Register Formik
    var registerFormik = (0,formik_esm/* useFormik */.TA)({
        initialValues: {
            fullName: (authData.registerData.firstName + " " + authData.registerData.lastName).trim() || "",
            email: authData.registerData.email || "",
            mobile: authData.mobileNumber || authData.registerData.mobile || "",
            pincode: authData.registerData.pincode || ""
        },
        validationSchema: yup_es/* object */.Ry({
            fullName: yup_es/* string */.Z_().trim().required("Full name is required"),
            email: yup_es/* string */.Z_().required("Email is required").email("Email is invalid"),
            mobile: yup_es/* string */.Z_().matches(regex/* phoneRegExp */.O, "Mobile number is not valid").test("len", "Mobile number needs to be exactly 10 digits", function(val) {
                return (val === null || val === void 0 ? void 0 : val.toString().length) === 10;
            }).required("Mobile is required"),
            pincode: yup_es/* string */.Z_().required("Pincode is required").matches(/^\d{6}$/, "Invalid pincode. Must be a 6-digit number")
        }),
        onSubmit: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values) {
                var apiEndpoint, requestPayload, data, ref, tmp, firstName, lastNameParts, lastName, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            setSendOtpLoading(true);
                            apiEndpoint = endpoints/* default.auth.sendOtp */.Z.auth.sendOtp();
                            requestPayload = {
                                mobile: values.mobile,
                                email: values.email,
                                pincode: values.pincode
                            };
                            _ctx.prev = 3;
                            _ctx.next = 6;
                            return http_client/* default.post */.Z.post(apiEndpoint, requestPayload);
                        case 6:
                            data = _ctx.sent.data;
                            // Log successful OTP send (non-blocking)
                            if (logStep) {
                                logStep("signup_otp_sent", {
                                    api_endpoint: apiEndpoint,
                                    request_payload: requestPayload,
                                    response_status: 200,
                                    response_payload: {
                                        otp_uuid: data.otp_uuid
                                    },
                                    success_message: data.message
                                });
                            }
                            ref = (0,_to_array/* default */.Z)(values.fullName.trim().split(" ")), tmp = ref[0], firstName = tmp === void 0 ? "" : tmp, lastNameParts = ref.slice(1);
                            lastName = lastNameParts.join(" ") || "";
                            authData.setOtpUid(data.otp_uuid);
                            authData.setMobileNumber(values.mobile);
                            authData.setAuthFlow("register");
                            authData.setRegisterData({
                                firstName: firstName,
                                lastName: lastName,
                                email: values.email,
                                mobile: values.mobile,
                                pincode: values.pincode
                            });
                            (0,react_toastify_esm/* toast */.Am)(data.message, {
                                type: "success",
                                toastId: "auth-otp-success"
                            });
                            navigateToStep("verifyOtp");
                            _ctx.next = 23;
                            break;
                        case 18:
                            _ctx.prev = 18;
                            _ctx.t0 = _ctx["catch"](3);
                            ;
                            // Log API error (non-blocking)
                            if (logStep) {
                                ;
                                logStep("signup_otp_sent", {
                                    api_endpoint: apiEndpoint,
                                    request_payload: requestPayload,
                                    response_status: ((ref3 = _ctx.t0.response) === null || ref3 === void 0 ? void 0 : ref3.status) || 500,
                                    error_message: ((ref4 = _ctx.t0.response) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.data) === null || ref5 === void 0 ? void 0 : ref5.message) || "Failed to send OTP",
                                    error_code: ((ref6 = _ctx.t0.response) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.status) === null || ref7 === void 0 ? void 0 : ref7.toString()) || "500"
                                });
                            }
                            if ((ref1 = _ctx.t0.response) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.data) === null || ref2 === void 0 ? void 0 : ref2.message) {
                                (0,react_toastify_esm/* toast */.Am)(_ctx.t0.response.data.message, {
                                    type: "error",
                                    toastId: "auth-otp-error"
                                });
                            } else {
                                (0,react_toastify_esm/* toast */.Am)("Something went wrong! Try again!", {
                                    type: "error",
                                    toastId: "auth-otp-error"
                                });
                            }
                        case 23:
                            setSendOtpLoading(false);
                        case 24:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        3,
                        18
                    ]
                ]);
            }));
            return function(values) {
                return _ref.apply(this, arguments);
            };
        }()
    });
    // Update mobile number in formik when it comes from authData
    (0,react.useEffect)(function() {
        if (authData.mobileNumber && !registerFormik.values.mobile) {
            registerFormik.setFieldValue("mobile", authData.mobileNumber);
        }
    }, [
        authData.mobileNumber
    ]);
    var isFormComplete = registerFormik.values.fullName && registerFormik.values.email && registerFormik.values.mobile && registerFormik.values.pincode && registerFormik.isValid;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "d-none d-md-block w-100",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (shap_of_you_module_default()).signup_face_desktop,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (shap_of_you_module_default()).bgImage,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: WelcomeScreen_dek,
                        alt: "Welcome Screen"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (shap_of_you_module_default()).shapeOfYou,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-7",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (shap_of_you_module_default()).content,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (shap_of_you_module_default()).title,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: SOYLockUp,
                                                alt: "Shape of You Logo"
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-5",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (shap_of_you_module_default()).Login_container_form,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (shap_of_you_module_default()).card,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                    className: (shap_of_you_module_default()).title_m,
                                                    children: "Enter Your Details"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: (shap_of_you_module_default()).subtitle,
                                                    children: "Let us get to know you better"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                                    onSubmit: registerFormik.handleSubmit,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (shap_of_you_module_default()).inputBox,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                                    className: (shap_of_you_module_default()).icon,
                                                                    width: "20",
                                                                    height: "20",
                                                                    viewBox: "0 0 36 36",
                                                                    fill: "none",
                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                            d: "M12 10.5C12 12.0913 12.6321 13.6174 13.7574 14.7426C14.8826 15.8679 16.4087 16.5 18 16.5C19.5913 16.5 21.1174 15.8679 22.2426 14.7426C23.3679 13.6174 24 12.0913 24 10.5C24 8.9087 23.3679 7.38258 22.2426 6.25736C21.1174 5.13214 19.5913 4.5 18 4.5C16.4087 4.5 14.8826 5.13214 13.7574 6.25736C12.6321 7.38258 12 8.9087 12 10.5Z",
                                                                            stroke: "#262121",
                                                                            strokeWidth: "3",
                                                                            strokeLinecap: "round",
                                                                            strokeLinejoin: "round"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                            d: "M9 31.5V28.5C9 26.9087 9.63214 25.3826 10.7574 24.2574C11.8826 23.1321 13.4087 22.5 15 22.5H21C22.5913 22.5 24.1174 23.1321 25.2426 24.2574C26.3679 25.3826 27 26.9087 27 28.5V31.5",
                                                                            stroke: "#262121",
                                                                            strokeWidth: "3",
                                                                            strokeLinecap: "round",
                                                                            strokeLinejoin: "round"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                    type: "text",
                                                                    placeholder: " Full Name",
                                                                    className: (shap_of_you_module_default()).input,
                                                                    value: registerFormik.values.fullName,
                                                                    onChange: function(e) {
                                                                        return registerFormik.setFieldValue("fullName", e.target.value);
                                                                    },
                                                                    onBlur: registerFormik.handleBlur
                                                                })
                                                            ]
                                                        }),
                                                        registerFormik.touched.fullName && registerFormik.errors.fullName ? /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                            className: "text-danger",
                                                            style: {
                                                                display: "block",
                                                                marginTop: "5px",
                                                                textAlign: "center"
                                                            },
                                                            children: registerFormik.errors.fullName
                                                        }) : null,
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (shap_of_you_module_default()).inputBox,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                                    className: (shap_of_you_module_default()).icon,
                                                                    width: "20",
                                                                    height: "20",
                                                                    viewBox: "0 0 36 36",
                                                                    fill: "none",
                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                        d: "M7.5 6H13.5L16.5 13.5L12.75 15.75C14.3564 19.0073 16.9927 21.6436 20.25 23.25L22.5 19.5L30 22.5V28.5C30 29.2956 29.6839 30.0587 29.1213 30.6213C28.5587 31.1839 27.7956 31.5 27 31.5C21.1489 31.1444 15.6302 28.6597 11.4852 24.5148C7.34026 20.3698 4.85557 14.8511 4.5 9C4.5 8.20435 4.81607 7.44129 5.37868 6.87868C5.94129 6.31607 6.70435 6 7.5 6Z",
                                                                        stroke: "#262121",
                                                                        strokeWidth: "3",
                                                                        strokeLinecap: "round",
                                                                        strokeLinejoin: "round"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                    type: "text",
                                                                    placeholder: " Phone number",
                                                                    className: (shap_of_you_module_default()).input,
                                                                    maxLength: 10,
                                                                    value: registerFormik.values.mobile,
                                                                    onChange: function(e) {
                                                                        var value = e.target.value.replace(/\D/g, "");
                                                                        registerFormik.setFieldValue("mobile", value);
                                                                    },
                                                                    onBlur: registerFormik.handleBlur
                                                                })
                                                            ]
                                                        }),
                                                        registerFormik.touched.mobile && registerFormik.errors.mobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                            className: "text-danger",
                                                            style: {
                                                                display: "block",
                                                                marginTop: "5px",
                                                                textAlign: "center"
                                                            },
                                                            children: registerFormik.errors.mobile
                                                        }) : null,
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (shap_of_you_module_default()).inputBox,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                                    className: (shap_of_you_module_default()).icon,
                                                                    width: "20",
                                                                    height: "20",
                                                                    viewBox: "0 0 36 36",
                                                                    fill: "none",
                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                            d: "M4.5 10.5C4.5 9.70435 4.81607 8.94129 5.37868 8.37868C5.94129 7.81607 6.70435 7.5 7.5 7.5H28.5C29.2956 7.5 30.0587 7.81607 30.6213 8.37868C31.1839 8.94129 31.5 9.70435 31.5 10.5V25.5C31.5 26.2956 31.1839 27.0587 30.6213 27.6213C30.0587 28.1839 29.2956 28.5 28.5 28.5H7.5C6.70435 28.5 5.94129 28.1839 5.37868 27.6213C4.81607 27.0587 4.5 26.2956 4.5 25.5V10.5Z",
                                                                            stroke: "#262121",
                                                                            strokeWidth: "3",
                                                                            strokeLinecap: "round",
                                                                            strokeLinejoin: "round"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                            d: "M4.5 10.5L18 19.5L31.5 10.5",
                                                                            stroke: "#262121",
                                                                            strokeWidth: "3",
                                                                            strokeLinecap: "round",
                                                                            strokeLinejoin: "round"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                    type: "email",
                                                                    placeholder: " Email Id",
                                                                    className: (shap_of_you_module_default()).input,
                                                                    value: registerFormik.values.email,
                                                                    onChange: function(e) {
                                                                        return registerFormik.setFieldValue("email", e.target.value);
                                                                    },
                                                                    onBlur: registerFormik.handleBlur
                                                                })
                                                            ]
                                                        }),
                                                        registerFormik.touched.email && registerFormik.errors.email ? /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                            className: "text-danger",
                                                            style: {
                                                                display: "block",
                                                                marginTop: "5px",
                                                                textAlign: "center"
                                                            },
                                                            children: registerFormik.errors.email
                                                        }) : null,
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (shap_of_you_module_default()).inputBox,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                                    className: (shap_of_you_module_default()).icon,
                                                                    width: "20",
                                                                    height: "20",
                                                                    viewBox: "0 0 32 32",
                                                                    fill: "none",
                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                            d: "M12 16C12 17.0609 12.4214 18.0783 13.1716 18.8284C13.9217 19.5786 14.9391 20 16 20C17.0609 20 18.0783 19.5786 18.8284 18.8284C19.5786 18.0783 20 17.0609 20 16C20 14.9391 19.5786 13.9217 18.8284 13.1716C18.0783 12.4214 17.0609 12 16 12C14.9391 12 13.9217 12.4214 13.1716 13.1716C12.4214 13.9217 12 14.9391 12 16Z",
                                                                            stroke: "#262121",
                                                                            strokeWidth: "2.66667",
                                                                            strokeLinecap: "round",
                                                                            strokeLinejoin: "round"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                            d: "M5.3335 16.0002C5.3335 18.8291 6.4573 21.5422 8.45769 23.5426C10.4581 25.543 13.1712 26.6668 16.0002 26.6668C18.8291 26.6668 21.5422 25.543 23.5426 23.5426C25.543 21.5422 26.6668 18.8291 26.6668 16.0002C26.6668 13.1712 25.543 10.4581 23.5426 8.45769C21.5422 6.4573 18.8291 5.3335 16.0002 5.3335C13.1712 5.3335 10.4581 6.4573 8.45769 8.45769C6.4573 10.4581 5.3335 13.1712 5.3335 16.0002Z",
                                                                            stroke: "#262121",
                                                                            strokeWidth: "2.66667",
                                                                            strokeLinecap: "round",
                                                                            strokeLinejoin: "round"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                            d: "M16 2.6665V5.33317",
                                                                            stroke: "#262121",
                                                                            strokeWidth: "2.66667",
                                                                            strokeLinecap: "round",
                                                                            strokeLinejoin: "round"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                            d: "M16 26.6665V29.3332",
                                                                            stroke: "#262121",
                                                                            strokeWidth: "2.66667",
                                                                            strokeLinecap: "round",
                                                                            strokeLinejoin: "round"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                            d: "M26.6665 16H29.3332",
                                                                            stroke: "#262121",
                                                                            strokeWidth: "2.66667",
                                                                            strokeLinecap: "round",
                                                                            strokeLinejoin: "round"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                            d: "M2.6665 16H5.33317",
                                                                            stroke: "#262121",
                                                                            strokeWidth: "2.66667",
                                                                            strokeLinecap: "round",
                                                                            strokeLinejoin: "round"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                    type: "number",
                                                                    placeholder: " Pincode",
                                                                    className: (shap_of_you_module_default()).input,
                                                                    maxLength: 6,
                                                                    value: registerFormik.values.pincode,
                                                                    onChange: function(e) {
                                                                        var value = e.target.value.replace(/\D/g, "");
                                                                        if (value.length <= 6) {
                                                                            registerFormik.setFieldValue("pincode", value);
                                                                        }
                                                                    },
                                                                    onBlur: registerFormik.handleBlur
                                                                })
                                                            ]
                                                        }),
                                                        registerFormik.touched.pincode && registerFormik.errors.pincode ? /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                            className: "text-danger",
                                                            style: {
                                                                display: "block",
                                                                marginTop: "5px",
                                                                textAlign: "center"
                                                            },
                                                            children: registerFormik.errors.pincode
                                                        }) : null,
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                            className: (shap_of_you_module_default()).button,
                                                            type: "submit",
                                                            disabled: sendOtpLoading || !isFormComplete,
                                                            style: sendOtpLoading || !isFormComplete ? {
                                                                background: "#d3d3d3",
                                                                color: "#888",
                                                                cursor: "not-allowed",
                                                                opacity: 0.6
                                                            } : {
                                                                background: "#C9302C",
                                                                color: "white",
                                                                cursor: "pointer"
                                                            },
                                                            children: [
                                                                sendOtpLoading ? "Sending..." : "Proceed",
                                                                " ",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                                    width: "25",
                                                                    height: "17",
                                                                    viewBox: "0 0 30 20",
                                                                    fill: "none",
                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                        d: "M0.000209928 11.0458L0 8.04596H24.2579L18.3333 2.12131L20.4546 0L30.0006 9.54596L20.4546 19.092L18.3333 16.9705L24.258 11.046L0.000209928 11.0458Z",
                                                                        fill: "currentcolor"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    style: {
                                                        textAlign: "center",
                                                        marginTop: "16px",
                                                        fontSize: "14px",
                                                        color: "#262121"
                                                    },
                                                    children: [
                                                        "Already a registered user?",
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            onClick: function() {
                                                                return navigateToStep("login");
                                                            },
                                                            style: {
                                                                color: "#C9302C",
                                                                cursor: "pointer",
                                                                fontWeight: 600
                                                            },
                                                            children: "Login"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var shape_of_you_desktop_new_SignupScreen = (SignupScreen_SignupScreen);

;// CONCATENATED MODULE: ./src/components/shape-of-you-desktop-new/VerifyOtpScreen.tsx
























var VerifyOtpScreen_RESEND_OTP_INTERVAL_SECONDS = 30;
var VerifyOtpScreen_VerifyOtpScreen = function(param) {
    var navigateToStep = param.navigateToStep, authData = param.authData, onAuthComplete = param.onAuthComplete, logStep = param.logStep;
    var dispatch = (0,store/* useAppDispatch */.T)();
    var ref = (0,react.useState)(false), loading = ref[0], setLoading = ref[1];
    var ref1 = (0,react.useState)(false), sendOtpLoading = ref1[0], setSendOtpLoading = ref1[1];
    var ref2 = (0,react.useState)(VerifyOtpScreen_RESEND_OTP_INTERVAL_SECONDS), resendTimeout = ref2[0], setResendTimeout = ref2[1];
    var ref3 = (0,react.useState)([
        "",
        "",
        "",
        "",
        "",
        ""
    ]), otpValues = ref3[0], setOtpValues = ref3[1];
    var ref4 = (0,react.useState)("idle"), verificationStatus = ref4[0], setVerificationStatus = ref4[1];
    var ref5 = (0,react.useState)(null), accessToken = ref5[0], setAccessToken = ref5[1];
    var currentDate = moment_timezone_default()().format("DD-MM-YYYY");
    var isOtpComplete = otpValues.every(function(val) {
        return val !== "";
    });
    // Countdown timer for resend OTP
    (0,react.useEffect)(function() {
        if (resendTimeout > 0) {
            var timer = setInterval(function() {
                setResendTimeout(resendTimeout - 1);
            }, 1000);
            return function() {
                return clearInterval(timer);
            };
        }
    }, [
        resendTimeout
    ]);
    // OTP Formik
    var otpFormik = (0,formik_esm/* useFormik */.TA)({
        initialValues: {
            otp: ""
        },
        validationSchema: yup_es/* object */.Ry({
            otp: yup_es/* string */.Z_().required("OTP is required").min(6, "Must be exactly 6 digits").max(6, "Must be exactly 6 digits").matches(/^\d{6}$/, "OTP must be 6 digits")
        }),
        onSubmit: function() {}
    });
    // Step 1: Verify OTP (without navigating)
    var handleVerifyOtp = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var otpString, apiEndpoint, requestPayload, data, apiEndpoint1, requestPayload1, data1, ref, ref1, ref2, ref3, ref4, ref5, stepName, ref6, ref7;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setVerificationStatus("verifying");
                        setLoading(true);
                        _ctx.prev = 2;
                        otpString = otpValues.join("");
                        if (!(authData.authFlow === "login")) {
                            _ctx.next = 17;
                            break;
                        }
                        apiEndpoint = endpoints/* default.auth.loginVerifyOtp */.Z.auth.loginVerifyOtp();
                        requestPayload = {
                            mobile: authData.mobileNumber,
                            otp: otpString,
                            otp_uuid: authData.otpUid
                        };
                        _ctx.next = 9;
                        return http_client/* default.post */.Z.post(apiEndpoint, requestPayload);
                    case 9:
                        data = _ctx.sent.data;
                        // Log successful login (non-blocking)
                        if (logStep) {
                            logStep("signup_login_success", {
                                api_endpoint: apiEndpoint,
                                request_payload: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, requestPayload), {
                                    otp: "******"
                                }),
                                response_status: 200,
                                response_payload: {
                                    access_token: "[token]"
                                },
                                success_message: "Login successful"
                            });
                        }
                        // Store access token and set verified status
                        setAccessToken(data === null || data === void 0 ? void 0 : data.access_token);
                        setVerificationStatus("verified");
                        _ctx.next = 15;
                        return handleAutoLogin(data === null || data === void 0 ? void 0 : data.access_token);
                    case 15:
                        _ctx.next = 29;
                        break;
                    case 17:
                        apiEndpoint1 = endpoints/* default.auth.signup */.Z.auth.signup();
                        requestPayload1 = {
                            name: "".concat(authData.registerData.firstName, " ").concat(authData.registerData.lastName),
                            mobile: authData.mobileNumber,
                            email: authData.registerData.email,
                            pincode: authData.registerData.pincode,
                            otp: otpString,
                            otp_uuid: authData.otpUid,
                            source: "shape_of_you"
                        };
                        _ctx.next = 21;
                        return http_client/* default.post */.Z.post(apiEndpoint1, requestPayload1);
                    case 21:
                        data1 = _ctx.sent.data;
                        // Log successful registration (non-blocking)
                        if (logStep) {
                            logStep("signup_register_success", {
                                api_endpoint: apiEndpoint1,
                                request_payload: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, requestPayload1), {
                                    otp: "******"
                                }),
                                response_status: 200,
                                response_payload: {
                                    access_token: "[token]"
                                },
                                success_message: "Registration successful"
                            });
                        }
                        // Track registration events
                        if (window.Moengage) {
                            window.Moengage.track_event("Registration Completed", {
                                mobile: authData.mobileNumber,
                                platform: "website"
                            });
                        }
                        if (window.smartech) {
                            (0,unbxd/* unbxdCusEngTrackUser */.nV)({
                                "pk^mobile": authData.mobileNumber,
                                NAME: "".concat(authData.registerData.firstName, " ").concat(authData.registerData.lastName),
                                email: authData.registerData.email,
                                PINCODE: authData.registerData.pincode,
                                SENCO_USER: "yes",
                                REGISTRATION_DATE_SENCO: currentDate
                            });
                            window.smartech("identify", authData.mobileNumber);
                            setTimeout(function() {
                                (0,unbxd/* unbxdCusEngTrackEvent */.$z)("Registration", {
                                    source: "web",
                                    platform: "senco"
                                });
                            }, 200);
                        }
                        // Store access token and set verified status
                        setAccessToken(data1.access_token);
                        setVerificationStatus("verified");
                        _ctx.next = 29;
                        return handleAutoLogin(data1.access_token);
                    case 29:
                        _ctx.next = 36;
                        break;
                    case 31:
                        _ctx.prev = 31;
                        _ctx.t0 = _ctx["catch"](2);
                        ;
                        // Log API error (non-blocking)
                        if (logStep) {
                            ;
                            stepName = authData.authFlow === "login" ? "signup_login_success" : "signup_register_success";
                            logStep(stepName, {
                                api_endpoint: authData.authFlow === "login" ? endpoints/* default.auth.loginVerifyOtp */.Z.auth.loginVerifyOtp() : endpoints/* default.auth.signup */.Z.auth.signup(),
                                response_status: ((ref1 = _ctx.t0.response) === null || ref1 === void 0 ? void 0 : ref1.status) || 500,
                                error_message: ((ref2 = _ctx.t0.response) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : ref3.message) || "OTP verification failed",
                                error_code: ((ref4 = _ctx.t0.response) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.status) === null || ref5 === void 0 ? void 0 : ref5.toString()) || "500"
                            });
                        }
                        // Check if error is "OTP does not match"
                        if (((ref = _ctx.t0.response) === null || ref === void 0 ? void 0 : ref.status) === 400) {
                            setVerificationStatus("error");
                        } else {
                            ;
                            setVerificationStatus("error");
                            if ((ref6 = _ctx.t0.response) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.data) === null || ref7 === void 0 ? void 0 : ref7.message) {
                                (0,react_toastify_esm/* toast */.Am)(_ctx.t0.response.data.message, {
                                    type: "error",
                                    toastId: "auth-otp-error"
                                });
                            } else {
                                (0,react_toastify_esm/* toast */.Am)("Something went wrong! Try again!", {
                                    type: "error",
                                    toastId: "auth-otp-error"
                                });
                            }
                        }
                    case 36:
                        setLoading(false);
                    case 37:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    31
                ]
            ]);
        }));
        return function handleVerifyOtp() {
            return _ref.apply(this, arguments);
        };
    }();
    // Auto-login after successful registration/login
    var handleAutoLogin = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(token) {
            var ref, user, pendingConsent;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        (0,lib.setCookies)("token", token, {
                            path: "/"
                        });
                        _ctx.next = 4;
                        return dispatch((0,auth/* fetchAuthUser */.zA)());
                    case 4:
                        ref = _ctx.sent;
                        user = ref.payload;
                        (0,react_toastify_esm/* toast */.Am)("Welcome ".concat(user.name), {
                            type: "success",
                            toastId: "auth-login-success"
                        });
                        if (window.Moengage) {
                            window.Moengage.track_event("Login", {
                                mobile: user.mobile
                            });
                            window.Moengage.add_first_name(user.name);
                            window.Moengage.add_mobile(user.mobile);
                            window.Moengage.add_unique_user_id(user.uuid);
                            if (user.email) {
                                window.Moengage.add_email(user.email);
                            }
                        }
                        if (window.smartech) {
                            (0,unbxd/* unbxdCusEngTrackUser */.nV)({
                                "pk^mobile": user === null || user === void 0 ? void 0 : user.mobile,
                                SENCO_USER: "yes"
                            });
                            window.smartech("identify", user === null || user === void 0 ? void 0 : user.mobile);
                            (0,unbxd/* unbxdCusEngTrackEvent */.$z)("Sign in ", {
                                source: "web",
                                platform: "senco"
                            });
                        }
                        dispatch((0,cart/* fetchCartItems */.Vw)());
                        dispatch((0,wishlist/* fetchWishlistItems */.nf)(user.id));
                        (0,tryOnTracking/* initTryOnTracking */.j)(user.id);
                        pendingConsent = localStorage.getItem("pendingConsentAcceptance");
                        if (!(pendingConsent === "true")) {
                            _ctx.next = 24;
                            break;
                        }
                        _ctx.prev = 14;
                        _ctx.next = 17;
                        return http_client/* default.post */.Z.post(endpoints/* default.auth.updateConsentForm */.Z.auth.updateConsentForm(), {
                            status: "accept"
                        });
                    case 17:
                        // Clear the localStorage flag
                        localStorage.removeItem("pendingConsentAcceptance");
                        ;
                        _ctx.next = 24;
                        break;
                    case 21:
                        _ctx.prev = 21;
                        _ctx.t0 = _ctx["catch"](14);
                        ;
                    case 24:
                        // Call parent completion handler or fallback to navigation
                        if (onAuthComplete) {
                            onAuthComplete();
                        } else {
                            // Fallback: Navigate to product view after successful login
                            navigateToStep("productView");
                        }
                        _ctx.next = 31;
                        break;
                    case 27:
                        _ctx.prev = 27;
                        _ctx.t1 = _ctx["catch"](0);
                        ;
                        (0,react_toastify_esm/* toast */.Am)("Login successful but failed to fetch user data", {
                            type: "warning",
                            toastId: "auth-warning"
                        });
                    case 31:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    27
                ],
                [
                    14,
                    21
                ]
            ]);
        }));
        return function handleAutoLogin(token) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleOtpChange = function(index, value) {
        if (value.length <= 1 && /^\d*$/.test(value)) {
            var newOtpValues = (0,_to_consumable_array/* default */.Z)(otpValues);
            newOtpValues[index] = value;
            setOtpValues(newOtpValues);
            // Reset verification status when user modifies OTP
            if (verificationStatus === "error" || verificationStatus === "verified") {
                setVerificationStatus("idle");
            }
            // Update formik value
            var otpString = newOtpValues.join("");
            otpFormik.setFieldValue("otp", otpString, false);
            // Auto-focus next input
            if (value && index < 5) {
                var nextInput = document.getElementById("otp-".concat(index + 1));
                nextInput === null || nextInput === void 0 ? void 0 : nextInput.focus();
            }
        }
    };
    var handleOtpKeyDown = function(index, e) {
        if (e.key === "Backspace" && !otpValues[index] && index > 0) {
            var prevInput = document.getElementById("otp-".concat(index - 1));
            prevInput === null || prevInput === void 0 ? void 0 : prevInput.focus();
        }
    };
    // Handle resend OTP
    var handleResendOtp = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var apiEndpoint, requestPayload, data, ref, ref1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(resendTimeout > 0)) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        setSendOtpLoading(true);
                        _ctx.prev = 3;
                        ;
                        ;
                        if (authData.authFlow === "login") {
                            apiEndpoint = endpoints/* default.auth.loginSendOtp */.Z.auth.loginSendOtp();
                            requestPayload = {
                                mobile: authData.mobileNumber
                            };
                        } else {
                            // Register flow - use the same endpoint as SignupScreen
                            apiEndpoint = endpoints/* default.auth.sendOtp */.Z.auth.sendOtp();
                            requestPayload = {
                                mobile: authData.mobileNumber,
                                email: authData.registerData.email,
                                pincode: authData.registerData.pincode
                            };
                        }
                        _ctx.next = 9;
                        return http_client/* default.post */.Z.post(apiEndpoint, requestPayload);
                    case 9:
                        data = _ctx.sent.data;
                        (0,react_toastify_esm/* toast */.Am)(data.message || "OTP resent successfully", {
                            type: "success",
                            toastId: "auth-otp-resend-success"
                        });
                        // Reset timer
                        setResendTimeout(VerifyOtpScreen_RESEND_OTP_INTERVAL_SECONDS);
                        _ctx.next = 18;
                        break;
                    case 14:
                        _ctx.prev = 14;
                        _ctx.t0 = _ctx["catch"](3);
                        ;
                        if ((ref = _ctx.t0.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.message) {
                            (0,react_toastify_esm/* toast */.Am)(_ctx.t0.response.data.message, {
                                type: "error",
                                toastId: "auth-otp-resend-error"
                            });
                        } else {
                            (0,react_toastify_esm/* toast */.Am)("Failed to resend OTP. Please try again!", {
                                type: "error",
                                toastId: "auth-otp-resend-error"
                            });
                        }
                    case 18:
                        setSendOtpLoading(false);
                    case 19:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    3,
                    14
                ]
            ]);
        }));
        return function handleResendOtp() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "d-none d-md-block w-100",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (shap_of_you_module_default()).otp_face_desktop,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (shap_of_you_module_default()).bgImage,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: WelcomeScreen_dek,
                        alt: "Welcome Screen"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (shap_of_you_module_default()).shapeOfYou,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-7",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (shap_of_you_module_default()).content,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (shap_of_you_module_default()).title,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: SOYLockUp,
                                                alt: "Shape of You Logo"
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-5",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (shap_of_you_module_default()).Login_container_form,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (shap_of_you_module_default()).card,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                    className: (shap_of_you_module_default()).title_m,
                                                    children: "Verify OTP"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: (shap_of_you_module_default()).subtitle,
                                                    children: "OTP has been sent to your phone number"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (shap_of_you_module_default()).otpContainer,
                                                    children: [
                                                        0,
                                                        1,
                                                        2,
                                                        3,
                                                        4,
                                                        5
                                                    ].map(function(index) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            id: "otp-".concat(index),
                                                            type: "password",
                                                            maxLength: 1,
                                                            className: (shap_of_you_module_default()).otpInput,
                                                            value: otpValues[index],
                                                            onChange: function(e) {
                                                                return handleOtpChange(index, e.target.value);
                                                            },
                                                            onKeyDown: function(e) {
                                                                return handleOtpKeyDown(index, e);
                                                            },
                                                            style: verificationStatus === "error" ? {
                                                                border: "2px solid #dc3545",
                                                                backgroundColor: "#ffe6e6"
                                                            } : {}
                                                        }, index);
                                                    })
                                                }),
                                                verificationStatus === "error" && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "text-danger",
                                                    style: {
                                                        display: "block",
                                                        textAlign: "left"
                                                    },
                                                    children: "Error! OTP incorrect"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    className: (shap_of_you_module_default()).timer,
                                                    children: [
                                                        "(OTP Timer",
                                                        " ",
                                                        resendTimeout > 0 ? "".concat(resendTimeout, "s") : "over",
                                                        ")"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (shap_of_you_module_default()).resendRow,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: "Didn't get an OTP?"
                                                        }),
                                                        resendTimeout > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            style: {
                                                                color: "#ccc",
                                                                cursor: "not-allowed"
                                                            },
                                                            children: "Resend OTP"
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                            className: (shap_of_you_module_default()).resendBtn,
                                                            onClick: handleResendOtp,
                                                            disabled: sendOtpLoading,
                                                            style: {
                                                                color: "#c9302c"
                                                            },
                                                            children: sendOtpLoading ? "Sending..." : "Resend OTP"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (shap_of_you_module_default()).editNumber,
                                                    onClick: function() {
                                                        return navigateToStep("login");
                                                    },
                                                    style: {
                                                        cursor: "pointer"
                                                    },
                                                    children: [
                                                        "Edit Phone Number",
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                            width: "20",
                                                            height: "20",
                                                            viewBox: "0 0 36 36",
                                                            fill: "none",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                    d: "M24.6374 6.90763L26.1223 5.42265C27.3526 4.19245 29.3472 4.19245 30.5773 5.42265C31.8075 6.65286 31.8075 8.64739 30.5773 9.8776L29.0923 11.3626M24.6374 6.90763L14.6484 16.8966C13.8871 17.658 13.3471 18.6117 13.086 19.6561L12 24L16.3438 22.914C17.3883 22.653 18.342 22.1128 19.1034 21.3516L29.0923 11.3626M24.6374 6.90763L29.0923 11.3626",
                                                                    stroke: "#262121",
                                                                    strokeWidth: "3",
                                                                    strokeLinejoin: "round"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                    d: "M28.4999 20.25C28.4999 25.1812 28.4998 27.6468 27.138 29.3064C26.8887 29.6101 26.6102 29.8887 26.3063 30.138C24.6468 31.5 22.1811 31.5 17.2498 31.5H16.5C10.8431 31.5 8.01474 31.5 6.25738 29.7426C4.50004 27.9853 4.5 25.1568 4.5 19.5V18.75C4.5 13.8188 4.5 11.3532 5.86191 9.69366C6.11125 9.38985 6.38985 9.11125 6.69366 8.86191C8.35318 7.5 10.8188 7.5 15.75 7.5",
                                                                    stroke: "#262121",
                                                                    strokeWidth: "3",
                                                                    strokeLinejoin: "round"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                    className: (shap_of_you_module_default()).submitBtn,
                                                    onClick: function(e) {
                                                        e.preventDefault();
                                                        if (isOtpComplete && !loading) {
                                                            handleVerifyOtp();
                                                        }
                                                    },
                                                    disabled: loading || !isOtpComplete,
                                                    style: loading || !isOtpComplete ? {
                                                        background: "#d3d3d3",
                                                        color: "#888",
                                                        cursor: "not-allowed",
                                                        opacity: 0.6
                                                    } : {
                                                        background: "#C9302C",
                                                        color: "white",
                                                        cursor: "pointer"
                                                    },
                                                    children: [
                                                        loading ? "Submitting..." : "Submit",
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                            width: "20",
                                                            height: "20",
                                                            viewBox: "0 0 36 36",
                                                            fill: "none",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M2.99972 19.4999L2.99951 16.5001H27.2574L21.3328 10.5754L23.4541 8.4541L33.0001 18.0001L23.4541 27.5461L21.3328 25.4246L27.2575 19.5001L2.99972 19.4999Z",
                                                                fill: "currentcolor"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var shape_of_you_desktop_new_VerifyOtpScreen = (VerifyOtpScreen_VerifyOtpScreen);

// EXTERNAL MODULE: ./node_modules/next/dist/styled-jsx/style.js
var style = __webpack_require__(60536);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./node_modules/swiper/modules/navigation/navigation.min.css
var navigation_min = __webpack_require__(92);
// EXTERNAL MODULE: ./node_modules/swiper/modules/thumbs/thumbs.min.css
var thumbs_min = __webpack_require__(75083);
// EXTERNAL MODULE: ./node_modules/swiper/modules/free-mode/free-mode.min.css
var free_mode_min = __webpack_require__(30706);
// EXTERNAL MODULE: ./src/assets/images/made-in-india.png
var made_in_india = __webpack_require__(99749);
;// CONCATENATED MODULE: ./src/components/shape-of-you-desktop-new/ProductDetailsModal.tsx

















var ProductDetailsModal = function(param) {
    var isOpen = param.isOpen, setIsOpen = param.setIsOpen, selectedProduct = param.selectedProduct, getImageSrc = param.getImageSrc, cartItem = param.cartItem, showAddedSuccess = param.showAddedSuccess, cartActionLoading = param.cartActionLoading, addToCart = param.addToCart, removeFromCart = param.removeFromCart;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var dispatch = (0,store/* useAppDispatch */.T)();
    var shapeOfYouState = (0,es/* useSelector */.v9)(shapeOfYou/* selectShapeOfYou */.Tk);
    var ref10 = (0,react.useState)("description"), activeTab = ref10[0], setActiveTab = ref10[1];
    var ref11 = (0,react.useState)(null), productDetails = ref11[0], setProductDetails = ref11[1];
    var ref12 = (0,react.useState)(null), thumbsSwiper = ref12[0], setThumbsSwiper = ref12[1];
    var ref13 = (0,react.useState)(null), mainSwiper = ref13[0], setMainSwiper = ref13[1];
    var ref14 = (0,react.useState)(0), activeSlide = ref14[0], setActiveSlide = ref14[1];
    var ref15 = (0,react.useState)(false), showCertificate = ref15[0], setShowCertificate = ref15[1];
    // Virtual Try On handler
    var openTryOn = function() {
        if (window.initMirrarUI && productDetails && "e517b5d3-15f1-4d2c-87a7-ecb16d0d151f") {
            window.initMirrarUI(productDetails.sku, {
                brandId: "e517b5d3-15f1-4d2c-87a7-ecb16d0d151f"
            });
        }
    };
    // Fetch full product details when selectedProduct changes
    (0,react.useEffect)(function() {
        if ((selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.slug) && isOpen) {
            dispatch((0,shapeOfYou/* fetchProductForShapeOfYou */.sz)(selectedProduct.slug)).unwrap().then(function(data) {
                setProductDetails(data);
            }).catch(function(error) {
                ;
            });
        }
    }, [
        selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.slug,
        isOpen,
        dispatch
    ]);
    // Get the product price info
    var productPrice = (productDetails === null || productDetails === void 0 ? void 0 : (ref = productDetails.prices) === null || ref === void 0 ? void 0 : ref[0]) || shapeOfYouState.selectedPrice;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (shap_of_you_module_default()).modal_pro_desktop_product,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((shap_of_you_module_default()).overlay_desktop, " ").concat(isOpen ? (shap_of_you_module_default()).show : ""),
                onClick: function() {
                    return setIsOpen(false);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: (shap_of_you_module_default()).closeBtn,
                        onClick: function() {
                            return setIsOpen(false);
                        },
                        children: "✕"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((shap_of_you_module_default()).modal, " ").concat(isOpen ? (shap_of_you_module_default()).open : ""),
                        onClick: function(e) {
                            return e.stopPropagation();
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (shap_of_you_module_default()).contentn,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (shap_of_you_module_default()).product_details_container,
                                children: selectedProduct ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "row",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "col-md-6 col-xxl-7",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (shap_of_you_module_default()).product_details_image,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (shap_of_you_module_default()).imageWrapper_n,
                                                        style: {
                                                            position: "relative"
                                                        },
                                                        children: (productDetails === null || productDetails === void 0 ? void 0 : productDetails.medias) && productDetails.medias.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                                                                    modules: [
                                                                        swiper_esm/* Navigation */.W_,
                                                                        swiper_esm/* Thumbs */.o3,
                                                                        swiper_esm/* FreeMode */.Rv
                                                                    ],
                                                                    navigation: true,
                                                                    onSwiper: setMainSwiper,
                                                                    thumbs: {
                                                                        swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null
                                                                    },
                                                                    onSlideChange: function(swiper) {
                                                                        return setActiveSlide(swiper.activeIndex);
                                                                    },
                                                                    className: "product-details-main-swiper",
                                                                    style: {
                                                                        width: "100%",
                                                                        height: "500px",
                                                                        marginBottom: "16px"
                                                                    },
                                                                    children: productDetails.medias.map(function(media, index) {
                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                style: {
                                                                                    width: "100%",
                                                                                    height: "100%",
                                                                                    display: "flex",
                                                                                    alignItems: "center",
                                                                                    justifyContent: "center"
                                                                                },
                                                                                children: media.media_type === "image" ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                                    src: media.media_url,
                                                                                    alt: "".concat(selectedProduct.title || "Product", " - ").concat(index + 1),
                                                                                    width: 500,
                                                                                    height: 500,
                                                                                    style: {
                                                                                        maxWidth: "100%",
                                                                                        maxHeight: "100%",
                                                                                        objectFit: "cover"
                                                                                    },
                                                                                    unoptimized: true,
                                                                                    onError: function(e) {
                                                                                        var target = e.target;
                                                                                        target.src = jel/* default.src */.Z.src;
                                                                                    }
                                                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                                                                                    src: media.media_url,
                                                                                    controls: true,
                                                                                    autoPlay: true,
                                                                                    muted: true,
                                                                                    loop: true,
                                                                                    style: {
                                                                                        maxWidth: "100%",
                                                                                        maxHeight: "100%",
                                                                                        objectFit: "cover"
                                                                                    }
                                                                                })
                                                                            })
                                                                        }, index);
                                                                    })
                                                                }),
                                                                productDetails.medias.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                                                                    modules: [
                                                                        swiper_esm/* Navigation */.W_,
                                                                        swiper_esm/* Thumbs */.o3,
                                                                        swiper_esm/* FreeMode */.Rv
                                                                    ],
                                                                    onSwiper: setThumbsSwiper,
                                                                    slidesPerView: 4,
                                                                    spaceBetween: 10,
                                                                    freeMode: true,
                                                                    watchSlidesProgress: true,
                                                                    className: "product-details-thumbs-swiper",
                                                                    style: {
                                                                        width: "100%",
                                                                        height: "100px"
                                                                    },
                                                                    children: productDetails.medias.map(function(media, index) {
                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                                                            onClick: function() {
                                                                                if (mainSwiper && !mainSwiper.destroyed) {
                                                                                    mainSwiper.slideTo(index);
                                                                                    setActiveSlide(index);
                                                                                }
                                                                            },
                                                                            style: {
                                                                                cursor: "pointer",
                                                                                border: activeSlide === index ? "1px solid #c91723" : "1px solid transparent",
                                                                                borderRadius: "0px",
                                                                                overflow: "hidden"
                                                                            },
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                style: {
                                                                                    width: "100%",
                                                                                    height: "100%",
                                                                                    display: "flex",
                                                                                    alignItems: "center",
                                                                                    justifyContent: "center",
                                                                                    pointerEvents: "none"
                                                                                },
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                                    src: media.media_type === "video" ? media.preview || media.media_url : media.media_url,
                                                                                    alt: "Thumbnail ".concat(index + 1),
                                                                                    width: 100,
                                                                                    height: 100,
                                                                                    style: {
                                                                                        width: "100%",
                                                                                        height: "100%",
                                                                                        objectFit: "cover",
                                                                                        cursor: "pointer",
                                                                                        pointerEvents: "none"
                                                                                    },
                                                                                    unoptimized: true
                                                                                })
                                                                            })
                                                                        }, index);
                                                                    })
                                                                })
                                                            ]
                                                        }) : // Fallback to single image if no medias available
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            src: getImageSrc(selectedProduct),
                                                            alt: selectedProduct.title || "Product",
                                                            width: 400,
                                                            height: 400,
                                                            onError: function(e) {
                                                                var target = e.target;
                                                                target.src = jel/* default.src */.Z.src;
                                                            }
                                                        })
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "col-md-6 col-xxl-5",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "jsx-eda6f64fc664f0bd" + " " + ((shap_of_you_module_default()).product_content || ""),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            style: {
                                                                display: "flex",
                                                                alignItems: "center",
                                                                gap: "0px",
                                                                marginBottom: "2px",
                                                                fontSize: "17px",
                                                                fontWeight: "800",
                                                                fontFamily: "newyork",
                                                                letterSpacing: "1px",
                                                                color: "#ff1933",
                                                                animation: "madeInIndiaColor 4s ease-in-out infinite"
                                                            },
                                                            className: "jsx-eda6f64fc664f0bd",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "jsx-eda6f64fc664f0bd",
                                                                    children: "MADE IN INDIA"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    src: made_in_india["default"],
                                                                    alt: "Made in India",
                                                                    width: 24,
                                                                    height: 16,
                                                                    style: {
                                                                        objectFit: "contain"
                                                                    }
                                                                })
                                                            ]
                                                        }),
                                                        (0,jsx_runtime.jsx)((style_default()), {
                                                            id: "eda6f64fc664f0bd",
                                                            children: "@-webkit-keyframes madeInIndiaColor{0%{color:#ff1933}20%{color:#ea00b8}40%{color:#ff1933}60%{color:#ea00b8}80%{color:#ff1933}100%{color:#ea00b8}}@-moz-keyframes madeInIndiaColor{0%{color:#ff1933}20%{color:#ea00b8}40%{color:#ff1933}60%{color:#ea00b8}80%{color:#ff1933}100%{color:#ea00b8}}@-o-keyframes madeInIndiaColor{0%{color:#ff1933}20%{color:#ea00b8}40%{color:#ff1933}60%{color:#ea00b8}80%{color:#ff1933}100%{color:#ea00b8}}@keyframes madeInIndiaColor{0%{color:#ff1933}20%{color:#ea00b8}40%{color:#ff1933}60%{color:#ea00b8}80%{color:#ff1933}100%{color:#ea00b8}}"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                            style: {
                                                                marginBottom: "2px"
                                                            },
                                                            className: "jsx-eda6f64fc664f0bd" + " " + ((shap_of_you_module_default()).title || ""),
                                                            children: selectedProduct.title || selectedProduct.slug || "Product Details"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            style: {
                                                                fontSize: "14px",
                                                                color: "#666",
                                                                marginBottom: "16px"
                                                            },
                                                            className: "jsx-eda6f64fc664f0bd",
                                                            children: [
                                                                "SKU:",
                                                                " ",
                                                                selectedProduct.sku || (productDetails === null || productDetails === void 0 ? void 0 : productDetails.sku) || "N/A"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "jsx-eda6f64fc664f0bd" + " " + "row",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "jsx-eda6f64fc664f0bd" + " " + "col-md-12",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "jsx-eda6f64fc664f0bd" + " " + "d-flex align-items-center gap-2 flex-wrap",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                                                                style: {
                                                                                    color: "#ff1933"
                                                                                },
                                                                                className: "jsx-eda6f64fc664f0bd" + " " + ((shap_of_you_module_default()).price || ""),
                                                                                children: [
                                                                                    "₹",
                                                                                    " ",
                                                                                    (productPrice === null || productPrice === void 0 ? void 0 : (ref1 = productPrice.discount) === null || ref1 === void 0 ? void 0 : ref1.total) || selectedProduct.price ? ((productPrice === null || productPrice === void 0 ? void 0 : (ref2 = productPrice.discount) === null || ref2 === void 0 ? void 0 : ref2.total) || selectedProduct.price).toLocaleString("en-IN") : "0"
                                                                                ]
                                                                            }),
                                                                            (productPrice === null || productPrice === void 0 ? void 0 : (ref3 = productPrice.discount) === null || ref3 === void 0 ? void 0 : ref3.total) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                style: {
                                                                                    textDecoration: "line-through",
                                                                                    color: "#999",
                                                                                    fontSize: "16px",
                                                                                    fontWeight: 400
                                                                                },
                                                                                className: "jsx-eda6f64fc664f0bd",
                                                                                children: [
                                                                                    "₹",
                                                                                    " ",
                                                                                    (ref4 = (productPrice === null || productPrice === void 0 ? void 0 : productPrice.total) || selectedProduct.price) === null || ref4 === void 0 ? void 0 : ref4.toLocaleString("en-IN")
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "jsx-eda6f64fc664f0bd" + " " + ((shap_of_you_module_default()).mrp_text || ""),
                                                                        children: "(MRP Inclusive of all taxes)"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        ((productPrice === null || productPrice === void 0 ? void 0 : productPrice.purity) || (productPrice === null || productPrice === void 0 ? void 0 : productPrice.metal_weight) || (productPrice === null || productPrice === void 0 ? void 0 : productPrice.gold_weight)) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            style: {
                                                                display: "grid",
                                                                gridTemplateColumns: "1fr 1fr",
                                                                border: "1px solid #ea00b8",
                                                                borderRadius: "8px",
                                                                marginTop: "16px",
                                                                marginBottom: "16px",
                                                                fontFamily: "Lato, sans-serif"
                                                            },
                                                            className: "jsx-eda6f64fc664f0bd",
                                                            children: [
                                                                (productPrice === null || productPrice === void 0 ? void 0 : productPrice.purity) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    style: {
                                                                        gap: "16px",
                                                                        padding: "10px",
                                                                        borderRight: "1px solid #ea00b8"
                                                                    },
                                                                    className: "jsx-eda6f64fc664f0bd",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            style: {
                                                                                fontSize: "14px",
                                                                                color: "#666",
                                                                                marginBottom: "4px"
                                                                            },
                                                                            className: "jsx-eda6f64fc664f0bd",
                                                                            children: "Metal"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            style: {
                                                                                fontSize: "14px",
                                                                                fontWeight: "600",
                                                                                color: "#262121"
                                                                            },
                                                                            className: "jsx-eda6f64fc664f0bd",
                                                                            children: productPrice.purity
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    style: {
                                                                        gap: "16px",
                                                                        padding: "10px"
                                                                    },
                                                                    className: "jsx-eda6f64fc664f0bd",
                                                                    children: ((productPrice === null || productPrice === void 0 ? void 0 : productPrice.metal_weight) || (productPrice === null || productPrice === void 0 ? void 0 : productPrice.gold_weight)) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        style: {
                                                                            gap: "16px",
                                                                            padding: "10px"
                                                                        },
                                                                        className: "jsx-eda6f64fc664f0bd",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                style: {
                                                                                    fontSize: "14px",
                                                                                    color: "#666",
                                                                                    marginBottom: "4px"
                                                                                },
                                                                                className: "jsx-eda6f64fc664f0bd",
                                                                                children: "Metal Weight"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                style: {
                                                                                    fontSize: "14px",
                                                                                    fontWeight: "600",
                                                                                    color: "#262121"
                                                                                },
                                                                                className: "jsx-eda6f64fc664f0bd",
                                                                                children: [
                                                                                    productPrice.metal_weight || productPrice.gold_weight,
                                                                                    " ",
                                                                                    productPrice.metal_weight || productPrice.gold_weight ? "g" : ""
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "jsx-eda6f64fc664f0bd" + " " + ((shap_of_you_module_default()).product_filters || ""),
                                                            children: (selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.purities) && selectedProduct.purities.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "jsx-eda6f64fc664f0bd" + " " + ((shap_of_you_module_default()).filter_section || ""),
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                        className: "jsx-eda6f64fc664f0bd",
                                                                        children: "Purity:"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "jsx-eda6f64fc664f0bd" + " " + ((shap_of_you_module_default()).filter_options || ""),
                                                                        children: selectedProduct.purities.map(function(purity) {
                                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                className: "jsx-eda6f64fc664f0bd" + " " + ((shap_of_you_module_default()).filter_badge || ""),
                                                                                children: purity
                                                                            }, purity);
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "jsx-eda6f64fc664f0bd" + " " + ((shap_of_you_module_default()).product_tabs || ""),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "jsx-eda6f64fc664f0bd" + " " + ((shap_of_you_module_default()).tabs || ""),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            onClick: function() {
                                                                                return setActiveTab("description");
                                                                            },
                                                                            className: "jsx-eda6f64fc664f0bd" + " " + "".concat((shap_of_you_module_default()).tab, " ").concat(activeTab === "description" ? (shap_of_you_module_default()).active : ""),
                                                                            children: "Description"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            onClick: function() {
                                                                                return setActiveTab("details");
                                                                            },
                                                                            className: "jsx-eda6f64fc664f0bd" + " " + "".concat((shap_of_you_module_default()).tab, " ").concat(activeTab === "details" ? (shap_of_you_module_default()).active : ""),
                                                                            children: "Details"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            onClick: function() {
                                                                                return setActiveTab("price");
                                                                            },
                                                                            className: "jsx-eda6f64fc664f0bd" + " " + "".concat((shap_of_you_module_default()).tab, " ").concat(activeTab === "price" ? (shap_of_you_module_default()).active : ""),
                                                                            children: "Price Break-up"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "jsx-eda6f64fc664f0bd" + " " + ((shap_of_you_module_default()).tab_content || ""),
                                                                    children: [
                                                                        activeTab === "description" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "jsx-eda6f64fc664f0bd" + " " + ((shap_of_you_module_default()).description || ""),
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                    className: "jsx-eda6f64fc664f0bd",
                                                                                    children: (selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.title) || "Unveil your inner radiance with this beautiful jewellery piece. A perfect blend of elegance and craftsmanship."
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: "jsx-eda6f64fc664f0bd" + " " + ((shap_of_you_module_default()).product_badges || ""),
                                                                                    children: [
                                                                                        !!(selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.fastDelivery) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            className: "jsx-eda6f64fc664f0bd" + " " + ((shap_of_you_module_default()).badge_green || ""),
                                                                                            children: "Fast Delivery"
                                                                                        }),
                                                                                        !!(selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.trending) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            className: "jsx-eda6f64fc664f0bd" + " " + ((shap_of_you_module_default()).badge_yellow || ""),
                                                                                            children: "Trending"
                                                                                        }),
                                                                                        !!(selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.new_arrival) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            className: "jsx-eda6f64fc664f0bd" + " " + ((shap_of_you_module_default()).badge_purple || ""),
                                                                                            children: "New Arrival"
                                                                                        }),
                                                                                        !!(selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.best_seller) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            className: "jsx-eda6f64fc664f0bd" + " " + ((shap_of_you_module_default()).badge_blue || ""),
                                                                                            children: "Best Seller"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                                    className: "jsx-eda6f64fc664f0bd" + " " + ((shap_of_you_module_default()).disclaimer || ""),
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                                            className: "jsx-eda6f64fc664f0bd",
                                                                                            children: "Disclaimer:"
                                                                                        }),
                                                                                        " The dimension of the actual product might vary. Due to differences in photographic lighting, the colour may slightly differ."
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        activeTab === "details" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "jsx-eda6f64fc664f0bd" + " " + ((shap_of_you_module_default()).description || ""),
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                                    className: "jsx-eda6f64fc664f0bd" + " " + ((shap_of_you_module_default()).details_product || ""),
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                                            className: "jsx-eda6f64fc664f0bd",
                                                                                            children: "Design Code: "
                                                                                        }),
                                                                                        (selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.sku) || "N/A"
                                                                                    ]
                                                                                }),
                                                                                (selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.categories) && selectedProduct.categories.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                                    className: "jsx-eda6f64fc664f0bd" + " " + ((shap_of_you_module_default()).details_product || ""),
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                                            className: "jsx-eda6f64fc664f0bd",
                                                                                            children: "Category: "
                                                                                        }),
                                                                                        selectedProduct.categories.map(function(cat) {
                                                                                            return cat.name;
                                                                                        }).join(", ")
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        activeTab === "price" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "jsx-eda6f64fc664f0bd" + " " + ((shap_of_you_module_default()).description || ""),
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                                    className: "jsx-eda6f64fc664f0bd" + " " + ((shap_of_you_module_default()).price_brackup || ""),
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                                            className: "jsx-eda6f64fc664f0bd",
                                                                                            children: "Price: "
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                            style: {
                                                                                                color: "#ff1933"
                                                                                            },
                                                                                            className: "jsx-eda6f64fc664f0bd",
                                                                                            children: [
                                                                                                "₹",
                                                                                                (productPrice === null || productPrice === void 0 ? void 0 : (ref5 = productPrice.discount) === null || ref5 === void 0 ? void 0 : ref5.total) || (selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.price) ? ((productPrice === null || productPrice === void 0 ? void 0 : (ref6 = productPrice.discount) === null || ref6 === void 0 ? void 0 : ref6.total) || (selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.price)).toLocaleString("en-IN") : "0"
                                                                                            ]
                                                                                        }),
                                                                                        (productPrice === null || productPrice === void 0 ? void 0 : (ref7 = productPrice.discount) === null || ref7 === void 0 ? void 0 : ref7.total) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                            style: {
                                                                                                textDecoration: "line-through",
                                                                                                color: "#999",
                                                                                                marginLeft: "8px",
                                                                                                fontSize: "14px"
                                                                                            },
                                                                                            className: "jsx-eda6f64fc664f0bd",
                                                                                            children: [
                                                                                                "₹",
                                                                                                (ref8 = (productPrice === null || productPrice === void 0 ? void 0 : productPrice.total) || (selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.price)) === null || ref8 === void 0 ? void 0 : ref8.toLocaleString("en-IN")
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                (productPrice === null || productPrice === void 0 ? void 0 : (ref9 = productPrice.discount) === null || ref9 === void 0 ? void 0 : ref9.total) && (productPrice === null || productPrice === void 0 ? void 0 : productPrice.total) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                                    className: "jsx-eda6f64fc664f0bd" + " " + ((shap_of_you_module_default()).price_brackup || ""),
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                                            className: "jsx-eda6f64fc664f0bd",
                                                                                            children: "You Save: "
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                            style: {
                                                                                                color: "#28a745",
                                                                                                fontWeight: 600
                                                                                            },
                                                                                            className: "jsx-eda6f64fc664f0bd",
                                                                                            children: [
                                                                                                "₹",
                                                                                                (productPrice.total - productPrice.discount.total).toLocaleString("en-IN")
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                typeof (selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.stock) !== "undefined" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                                    className: "jsx-eda6f64fc664f0bd" + " " + ((shap_of_you_module_default()).price_brackup || ""),
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                                            className: "jsx-eda6f64fc664f0bd",
                                                                                            children: "Stock Status: "
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            style: {
                                                                                                color: selectedProduct.stock > 0 ? "#28a745" : "#dc3545"
                                                                                            },
                                                                                            className: "jsx-eda6f64fc664f0bd",
                                                                                            children: selectedProduct.stock > 0 ? "In Stock" : "Made To Order"
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            style: {
                                                                marginTop: "24px",
                                                                marginBottom: "24px"
                                                            },
                                                            className: "jsx-eda6f64fc664f0bd",
                                                            children: showAddedSuccess ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                                disabled: true,
                                                                style: {
                                                                    width: "260px",
                                                                    padding: "10px 24px",
                                                                    backgroundColor: "#28a745",
                                                                    color: "white",
                                                                    border: "none",
                                                                    borderRadius: "30px",
                                                                    fontSize: "16px",
                                                                    fontWeight: "600",
                                                                    cursor: "not-allowed",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    gap: "8px",
                                                                    textTransform: "uppercase",
                                                                    letterSpacing: "0.5px",
                                                                    float: "right"
                                                                },
                                                                className: "jsx-eda6f64fc664f0bd",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                                        width: "20",
                                                                        height: "20",
                                                                        viewBox: "0 0 24 24",
                                                                        fill: "none",
                                                                        className: "jsx-eda6f64fc664f0bd",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                            d: "M20 6L9 17L4 12",
                                                                            stroke: "white",
                                                                            strokeWidth: "2",
                                                                            strokeLinecap: "round",
                                                                            strokeLinejoin: "round",
                                                                            className: "jsx-eda6f64fc664f0bd"
                                                                        })
                                                                    }),
                                                                    "Added Successfully"
                                                                ]
                                                            }) : cartItem ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                disabled: true,
                                                                style: {
                                                                    width: "260px",
                                                                    padding: "10px 24px",
                                                                    backgroundColor: "#22c55e",
                                                                    color: "white",
                                                                    border: "none",
                                                                    borderRadius: "30px",
                                                                    fontSize: "16px",
                                                                    fontWeight: "600",
                                                                    cursor: "default",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    gap: "8px",
                                                                    textTransform: "uppercase",
                                                                    letterSpacing: "0.5px",
                                                                    transition: "background-color 0.3s ease",
                                                                    float: "right"
                                                                },
                                                                className: "jsx-eda6f64fc664f0bd",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                    style: {
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        justifyContent: "center",
                                                                        gap: "8px"
                                                                    },
                                                                    className: "jsx-eda6f64fc664f0bd",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                                            width: "24",
                                                                            height: "24",
                                                                            viewBox: "0 0 24 24",
                                                                            fill: "none",
                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                            className: "jsx-eda6f64fc664f0bd",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                                d: "M20 6L9 17L4 12",
                                                                                stroke: "white",
                                                                                strokeWidth: "2",
                                                                                strokeLinecap: "round",
                                                                                strokeLinejoin: "round",
                                                                                className: "jsx-eda6f64fc664f0bd"
                                                                            })
                                                                        }),
                                                                        "Added To Cart"
                                                                    ]
                                                                })
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                onClick: function() {
                                                                    return addToCart(false);
                                                                },
                                                                disabled: cartActionLoading || !selectedProduct,
                                                                style: {
                                                                    width: "260px",
                                                                    padding: "10px 24px",
                                                                    backgroundColor: cartActionLoading || !selectedProduct ? "#999" : "#c91723",
                                                                    color: "white",
                                                                    border: "none",
                                                                    borderRadius: "30px",
                                                                    fontSize: "16px",
                                                                    fontWeight: "600",
                                                                    cursor: cartActionLoading || !selectedProduct ? "not-allowed" : "pointer",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    gap: "8px",
                                                                    textTransform: "uppercase",
                                                                    letterSpacing: "0.5px",
                                                                    transition: "background-color 0.3s ease",
                                                                    float: "right"
                                                                },
                                                                onMouseEnter: function(e) {
                                                                    if (!cartActionLoading && selectedProduct) {
                                                                        e.currentTarget.style.backgroundColor = "#a01219";
                                                                    }
                                                                },
                                                                onMouseLeave: function(e) {
                                                                    if (!cartActionLoading && selectedProduct) {
                                                                        e.currentTarget.style.backgroundColor = "#c91723";
                                                                    }
                                                                },
                                                                className: "jsx-eda6f64fc664f0bd",
                                                                children: cartActionLoading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                                                                            animation: "border",
                                                                            size: "sm"
                                                                        }),
                                                                        "Adding..."
                                                                    ]
                                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                                            width: "20",
                                                                            height: "20",
                                                                            viewBox: "0 0 24 24",
                                                                            fill: "none",
                                                                            className: "jsx-eda6f64fc664f0bd",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                                    d: "M4 19C4 19.5304 4.21071 20.0391 4.58579 20.4142C4.96086 20.7893 5.46957 21 6 21C6.53043 21 7.03914 20.7893 7.41421 20.4142C7.78929 20.0391 8 19.5304 8 19C8 18.4696 7.78929 17.9609 7.41421 17.5858C7.03914 17.2107 6.53043 17 6 17C5.46957 17 4.96086 17.2107 4.58579 17.5858C4.21071 17.9609 4 18.4696 4 19Z",
                                                                                    stroke: "white",
                                                                                    strokeWidth: "2",
                                                                                    strokeLinecap: "round",
                                                                                    strokeLinejoin: "round",
                                                                                    className: "jsx-eda6f64fc664f0bd"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                                    d: "M12.5 17H6V3H4",
                                                                                    stroke: "white",
                                                                                    strokeWidth: "2",
                                                                                    strokeLinecap: "round",
                                                                                    strokeLinejoin: "round",
                                                                                    className: "jsx-eda6f64fc664f0bd"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                                    d: "M6 5L20 6L19.14 12.017M16.5 13H6",
                                                                                    stroke: "white",
                                                                                    strokeWidth: "2",
                                                                                    strokeLinecap: "round",
                                                                                    strokeLinejoin: "round",
                                                                                    className: "jsx-eda6f64fc664f0bd"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                                    d: "M16 19H22",
                                                                                    stroke: "white",
                                                                                    strokeWidth: "2",
                                                                                    strokeLinecap: "round",
                                                                                    strokeLinejoin: "round",
                                                                                    className: "jsx-eda6f64fc664f0bd"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                                    d: "M19 16V22",
                                                                                    stroke: "white",
                                                                                    strokeWidth: "2",
                                                                                    strokeLinecap: "round",
                                                                                    strokeLinejoin: "round",
                                                                                    className: "jsx-eda6f64fc664f0bd"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        "Add to Cart"
                                                                    ]
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "jsx-eda6f64fc664f0bd" + " " + ((shap_of_you_module_default()).product_certificate_mobile || ""),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "jsx-eda6f64fc664f0bd" + " " + ((shap_of_you_module_default()).certificate_badges || ""),
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "jsx-eda6f64fc664f0bd",
                                                                        children: "100% CERTIFIED"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "jsx-eda6f64fc664f0bd",
                                                                        children: "LIFETIME EXCHANGE @STORE"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        padding: "20px",
                                        textAlign: "center"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "No product selected"
                                    })
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                show: showCertificate,
                onHide: function() {
                    return setShowCertificate(false);
                },
                centered: true,
                size: "lg",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Body */.Z.Body, {
                    style: {
                        padding: 0
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: __webpack_require__(52266),
                        alt: "Sample Certificate",
                        priority: true,
                        style: {
                            width: "100%",
                            height: "auto"
                        }
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var shape_of_you_desktop_new_ProductDetailsModal = (ProductDetailsModal);

;// CONCATENATED MODULE: ./src/components/shape-of-you-desktop-new/FilterModal.tsx







var FilterModal = function(param) {
    var isOpen = param.isOpen, setIsOpen = param.setIsOpen, filter = param.filter, setFilter = param.setFilter, activeCategory = param.activeCategory;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var categoryState = (0,es/* useSelector */.v9)(function(state) {
        return state.category;
    });
    var ref8 = (0,react.useState)("Price"), selectedFilterTab = ref8[0], setSelectedFilterTab = ref8[1];
    var ref9 = (0,react.useState)({
        metal: [],
        occasions: [],
        priceRange: null,
        priceMin: null,
        priceMax: null
    }), filterSheet = ref9[0], setFilterSheet = ref9[1];
    // Price options for filter
    var priceOptions = [
        {
            label: "Below ₹ 10,000",
            min: null,
            max: 10000
        },
        {
            label: "₹ 10,000 – ₹ 20,000",
            min: 10000,
            max: 20000
        },
        {
            label: "₹ 30,000 – ₹ 40,000",
            min: 30000,
            max: 40000
        },
        {
            label: "₹ 40,000 – ₹ 50,000",
            min: 40000,
            max: 50000
        },
        {
            label: "₹ 50,000 – ₹ 1,00,000",
            min: 50000,
            max: 100000
        }, 
    ];
    // Sync filterSheet with filter when modal opens
    (0,react.useEffect)(function() {
        if (isOpen) {
            setFilterSheet({
                metal: filter.metal || [],
                occasions: filter.occasions || [],
                priceRange: filter.priceRange || null,
                priceMin: filter.priceMin || null,
                priceMax: filter.priceMax || null
            });
        }
    }, [
        isOpen,
        filter
    ]);
    // Handle filter changes
    var handleSheetFilterChange = function(filterType, value) {
        setFilterSheet(function(prev) {
            if (filterType === "price") {
                var _Math, _Math1;
                var label = value.label;
                var currentSelected = prev.priceRange ? prev.priceRange.split("|") : [];
                var newSelected = currentSelected.includes(label) ? currentSelected.filter(function(r) {
                    return r !== label;
                }) : (0,_to_consumable_array/* default */.Z)(currentSelected).concat([
                    label
                ]);
                // Compute merged min/max from all selected ranges
                var selectedOptions = priceOptions.filter(function(opt) {
                    return newSelected.includes(opt.label);
                });
                var hasNullMin = selectedOptions.some(function(opt) {
                    return opt.min === null;
                });
                var mins = selectedOptions.map(function(opt) {
                    return opt.min;
                }).filter(function(m) {
                    return m !== null;
                });
                var maxes = selectedOptions.map(function(opt) {
                    return opt.max;
                });
                var priceMin = selectedOptions.length === 0 ? null : hasNullMin ? null : mins.length > 0 ? (_Math = Math).min.apply(_Math, (0,_to_consumable_array/* default */.Z)(mins)) : null;
                var priceMax = maxes.length > 0 ? (_Math1 = Math).max.apply(_Math1, (0,_to_consumable_array/* default */.Z)(maxes)) : null;
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                    priceRange: newSelected.length > 0 ? newSelected.join("|") : null,
                    priceMin: priceMin,
                    priceMax: priceMax
                });
            } else if (filterType === "metal") {
                var metals = (prev === null || prev === void 0 ? void 0 : prev.metal) || [];
                if (metals.includes(value)) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                        metal: metals.filter(function(m) {
                            return m !== value;
                        })
                    });
                } else {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                        metal: (0,_to_consumable_array/* default */.Z)(metals).concat([
                            value
                        ])
                    });
                }
            } else if (filterType === "occasion") {
                var occasions = (prev === null || prev === void 0 ? void 0 : prev.occasions) || [];
                if (occasions.includes(value)) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                        occasions: occasions.filter(function(m) {
                            return m !== value;
                        })
                    });
                } else {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                        occasions: (0,_to_consumable_array/* default */.Z)(occasions).concat([
                            value
                        ])
                    });
                }
            }
            return prev;
        });
    };
    // Apply filters and close modal
    var handleApplyFilter = function() {
        setFilter(filterSheet);
        setIsOpen(false);
    };
    // Clear all filters
    var handleClearFilters = function() {
        var clearedSheet = {
            metal: [],
            occasions: [],
            priceRange: null,
            priceMin: null,
            priceMax: null
        };
        setFilterSheet(clearedSheet);
    };
    // CheckIcon component
    var CheckIcon = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            width: "12",
            height: "12",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20 6L9 17L4 12",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (shap_of_you_module_default()).modal_pro_desktop_filter,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "".concat((shap_of_you_module_default()).overlay_desktop, " ").concat(isOpen ? (shap_of_you_module_default()).show : ""),
            onClick: function() {
                return setIsOpen(false);
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: (shap_of_you_module_default()).closeBtn,
                    onClick: function() {
                        return setIsOpen(false);
                    },
                    children: "✕"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((shap_of_you_module_default()).modal, " ").concat(isOpen ? (shap_of_you_module_default()).open : ""),
                    onClick: function(e) {
                        return e.stopPropagation();
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (shap_of_you_module_default()).contentn,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (shap_of_you_module_default()).filterWrapper,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "d-none d-md-block w-100",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (shap_of_you_module_default()).header,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                        style: {
                                                            margin: "0 10px"
                                                        },
                                                        width: "30",
                                                        height: "30",
                                                        viewBox: "0 0 36 36",
                                                        fill: "none",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M6 15C6 15.7956 6.31607 16.5587 6.87868 17.1213C7.44129 17.6839 8.20435 18 9 18C9.79565 18 10.5587 17.6839 11.1213 17.1213C11.6839 16.5587 12 15.7956 12 15C12 14.2044 11.6839 13.4413 11.1213 12.8787C10.5587 12.3161 9.79565 12 9 12C8.20435 12 7.44129 12.3161 6.87868 12.8787C6.31607 13.4413 6 14.2044 6 15Z",
                                                                stroke: "#262121",
                                                                strokeWidth: "3",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M9 6V12",
                                                                stroke: "#262121",
                                                                strokeWidth: "3",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M9 18V30",
                                                                stroke: "#262121",
                                                                strokeWidth: "3",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M15 24C15 24.7956 15.3161 25.5587 15.8787 26.1213C16.4413 26.6839 17.2044 27 18 27C18.7956 27 19.5587 26.6839 20.1213 26.1213C20.6839 25.5587 21 24.7956 21 24C21 23.2044 20.6839 22.4413 20.1213 21.8787C19.5587 21.3161 18.7956 21 18 21C17.2044 21 16.4413 21.3161 15.8787 21.8787C15.3161 22.4413 15 23.2044 15 24Z",
                                                                stroke: "#262121",
                                                                strokeWidth: "3",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M18 6V21",
                                                                stroke: "#262121",
                                                                strokeWidth: "3",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M18 27V30",
                                                                stroke: "#262121",
                                                                strokeWidth: "3",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M24 10.5C24 11.2956 24.3161 12.0587 24.8787 12.6213C25.4413 13.1839 26.2044 13.5 27 13.5C27.7956 13.5 28.5587 13.1839 29.1213 12.6213C29.6839 12.0587 30 11.2956 30 10.5C30 9.70435 29.6839 8.94129 29.1213 8.37868C28.5587 7.81607 27.7956 7.5 27 7.5C26.2044 7.5 25.4413 7.81607 24.8787 8.37868C24.3161 8.94129 24 9.70435 24 10.5Z",
                                                                stroke: "#262121",
                                                                strokeWidth: "3",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M27 6V7.5",
                                                                stroke: "#262121",
                                                                strokeWidth: "3",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M27 13.5V30",
                                                                stroke: "#262121",
                                                                strokeWidth: "3",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round"
                                                            })
                                                        ]
                                                    }),
                                                    "Filter By"
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (shap_of_you_module_default()).tabs,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    className: "".concat((shap_of_you_module_default()).tab, " ").concat(selectedFilterTab === "Price" ? (shap_of_you_module_default()).active : ""),
                                                    onClick: function() {
                                                        return setSelectedFilterTab("Price");
                                                    },
                                                    children: "Price"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    className: "".concat((shap_of_you_module_default()).tab, " ").concat(selectedFilterTab === "Purity" ? (shap_of_you_module_default()).active : ""),
                                                    onClick: function() {
                                                        return setSelectedFilterTab("Purity");
                                                    },
                                                    children: "Purity"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    className: "".concat((shap_of_you_module_default()).tab, " ").concat(selectedFilterTab === "Occassion" ? (shap_of_you_module_default()).active : ""),
                                                    onClick: function() {
                                                        return setSelectedFilterTab("Occassion");
                                                    },
                                                    children: "Occassion"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (shap_of_you_module_default()).content,
                                            children: [
                                                selectedFilterTab === "Price" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (shap_of_you_module_default()).options,
                                                    children: priceOptions.map(function(option) {
                                                        var selectedRanges = (filterSheet === null || filterSheet === void 0 ? void 0 : filterSheet.priceRange) ? filterSheet.priceRange.split("|") : [];
                                                        var isChecked = selectedRanges.includes(option.label);
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                            className: (shap_of_you_module_default()).optionItem,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    style: {
                                                                        fontFamily: isChecked ? "Sweet Sans Pro Medium" : "Sweet Sans Pro Regular"
                                                                    },
                                                                    children: option.label
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                    type: "checkbox",
                                                                    name: "price",
                                                                    checked: isChecked,
                                                                    onChange: function() {
                                                                        return handleSheetFilterChange("price", option);
                                                                    },
                                                                    style: {
                                                                        display: "none"
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: (shap_of_you_module_default()).checkbox,
                                                                    style: {
                                                                        borderRadius: "50%",
                                                                        border: "1px solid #ccc",
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        justifyContent: "center",
                                                                        width: "16px",
                                                                        height: "16px"
                                                                    },
                                                                    children: isChecked && /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckIcon, {})
                                                                })
                                                            ]
                                                        }, option.label);
                                                    })
                                                }),
                                                selectedFilterTab === "Purity" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (shap_of_you_module_default()).options,
                                                    children: [
                                                        (ref = categoryState.similarFilters) === null || ref === void 0 ? void 0 : (ref1 = ref.purities) === null || ref1 === void 0 ? void 0 : ref1.map(function(purity, index) {
                                                            var ref;
                                                            var isChecked = (filterSheet === null || filterSheet === void 0 ? void 0 : (ref = filterSheet.metal) === null || ref === void 0 ? void 0 : ref.includes(purity)) || false;
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                className: (shap_of_you_module_default()).optionItem,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        style: {
                                                                            fontFamily: isChecked ? "Sweet Sans Pro Medium" : "Sweet Sans Pro Regular"
                                                                        },
                                                                        children: purity
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                        type: "checkbox",
                                                                        name: "purity",
                                                                        checked: isChecked,
                                                                        onChange: function() {
                                                                            return handleSheetFilterChange("metal", purity);
                                                                        },
                                                                        style: {
                                                                            display: "none"
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: (shap_of_you_module_default()).checkbox,
                                                                        style: {
                                                                            borderRadius: "50%",
                                                                            border: "1px solid #ccc",
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            justifyContent: "center",
                                                                            width: "16px",
                                                                            height: "16px"
                                                                        },
                                                                        children: isChecked && /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckIcon, {})
                                                                    })
                                                                ]
                                                            }, index);
                                                        }),
                                                        (!((ref2 = categoryState.similarFilters) === null || ref2 === void 0 ? void 0 : ref2.purities) || ((ref3 = categoryState.similarFilters) === null || ref3 === void 0 ? void 0 : ref3.purities.length) === 0) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (shap_of_you_module_default()).placeholder,
                                                            children: [
                                                                "No purity options available for ",
                                                                activeCategory
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                selectedFilterTab === "Occassion" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (shap_of_you_module_default()).options,
                                                    children: [
                                                        (ref4 = categoryState.similarFilters) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.occasions) === null || ref5 === void 0 ? void 0 : ref5.map(function(occasion, index) {
                                                            var ref;
                                                            var isChecked = (filterSheet === null || filterSheet === void 0 ? void 0 : (ref = filterSheet.occasions) === null || ref === void 0 ? void 0 : ref.includes(occasion.name)) || false;
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                className: (shap_of_you_module_default()).optionItem,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        style: {
                                                                            fontFamily: isChecked ? "Sweet Sans Pro Medium" : "Sweet Sans Pro Regular"
                                                                        },
                                                                        children: occasion.name
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                        type: "checkbox",
                                                                        name: "occasion",
                                                                        checked: isChecked,
                                                                        onChange: function() {
                                                                            return handleSheetFilterChange("occasion", occasion.name);
                                                                        },
                                                                        style: {
                                                                            display: "none"
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: (shap_of_you_module_default()).checkbox,
                                                                        style: {
                                                                            borderRadius: "50%",
                                                                            border: "1px solid #ccc",
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            justifyContent: "center",
                                                                            width: "16px",
                                                                            height: "16px"
                                                                        },
                                                                        children: isChecked && /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckIcon, {})
                                                                    })
                                                                ]
                                                            }, index);
                                                        }),
                                                        (!((ref6 = categoryState.similarFilters) === null || ref6 === void 0 ? void 0 : ref6.occasions) || ((ref7 = categoryState.similarFilters) === null || ref7 === void 0 ? void 0 : ref7.occasions.length) === 0) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (shap_of_you_module_default()).placeholder,
                                                            children: [
                                                                "No occasion options available for ",
                                                                activeCategory
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (shap_of_you_module_default()).footer,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            className: (shap_of_you_module_default()).clearBtn,
                                            onClick: handleClearFilters,
                                            children: "Clear Selection"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                            className: (shap_of_you_module_default()).applyBtn,
                                            onClick: handleApplyFilter,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                    style: {
                                                        marginRight: "10px"
                                                    },
                                                    width: "17",
                                                    height: "13",
                                                    viewBox: "0 0 17 13",
                                                    fill: "none",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M16.2637 1.41406L6.36328 11.3135L0.707031 5.65625L1.41406 4.94922L6.36426 9.89941L15.5566 0.707031L16.2637 1.41406Z",
                                                        fill: "#262121",
                                                        stroke: "white"
                                                    })
                                                }),
                                                "Apply"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var shape_of_you_desktop_new_FilterModal = (FilterModal);

;// CONCATENATED MODULE: ./src/components/shape-of-you-desktop-new/CartModal.tsx



















var CartModal_CartModal = function(param) {
    var isOpen = param.isOpen, setIsOpen = param.setIsOpen;
    var router = (0,next_router.useRouter)();
    var dispatch = (0,store/* useAppDispatch */.T)();
    var cartState = (0,es/* useSelector */.v9)(cart/* selectCart */.KY);
    var wishlistState = (0,es/* useSelector */.v9)(wishlist/* selectWishlist */.jq);
    var authState = (0,es/* useSelector */.v9)(auth/* selectAuth */.Hz);
    var ref = (0,react.useState)(null), removingId = ref[0], setRemovingId = ref[1];
    var ref1 = (0,react.useState)(null), wishlistLoadingId = ref1[0], setWishlistLoadingId = ref1[1];
    var ref2 = (0,react.useState)(null), addOneMoreLoadingId = ref2[0], setAddOneMoreLoadingId = ref2[1];
    var handleContinueShopping = function() {
        setIsOpen(false);
    };
    var handleProceedToCheckout = function() {
        setIsOpen(false);
        router.push("/cart");
    };
    var handleRemove = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(item) {
            var ref, ref1, ref2;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setRemovingId(item.id);
                        _ctx.prev = 1;
                        ;
                        _ctx.next = 5;
                        return http_client/* default.delete */.Z["delete"](endpoints/* default.cart.remove */.Z.cart.remove(item.id));
                    case 5:
                        _ctx.next = 7;
                        return dispatch((0,cart/* fetchCartItems */.Vw)());
                    case 7:
                        react_toastify_esm/* toast.info */.Am.info("Item removed from cart");
                        (0,unbxd/* unbxdCusEngTrackEvent */.$z)("Remove from cart ", {
                            source: "web",
                            platform: "senco",
                            prid: (ref = item.data) === null || ref === void 0 ? void 0 : ref.product_id,
                            variant_id: item.identifier,
                            image: item.product_image || item.image,
                            prqt: 1,
                            product_name: ((ref1 = item.product) === null || ref1 === void 0 ? void 0 : ref1.title) || item.product_name || item.name,
                            category: ((ref2 = item.product) === null || ref2 === void 0 ? void 0 : ref2.category) || "",
                            brand: constants/* BRAND_NAME */.R,
                            amount: item.product_discounted_price || item.product_price || item.price,
                            product_url: "".concat(window.location.origin, "/jewellery/").concat(item.slug)
                        });
                        _ctx.next = 14;
                        break;
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](1);
                        react_toastify_esm/* toast.error */.Am.error("Failed to remove item");
                    case 14:
                        _ctx.prev = 14;
                        setRemovingId(null);
                        return _ctx.finish(14);
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    11,
                    14,
                    17
                ]
            ]);
        }));
        return function handleRemove(item) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleAddOneMore = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(item) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(addOneMoreLoadingId === item.id)) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        setAddOneMoreLoadingId(item.id);
                        _ctx.prev = 3;
                        ;
                        _ctx.next = 7;
                        return http_client/* default.post */.Z.post(endpoints/* default.cart.add */.Z.cart.add(), {
                            type: "product",
                            identifier: item.identifier
                        });
                    case 7:
                        _ctx.next = 9;
                        return dispatch((0,cart/* fetchCartItems */.Vw)());
                    case 9:
                        // toast("Another one added to the cart!", {
                        //   type: "info",
                        //   toastId: "cart-update-success",
                        // });
                        (0,fpixel/* fbqTrackEvent */.dK)("CustomizeProduct");
                        window.dataLayer.push({
                            ecommerce: null
                        });
                        window.dataLayer.push({
                            event: "add_to_cart",
                            ecommerce: {
                                currency: "INR",
                                value: item.product_discounted_price || item.product_price || item.price || 0,
                                items: [
                                    {
                                        item_id: ((ref = item.data) === null || ref === void 0 ? void 0 : ref.product_id) || ((ref1 = item.product) === null || ref1 === void 0 ? void 0 : ref1.sku) || item.sku || "",
                                        item_name: ((ref2 = item.product) === null || ref2 === void 0 ? void 0 : ref2.title) || item.product_name || item.name,
                                        item_brand: ga4/* GA4_ITEM_BRAND */.Ye,
                                        item_category: ((ref3 = item.product) === null || ref3 === void 0 ? void 0 : ref3.category) || "",
                                        item_variant: ((ref4 = item.data) === null || ref4 === void 0 ? void 0 : ref4.purity) || ((ref5 = item.product) === null || ref5 === void 0 ? void 0 : ref5.purity) || ((ref6 = item.product) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.purities) === null || ref7 === void 0 ? void 0 : ref7[0]) || item.identifier,
                                        price: item.product_discounted_price || item.product_price || item.price || 0,
                                        quantity: 1
                                    }, 
                                ]
                            }
                        });
                        (0,unbxd/* unbxdCusEngTrackEvent */.$z)("Add to cart ", {
                            source: "web",
                            platform: "senco",
                            prid: (ref8 = item.data) === null || ref8 === void 0 ? void 0 : ref8.product_id,
                            variant_id: item.identifier,
                            image_url: item.product_image || item.image,
                            prqt: 1,
                            product_name: ((ref9 = item.product) === null || ref9 === void 0 ? void 0 : ref9.title) || item.product_name || item.name,
                            category: ((ref10 = item.product) === null || ref10 === void 0 ? void 0 : ref10.category) || "",
                            brand: constants/* BRAND_NAME */.R,
                            amount: item.product_discounted_price || item.product_price || item.price,
                            product_url: "".concat(window.location.origin, "/jewellery/").concat(item.slug),
                            discounted_price: item.product_discounted_price || 0,
                            stock_availability: 1
                        });
                        _ctx.next = 19;
                        break;
                    case 15:
                        _ctx.prev = 15;
                        _ctx.t0 = _ctx["catch"](3);
                        ;
                        if (_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref11 = _ctx.t0.response) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.data) === null || ref12 === void 0 ? void 0 : ref12.message) {
                            (0,react_toastify_esm/* toast */.Am)(_ctx.t0.response.data.message, {
                                type: "error",
                                toastId: "add-one-more-error"
                            });
                        } else {
                        // toast("Something went wrong! Try again!", {
                        //   type: "error",
                        //   toastId: "add-one-more-error",
                        // });
                        }
                    case 19:
                        setAddOneMoreLoadingId(null);
                    case 20:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    3,
                    15
                ]
            ]);
        }));
        return function handleAddOneMore(item) {
            return _ref.apply(this, arguments);
        };
    }();
    var isInWishlist = function(item) {
        var ref;
        var productId = (ref = item.data) === null || ref === void 0 ? void 0 : ref.product_id;
        return wishlistState.items.some(function(v) {
            return v.id == productId;
        });
    };
    var handleWishlist = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(item) {
            var ref, productId, ref1, ref2;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        if (!(wishlistLoadingId === item.id)) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 3:
                        if (authState.user) {
                            _ctx.next = 6;
                            break;
                        }
                        dispatch(auth/* authActions.setIsModalOpen */.YV.setIsModalOpen(true));
                        return _ctx.abrupt("return");
                    case 6:
                        productId = (ref = item.data) === null || ref === void 0 ? void 0 : ref.product_id;
                        setWishlistLoadingId(item.id);
                        _ctx.prev = 8;
                        if (!isInWishlist(item)) {
                            _ctx.next = 20;
                            break;
                        }
                        if (confirm("Are you sure you want to remove this product from wishlist?")) {
                            _ctx.next = 13;
                            break;
                        }
                        setWishlistLoadingId(null);
                        return _ctx.abrupt("return");
                    case 13:
                        _ctx.next = 15;
                        return http_client/* default.post */.Z.post(endpoints/* default.wishlist.remove */.Z.wishlist.remove(), {
                            product_id: productId,
                            user_id: authState.user.id
                        });
                    case 15:
                        _ctx.next = 17;
                        return dispatch((0,wishlist/* fetchWishlistItems */.nf)(authState.user.id));
                    case 17:
                        (0,react_toastify_esm/* toast */.Am)("Item removed from wishlist", {
                            type: "success",
                            toastId: "wishlist-remove-success"
                        });
                        _ctx.next = 26;
                        break;
                    case 20:
                        _ctx.next = 22;
                        return http_client/* default.post */.Z.post(endpoints/* default.wishlist.add */.Z.wishlist.add(), {
                            product_id: productId,
                            user_id: authState.user.id
                        });
                    case 22:
                        _ctx.next = 24;
                        return dispatch((0,wishlist/* fetchWishlistItems */.nf)(authState.user.id));
                    case 24:
                        (0,react_toastify_esm/* toast */.Am)("Item added to wishlist", {
                            type: "success",
                            toastId: "wishlist-add-success"
                        });
                        if (window.smartech) {
                            ;
                            (0,unbxd/* unbxdCusEngTrackEvent */.$z)("Add to wishlist ", {
                                source: "web",
                                platform: "senco",
                                prid: (ref1 = item.data) === null || ref1 === void 0 ? void 0 : ref1.product_id,
                                variant_id: item.identifier,
                                image: item.product_image || item.image,
                                prqt: 1,
                                product_name: ((ref2 = item.product) === null || ref2 === void 0 ? void 0 : ref2.title) || item.product_name || item.name,
                                amount: item.product_price || item.price,
                                product_url: "".concat(window.location.origin, "/jewellery/").concat(item.slug),
                                discounted_price: item.product_discounted_price || 0,
                                stock_availability: 1
                            });
                        }
                    case 26:
                        _ctx.next = 30;
                        break;
                    case 28:
                        _ctx.prev = 28;
                        _ctx.t0 = _ctx["catch"](8);
                    case 30:
                        setWishlistLoadingId(null);
                    case 31:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    8,
                    28
                ]
            ]);
        }));
        return function handleWishlist(item) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (shap_of_you_module_default()).modal_pro_desktop_cart,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "".concat((shap_of_you_module_default()).overlay_desktop, " ").concat(isOpen ? (shap_of_you_module_default()).show : ""),
            onClick: function() {
                return setIsOpen(false);
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: (shap_of_you_module_default()).closeBtn,
                    onClick: function() {
                        return setIsOpen(false);
                    },
                    children: "✕"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "".concat((shap_of_you_module_default()).modal, " ").concat(isOpen ? (shap_of_you_module_default()).open : ""),
                    onClick: function(e) {
                        return e.stopPropagation();
                    },
                    style: {
                        display: "flex",
                        flexDirection: "column"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (shap_of_you_module_default()).header,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: "Cart Page"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (shap_of_you_module_default()).wrapper_card_desktop,
                            children: cartState.items_loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (shap_of_you_module_default()).loading,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                                    animation: "border",
                                    role: "status"
                                })
                            }) : cartState.items.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (shap_of_you_module_default()).empty,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Your cart is empty"
                                })
                            }) : cartState.items.map(function(item) {
                                var ref, ref1;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (shap_of_you_module_default()).item,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (shap_of_you_module_default()).row,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (shap_of_you_module_default()).imageBox,
                                                children: item.product_image || item.image ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: item.product_image || item.image,
                                                    alt: "product"
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (shap_of_you_module_default()).imagePlaceholder
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (shap_of_you_module_default()).details,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "w-100",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: (shap_of_you_module_default()).title,
                                                                children: ((ref = item.product) === null || ref === void 0 ? void 0 : ref.title) || item.product_name || item.name
                                                            }),
                                                            item.data.purity && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                className: (shap_of_you_module_default()).meta,
                                                                children: [
                                                                    "Purity: ",
                                                                    item.data.purity
                                                                ]
                                                            }),
                                                            item.diamond_shape && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                className: (shap_of_you_module_default()).meta,
                                                                children: [
                                                                    "Diamond Shape: ",
                                                                    item.diamond_shape
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                className: (shap_of_you_module_default()).price,
                                                                children: [
                                                                    "₹",
                                                                    " ",
                                                                    (item.product_discounted_price || item.product_price || item.price || 0).toLocaleString("en-IN")
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (shap_of_you_module_default()).actions,
                                                        children: [
                                                            ((ref1 = item.data) === null || ref1 === void 0 ? void 0 : ref1.is_limited_stock) == 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                onClick: function() {
                                                                    return handleAddOneMore(item);
                                                                },
                                                                disabled: addOneMoreLoadingId === item.id,
                                                                className: "".concat((shap_of_you_module_default()).button, " ").concat((shap_of_you_module_default()).addBtn),
                                                                children: addOneMoreLoadingId === item.id ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                                                                    animation: "border",
                                                                    size: "sm"
                                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                            className: "bi bi-plus-lg"
                                                                        }),
                                                                        " Add One More"
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                                onClick: function() {
                                                                    return handleRemove(item);
                                                                },
                                                                disabled: removingId === item.id,
                                                                className: "".concat((shap_of_you_module_default()).button, " ").concat((shap_of_you_module_default()).removeBtn),
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                        className: "bi bi-trash"
                                                                    }),
                                                                    " Remove"
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (shap_of_you_module_default()).heart,
                                                children: wishlistLoadingId === item.id ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                                                    animation: "border",
                                                    size: "sm"
                                                }) : isInWishlist(item) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    className: "bi bi-heart-fill",
                                                    style: {
                                                        color: "#FF1933",
                                                        cursor: "pointer"
                                                    },
                                                    onClick: function() {
                                                        return handleWishlist(item);
                                                    },
                                                    title: "Remove from Wishlist"
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    className: "bi bi-heart",
                                                    style: {
                                                        cursor: "pointer"
                                                    },
                                                    onClick: function() {
                                                        return handleWishlist(item);
                                                    },
                                                    title: "Add to Wishlist"
                                                })
                                            })
                                        ]
                                    })
                                }, item.id);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (shap_of_you_module_default()).footer1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    onClick: handleContinueShopping,
                                    className: "".concat((shap_of_you_module_default()).button, " ").concat((shap_of_you_module_default()).continueBtn),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                            width: "16",
                                            height: "16",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M19 12H5",
                                                    stroke: "#262121",
                                                    strokeWidth: "2",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M12 5L5 12L12 19",
                                                    stroke: "#262121",
                                                    strokeWidth: "2",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round"
                                                })
                                            ]
                                        }),
                                        "Continue Shopping"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    onClick: handleProceedToCheckout,
                                    className: "".concat((shap_of_you_module_default()).button, " ").concat((shap_of_you_module_default()).checkoutBtn),
                                    children: [
                                        "Proceed to Checkout",
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                            width: "16",
                                            height: "16",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M5 12H19",
                                                    stroke: "white",
                                                    strokeWidth: "2",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M12 5L19 12L12 19",
                                                    stroke: "white",
                                                    strokeWidth: "2",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var shape_of_you_desktop_new_CartModal = (CartModal_CartModal);

;// CONCATENATED MODULE: ./src/components/shape-of-you-desktop-new/LiveCameraPermissionModal.tsx






var LiveCameraPermissionModal_LiveCameraPermissionModal = function(param) {
    var show = param.show, onHide = param.onHide, onPermissionGranted = param.onPermissionGranted, onPermissionDenied = param.onPermissionDenied, logStep = param.logStep;
    var ref = (0,react.useState)(false), isRequesting = ref[0], setIsRequesting = ref[1];
    // Handle "Allow this time" - request camera permission
    var handleAllowThisTime = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var stream;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setIsRequesting(true);
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return navigator.mediaDevices.getUserMedia({
                            video: {
                                facingMode: "user"
                            }
                        });
                    case 4:
                        stream = _ctx.sent;
                        // Permission granted! Stop the stream and save to localStorage
                        stream.getTracks().forEach(function(track) {
                            return track.stop();
                        });
                        localStorage.setItem("cameraPermissionGranted", "true");
                        // Log camera permission granted (non-blocking)
                        if (logStep) {
                            logStep("camera_permission_granted");
                        }
                        // Close modal and trigger success callback
                        onHide();
                        onPermissionGranted();
                        _ctx.next = 18;
                        break;
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](1);
                        ;
                        // Log camera permission denied (non-blocking)
                        if (logStep) {
                            logStep("camera_permission_denied", {
                                error_message: "User denied camera permission"
                            });
                        }
                        // Close modal and trigger denied callback
                        onHide();
                        onPermissionDenied();
                    case 18:
                        _ctx.prev = 18;
                        setIsRequesting(false);
                        return _ctx.finish(18);
                    case 21:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    12,
                    18,
                    21
                ]
            ]);
        }));
        return function handleAllowThisTime() {
            return _ref.apply(this, arguments);
        };
    }();
    // Handle "Allow on every visit" - same as "Allow this time" for camera
    var handleAllowEveryVisit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return handleAllowThisTime();
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleAllowEveryVisit() {
            return _ref.apply(this, arguments);
        };
    }();
    // Handle "Don't Allow"
    var handleDontAllow = function() {
        // Log camera permission denied (non-blocking)
        if (logStep) {
            logStep("camera_permission_denied", {
                error_message: "User clicked Don't Allow"
            });
        }
        // Close modal
        onHide();
        // Trigger denied callback
        onPermissionDenied();
    };
    if (!show) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        show: show,
        onHide: onHide,
        className: (shap_of_you_module_default()).custom_modal,
        centered: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Body */.Z.Body, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (shap_of_you_module_default()).modal,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                        children: [
                            "“sencogoldanddiamonds.com” ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            " wants to"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        className: (shap_of_you_module_default()).checkbox,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                width: "20",
                                height: "16",
                                viewBox: "0 0 30 24",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M3 24C2.175 24 1.46875 23.7063 0.88125 23.1188C0.29375 22.5312 0 21.825 0 21V3C0 2.175 0.29375 1.46875 0.88125 0.88125C1.46875 0.29375 2.175 0 3 0H21C21.825 0 22.5312 0.29375 23.1188 0.88125C23.7063 1.46875 24 2.175 24 3V9.75L30 3.75V20.25L24 14.25V21C24 21.825 23.7063 22.5312 23.1188 23.1188C22.5312 23.7063 21.825 24 21 24H3ZM3 21H21V3H3V21Z",
                                    fill: "#46474C"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "Use your camera"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (shap_of_you_module_default()).actions,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: (shap_of_you_module_default()).primary,
                                onClick: handleAllowThisTime,
                                disabled: isRequesting,
                                children: isRequesting ? "Requesting..." : "Allow this time"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: (shap_of_you_module_default()).primary,
                                onClick: handleAllowEveryVisit,
                                disabled: isRequesting,
                                children: "Allow on every visit"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: (shap_of_you_module_default()).primary,
                                onClick: handleDontAllow,
                                disabled: isRequesting,
                                children: "Don't Allow"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var shape_of_you_desktop_new_LiveCameraPermissionModal = (LiveCameraPermissionModal_LiveCameraPermissionModal); /*
  ============================================
  PREVIOUS FIXED OVERLAY DESIGN (COMMENTED OUT)
  ============================================
  This is the old full-screen fixed overlay design for the livestreaming modal.
  Kept for future reference. The new design uses React-Bootstrap Modal to match
  the desktop CameraPermissionScreen layout.
  
  Old JSX:
  
  return (
    <div
      className="d-none d-md-flex"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 2000,
        background: "rgba(0,0,0,0.6)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
      }}
      role="dialog"
      aria-modal="true"
    >
      <div
        style={{
          backgroundColor: "white",
          borderRadius: "20px",
          padding: "20px",
          textAlign: "left",
          maxWidth: "420px",
          boxShadow: "0 8px 30px rgba(0,0,0,0.35)",
        }}
      >
        <h3
          style={{
            fontSize: "20px",
            fontWeight: 400,
            marginBottom: "8px",
            color: "#000",
            fontFamily: "Sweet Sans Pro Regular",
          }}
        >
          &ldquo;Senco Gold&rdquo; Would Like To Access Your Camera
        </h3>
        <p
          style={{
            fontSize: "14px",
            color: "#666",
            marginBottom: "20px",
            lineHeight: 1.4,
          }}
        >
          This app requires access to camera
        </p>

        <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
          <button
            onClick={() => {
              handleDontAllow();
            }}
            disabled={isRequesting}
            style={{
              flex: 1,
              padding: "10px 12px",
              backgroundColor: "#f0f0f0",
              border: "none",
              borderRadius: "20px",
              fontSize: "15px",
              fontWeight: 500,
              color: "#333",
              cursor: isRequesting ? "not-allowed" : "pointer",
            }}
          >
            Don&apos;t Allow
          </button>
          <button
            onClick={handleAllowThisTime}
            disabled={isRequesting}
            style={{
              flex: 1,
              padding: "10px 12px",
              backgroundColor: "#007AFF",
              border: "none",
              borderRadius: "20px",
              fontSize: "15px",
              fontWeight: 500,
              color: "white",
              cursor: isRequesting ? "not-allowed" : "pointer",
            }}
          >
            {isRequesting ? "Requesting..." : "OK"}
          </button>
        </div>
      </div>
    </div>
  );
*/ 

;// CONCATENATED MODULE: ./src/components/shape-of-you-desktop-new/ProductViewScreen.tsx
































var ProductViewScreen_ProductViewScreen = function(param) {
    var navigateToStep = param.navigateToStep, filter = param.filter, setFilter = param.setFilter, logStep = param.logStep;
    var ref, ref1;
    var dispatch = (0,store/* useAppDispatch */.T)();
    var router = (0,next_router.useRouter)();
    var ref2 = (0,es/* useSelector */.v9)(shapeOfYou/* selectShapeOfYou */.Tk), recommendations = ref2.recommendations, capturedImage = ref2.capturedImage;
    var categoryState = (0,es/* useSelector */.v9)(function(state) {
        return state.category;
    });
    var cartState = (0,es/* useSelector */.v9)(cart/* selectCart */.KY);
    var authState = (0,es/* useSelector */.v9)(auth/* selectAuth */.Hz);
    var ref3 = (0,react.useState)("Necklace"), activeCategory = ref3[0], setActiveCategory = ref3[1];
    var ref4 = (0,react.useState)(false), loading = ref4[0], setLoading = ref4[1];
    var ref5 = (0,react.useState)([]), productIds = ref5[0], setProductIds = ref5[1];
    var ref6 = (0,react.useState)([]), availableCategories = ref6[0], setAvailableCategories = ref6[1];
    var ref7 = (0,react.useState)(""), selected = ref7[0], setSelected = ref7[1];
    // Virtual try-on image state
    var ref8 = (0,react.useState)(null), virtualTryOnImage = ref8[0], setVirtualTryOnImage = ref8[1];
    var ref9 = (0,react.useState)(false), isGeneratingImage = ref9[0], setIsGeneratingImage = ref9[1];
    // Track selected products per category
    var ref10 = (0,react.useState)(null), selectedEarringId = ref10[0], setSelectedEarringId = ref10[1];
    var ref11 = (0,react.useState)(null), selectedNecklaceId = ref11[0], setSelectedNecklaceId = ref11[1];
    // Live mode state
    var ref12 = (0,react.useState)(false), isLiveMode = ref12[0], setIsLiveMode = ref12[1];
    var liveModeIframeRef = (0,react.useRef)(null);
    // Bump this to force a re-sync of the iframe when selection changes
    var ref13 = (0,react.useState)(0), liveModeSyncSeq = ref13[0], setLiveModeSyncSeq = ref13[1];
    var swiperRef = (0,react.useRef)(null);
    // Cart action loading state
    var ref14 = (0,react.useState)(false), cartActionLoading = ref14[0], setCartActionLoading = ref14[1];
    var ref15 = (0,react.useState)(false), showAddedSuccess = ref15[0], setShowAddedSuccess = ref15[1];
    // Live mode camera permission state
    var ref16 = (0,react.useState)(false), showCameraPermissionModal = ref16[0], setShowCameraPermissionModal = ref16[1];
    var ref17 = (0,react.useState)(false), cameraPermissionChecked = ref17[0], setCameraPermissionChecked = ref17[1];
    // Call image augmentation API (following Product.tsx pattern)
    var callImageAPI = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(earringId, necklaceId) {
            var earringProductId, necklaceProductId, requestBody, response;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (capturedImage) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        earringProductId = earringId !== undefined ? earringId : selectedEarringId;
                        necklaceProductId = necklaceId !== undefined ? necklaceId : selectedNecklaceId;
                        if (!(!earringProductId && !necklaceProductId)) {
                            _ctx.next = 6;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 6:
                        setIsGeneratingImage(true);
                        _ctx.prev = 7;
                        requestBody = {
                            image_data: capturedImage
                        };
                        // Add earring product ID if available
                        if (earringProductId) {
                            requestBody.earring_product_id = earringProductId;
                        }
                        // Add necklace product ID if available
                        if (necklaceProductId) {
                            requestBody.necklace_product_id = necklaceProductId;
                        }
                        _ctx.next = 13;
                        return http_client/* default.post */.Z.post(endpoints/* default.shape_of_you.image */.Z.shape_of_you.image(), requestBody);
                    case 13:
                        response = _ctx.sent;
                        // Set the virtual try-on image from the API response
                        if (response.data.success && response.data.image) {
                            setVirtualTryOnImage(response.data.image);
                            dispatch(shapeOfYou/* shapeOfYouActions.setVirtualTryOnImage */.r1.setVirtualTryOnImage(response.data.image));
                        }
                        _ctx.next = 22;
                        break;
                    case 17:
                        _ctx.prev = 17;
                        _ctx.t0 = _ctx["catch"](7);
                        react_toastify_esm/* toast.error */.Am.error("Error updating virtual try-on image");
                        setVirtualTryOnImage(null);
                        dispatch(shapeOfYou/* shapeOfYouActions.setVirtualTryOnImage */.r1.setVirtualTryOnImage(null));
                    case 22:
                        _ctx.prev = 22;
                        setIsGeneratingImage(false);
                        return _ctx.finish(22);
                    case 25:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    7,
                    17,
                    22,
                    25
                ]
            ]);
        }));
        return function(earringId, necklaceId) {
            return _ref.apply(this, arguments);
        };
    }(), [
        capturedImage,
        selectedEarringId,
        selectedNecklaceId,
        dispatch
    ]);
    // Stable ref so the fetch effect can call callImageAPI without it being a dep
    var callImageAPIRef = (0,react.useRef)(callImageAPI);
    callImageAPIRef.current = callImageAPI;
    var products = ((ref = categoryState.similarProducts) === null || ref === void 0 ? void 0 : ref.data) || [];
    // Get product SKUs for selected products (matching desktop Product.tsx pattern)
    var getSelectedProductSkusByCategory = function() {
        var earringItems = [];
        var necklaceItems = [];
        if (selectedEarringId) {
            var earringProduct = products.find(function(p) {
                return String(p.id) === String(selectedEarringId) || String(p.product_id) === String(selectedEarringId) || String(p.sku) === String(selectedEarringId);
            });
            var sku = String((earringProduct === null || earringProduct === void 0 ? void 0 : earringProduct.sku) || selectedEarringId).trim();
            if (sku && sku !== "undefined" && sku !== "null") {
                earringItems.push({
                    productId: sku
                });
            }
        }
        if (selectedNecklaceId) {
            var necklaceProduct = products.find(function(p) {
                return String(p.id) === String(selectedNecklaceId) || String(p.product_id) === String(selectedNecklaceId) || String(p.sku) === String(selectedNecklaceId);
            });
            var sku1 = String((necklaceProduct === null || necklaceProduct === void 0 ? void 0 : necklaceProduct.sku) || selectedNecklaceId).trim();
            if (sku1 && sku1 !== "undefined" && sku1 !== "null") {
                necklaceItems.push({
                    productId: sku1
                });
            }
        }
        return {
            earringItems: earringItems,
            necklaceItems: necklaceItems
        };
    };
    var getLiveModeTargetOrigin = function() {
        var ref;
        var src = (ref = liveModeIframeRef.current) === null || ref === void 0 ? void 0 : ref.src;
        if (!src) return "https://jewel-aug.adamastech.org";
        try {
            return new URL(src).origin;
        } catch (e) {
            return "https://jewel-aug.adamastech.org";
        }
    };
    // Helper function to send product to iframe with retry (matching desktop Product.tsx)
    var sendProductToIframe = function(sku, category) {
        var clearOtherCategory = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, otherCategoryHadValue = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
        var ref;
        var iframeWin = (ref = liveModeIframeRef.current) === null || ref === void 0 ? void 0 : ref.contentWindow;
        if (!iframeWin) {
            ;
            return;
        }
        var targetOrigin = getLiveModeTargetOrigin();
        var sendMessage = function() {
            iframeWin.postMessage({
                type: "overlay-products",
                category: category,
                items: [
                    {
                        productId: sku
                    }
                ]
            }, targetOrigin);
            ;
            if (clearOtherCategory && otherCategoryHadValue) {
                var otherCategory = category === "EARRING" ? "NECKLACE" : "EARRING";
                iframeWin.postMessage({
                    type: "overlay-products",
                    category: otherCategory,
                    items: []
                }, targetOrigin);
                ;
            }
        };
        // Send once — postMessage is synchronous & reliable when iframe is loaded
        sendMessage();
    };
    // Track if we've logged product_viewed
    var hasLoggedProductView = (0,react.useRef)(false);
    // Log product_viewed when products are first displayed
    (0,react.useEffect)(function() {
        if (recommendations && logStep && !hasLoggedProductView.current) {
            logStep("product_viewed");
            hasLoggedProductView.current = true;
        }
    }, [
        recommendations,
        logStep
    ]);
    // Determine available categories from recommendations
    (0,react.useEffect)(function() {
        if (recommendations) {
            var categories = Object.keys(recommendations).filter(function(key) {
                return key === "Earring" || key === "Necklace";
            });
            setAvailableCategories(categories);
            // Set initial active category if not already set
            if (categories.length > 0 && !categories.includes(activeCategory)) {
                setActiveCategory(categories[0]);
            }
        }
    }, [
        recommendations,
        activeCategory
    ]);
    // Fetch product IDs when category changes (following Product.tsx pattern)
    (0,react.useEffect)(function() {
        var cancelled = false;
        var fetchProductIds = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var categoryData, requestBody, response, ids, ref, ref1, result, fetchedProducts, firstProduct, firstId;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (!(!recommendations || !activeCategory)) {
                                _ctx.next = 2;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 2:
                            categoryData = recommendations[activeCategory];
                            if (categoryData) {
                                _ctx.next = 5;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 5:
                            // Show loading immediately when category changes (prevents "No products available" flash)
                            setLoading(true);
                            setProductIds([]);
                            _ctx.prev = 7;
                            requestBody = {
                                mode: activeCategory
                            };
                            _ctx.next = 11;
                            return http_client/* default.post */.Z.post(endpoints/* default.shape_of_you.products */.Z.shape_of_you.products(), requestBody);
                        case 11:
                            response = _ctx.sent;
                            if (!cancelled) {
                                _ctx.next = 14;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 14:
                            if (!(response && response.data && response.data.product_ids)) {
                                _ctx.next = 29;
                                break;
                            }
                            ids = response.data.product_ids;
                            setProductIds(ids);
                            if (!(ids.length > 0)) {
                                _ctx.next = 29;
                                break;
                            }
                            ;
                            _ctx.next = 21;
                            return dispatch((0,category/* fetchSimilarProducts */.sy)({
                                query: (0,_object_spread/* default */.Z)({
                                    skus: ids,
                                    size: ids.length
                                }, filter)
                            }));
                        case 21:
                            result = _ctx.sent;
                            if (!cancelled) {
                                _ctx.next = 24;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 24:
                            // Fetch filter options (non-blocking)
                            dispatch((0,category/* fetchSimilarProductFilters */.RI)({
                                query: (0,_object_spread/* default */.Z)({
                                    skus: ids,
                                    size: ids.length
                                }, filter)
                            }));
                            fetchedProducts = ((ref = result) === null || ref === void 0 ? void 0 : (ref1 = ref.payload) === null || ref1 === void 0 ? void 0 : ref1.data) || [];
                            firstProduct = fetchedProducts[0];
                            // Only proceed with selection if a real product was found
                            if (firstProduct) {
                                firstId = String(firstProduct.sku || firstProduct.id || firstProduct.product_id);
                                // Auto-select first product
                                setSelected(firstId);
                                // Update category-specific ID and call image API only when a
                                // matching product exists (firstId === product.sku in the swiper)
                                if (activeCategory === "Earring") {
                                    setSelectedEarringId(firstId);
                                    if (capturedImage) {
                                        callImageAPIRef.current(firstId, null);
                                    }
                                } else if (activeCategory === "Necklace") {
                                    setSelectedNecklaceId(firstId);
                                    if (capturedImage) {
                                        callImageAPIRef.current(null, firstId);
                                    }
                                }
                            }
                            // Center the first item in swiper after it's initialized
                            setTimeout(function() {
                                if (swiperRef.current) {
                                    try {
                                        var ref;
                                        var swiper = swiperRef.current;
                                        if ((ref = swiper.params) === null || ref === void 0 ? void 0 : ref.loop) {
                                            swiper.slideToLoop(0, 0);
                                        } else {
                                            swiper.slideTo(0, 0);
                                        }
                                    } catch (error) {
                                    // Swiper not ready yet, ignore
                                    }
                                }
                            }, 200);
                        case 29:
                            _ctx.next = 34;
                            break;
                        case 31:
                            _ctx.prev = 31;
                            _ctx.t0 = _ctx["catch"](7);
                            if (!cancelled) {
                                react_toastify_esm/* toast.error */.Am.error("Failed to load products");
                                setProductIds([]);
                            }
                        case 34:
                            _ctx.prev = 34;
                            if (!cancelled) {
                                // Increase loader time slightly so product display gets time to render properly
                                setTimeout(function() {
                                    if (!cancelled) setLoading(false);
                                }, 1500);
                            }
                            return _ctx.finish(34);
                        case 37:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        7,
                        31,
                        34,
                        37
                    ]
                ]);
            }));
            return function fetchProductIds() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchProductIds();
        return function() {
            cancelled = true;
        };
    }, [
        activeCategory,
        recommendations,
        dispatch,
        filter,
        capturedImage
    ]);
    // Send product data to iframe when live mode is active (matching desktop Product.tsx)
    (0,react.useEffect)(function() {
        var ref;
        if (!isLiveMode || !liveModeIframeRef.current) return;
        var sendProductDataOnce = function() {
            var ref;
            var iframeWin = (ref = liveModeIframeRef.current) === null || ref === void 0 ? void 0 : ref.contentWindow;
            if (!iframeWin) return false;
            var ref1 = getSelectedProductSkusByCategory(), earringItems = ref1.earringItems, necklaceItems = ref1.necklaceItems;
            var targetOrigin = getLiveModeTargetOrigin();
            if (earringItems.length > 0) {
                iframeWin.postMessage({
                    type: "overlay-products",
                    category: "EARRING",
                    items: earringItems
                }, targetOrigin);
                ;
            } else {
                iframeWin.postMessage({
                    type: "overlay-products",
                    category: "EARRING",
                    items: []
                }, targetOrigin);
            }
            if (necklaceItems.length > 0) {
                iframeWin.postMessage({
                    type: "overlay-products",
                    category: "NECKLACE",
                    items: necklaceItems
                }, targetOrigin);
                ;
            } else {
                iframeWin.postMessage({
                    type: "overlay-products",
                    category: "NECKLACE",
                    items: []
                }, targetOrigin);
            }
            return true;
        };
        var retryTimeout = null;
        var sendWithRetry = function() {
            if (retryTimeout) {
                clearTimeout(retryTimeout);
                retryTimeout = null;
            }
            sendProductDataOnce();
            // Single safety retry after 1s in case the first message was missed
            retryTimeout = setTimeout(function() {
                sendProductDataOnce();
                retryTimeout = null;
            }, 1000);
        };
        var iframe = liveModeIframeRef.current;
        if (((ref = iframe.contentDocument) === null || ref === void 0 ? void 0 : ref.readyState) === "complete") {
            sendWithRetry();
        } else {
            var onLoad = function() {
                setTimeout(function() {
                    sendWithRetry();
                }, 300);
            };
            iframe.addEventListener("load", onLoad, {
                once: true
            });
        }
        return function() {
            if (retryTimeout) {
                clearTimeout(retryTimeout);
                retryTimeout = null;
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isLiveMode,
        selectedEarringId,
        selectedNecklaceId,
        products,
        liveModeSyncSeq, 
    ]);
    // Get selected product details
    var selectedProduct = products.find(function(p) {
        return String(p.id) === String(selected) || String(p.product_id) === String(selected) || String(p.sku) === String(selected);
    });
    // Check if selected product is in cart
    var cartItem = (0,react.useMemo)(function() {
        return selectedProduct ? cartState.items.find(function(v) {
            var ref;
            return v.identifier == ((ref = selectedProduct.priceId) === null || ref === void 0 ? void 0 : ref.toString()) || "";
        }) || null : null;
    }, [
        cartState.items,
        selectedProduct
    ]);
    // Handle category tab click (matching desktop handleTabClick pattern)
    var handleCategoryClick = function(category) {
        setActiveCategory(category);
        setSelected(""); // Reset selection when switching categories
        setVirtualTryOnImage(null); // Clear virtual try-on image when switching tabs
        dispatch(shapeOfYou/* shapeOfYouActions.setVirtualTryOnImage */.r1.setVirtualTryOnImage(null));
        // Clear product IDs so first product of new tab will be set by the products effect
        setSelectedEarringId(null);
        setSelectedNecklaceId(null);
    };
    // Handle product selection and call image API
    var handleProductSelect = function(product, productId, index) {
        setSelected(productId);
        // Log product selection (non-blocking)
        if (logStep) {
            var ref;
            logStep("product_selected", {
                success_message: "Product selected successfully",
                success_code: "200",
                response_status: 200,
                request_payload: {
                    action: "product_click",
                    product_id: productId,
                    category: activeCategory,
                    index: index
                },
                response_payload: {
                    product_id: productId,
                    product_sku: (product === null || product === void 0 ? void 0 : product.sku) || null,
                    product_title: (product === null || product === void 0 ? void 0 : product.title) || (product === null || product === void 0 ? void 0 : product.slug) || null,
                    product_price: (product === null || product === void 0 ? void 0 : product.price) || null,
                    product_category: activeCategory,
                    product_image: (product === null || product === void 0 ? void 0 : product.image) || (product === null || product === void 0 ? void 0 : (ref = product.images) === null || ref === void 0 ? void 0 : ref[0]) || null,
                    has_fast_delivery: (product === null || product === void 0 ? void 0 : product.fastDelivery) || false,
                    is_trending: (product === null || product === void 0 ? void 0 : product.trending) || false,
                    is_new_arrival: (product === null || product === void 0 ? void 0 : product.new_arrival) || false,
                    selection_index: index
                }
            });
        }
        // Slide to the selected item to center it
        if (swiperRef.current) {
            try {
                var ref1;
                var swiper = swiperRef.current;
                if ((ref1 = swiper.params) === null || ref1 === void 0 ? void 0 : ref1.loop) {
                    swiper.slideToLoop(index, 300);
                } else {
                    swiper.slideTo(index, 300);
                }
            } catch (error) {
            // Swiper not ready, ignore
            }
        }
        // Determine which ID to update and whether to clear the other category
        var clearOtherCategory = false;
        var otherCategoryHadValue = false;
        if (activeCategory === "Earring") {
            setSelectedEarringId(productId);
            if (selectedNecklaceId) {
                setSelectedNecklaceId(null);
                clearOtherCategory = true;
                otherCategoryHadValue = true;
            }
            // Call image API with ONLY earring ID
            if (capturedImage) {
                callImageAPI(productId, null);
            }
        } else if (activeCategory === "Necklace") {
            setSelectedNecklaceId(productId);
            if (selectedEarringId) {
                setSelectedEarringId(null);
                clearOtherCategory = true;
                otherCategoryHadValue = true;
            }
            // Call image API with ONLY necklace ID
            if (capturedImage) {
                callImageAPI(null, productId);
            }
        }
        // Get the product SKU
        var sku = String(product.sku || productId).trim();
        // Send to iframe FIRST if in live mode (matching desktop Product.tsx)
        if (isLiveMode && sku && sku !== "undefined" && sku !== "null") {
            var category = activeCategory === "Earring" ? "EARRING" : "NECKLACE";
            sendProductToIframe(sku, category, clearOtherCategory, otherCategoryHadValue);
            // Also trigger useEffect sync as backup
            setLiveModeSyncSeq(function(s) {
                return s + 1;
            });
        }
    };
    // Check camera permission and toggle live mode
    var handleLiveModeToggle = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var permissionStatus, persisted;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!isLiveMode) {
                            _ctx.next = 3;
                            break;
                        }
                        setIsLiveMode(false);
                        return _ctx.abrupt("return");
                    case 3:
                        _ctx.prev = 3;
                        _ctx.next = 6;
                        return navigator.permissions.query({
                            name: "camera"
                        });
                    case 6:
                        permissionStatus = _ctx.sent;
                        if (permissionStatus.state === "granted") {
                            persisted = localStorage.getItem("cameraPermissionGranted");
                            if (persisted === "true") {
                                setIsLiveMode(true);
                            } else {
                                // Browser granted but app flag not set - show modal to confirm
                                setShowCameraPermissionModal(true);
                            }
                        } else if (permissionStatus.state === "prompt") {
                            // User hasn't made a decision yet - show modal to request
                            setShowCameraPermissionModal(true);
                        } else if (permissionStatus.state === "denied") {
                            // User has previously denied permission
                            react_toastify_esm/* toast.error */.Am.error("Camera permission denied. Please enable it in your browser settings.");
                        }
                        _ctx.next = 14;
                        break;
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](3);
                        ;
                        setShowCameraPermissionModal(true);
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    3,
                    10
                ]
            ]);
        }));
        return function handleLiveModeToggle() {
            return _ref.apply(this, arguments);
        };
    }();
    // Handle camera permission allowed
    var handleCameraPermissionAllowed = function() {
        setShowCameraPermissionModal(false);
        setIsLiveMode(true);
        react_toastify_esm/* toast.success */.Am.success("Camera access granted. Live View enabled.");
    };
    // Handle camera permission denied
    var handleCameraPermissionDenied = function() {
        setShowCameraPermissionModal(false);
        setIsLiveMode(false);
        react_toastify_esm/* toast.error */.Am.error("Camera permission denied. Switched back to Photo mode.");
    };
    // Add to cart function
    var addToCart = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var redirect, ref, ref1, _args = arguments;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        redirect = _args.length > 0 && _args[0] !== void 0 ? _args[0] : false;
                        if (selectedProduct) {
                            _ctx.next = 4;
                            break;
                        }
                        react_toastify_esm/* toast.error */.Am.error("Please select a product first");
                        return _ctx.abrupt("return");
                    case 4:
                        if (authState.user) {
                            _ctx.next = 7;
                            break;
                        }
                        dispatch(auth/* authActions.setIsModalOpen */.YV.setIsModalOpen(true));
                        return _ctx.abrupt("return");
                    case 7:
                        setCartActionLoading(true);
                        _ctx.prev = 8;
                        ;
                        _ctx.next = 12;
                        return http_client/* default.post */.Z.post(endpoints/* default.cart.add */.Z.cart.add(), {
                            is_solitaire: false,
                            type: "product",
                            identifier: selectedProduct.priceId
                        });
                    case 12:
                        _ctx.next = 14;
                        return dispatch((0,cart/* fetchCartItems */.Vw)());
                    case 14:
                        // Show success state momentarily
                        setCartActionLoading(false);
                        setShowAddedSuccess(true);
                        // Hide success state after 1.5 seconds
                        setTimeout(function() {
                            setShowAddedSuccess(false);
                        }, 1500);
                        react_toastify_esm/* toast.success */.Am.success("Item added to cart");
                        window.dataLayer.push({
                            ecommerce: null
                        });
                        window.dataLayer.push({
                            event: "add_to_cart",
                            ecommerce: {
                                currency: "INR",
                                value: selectedProduct.price,
                                items: [
                                    {
                                        item_id: selectedProduct.id || selectedProduct.product_id || selectedProduct.sku,
                                        item_name: selectedProduct.title || selectedProduct.slug,
                                        item_brand: ga4/* GA4_ITEM_BRAND */.Ye,
                                        item_category: activeCategory,
                                        item_variant: selectedProduct.purity || ((ref = selectedProduct.purities) === null || ref === void 0 ? void 0 : ref[0]) || selectedProduct.priceId,
                                        price: selectedProduct.price,
                                        quantity: 1
                                    }, 
                                ]
                            }
                        });
                        (0,unbxd/* unbxdCusEngTrackEvent */.$z)("Add to cart ", {
                            source: "web",
                            platform: "senco",
                            prid: selectedProduct.id || selectedProduct.product_id,
                            variant_id: selectedProduct.priceId,
                            image_url: selectedProduct.image || selectedProduct.images && selectedProduct.images[0],
                            prqt: 1,
                            product_name: selectedProduct.title || selectedProduct.slug,
                            category: activeCategory || "",
                            brand: constants/* BRAND_NAME */.R,
                            amount: selectedProduct.price,
                            product_url: "".concat(window.location.origin, "/jewellery/").concat(selectedProduct.slug),
                            discounted_price: selectedProduct.discounted_price || 0,
                            stock_availability: 1
                        });
                        // Log product added to cart (non-blocking)
                        if (logStep) {
                            logStep("product_added_to_cart", {
                                api_endpoint: endpoints/* default.cart.add */.Z.cart.add(),
                                request_payload: {
                                    is_solitaire: false,
                                    type: "product",
                                    identifier: selectedProduct.priceId
                                },
                                response_status: 200,
                                success_message: "Item added to cart successfully",
                                response_payload: {
                                    product_id: selectedProduct.id || selectedProduct.product_id,
                                    product_sku: selectedProduct.sku,
                                    product_title: selectedProduct.title || selectedProduct.slug,
                                    product_price: selectedProduct.price,
                                    category: activeCategory
                                }
                            });
                            // Also log session completed (Shape of You flow completed successfully)
                            logStep("session_completed", {
                                success_message: "Shape of You session completed - Product added to cart",
                                success_code: "SESSION_COMPLETED",
                                response_status: 200,
                                request_payload: {
                                    completion_action: "add_to_cart",
                                    session_stage: "product_view"
                                },
                                response_payload: {
                                    completion_type: "product_added_to_cart",
                                    product_id: selectedProduct.id || selectedProduct.product_id,
                                    product_sku: selectedProduct.sku,
                                    product_title: selectedProduct.title || selectedProduct.slug,
                                    product_price: selectedProduct.price,
                                    product_category: activeCategory,
                                    cart_item_identifier: selectedProduct.priceId,
                                    completed_at: new Date().toISOString()
                                }
                            });
                        }
                        if (redirect) {
                            router.push("/cart");
                        }
                        _ctx.next = 30;
                        break;
                    case 25:
                        _ctx.prev = 25;
                        _ctx.t0 = _ctx["catch"](8);
                        ;
                        if (Number(_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref1 = _ctx.t0.response) === null || ref1 === void 0 ? void 0 : ref1.status) === 400) {
                            react_toastify_esm/* toast.error */.Am.error("Something went wrong! Refreshing the page!");
                            window.location.reload();
                        } else {
                            react_toastify_esm/* toast.error */.Am.error("Failed to add item to cart");
                        }
                        setCartActionLoading(false);
                    case 30:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    8,
                    25
                ]
            ]);
        }));
        return function addToCart() {
            return _ref.apply(this, arguments);
        };
    }();
    // Remove from cart function
    var removeFromCart = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (confirm("Are you sure you want to remove this item from cart?")) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        setCartActionLoading(true);
                        _ctx.prev = 3;
                        _ctx.next = 6;
                        return http_client/* default.delete */.Z["delete"](endpoints/* default.cart.remove */.Z.cart.remove(cartItem === null || cartItem === void 0 ? void 0 : cartItem.id));
                    case 6:
                        _ctx.next = 8;
                        return dispatch((0,cart/* fetchCartItems */.Vw)());
                    case 8:
                        react_toastify_esm/* toast.info */.Am.info("Item removed from cart");
                        _ctx.next = 14;
                        break;
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](3);
                        react_toastify_esm/* toast.error */.Am.error("Failed to remove item from cart");
                    case 14:
                        _ctx.prev = 14;
                        setCartActionLoading(false);
                        return _ctx.finish(14);
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    3,
                    11,
                    14,
                    17
                ]
            ]);
        }));
        return function removeFromCart() {
            return _ref.apply(this, arguments);
        };
    }();
    // Check if any filters are active
    var hasActiveFilters = function() {
        return filter.metal && filter.metal.length > 0 || filter.occasions && filter.occasions.length > 0 || filter.priceMin !== null || filter.priceMax !== null || filter.priceRange !== null && filter.priceRange !== "";
    };
    // Get image source with fallback
    var getImageSrc = function(product) {
        if (!product) return nekl_s/* default.src */.Z.src;
        if (product.image && typeof product.image === "string") {
            return product.image;
        }
        if (product.images && Array.isArray(product.images) && product.images.length > 0) {
            if (typeof product.images[0] === "string") {
                return product.images[0];
            } else if (product.images[0] && product.images[0].url) {
                return product.images[0].url;
            }
        }
        if (product.image_url) return product.image_url;
        if (product.primary_image) return product.primary_image;
        if (product.thumbnail) return product.thumbnail;
        return nekl_s/* default.src */.Z.src;
    };
    var ref18 = (0,react.useState)(false), isOpen = ref18[0], setIsOpen = ref18[1];
    var ref19 = (0,react.useState)(false), isFilterOpen = ref19[0], setIsFilterOpen = ref19[1];
    var ref20 = (0,react.useState)(false), isCartOpen = ref20[0], setIsCartOpen = ref20[1];
    var ref21 = (0,react.useState)(true), isPanelExpanded = ref21[0], setIsPanelExpanded = ref21[1];
    (0,react.useEffect)(function() {
        document.body.style.overflow = isOpen || isFilterOpen || isCartOpen ? "hidden" : "auto";
        return function() {
            document.body.style.overflow = "auto";
        };
    }, [
        isOpen,
        isFilterOpen,
        isCartOpen
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "d-none d-md-block w-100",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (shap_of_you_module_default()).container_desktop,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (shap_of_you_module_default()).image_main,
                            children: [
                                isLiveMode ? // Show Live Mode iframe
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        position: "relative",
                                        width: "100%",
                                        height: "100%"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                        ref: liveModeIframeRef,
                                        id: "live-mode-frame",
                                        src: "https://jewel-aug.adamastech.org/shape-of-you/overlay-preview-alt",
                                        title: "Live Mode Overlay",
                                        allow: "camera; microphone; autoplay",
                                        style: {
                                            width: "100%",
                                            height: "100%",
                                            border: "none",
                                            background: "transparent",
                                            display: "block",
                                            pointerEvents: "none"
                                        }
                                    })
                                }) : virtualTryOnImage ? // Show virtual try-on image if available
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: virtualTryOnImage,
                                    alt: "Virtual Try-On",
                                    className: (shap_of_you_module_default()).bgImage,
                                    layout: "fill",
                                    objectFit: "cover",
                                    unoptimized: true
                                }) : capturedImage ? // Show captured image if no virtual try-on yet
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: capturedImage,
                                    alt: "Your Photo",
                                    className: (shap_of_you_module_default()).bgImage,
                                    layout: "fill",
                                    objectFit: "cover",
                                    unoptimized: true
                                }) : // Fallback to default image
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: ProductPage_Default_Selection,
                                    alt: "Background",
                                    className: (shap_of_you_module_default()).bgImage
                                }),
                                isGeneratingImage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        position: "absolute",
                                        inset: 0,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        background: "rgba(0, 0, 0, 0.4)",
                                        zIndex: 5
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        style: {
                                            textAlign: "center",
                                            color: "#fff"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                                                animation: "border",
                                                role: "status"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                style: {
                                                    marginTop: "1rem",
                                                    fontSize: "14px"
                                                },
                                                children: "Generating virtual try-on..."
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        !isOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (shap_of_you_module_default()).topSwitch,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: (shap_of_you_module_default()).back_arrow,
                                    onClick: function() {
                                        if (logStep) {
                                            logStep("product_view_back_clicked");
                                        }
                                        navigateToStep("uploadOrScan");
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "bi bi-arrow-left"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (shap_of_you_module_default())["switch"],
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: isLiveMode ? (shap_of_you_module_default()).active : (shap_of_you_module_default()).live,
                                            onClick: handleLiveModeToggle,
                                            style: {
                                                cursor: "pointer"
                                            },
                                            children: "Live View"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: !isLiveMode ? (shap_of_you_module_default()).active : (shap_of_you_module_default()).live,
                                            onClick: handleLiveModeToggle,
                                            style: {
                                                cursor: "pointer"
                                            },
                                            children: "Photo"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (shap_of_you_module_default()).filter_top_cta,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: (shap_of_you_module_default()).filter,
                                                onClick: function() {
                                                    return setIsFilterOpen(true);
                                                },
                                                style: {
                                                    position: "relative",
                                                    cursor: "pointer"
                                                },
                                                children: [
                                                    hasActiveFilters() ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: filter_icon,
                                                        alt: "Filter Icon",
                                                        width: 24,
                                                        height: 24
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                        width: "24",
                                                        height: "24",
                                                        viewBox: "0 0 24 24",
                                                        fill: "none",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M4 10C4 10.5304 4.21071 11.0391 4.58579 11.4142C4.96086 11.7893 5.46957 12 6 12C6.53043 12 7.03914 11.7893 7.41421 11.4142C7.78929 11.0391 8 10.5304 8 10C8 9.46957 7.78929 8.96086 7.41421 8.58579C7.03914 8.21071 6.53043 8 6 8C5.46957 8 4.96086 8.21071 4.58579 8.58579C4.21071 8.96086 4 9.46957 4 10Z",
                                                                stroke: "white",
                                                                strokeWidth: "2",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M6 4V8",
                                                                stroke: "white",
                                                                strokeWidth: "2",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M6 12V20",
                                                                stroke: "white",
                                                                strokeWidth: "2",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M10 16C10 16.5304 10.2107 17.0391 10.5858 17.4142C10.9609 17.7893 11.4696 18 12 18C12.5304 18 13.0391 17.7893 13.4142 17.4142C13.7893 17.0391 14 16.5304 14 16C14 15.4696 13.7893 14.9609 13.4142 14.5858C13.0391 14.2107 12.5304 14 12 14C11.4696 14 10.9609 14.2107 10.5858 14.5858C10.2107 14.9609 10 15.4696 10 16Z",
                                                                stroke: "white",
                                                                strokeWidth: "2",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M12 4V14",
                                                                stroke: "white",
                                                                strokeWidth: "2",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M12 18V20",
                                                                stroke: "white",
                                                                strokeWidth: "2",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M16 7C16 7.53043 16.2107 8.03914 16.5858 8.41421C16.9609 8.78929 17.4696 9 18 9C18.5304 9 19.0391 8.78929 19.4142 8.41421C19.7893 8.03914 20 7.53043 20 7C20 6.46957 19.7893 5.96086 19.4142 5.58579C19.0391 5.21071 18.5304 5 18 5C17.4696 5 16.9609 5.21071 16.5858 5.58579C16.2107 5.96086 16 6.46957 16 7Z",
                                                                stroke: "white",
                                                                strokeWidth: "2",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M18 4V5",
                                                                stroke: "white",
                                                                strokeWidth: "2",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M18 9V20",
                                                                stroke: "white",
                                                                strokeWidth: "2",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round"
                                                            })
                                                        ]
                                                    }),
                                                    "Filter"
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (shap_of_you_module_default()).cartIcon,
                                            style: {
                                                position: "relative",
                                                cursor: "pointer"
                                            },
                                            onClick: function() {
                                                return setIsCartOpen(true);
                                            },
                                            children: [
                                                "Cart",
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                    width: "24",
                                                    height: "24",
                                                    viewBox: "0 0 24 24",
                                                    fill: "none",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M4 19C4 19.5304 4.21071 20.0391 4.58579 20.4142C4.96086 20.7893 5.46957 21 6 21C6.53043 21 7.03914 20.7893 7.41421 20.4142C7.78929 20.0391 8 19.5304 8 19C8 18.4696 7.78929 17.9609 7.41421 17.5858C7.03914 17.2107 6.53043 17 6 17C5.46957 17 4.96086 17.2107 4.58579 17.5858C4.21071 17.9609 4 18.4696 4 19Z",
                                                            stroke: "#262121",
                                                            strokeWidth: "2",
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M15 19C15 19.5304 15.2107 20.0391 15.5858 20.4142C15.9609 20.7893 16.4696 21 17 21C17.5304 21 18.0391 20.7893 18.4142 20.4142C18.7893 20.0391 19 19.5304 19 19C19 18.4696 18.7893 17.9609 18.4142 17.5858C18.0391 17.2107 17.5304 17 17 17C16.4696 17 15.9609 17.2107 15.5858 17.5858C15.2107 17.9609 15 18.4696 15 19Z",
                                                            stroke: "#262121",
                                                            strokeWidth: "2",
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M17 17H6V3H4",
                                                            stroke: "#262121",
                                                            strokeWidth: "2",
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M6 5L20 6L19 13H6",
                                                            stroke: "#262121",
                                                            strokeWidth: "2",
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round"
                                                        })
                                                    ]
                                                }),
                                                !!cartState.items.length && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    style: {
                                                        position: "absolute",
                                                        top: "7px",
                                                        right: "29px",
                                                        background: "#c91723",
                                                        color: "white",
                                                        borderRadius: "50%",
                                                        width: "20px",
                                                        height: "20px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        fontSize: "12px",
                                                        fontWeight: "600"
                                                    },
                                                    children: cartState.items.length
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        !isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            onClick: function() {
                                return setIsPanelExpanded(!isPanelExpanded);
                            },
                            style: {
                                position: "absolute",
                                bottom: isPanelExpanded ? "230px" : "20px",
                                left: "50%",
                                transform: "translateX(-50%)",
                                cursor: "pointer",
                                zIndex: 10,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                transition: "bottom 0.4s ease"
                            },
                            children: isPanelExpanded ? // Down arrow (expanded → click to collapse)
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                width: "173",
                                height: "36",
                                viewBox: "0 0 173 36",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("foreignObject", {
                                        x: "-6",
                                        y: "-5.99998",
                                        width: "185",
                                        height: "48",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            style: {
                                                backdropFilter: "blur(3px)",
                                                clipPath: "url(#bgblur_pv_expand_clip)",
                                                height: "100%",
                                                width: "100%"
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                        "data-figma-bg-blur-radius": "6",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M92.4653 20L86.4998 24L80.5343 20",
                                                stroke: "white",
                                                strokeOpacity: "0.31",
                                                strokeWidth: "3",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M93.957 13.25L86.5001 18.25L79.0432 13.25",
                                                stroke: "white",
                                                strokeWidth: "3",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                                            id: "bgblur_pv_expand_clip",
                                            transform: "translate(6 5.99998)",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M173 24C173 30.6274 167.627 36 161 36L12 36C5.37259 36 4.69686e-07 30.6274 1.04907e-06 24L2.09815e-06 12C2.67753e-06 5.37258 5.37259 4.69686e-07 12 1.04907e-06L161 1.40751e-05C167.627 1.46545e-05 173 5.3726 173 12L173 24Z"
                                            })
                                        })
                                    })
                                ]
                            }) : // Up arrow (collapsed → click to expand)
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                width: "24",
                                height: "20",
                                viewBox: "0 0 18 14",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M2.96094 5.5L8.80471 1.5L14.6485 5.5",
                                        stroke: "white",
                                        strokeOpacity: "0.31",
                                        strokeWidth: "3",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M1.5 12.25L8.80471 7.25L16.1094 12.25",
                                        stroke: "white",
                                        strokeWidth: "3",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round"
                                    })
                                ]
                            })
                        }),
                        !isOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (shap_of_you_module_default()).priceRow,
                            style: {
                                transition: "opacity 0.4s ease, transform 0.4s ease",
                                opacity: isPanelExpanded ? 1 : 0,
                                transform: isPanelExpanded ? "translateY(0)" : "translateY(20px)",
                                pointerEvents: isPanelExpanded ? "auto" : "none"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (shap_of_you_module_default()).price,
                                    children: [
                                        "₹",
                                        selectedProduct ? ((selectedProduct === null || selectedProduct === void 0 ? void 0 : (ref1 = selectedProduct.discount) === null || ref1 === void 0 ? void 0 : ref1.total) || selectedProduct.price || 0).toLocaleString("en-IN") : "0"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (shap_of_you_module_default()).details_open,
                                    onClick: function() {
                                        return selectedProduct && setIsOpen(true);
                                    },
                                    style: {
                                        cursor: "pointer"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                            width: "20",
                                            height: "20",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M12 9H12.01",
                                                    stroke: "white",
                                                    strokeWidth: "2",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M11 12H12V16H13",
                                                    stroke: "white",
                                                    strokeWidth: "2",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M12 3C19.2 3 21 4.8 21 12C21 19.2 19.2 21 12 21C4.8 21 3 19.2 3 12C3 4.8 4.8 3 12 3Z",
                                                    stroke: "white",
                                                    strokeWidth: "2",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round"
                                                })
                                            ]
                                        }),
                                        "Details"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (shap_of_you_module_default()).thumbnailRow,
                            style: {
                                transition: "opacity 0.4s ease, transform 0.4s ease",
                                opacity: isPanelExpanded ? 1 : 0,
                                transform: isPanelExpanded ? "translateY(0)" : "translateY(20px)",
                                pointerEvents: isPanelExpanded ? "auto" : "none"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (shap_of_you_module_default()).thumbnailRow_container,
                                children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        textAlign: "center",
                                        padding: "20px"
                                    }
                                }) : products.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                                    onSwiper: function(swiper) {
                                        swiperRef.current = swiper;
                                    },
                                    slidesPerView: 5,
                                    centeredSlides: true,
                                    loop: products.length > 5,
                                    spaceBetween: 10,
                                    pagination: {
                                        clickable: true
                                    },
                                    modules: [
                                        swiper_esm/* Pagination */.tl
                                    ],
                                    className: (shap_of_you_module_default()).mySwiper,
                                    children: products.map(function(product, index) {
                                        var productId = String(product.sku);
                                        var isSelected = String(selected) === productId || String(selected) === String(product.id) || String(selected) === String(product.product_id);
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat((shap_of_you_module_default()).slide, " ").concat(isSelected ? (shap_of_you_module_default()).selected : ""),
                                                onClick: function() {
                                                    return handleProductSelect(product, productId, index);
                                                },
                                                style: {
                                                    cursor: "pointer"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: getImageSrc(product),
                                                    alt: product.name || "Product",
                                                    width: 80,
                                                    height: 80,
                                                    onError: function(e) {
                                                        var target = e.target;
                                                        target.src = nekl_s/* default.src */.Z.src;
                                                    }
                                                })
                                            })
                                        }, productId);
                                    })
                                }, activeCategory) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        textAlign: "center",
                                        padding: "20px",
                                        color: "#fff"
                                    },
                                    children: "No products available"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (shap_of_you_module_default()).categoryTabs,
                            style: {
                                transition: "opacity 0.4s ease, transform 0.4s ease",
                                opacity: isPanelExpanded ? 1 : 0,
                                transform: isPanelExpanded ? "translateY(0)" : "translateY(20px)",
                                pointerEvents: isPanelExpanded ? "auto" : "none"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (shap_of_you_module_default()).tabs,
                                children: [
                                    availableCategories.includes("Earring") && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "".concat((shap_of_you_module_default()).tab, " ").concat(activeCategory === "Earring" ? (shap_of_you_module_default()).active : ""),
                                        onClick: function() {
                                            return handleCategoryClick("Earring");
                                        },
                                        children: "Earrings"
                                    }),
                                    availableCategories.includes("Necklace") && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "".concat((shap_of_you_module_default()).tab, " ").concat(activeCategory === "Necklace" ? (shap_of_you_module_default()).active : ""),
                                        onClick: function() {
                                            return handleCategoryClick("Necklace");
                                        },
                                        children: "Necklace"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (shap_of_you_module_default()).bottomBar,
                            style: {
                                transition: "opacity 0.4s ease, transform 0.4s ease",
                                opacity: isPanelExpanded ? 1 : 0,
                                transform: isPanelExpanded ? "translateY(0)" : "translateY(20px)",
                                pointerEvents: isPanelExpanded ? "auto" : "none"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (shap_of_you_module_default()).share,
                                    onClick: function() {
                                        return navigateToStep("shareView");
                                    },
                                    style: {
                                        cursor: "pointer"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                        width: "18",
                                        height: "16",
                                        viewBox: "0 0 18 16",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M10.0002 0V4C3.42519 5.028 0.980188 10.788 0.000188363 16C-0.0368116 16.206 5.38419 10.038 10.0002 10V14L18.0002 7L10.0002 0Z",
                                            fill: "white"
                                        })
                                    })
                                }),
                                showAddedSuccess ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    className: (shap_of_you_module_default()).cartBtn,
                                    disabled: true,
                                    style: {
                                        backgroundColor: "#28a745",
                                        cursor: "not-allowed",
                                        whiteSpace: "nowrap"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            width: "24",
                                            height: "24",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M20 6L9 17L4 12",
                                                stroke: "white",
                                                strokeWidth: "2",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            })
                                        }),
                                        " ",
                                        "Added Successfully"
                                    ]
                                }) : cartItem ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: (shap_of_you_module_default()).cartBtn,
                                    disabled: true,
                                    style: {
                                        backgroundColor: "#22c55e",
                                        cursor: "default"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        style: {
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            gap: "8px",
                                            whiteSpace: "nowrap"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                width: "24",
                                                height: "24",
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M20 6L9 17L4 12",
                                                    stroke: "white",
                                                    strokeWidth: "2",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round"
                                                })
                                            }),
                                            "Added To Cart"
                                        ]
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: (shap_of_you_module_default()).cartBtn,
                                    onClick: function() {
                                        return addToCart(false);
                                    },
                                    disabled: cartActionLoading || !selectedProduct,
                                    style: {
                                        backgroundColor: cartActionLoading ? "#999" : undefined,
                                        cursor: cartActionLoading || !selectedProduct ? "not-allowed" : "pointer"
                                    },
                                    children: cartActionLoading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                                                animation: "border",
                                                size: "sm",
                                                className: "me-2"
                                            }),
                                            "Adding..."
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                width: "24",
                                                height: "24",
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M4 19C4 19.5304 4.21071 20.0391 4.58579 20.4142C4.96086 20.7893 5.46957 21 6 21C6.53043 21 7.03914 20.7893 7.41421 20.4142C7.78929 20.0391 8 19.5304 8 19C8 18.4696 7.78929 17.9609 7.41421 17.5858C7.03914 17.2107 6.53043 17 6 17C5.46957 17 4.96086 17.2107 4.58579 17.5858C4.21071 17.9609 4 18.4696 4 19Z",
                                                        stroke: "white",
                                                        strokeWidth: "2",
                                                        strokeLinecap: "round",
                                                        strokeLinejoin: "round"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M12.5 17H6V3H4",
                                                        stroke: "white",
                                                        strokeWidth: "2",
                                                        strokeLinecap: "round",
                                                        strokeLinejoin: "round"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M6 5L20 6L19.14 12.017M16.5 13H6",
                                                        stroke: "white",
                                                        strokeWidth: "2",
                                                        strokeLinecap: "round",
                                                        strokeLinejoin: "round"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M16 19H22",
                                                        stroke: "white",
                                                        strokeWidth: "2",
                                                        strokeLinecap: "round",
                                                        strokeLinejoin: "round"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M19 16V22",
                                                        stroke: "white",
                                                        strokeWidth: "2",
                                                        strokeLinecap: "round",
                                                        strokeLinejoin: "round"
                                                    })
                                                ]
                                            }),
                                            " ",
                                            "Add to Cart"
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(shape_of_you_desktop_new_ProductDetailsModal, {
                isOpen: isOpen,
                setIsOpen: setIsOpen,
                selectedProduct: selectedProduct,
                getImageSrc: getImageSrc,
                cartItem: cartItem,
                showAddedSuccess: showAddedSuccess,
                cartActionLoading: cartActionLoading,
                addToCart: addToCart,
                removeFromCart: removeFromCart
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(shape_of_you_desktop_new_FilterModal, {
                isOpen: isFilterOpen,
                setIsOpen: setIsFilterOpen,
                filter: filter,
                setFilter: setFilter,
                activeCategory: activeCategory
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(shape_of_you_desktop_new_CartModal, {
                isOpen: isCartOpen,
                setIsOpen: setIsCartOpen
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(shape_of_you_desktop_new_LiveCameraPermissionModal, {
                show: showCameraPermissionModal,
                onHide: function() {
                    return setShowCameraPermissionModal(false);
                },
                onPermissionGranted: handleCameraPermissionAllowed,
                onPermissionDenied: handleCameraPermissionDenied,
                logStep: logStep
            })
        ]
    });
};
/* harmony default export */ var shape_of_you_desktop_new_ProductViewScreen = (ProductViewScreen_ProductViewScreen);

;// CONCATENATED MODULE: ./src/components/shape-of-you-desktop-new/FilterViewScreen.tsx







var FilterViewScreen_FilterViewScreen = function(param) {
    var navigateToStep = param.navigateToStep, filter = param.filter, setFilter = param.setFilter, activeTab = param.activeTab;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var ref8 = (0,react.useState)("Price"), selectedTab = ref8[0], setSelectedTab = ref8[1];
    var ref9 = (0,react.useState)({
        metal: [],
        occasions: [],
        priceRange: null,
        priceMin: null,
        priceMax: null
    }), filterSheet = ref9[0], setFilterSheet = ref9[1];
    var categoryState = (0,es/* useSelector */.v9)(function(state) {
        return state.category;
    });
    // Price options matching Product.tsx
    var priceOptions = [
        {
            label: "Below ₹ 10,000",
            min: null,
            max: 10000
        },
        {
            label: "₹ 10,000 – ₹ 20,000",
            min: 10000,
            max: 20000
        },
        {
            label: "₹ 30,000 – ₹ 40,000",
            min: 30000,
            max: 40000
        },
        {
            label: "₹ 40,000 – ₹ 50,000",
            min: 40000,
            max: 50000
        },
        {
            label: "₹ 50,000 – ₹ 1,00,000",
            min: 50000,
            max: 100000
        }, 
    ];
    // Sync filterSheet with filter when component mounts or filter changes
    (0,react.useEffect)(function() {
        setFilterSheet({
            metal: filter.metal || [],
            occasions: filter.occasions || [],
            priceRange: filter.priceRange || null,
            priceMin: filter.priceMin || null,
            priceMax: filter.priceMax || null
        });
    }, [
        filter
    ]);
    // Handle filter changes in the sheet (temporary state)
    var handleSheetFilterChange = function(filterType, value) {
        setFilterSheet(function(prev) {
            if (filterType === "price") {
                var _Math, _Math1;
                var label = value.label;
                var currentSelected = prev.priceRange ? prev.priceRange.split("|") : [];
                var newSelected = currentSelected.includes(label) ? currentSelected.filter(function(r) {
                    return r !== label;
                }) : (0,_to_consumable_array/* default */.Z)(currentSelected).concat([
                    label
                ]);
                // Compute merged min/max from all selected ranges
                var selectedOptions = priceOptions.filter(function(opt) {
                    return newSelected.includes(opt.label);
                });
                var hasNullMin = selectedOptions.some(function(opt) {
                    return opt.min === null;
                });
                var mins = selectedOptions.map(function(opt) {
                    return opt.min;
                }).filter(function(m) {
                    return m !== null;
                });
                var maxes = selectedOptions.map(function(opt) {
                    return opt.max;
                });
                var priceMin = selectedOptions.length === 0 ? null : hasNullMin ? null : mins.length > 0 ? (_Math = Math).min.apply(_Math, (0,_to_consumable_array/* default */.Z)(mins)) : null;
                var priceMax = maxes.length > 0 ? (_Math1 = Math).max.apply(_Math1, (0,_to_consumable_array/* default */.Z)(maxes)) : null;
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                    priceRange: newSelected.length > 0 ? newSelected.join("|") : null,
                    priceMin: priceMin,
                    priceMax: priceMax
                });
            } else if (filterType === "metal") {
                // For purity filter
                var metals = (prev === null || prev === void 0 ? void 0 : prev.metal) || [];
                if (metals.includes(value)) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                        metal: metals.filter(function(m) {
                            return m !== value;
                        })
                    });
                } else {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                        metal: (0,_to_consumable_array/* default */.Z)(metals).concat([
                            value
                        ])
                    });
                }
            } else if (filterType === "occasion") {
                // For occasion filter
                var occasions = (prev === null || prev === void 0 ? void 0 : prev.occasions) || [];
                if (occasions.includes(value)) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                        occasions: occasions.filter(function(m) {
                            return m !== value;
                        })
                    });
                } else {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                        occasions: (0,_to_consumable_array/* default */.Z)(occasions).concat([
                            value
                        ])
                    });
                }
            }
            return prev;
        });
    };
    // Apply filters and navigate back
    var handleApplyFilter = function() {
        setFilter(filterSheet);
        navigateToStep("productView");
    };
    // Clear all filters
    var handleClearFilters = function() {
        var clearedSheet = {
            metal: [],
            occasions: [],
            priceRange: null,
            priceMin: null,
            priceMax: null
        };
        setFilterSheet(clearedSheet);
    };
    var handleBackToProduct = function() {
        navigateToStep("productView");
    };
    // Check icon component
    var CheckIcon = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            width: "12",
            height: "12",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20 6L9 17L4 12",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "d-none d-md-block w-100",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (shap_of_you_module_default()).filterWrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "d-none d-md-block w-100",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (shap_of_you_module_default()).header,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                children: [
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (shap_of_you_module_default()).backArrow,
                                        onClick: handleBackToProduct,
                                        children: "←"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                        style: {
                                            margin: "0 10px"
                                        },
                                        width: "30",
                                        height: "30",
                                        viewBox: "0 0 36 36",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M6 15C6 15.7956 6.31607 16.5587 6.87868 17.1213C7.44129 17.6839 8.20435 18 9 18C9.79565 18 10.5587 17.6839 11.1213 17.1213C11.6839 16.5587 12 15.7956 12 15C12 14.2044 11.6839 13.4413 11.1213 12.8787C10.5587 12.3161 9.79565 12 9 12C8.20435 12 7.44129 12.3161 6.87868 12.8787C6.31607 13.4413 6 14.2044 6 15Z",
                                                stroke: "#262121",
                                                strokeWidth: "3",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M9 6V12",
                                                stroke: "#262121",
                                                strokeWidth: "3",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M9 18V30",
                                                stroke: "#262121",
                                                strokeWidth: "3",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M15 24C15 24.7956 15.3161 25.5587 15.8787 26.1213C16.4413 26.6839 17.2044 27 18 27C18.7956 27 19.5587 26.6839 20.1213 26.1213C20.6839 25.5587 21 24.7956 21 24C21 23.2044 20.6839 22.4413 20.1213 21.8787C19.5587 21.3161 18.7956 21 18 21C17.2044 21 16.4413 21.3161 15.8787 21.8787C15.3161 22.4413 15 23.2044 15 24Z",
                                                stroke: "#262121",
                                                strokeWidth: "3",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M18 6V21",
                                                stroke: "#262121",
                                                strokeWidth: "3",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M18 27V30",
                                                stroke: "#262121",
                                                strokeWidth: "3",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M24 10.5C24 11.2956 24.3161 12.0587 24.8787 12.6213C25.4413 13.1839 26.2044 13.5 27 13.5C27.7956 13.5 28.5587 13.1839 29.1213 12.6213C29.6839 12.0587 30 11.2956 30 10.5C30 9.70435 29.6839 8.94129 29.1213 8.37868C28.5587 7.81607 27.7956 7.5 27 7.5C26.2044 7.5 25.4413 7.81607 24.8787 8.37868C24.3161 8.94129 24 9.70435 24 10.5Z",
                                                stroke: "#262121",
                                                strokeWidth: "3",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M27 6V7.5",
                                                stroke: "#262121",
                                                strokeWidth: "3",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M27 13.5V30",
                                                stroke: "#262121",
                                                strokeWidth: "3",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            })
                                        ]
                                    }),
                                    "Filter By"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (shap_of_you_module_default()).tabs,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: "".concat((shap_of_you_module_default()).tab, " ").concat(selectedTab === "Price" ? (shap_of_you_module_default()).active : ""),
                                    onClick: function() {
                                        return setSelectedTab("Price");
                                    },
                                    children: "Price"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: "".concat((shap_of_you_module_default()).tab, " ").concat(selectedTab === "Purity" ? (shap_of_you_module_default()).active : ""),
                                    onClick: function() {
                                        return setSelectedTab("Purity");
                                    },
                                    children: "Purity"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: "".concat((shap_of_you_module_default()).tab, " ").concat(selectedTab === "Occassion" ? (shap_of_you_module_default()).active : ""),
                                    onClick: function() {
                                        return setSelectedTab("Occassion");
                                    },
                                    children: "Occassion"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (shap_of_you_module_default()).content,
                            children: [
                                selectedTab === "Price" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (shap_of_you_module_default()).options,
                                    children: priceOptions.map(function(option) {
                                        var selectedRanges = (filterSheet === null || filterSheet === void 0 ? void 0 : filterSheet.priceRange) ? filterSheet.priceRange.split("|") : [];
                                        var isChecked = selectedRanges.includes(option.label);
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                            className: (shap_of_you_module_default()).optionItem,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    style: {
                                                        fontWeight: isChecked ? "bold" : "normal"
                                                    },
                                                    children: option.label
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "checkbox",
                                                    name: "price",
                                                    checked: isChecked,
                                                    onChange: function() {
                                                        return handleSheetFilterChange("price", option);
                                                    },
                                                    style: {
                                                        display: "none"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (shap_of_you_module_default()).checkbox,
                                                    style: {
                                                        borderRadius: "50%",
                                                        border: "1px solid #ccc",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        width: "16px",
                                                        height: "16px"
                                                    },
                                                    children: isChecked && /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckIcon, {})
                                                })
                                            ]
                                        }, option.label);
                                    })
                                }),
                                selectedTab === "Purity" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (shap_of_you_module_default()).options,
                                    children: [
                                        (ref = categoryState.similarFilters) === null || ref === void 0 ? void 0 : (ref1 = ref.purities) === null || ref1 === void 0 ? void 0 : ref1.map(function(purity, index) {
                                            var ref;
                                            var isChecked = (filterSheet === null || filterSheet === void 0 ? void 0 : (ref = filterSheet.metal) === null || ref === void 0 ? void 0 : ref.includes(purity)) || false;
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                className: (shap_of_you_module_default()).optionItem,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        style: {
                                                            fontWeight: isChecked ? "bold" : "normal"
                                                        },
                                                        children: purity
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        type: "checkbox",
                                                        name: "purity",
                                                        checked: isChecked,
                                                        onChange: function() {
                                                            return handleSheetFilterChange("metal", purity);
                                                        },
                                                        style: {
                                                            display: "none"
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (shap_of_you_module_default()).checkbox,
                                                        style: {
                                                            borderRadius: "50%",
                                                            border: "1px solid #ccc",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            width: "16px",
                                                            height: "16px"
                                                        },
                                                        children: isChecked && /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckIcon, {})
                                                    })
                                                ]
                                            }, index);
                                        }),
                                        (!((ref2 = categoryState.similarFilters) === null || ref2 === void 0 ? void 0 : ref2.purities) || ((ref3 = categoryState.similarFilters) === null || ref3 === void 0 ? void 0 : ref3.purities.length) === 0) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (shap_of_you_module_default()).placeholder,
                                            children: [
                                                "No purity options available for ",
                                                activeTab
                                            ]
                                        })
                                    ]
                                }),
                                selectedTab === "Occassion" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (shap_of_you_module_default()).options,
                                    children: [
                                        (ref4 = categoryState.similarFilters) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.occasions) === null || ref5 === void 0 ? void 0 : ref5.map(function(occasion, index) {
                                            var ref;
                                            var isChecked = (filterSheet === null || filterSheet === void 0 ? void 0 : (ref = filterSheet.occasions) === null || ref === void 0 ? void 0 : ref.includes(occasion.name)) || false;
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                className: (shap_of_you_module_default()).optionItem,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        style: {
                                                            fontWeight: isChecked ? "bold" : "normal"
                                                        },
                                                        children: occasion.name
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        type: "checkbox",
                                                        name: "occasion",
                                                        checked: isChecked,
                                                        onChange: function() {
                                                            return handleSheetFilterChange("occasion", occasion.name);
                                                        },
                                                        style: {
                                                            display: "none"
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (shap_of_you_module_default()).checkbox,
                                                        style: {
                                                            borderRadius: "50%",
                                                            border: "1px solid #ccc",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            width: "16px",
                                                            height: "16px"
                                                        },
                                                        children: isChecked && /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckIcon, {})
                                                    })
                                                ]
                                            }, index);
                                        }),
                                        (!((ref6 = categoryState.similarFilters) === null || ref6 === void 0 ? void 0 : ref6.occasions) || ((ref7 = categoryState.similarFilters) === null || ref7 === void 0 ? void 0 : ref7.occasions.length) === 0) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (shap_of_you_module_default()).placeholder,
                                            children: [
                                                "No occasion options available for ",
                                                activeTab
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (shap_of_you_module_default()).footer,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: (shap_of_you_module_default()).clearBtn,
                            onClick: handleClearFilters,
                            children: "Clear Selection"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            className: (shap_of_you_module_default()).applyBtn,
                            onClick: handleApplyFilter,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                    style: {
                                        marginRight: "10px"
                                    },
                                    width: "17",
                                    height: "13",
                                    viewBox: "0 0 17 13",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M16.2637 1.41406L6.36328 11.3135L0.707031 5.65625L1.41406 4.94922L6.36426 9.89941L15.5566 0.707031L16.2637 1.41406Z",
                                        fill: "#262121",
                                        stroke: "white"
                                    })
                                }),
                                "Apply"
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var shape_of_you_desktop_new_FilterViewScreen = (FilterViewScreen_FilterViewScreen);

;// CONCATENATED MODULE: ./src/components/shape-of-you-desktop-new/ShareViewScreen.tsx









var ShareViewScreen_ShareViewScreen = function(param) {
    var navigateToStep = param.navigateToStep, virtualTryOnImage = param.virtualTryOnImage, capturedImage = param.capturedImage, logStep = param.logStep;
    // Determine which image to display (same priority as mobile)
    // Priority: virtualTryOnImage (with jewelry) > capturedImage (original) > default
    var displayImage = virtualTryOnImage || capturedImage || SharePage/* default */.Z;
    var isBase64 = typeof displayImage === "string" && displayImage.startsWith("data:");
    // Composite the user photo with both logos using Canvas
    var compositeImageWithLogos = function(imageUrl) {
        return new Promise(function(resolve, reject) {
            var canvas = document.createElement("canvas");
            var ctx = canvas.getContext("2d");
            if (!ctx) return reject(new Error("Canvas not supported"));
            var mainImg = new window.Image();
            mainImg.crossOrigin = "anonymous";
            mainImg.onload = function() {
                canvas.width = mainImg.width;
                canvas.height = mainImg.height;
                ctx.drawImage(mainImg, 0, 0);
                var padding = canvas.width * 0.03;
                var logoHeight = canvas.height * 0.08;
                var shapeImg = new window.Image();
                shapeImg.crossOrigin = "anonymous";
                shapeImg.onload = function() {
                    // Draw Shape of You logo — bottom-left
                    var shapeW = shapeImg.width / shapeImg.height * logoHeight;
                    ctx.drawImage(shapeImg, padding, canvas.height - logoHeight - padding, shapeW, logoHeight);
                    // Draw text — bottom-right
                    var fontSize = Math.max(12, canvas.height * 0.022);
                    ctx.font = "".concat(fontSize, "px sans-serif");
                    ctx.fillStyle = "#ffffff";
                    ctx.textAlign = "right";
                    ctx.shadowColor = "rgba(0,0,0,0.6)";
                    ctx.shadowBlur = 4;
                    var line1 = "Shop jewellery made for your face shape";
                    var line2 = "www.sencogoldanddiamonds.com";
                    var lineSpacing = fontSize * 1.4;
                    var textX = canvas.width - padding;
                    var textY = canvas.height - padding - lineSpacing;
                    ctx.fillText(line1, textX, textY);
                    ctx.fillText(line2, textX, textY + lineSpacing);
                    ctx.shadowBlur = 0;
                    resolve(canvas.toDataURL("image/jpeg", 0.92));
                };
                shapeImg.onerror = function() {
                    return resolve(canvas.toDataURL("image/jpeg", 0.92));
                };
                var _src;
                shapeImg.src = (_src = logo_left.src) !== null && _src !== void 0 ? _src : logo_left;
            };
            mainImg.onerror = reject;
            mainImg.src = imageUrl;
        });
    };
    // Handle download functionality
    var handleDownload = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var downloadImage, composited, link;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        downloadImage = virtualTryOnImage || capturedImage;
                        if (downloadImage) {
                            _ctx.next = 5;
                            break;
                        }
                        react_toastify_esm/* toast.error */.Am.error("No image available to download");
                        return _ctx.abrupt("return");
                    case 5:
                        _ctx.next = 7;
                        return compositeImageWithLogos(downloadImage);
                    case 7:
                        composited = _ctx.sent;
                        link = document.createElement("a");
                        link.href = composited;
                        link.download = "senco-jewelry-tryon.jpg";
                        link.style.display = "none";
                        document.body.appendChild(link);
                        link.click();
                        setTimeout(function() {
                            return document.body.removeChild(link);
                        }, 100);
                        if (logStep) logStep("share_view_download_clicked");
                        react_toastify_esm/* toast.success */.Am.success("Image downloaded successfully");
                        _ctx.next = 23;
                        break;
                    case 19:
                        _ctx.prev = 19;
                        _ctx.t0 = _ctx["catch"](0);
                        ;
                        react_toastify_esm/* toast.error */.Am.error("Failed to download image. Please try again.");
                    case 23:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    19
                ]
            ]);
        }));
        return function handleDownload() {
            return _ref.apply(this, arguments);
        };
    }();
    // Handle share functionality
    var handleShare = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var composited, base64Response, blob, file, link;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        if (isBase64) {
                            _ctx.next = 4;
                            break;
                        }
                        react_toastify_esm/* toast.error */.Am.error("No image available to share");
                        return _ctx.abrupt("return");
                    case 4:
                        _ctx.next = 6;
                        return compositeImageWithLogos(displayImage);
                    case 6:
                        composited = _ctx.sent;
                        _ctx.next = 9;
                        return fetch(composited);
                    case 9:
                        base64Response = _ctx.sent;
                        _ctx.next = 12;
                        return base64Response.blob();
                    case 12:
                        blob = _ctx.sent;
                        file = new File([
                            blob
                        ], "senco-jewelry-tryon.jpg", {
                            type: "image/jpeg"
                        });
                        if (!("share" in navigator && "canShare" in navigator && navigator.canShare({
                            files: [
                                file
                            ]
                        }))) {
                            _ctx.next = 19;
                            break;
                        }
                        _ctx.next = 17;
                        return navigator.share({
                            title: "My Senco Jewellery Look",
                            text: "Check out how I look with Senco Jewellery! They suggested pieces based on my face shape —https://sencogoldanddiamonds.com/shape-of-you you should try this too!",
                            files: [
                                file
                            ]
                        });
                    case 17:
                        _ctx.next = 25;
                        break;
                    case 19:
                        if (!("share" in navigator)) {
                            _ctx.next = 24;
                            break;
                        }
                        _ctx.next = 22;
                        return navigator.share({
                            title: "My Senco Jewellery Look",
                            text: "Check out how I look with Senco Jewellery! They suggested pieces based on my face shape —https://sencogoldanddiamonds.com/shape-of-you you should try this too!",
                            url: window.location.href
                        });
                    case 22:
                        _ctx.next = 25;
                        break;
                    case 24:
                        {
                            link = document.createElement("a");
                            link.href = composited;
                            link.download = "senco-jewelry-tryon.jpg";
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                            react_toastify_esm/* toast.success */.Am.success("Image downloaded successfully");
                        }
                    case 25:
                        _ctx.next = 30;
                        break;
                    case 27:
                        _ctx.prev = 27;
                        _ctx.t0 = _ctx["catch"](0);
                        if (_ctx.t0.name !== "AbortError") {
                            ;
                            react_toastify_esm/* toast.error */.Am.error("Failed to share. Please try again.");
                        }
                    case 30:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    27
                ]
            ]);
        }));
        return function handleShare() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "d-none d-md-block w-100",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (shap_of_you_module_default()).SharePage_desktop,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (shap_of_you_module_default()).bgImage,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (shap_of_you_module_default()).image_center,
                        children: virtualTryOnImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: virtualTryOnImage,
                            alt: "Virtual Try On"
                        }) : capturedImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: capturedImage,
                            alt: "Captured Face"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: SharePage/* default */.Z,
                            alt: "Share Page"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (shap_of_you_module_default()).shapeOfYou,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: (shap_of_you_module_default()).dwn,
                            onClick: handleDownload,
                            style: {
                                cursor: "pointer"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                className: "bi bi-download"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: (shap_of_you_module_default()).back_arrow,
                            onClick: function() {
                                if (logStep) {
                                    logStep("share_view_back_clicked");
                                }
                                navigateToStep("productView");
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                className: "bi bi-arrow-left"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (shap_of_you_module_default()).bottom_container,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (shap_of_you_module_default()).logo_left,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: logo_left,
                                        alt: ""
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (shap_of_you_module_default()).text_right,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        children: [
                                            "Shop jewellery made for your face shape ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "https://sencogoldanddiamonds.com/",
                                                children: "www.sencogoldanddiamonds.com"
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (shap_of_you_module_default()).container_btn,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    className: (shap_of_you_module_default()).editNumber,
                                    onClick: function() {
                                        if (logStep) {
                                            logStep("share_view_retake_clicked");
                                        }
                                        navigateToStep("uploadOrScan");
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            className: "mx-1",
                                            width: "18",
                                            height: "18",
                                            viewBox: "0 0 36 36",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M8.19386 6.64893C10.8233 4.37532 14.251 3 18 3C26.2842 3 33 9.71572 33 18C33 21.2041 31.9953 24.1737 30.2838 26.6109L25.5 18H30C30 11.3726 24.6275 6 18 6C14.7747 6 11.8467 7.2724 9.69034 9.34263L8.19386 6.64893ZM27.8061 29.3511C25.1766 31.6246 21.749 33 18 33C9.71572 33 3 26.2842 3 18C3 14.7958 4.00469 11.8262 5.7162 9.38916L10.5 18H6C6 24.6275 11.3726 30 18 30C21.2253 30 24.1533 28.7276 26.3097 26.6574L27.8061 29.3511Z",
                                                fill: "white"
                                            })
                                        }),
                                        "Retake"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    className: (shap_of_you_module_default()).submitBtn1,
                                    onClick: handleShare,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            className: "mx-1",
                                            width: "18",
                                            height: "17",
                                            viewBox: "0 0 20 18",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M11.0002 1V5C4.42519 6.028 1.98019 11.788 1.00019 17C0.963188 17.206 6.38419 11.038 11.0002 11V15L19.0002 8L11.0002 1Z",
                                                stroke: "white",
                                                strokeWidth: "2",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            })
                                        }),
                                        "Share"
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var shape_of_you_desktop_new_ShareViewScreen = (ShareViewScreen_ShareViewScreen);

;// CONCATENATED MODULE: ./src/components/shape-of-you-desktop-new/PhotoCaptureFlow.tsx














var PhotoCaptureFlow_PhotoCaptureFlow = function(param) {
    var initialStep = param.initialStep, isAuthenticated = param.isAuthenticated, onComplete = param.onComplete, onExit = param.onExit, logStep = param.logStep;
    var dispatch = (0,store/* useAppDispatch */.T)();
    // Internal state management
    var ref = (0,react.useState)(initialStep), currentStep = ref[0], setCurrentStep = ref[1];
    var ref1 = (0,react.useState)(false), isLoading = ref1[0], setIsLoading = ref1[1];
    var ref2 = (0,react.useState)(null), capturedImage = ref2[0], setCapturedImage = ref2[1];
    var ref3 = (0,react.useState)("upload"), captureMethod = ref3[0], setCaptureMethod = ref3[1];
    var ref4 = (0,react.useState)({
        faceShape: "",
        complexion: "",
        undertone: ""
    }), faceData = ref4[0], setFaceData = ref4[1];
    // Internal navigation - accepts DesktopStep for compatibility but only handles PhotoCaptureStep
    var navigateToStep = function(step) {
        var validSteps = [
            "uploadOrScan",
            "galleryPermission",
            "cameraPermission",
            "faceScanning",
            "permissionDenied",
            "imageNotPermitted",
            "faceResult", 
        ];
        if (validSteps.includes(step)) {
            setCurrentStep(step);
        } else {
            ;
        }
    };
    // Send image to API (following FaceScan pattern)
    var sendImageToAPI = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(base64Image) {
            var method, requestPayload, apiEndpoint, ref, data, ref1, ref2, errorMessage, ref3, ref4, ref5, _args = arguments;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        method = _args.length > 1 && _args[1] !== void 0 ? _args[1] : "upload";
                        setIsLoading(true);
                        requestPayload = {
                            image_data: base64Image
                        };
                        apiEndpoint = endpoints/* default.shape_of_you.profile */.Z.shape_of_you.profile();
                        _ctx.prev = 4;
                        ;
                        _ctx.next = 8;
                        return http_client/* default.post */.Z.post(apiEndpoint, requestPayload);
                    case 8:
                        data = _ctx.sent.data;
                        ;
                        // Log successful face scan with API response (non-blocking)
                        if (logStep) {
                            logStep("face_scan_uploaded", {
                                api_endpoint: apiEndpoint,
                                request_payload: {
                                    image_data: "[base64...]"
                                },
                                response_status: 200,
                                response_payload: {
                                    face_shape: data.face_shape,
                                    tone: data.tone,
                                    undertone: data.undertone
                                }
                            });
                        }
                        // Store in Redux
                        dispatch(shapeOfYou/* shapeOfYouActions.setCapturedImage */.r1.setCapturedImage(base64Image));
                        // Extract and store response data
                        setCapturedImage(base64Image);
                        setCaptureMethod(method);
                        setFaceData({
                            faceShape: ((ref = data.face_shape) === null || ref === void 0 ? void 0 : ref.label) || "",
                            complexion: (data === null || data === void 0 ? void 0 : data.tone) || "",
                            undertone: (data === null || data === void 0 ? void 0 : data.undertone) || ""
                        });
                        // Navigate to result screen
                        navigateToStep("faceResult");
                        _ctx.next = 27;
                        break;
                    case 18:
                        _ctx.prev = 18;
                        _ctx.t0 = _ctx["catch"](4);
                        ;
                        ;
                        errorMessage = ((ref1 = _ctx.t0.response) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.data) === null || ref2 === void 0 ? void 0 : ref2.message) || "Failed to analyze image";
                        // Log API error (non-blocking)
                        if (logStep) {
                            ;
                            logStep("face_scan_uploaded", {
                                api_endpoint: apiEndpoint,
                                request_payload: {
                                    image_data: "[base64...]"
                                },
                                response_status: ((ref3 = _ctx.t0.response) === null || ref3 === void 0 ? void 0 : ref3.status) || 500,
                                error_message: errorMessage,
                                error_code: ((ref4 = _ctx.t0.response) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.status) === null || ref5 === void 0 ? void 0 : ref5.toString()) || "500"
                            });
                        }
                        // For any API error, store the image and navigate to imageNotPermitted screen
                        setCapturedImage(base64Image);
                        setCaptureMethod(method);
                        navigateToStep("imageNotPermitted");
                    case 27:
                        _ctx.prev = 27;
                        setIsLoading(false);
                        return _ctx.finish(27);
                    case 30:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    4,
                    18,
                    27,
                    30
                ]
            ]);
        }));
        return function sendImageToAPI(base64Image) {
            return _ref.apply(this, arguments);
        };
    }();
    // Wrapper for upload method
    var handleUploadImage = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(base64Image) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return sendImageToAPI(base64Image, "upload");
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleUploadImage(base64Image) {
            return _ref.apply(this, arguments);
        };
    }();
    // Wrapper for scan method
    var handleScanImage = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(base64Image) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return sendImageToAPI(base64Image, "scan");
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleScanImage(base64Image) {
            return _ref.apply(this, arguments);
        };
    }();
    // Handle reupload - reset state and go back to start
    var handleReupload = function() {
        setCapturedImage(null);
        setCaptureMethod("upload");
        setFaceData({
            faceShape: "",
            complexion: "",
            undertone: ""
        });
        navigateToStep("uploadOrScan");
    };
    // Handle explore jewellery - fetch recommendations then call parent onComplete
    var handleExploreJewellery = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(!faceData.faceShape || !capturedImage)) {
                            _ctx.next = 3;
                            break;
                        }
                        react_toastify_esm/* toast.error */.Am.error("No data available");
                        return _ctx.abrupt("return");
                    case 3:
                        setIsLoading(true);
                        _ctx.prev = 4;
                        _ctx.next = 7;
                        return http_client/* default.post */.Z.post(endpoints/* default.shape_of_you.run */.Z.shape_of_you.run(), {
                            complexion: faceData.complexion,
                            face_shape: faceData.faceShape,
                            tone: faceData.undertone
                        });
                    case 7:
                        data = _ctx.sent.data;
                        ;
                        // Store recommendations in Redux
                        dispatch(shapeOfYou/* shapeOfYouActions.setRecommendations */.r1.setRecommendations(data));
                        // Call parent onComplete to navigate
                        onComplete({
                            faceShape: faceData.faceShape,
                            complexion: faceData.complexion,
                            undertone: faceData.undertone,
                            capturedImage: capturedImage
                        });
                        _ctx.next = 17;
                        break;
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](4);
                        ;
                        react_toastify_esm/* toast.error */.Am.error("Failed to get recommendations. Please try again.");
                    case 17:
                        _ctx.prev = 17;
                        setIsLoading(false);
                        return _ctx.finish(17);
                    case 20:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    4,
                    13,
                    17,
                    20
                ]
            ]);
        }));
        return function handleExploreJewellery() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            currentStep === "uploadOrScan" && /*#__PURE__*/ (0,jsx_runtime.jsx)(shape_of_you_desktop_new_UploadOrScanScreen, {
                navigateToStep: navigateToStep,
                onImageSelect: handleUploadImage,
                logStep: logStep
            }),
            currentStep === "faceScanning" && /*#__PURE__*/ (0,jsx_runtime.jsx)(shape_of_you_desktop_new_FaceScanningScreen, {
                navigateToStep: navigateToStep,
                onCapture: handleScanImage,
                logStep: logStep
            }),
            currentStep === "permissionDenied" && /*#__PURE__*/ (0,jsx_runtime.jsx)(shape_of_you_desktop_new_PermissionDeniedScreen, {
                navigateToStep: navigateToStep,
                isAuthenticated: isAuthenticated,
                onExit: onExit
            }),
            currentStep === "imageNotPermitted" && /*#__PURE__*/ (0,jsx_runtime.jsx)(shape_of_you_desktop_new_ImageNotPermittedScreen, {
                navigateToStep: navigateToStep,
                errorMessage: "No face detected in the image. Please try again with a clear photo showing your face.",
                onRetry: handleReupload,
                capturedImage: capturedImage
            }),
            currentStep === "faceResult" && /*#__PURE__*/ (0,jsx_runtime.jsx)(shape_of_you_desktop_new_FaceResultScreen, {
                navigateToStep: navigateToStep,
                isAuthenticated: isAuthenticated,
                faceShape: faceData.faceShape,
                complexion: faceData.complexion,
                capturedImage: capturedImage,
                captureMethod: captureMethod,
                onReupload: handleReupload,
                onExploreJewellery: handleExploreJewellery,
                logStep: logStep
            }),
            isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100vw",
                    height: "100vh",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "rgba(0, 0, 0, 0.7)",
                    zIndex: 9999
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        textAlign: "center",
                        color: "#fff"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "spinner-border text-light mb-3",
                            role: "status",
                            style: {
                                width: "3rem",
                                height: "3rem"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "visually-hidden",
                                children: "Analyzing image..."
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            style: {
                                fontSize: "1.2rem",
                                fontWeight: "bold"
                            },
                            children: "Analyzing your image..."
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var shape_of_you_desktop_new_PhotoCaptureFlow = (PhotoCaptureFlow_PhotoCaptureFlow);

;// CONCATENATED MODULE: ./src/components/shape-of-you-desktop-new/AuthenticationFlow.tsx





var AuthenticationFlow_AuthenticationFlow = function(param) {
    var initialStep = param.initialStep, onComplete = param.onComplete, onExit = param.onExit, logStep = param.logStep;
    // Internal state management
    var ref = (0,react.useState)(initialStep), currentStep = ref[0], setCurrentStep = ref[1];
    var ref1 = (0,react.useState)("login"), authFlow = ref1[0], setAuthFlow = ref1[1];
    var ref2 = (0,react.useState)(""), mobileNumber = ref2[0], setMobileNumber = ref2[1];
    var ref3 = (0,react.useState)(false), otpUid = ref3[0], setOtpUid = ref3[1];
    var ref4 = (0,react.useState)({
        firstName: "",
        lastName: "",
        email: "",
        mobile: "",
        pincode: ""
    }), registerData = ref4[0], setRegisterData = ref4[1];
    // Internal navigation - accepts DesktopStep for compatibility but only handles AuthStep
    var navigateToStep = function(step) {
        var validSteps = [
            "login",
            "signup",
            "verifyOtp"
        ];
        if (validSteps.includes(step)) {
            setCurrentStep(step);
        } else {
            ;
        }
    };
    // Prepare authData object for child components
    var authData = {
        authFlow: authFlow,
        setAuthFlow: setAuthFlow,
        mobileNumber: mobileNumber,
        setMobileNumber: setMobileNumber,
        otpUid: otpUid,
        setOtpUid: setOtpUid,
        registerData: registerData,
        setRegisterData: setRegisterData
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            currentStep === "login" && /*#__PURE__*/ (0,jsx_runtime.jsx)(shape_of_you_desktop_new_LoginScreen, {
                navigateToStep: navigateToStep,
                authData: authData,
                logStep: logStep
            }),
            currentStep === "signup" && /*#__PURE__*/ (0,jsx_runtime.jsx)(shape_of_you_desktop_new_SignupScreen, {
                navigateToStep: navigateToStep,
                authData: authData,
                logStep: logStep
            }),
            currentStep === "verifyOtp" && /*#__PURE__*/ (0,jsx_runtime.jsx)(shape_of_you_desktop_new_VerifyOtpScreen, {
                navigateToStep: navigateToStep,
                authData: authData,
                onAuthComplete: onComplete,
                logStep: logStep
            })
        ]
    });
};
/* harmony default export */ var shape_of_you_desktop_new_AuthenticationFlow = (AuthenticationFlow_AuthenticationFlow);

;// CONCATENATED MODULE: ./src/components/shape-of-you-desktop-new/index.ts
// Export all desktop components





















;// CONCATENATED MODULE: ./src/pages/shape-of-you.tsx
























// External function to check camera permission
var checkCameraPermission = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var status;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (true) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return", false);
                case 2:
                    _ctx.prev = 2;
                    _ctx.next = 5;
                    return navigator.permissions.query({
                        name: "camera"
                    });
                case 5:
                    status = _ctx.sent;
                    return _ctx.abrupt("return", status.state === "granted");
                case 9:
                    _ctx.prev = 9;
                    _ctx.t0 = _ctx["catch"](2);
                    ;
                    return _ctx.abrupt("return", false);
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                2,
                9
            ]
        ]);
    }));
    return function checkCameraPermission() {
        return _ref.apply(this, arguments);
    };
}();





// UUID v4 generator
var generateUUID = function() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0;
        var v = c === "x" ? r : r & 0x3 | 0x8;
        return v === null || v === void 0 ? void 0 : v.toString(16);
    });
};

// Desktop components

var ShapOfYou = function() {
    var ref;
    var ref1 = (0,react.useState)(false), showModal = ref1[0], setShowModal = ref1[1];
    var ref2 = (0,react.useState)("introSlider"), modalStep = ref2[0], setModalStep = ref2[1];
    var router = (0,next_router.useRouter)();
    var ref3 = (0,react.useState)("Necklace"), activeTab = ref3[0], setActiveTab = ref3[1];
    var ref4 = (0,react.useState)(1), selected = ref4[0], setSelected = ref4[1];
    var ref5 = (0,react.useState)("Purity"), activeFilterTab = ref5[0], setActiveFilterTab = ref5[1];
    var ref6 = (0,react.useState)("24K Yellow Gold"), selectedPurity = ref6[0], setSelectedPurity = ref6[1];
    var ref7 = (0,react.useState)(false), showFilter = ref7[0], setShowFilter = ref7[1];
    var ref8 = (0,react.useState)("₹0 – ₹10,000"), selectedPriceRange = ref8[0], setSelectedPriceRange = ref8[1];
    var ref9 = (0,react.useState)("Anniversary"), selectedOccassion = ref9[0], setSelectedOccassion = ref9[1];
    var authState = (0,es/* useSelector */.v9)(auth/* selectAuth */.Hz);
    var shapeOfYouState = (0,es/* useSelector */.v9)(shapeOfYou/* selectShapeOfYou */.Tk);
    // Filter state for mobile view
    var ref10 = (0,react.useState)({
        metal: [],
        occasions: [],
        priceRange: null,
        priceMin: null,
        priceMax: null
    }), mobileFilter = ref10[0], setMobileFilter = ref10[1];
    // Check camera permission on component mount
    var initializeCameraPermission = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var hasPermission;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return checkCameraPermission();
                    case 2:
                        hasPermission = _ctx.sent;
                        ;
                        // If permission is already granted, skip camera modal and go to faceScan
                        if (hasPermission) {
                            setModalStep("faceScan");
                        } else {
                            setModalStep("camera");
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function initializeCameraPermission() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        initializeCameraPermission();
    }, []);
    var handleCloseModal = function() {
        initializeCameraPermission();
        setShowModal(false);
    };
    var handleStartExperience = function() {
        setShowModal(true);
        setModalStep("introSlider");
    };
    var handleIntroSliderGetStarted = function() {
        setModalStep("introExperience");
    };
    var handleIntroExperienceGetStarted = function() {
        initializeCameraPermission();
    };
    // Auto-navigate to product if user is already logged in when signup step is reached
    (0,react.useEffect)(function() {
        if (modalStep === "signup" && authState.user) {
            setModalStep("product");
        }
    }, [
        modalStep,
        authState.user,
        setModalStep
    ]);
    var ref11 = (0,react.useState)(false), loading = ref11[0], setLoading = ref11[1];
    var handleScan = function() {
        setLoading(true);
        // Fake scanning
        setTimeout(function() {
            setLoading(false);
            alert("Scan Complete!");
        }, 4000);
    };
    // const [selectedTab, setSelectedTab] = useState("price");
    // const [selectedPrice, setSelectedPrice] = useState("₹0 – ₹10,000");
    // const [selectedImage, setSelectedImage] = useState("necklace");
    // const [activeCategory, setActiveCategory] = useState("Necklace");
    // Mobile flow state management
    var ref12 = (0,react.useState)("splash"), mobileStep = ref12[0], setMobileStep = ref12[1];
    // Desktop flow state management
    var ref13 = (0,react.useState)("splash"), desktopStep = ref13[0], setDesktopStep = ref13[1];
    // Session ID for logging (generated once per session, regenerates on refresh)
    var ref14 = (0,react.useState)(function() {
        return generateUUID();
    }), sessionId = ref14[0];
    // Logging utility function for Shape of You mobile flow
    var logShapeOfYouStep = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(step, apiDetails) {
            var ref, ref1, payload;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        ;
                        ;
                        payload = {
                            session_id: sessionId,
                            user_mobile: ((ref = authState.user) === null || ref === void 0 ? void 0 : ref.mobile) || null,
                            step: step,
                            api_endpoint: (apiDetails === null || apiDetails === void 0 ? void 0 : apiDetails.api_endpoint) || null,
                            request_payload: (apiDetails === null || apiDetails === void 0 ? void 0 : apiDetails.request_payload) || null,
                            response_status: (ref1 = apiDetails === null || apiDetails === void 0 ? void 0 : apiDetails.response_status) !== null && ref1 !== void 0 ? ref1 : null,
                            response_payload: (apiDetails === null || apiDetails === void 0 ? void 0 : apiDetails.response_payload) || null,
                            success_message: (apiDetails === null || apiDetails === void 0 ? void 0 : apiDetails.success_message) || null,
                            success_code: (apiDetails === null || apiDetails === void 0 ? void 0 : apiDetails.success_code) || null,
                            error_message: (apiDetails === null || apiDetails === void 0 ? void 0 : apiDetails.error_message) || null,
                            error_code: (apiDetails === null || apiDetails === void 0 ? void 0 : apiDetails.error_code) || null
                        };
                        _ctx.next = 6;
                        return http_client/* default.post */.Z.post(endpoints/* default.shape_of_you.log */.Z.shape_of_you.log(), payload);
                    case 6:
                        ;
                        _ctx.next = 12;
                        break;
                    case 9:
                        _ctx.prev = 9;
                        _ctx.t0 = _ctx["catch"](0);
                        ;
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    9
                ]
            ]);
        }));
        return function(step, apiDetails) {
            return _ref.apply(this, arguments);
        };
    }(), [
        sessionId,
        (ref = authState.user) === null || ref === void 0 ? void 0 : ref.mobile
    ]);
    // Generic navigation function for mobile steps
    var navigateToStep = function(step) {
        setMobileStep(step);
    };
    // Generic navigation function for desktop steps
    var navigateToDesktopStep = function(step) {
        setDesktopStep(step);
    };
    // Auto-navigate from splash to walkthrough after 3 seconds (mobile)
    (0,react.useEffect)(function() {
        if (mobileStep === "splash") {
            var timer = setTimeout(function() {
                setMobileStep("walkthrough");
            }, 5000);
            return function() {
                return clearTimeout(timer);
            };
        }
    }, [
        mobileStep
    ]);
    // Auto-navigate from splash to walkthrough after 3 seconds (desktop)
    (0,react.useEffect)(function() {
        if (desktopStep === "splash") {
            var timer = setTimeout(function() {
                setDesktopStep("walkthrough");
            }, 5000);
            return function() {
                return clearTimeout(timer);
            };
        }
    }, [
        desktopStep
    ]);
    // Auto-navigate to productView if user is already logged in (mobile)
    (0,react.useEffect)(function() {
        if (authState.user && (mobileStep === "login" || mobileStep === "signup" || mobileStep === "verifyOtp")) {
            setMobileStep("productView");
        }
    }, [
        mobileStep,
        authState.user
    ]);
    // Auto-navigate to productView if user is already logged in (desktop)
    (0,react.useEffect)(function() {
        if (authState.user && (desktopStep === "login" || desktopStep === "signup" || desktopStep === "verifyOtp")) {
            setDesktopStep("productView");
        }
    }, [
        desktopStep,
        authState.user
    ]);
    // Handle pending navigation from PermissionDeniedScreen (Mobile)
    (0,react.useEffect)(function() {
        var pendingNav = localStorage.getItem("pendingNavigation");
        if (pendingNav && mobileStep === "splash") {
            // Clear the flag
            localStorage.removeItem("pendingNavigation");
            // Navigate to the pending destination
            setMobileStep(pendingNav);
        }
    }, [
        mobileStep
    ]);
    // Handle pending navigation from PermissionDeniedScreen (Desktop)
    (0,react.useEffect)(function() {
        var pendingNav = localStorage.getItem("pendingNavigation");
        if (pendingNav && desktopStep === "splash") {
            // Clear the flag
            localStorage.removeItem("pendingNavigation");
            // Navigate to the pending destination
            setDesktopStep(pendingNav);
        }
    }, [
        desktopStep
    ]);
    // Log mobile step changes
    (0,react.useEffect)(function() {
        // Map mobileStep to log step names
        var stepMapping = {
            splash: "intro_slider_viewed",
            walkthrough: "intro_slider_viewed",
            about: "intro_slider_viewed",
            welcome: "intro_experience_started",
            uploadOrScan: "face_scan_captured",
            faceResult: "face_scan_proceeded",
            login: "signup_viewed",
            signup: "signup_viewed",
            productView: "product_viewed"
        };
        var logStep = stepMapping[mobileStep];
        if (logStep) {
            logShapeOfYouStep(logStep);
        }
    }, [
        mobileStep,
        logShapeOfYouStep
    ]);
    // Log desktop step changes
    (0,react.useEffect)(function() {
        // Map desktopStep to log step names
        var stepMapping = {
            splash: "intro_slider_viewed",
            walkthrough: "intro_slider_viewed",
            about: "intro_slider_viewed",
            welcome: "intro_experience_started",
            uploadOrScan: "face_scan_captured",
            faceResult: "face_scan_proceeded",
            login: "signup_viewed",
            signup: "signup_viewed",
            productView: "product_viewed"
        };
        var logStep = stepMapping[desktopStep];
        if (logStep) {
            logShapeOfYouStep(logStep);
        }
    }, [
        desktopStep,
        logShapeOfYouStep
    ]);
    // Track session abandonment
    var hasReachedProductView = (0,react.useRef)(false);
    var sessionCompleted = (0,react.useRef)(false);
    // Mark when user reaches product view (engaged with the experience) - Mobile
    (0,react.useEffect)(function() {
        if (mobileStep === "productView") {
            hasReachedProductView.current = true;
        }
    }, [
        mobileStep
    ]);
    // Mark when user reaches product view (engaged with the experience) - Desktop
    (0,react.useEffect)(function() {
        if (desktopStep === "productView") {
            hasReachedProductView.current = true;
        }
    }, [
        desktopStep
    ]);
    // Mark session as completed when user reaches shareView (Mobile)
    (0,react.useEffect)(function() {
        if (mobileStep === "shareView" && !sessionCompleted.current) {
            sessionCompleted.current = true;
            logShapeOfYouStep("session_completed", {
                success_message: "User completed the Shape of You experience",
                success_code: "SESSION_COMPLETE",
                response_payload: {
                    completion_type: "share_view_reached",
                    completed_at: new Date().toISOString()
                }
            });
        }
    }, [
        mobileStep,
        logShapeOfYouStep
    ]);
    // Mark session as completed when user reaches shareView (Desktop)
    (0,react.useEffect)(function() {
        if (desktopStep === "shareView" && !sessionCompleted.current) {
            sessionCompleted.current = true;
            logShapeOfYouStep("session_completed", {
                success_message: "User completed the Shape of You experience",
                success_code: "SESSION_COMPLETE",
                response_payload: {
                    completion_type: "share_view_reached",
                    completed_at: new Date().toISOString()
                }
            });
        }
    }, [
        desktopStep,
        logShapeOfYouStep
    ]);
    // Track if user abandons session by navigating away from product view back to early steps (Mobile)
    (0,react.useEffect)(function() {
        // If user reached product view but then goes back to splash/walkthrough/welcome (abandoning the flow)
        if (hasReachedProductView.current && !sessionCompleted.current && (mobileStep === "splash" || mobileStep === "walkthrough" || mobileStep === "welcome")) {
            logShapeOfYouStep("session_abandoned", {
                error_message: "User navigated away from product view",
                error_code: "NAVIGATION_BACK",
                request_payload: {
                    abandonment_trigger: "navigation",
                    from_step: "productView",
                    to_step: mobileStep
                },
                response_payload: {
                    abandonment_type: "navigation_back",
                    last_step: "productView",
                    navigated_to: mobileStep,
                    abandoned_at: new Date().toISOString(),
                    user_reached_product_view: true
                }
            });
            sessionCompleted.current = true; // Mark as handled
        }
    }, [
        mobileStep,
        logShapeOfYouStep
    ]);
    // Track if user abandons session by navigating away from product view back to early steps (Desktop)
    (0,react.useEffect)(function() {
        // If user reached product view but then goes back to splash/walkthrough/welcome (abandoning the flow)
        if (hasReachedProductView.current && !sessionCompleted.current && (desktopStep === "splash" || desktopStep === "walkthrough" || desktopStep === "welcome")) {
            logShapeOfYouStep("session_abandoned", {
                error_message: "User navigated away from product view",
                error_code: "NAVIGATION_BACK",
                request_payload: {
                    abandonment_trigger: "navigation",
                    from_step: "productView",
                    to_step: desktopStep
                },
                response_payload: {
                    abandonment_type: "navigation_back",
                    last_step: "productView",
                    navigated_to: desktopStep,
                    abandoned_at: new Date().toISOString(),
                    user_reached_product_view: true
                }
            });
            sessionCompleted.current = true; // Mark as handled
        }
    }, [
        desktopStep,
        logShapeOfYouStep
    ]);
    // Track session abandonment on page unload (user closes tab/browser or refreshes)
    (0,react.useEffect)(function() {
        var handleBeforeUnload = function(e) {
            // Only log abandonment if user reached product view but didn't complete session
            if (hasReachedProductView.current && !sessionCompleted.current) {
                var ref, ref1;
                // Determine which view is active (use desktopStep if user is on desktop, mobileStep otherwise)
                var currentStep = window.innerWidth >= 768 ? desktopStep : mobileStep;
                // Use sendBeacon for reliable logging on page unload
                var payload = {
                    session_id: sessionId,
                    user_mobile: ((ref = authState.user) === null || ref === void 0 ? void 0 : ref.mobile) || null,
                    step: "session_abandoned",
                    api_endpoint: null,
                    request_payload: {
                        abandonment_trigger: "page_unload",
                        from_step: currentStep,
                        user_authenticated: !!authState.user,
                        view_type: window.innerWidth >= 768 ? "desktop" : "mobile"
                    },
                    response_status: null,
                    response_payload: {
                        abandonment_type: "page_unload",
                        last_step: currentStep,
                        abandoned_at: new Date().toISOString(),
                        user_reached_product_view: true,
                        user_mobile: ((ref1 = authState.user) === null || ref1 === void 0 ? void 0 : ref1.mobile) || null
                    },
                    success_message: null,
                    success_code: null,
                    error_message: "User closed page or refreshed without completing session",
                    error_code: "PAGE_UNLOAD"
                };
                // Use sendBeacon for reliable delivery during page unload
                if (navigator.sendBeacon) {
                    var blob = new Blob([
                        JSON.stringify(payload)
                    ], {
                        type: "application/json"
                    });
                    navigator.sendBeacon(endpoints/* default.shape_of_you.log */.Z.shape_of_you.log(), blob);
                }
            }
        };
        window.addEventListener("beforeunload", handleBeforeUnload);
        return function() {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, [
        sessionId,
        authState.user,
        mobileStep,
        desktopStep
    ]);
    var ref15 = (0,react.useState)(false), show = ref15[0], setShow = ref15[1];
    var handleClose = function() {
        return setShow(false);
    };
    var handleShow = function() {
        return setShow(true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
             false && /*#__PURE__*/ 0,
            desktopStep === "splash" && /*#__PURE__*/ (0,jsx_runtime.jsx)(shape_of_you_desktop_new_SplashScreen, {
                navigateToStep: navigateToDesktopStep
            }),
            desktopStep === "walkthrough" && /*#__PURE__*/ (0,jsx_runtime.jsx)(shape_of_you_desktop_new_WalkthroughScreen, {
                navigateToStep: navigateToDesktopStep,
                logStep: logShapeOfYouStep
            }),
            desktopStep === "about" && /*#__PURE__*/ (0,jsx_runtime.jsx)(shape_of_you_desktop_new_AboutScreen, {
                navigateToStep: navigateToDesktopStep,
                isAuthenticated: !!authState.user,
                logStep: logShapeOfYouStep
            }),
            desktopStep === "tc" && /*#__PURE__*/ (0,jsx_runtime.jsx)(shape_of_you_desktop_new_TermsConditionsScreen, {
                navigateToStep: navigateToDesktopStep,
                isAuthenticated: !!authState.user,
                logStep: logShapeOfYouStep
            }),
            desktopStep === "welcome" && /*#__PURE__*/ (0,jsx_runtime.jsx)(shape_of_you_desktop_new_WelcomeScreen, {
                navigateToStep: navigateToDesktopStep
            }),
            (desktopStep === "uploadOrScan" || desktopStep === "cameraPermission" || desktopStep === "faceScanning" || desktopStep === "permissionDenied" || desktopStep === "imageNotPermitted" || desktopStep === "faceResult") && /*#__PURE__*/ (0,jsx_runtime.jsx)(shape_of_you_desktop_new_PhotoCaptureFlow, {
                initialStep: desktopStep,
                isAuthenticated: !!authState.user,
                logStep: logShapeOfYouStep,
                onComplete: function(data) {
                    ;
                    // Navigate based on authentication status
                    if (authState.user) {
                        setDesktopStep("productView");
                    } else {
                        setDesktopStep("login");
                    }
                },
                onExit: function() {
                    // User exited the flow
                    setDesktopStep("splash");
                }
            }),
            (desktopStep === "login" || desktopStep === "signup" || desktopStep === "verifyOtp") && !authState.user && /*#__PURE__*/ (0,jsx_runtime.jsx)(shape_of_you_desktop_new_AuthenticationFlow, {
                initialStep: desktopStep,
                logStep: logShapeOfYouStep,
                onComplete: function() {
                    // User completed authentication successfully
                    setDesktopStep("productView");
                },
                onExit: function() {
                    // User exited authentication flow
                    setDesktopStep("splash");
                }
            }),
            desktopStep === "filterView" && /*#__PURE__*/ (0,jsx_runtime.jsx)(shape_of_you_desktop_new_FilterViewScreen, {
                navigateToStep: navigateToDesktopStep,
                filter: mobileFilter,
                setFilter: setMobileFilter,
                activeTab: activeTab
            }),
            desktopStep === "productView" && /*#__PURE__*/ (0,jsx_runtime.jsx)(shape_of_you_desktop_new_ProductViewScreen, {
                navigateToStep: navigateToDesktopStep,
                filter: mobileFilter,
                setFilter: setMobileFilter,
                activeTab: activeTab,
                setActiveTab: setActiveTab,
                selected: selected,
                setSelected: setSelected,
                logStep: logShapeOfYouStep
            }),
            desktopStep === "shareView" && /*#__PURE__*/ (0,jsx_runtime.jsx)(shape_of_you_desktop_new_ShareViewScreen, {
                navigateToStep: navigateToDesktopStep,
                virtualTryOnImage: shapeOfYouState.virtualTryOnImage,
                capturedImage: shapeOfYouState.capturedImage
            }),
            mobileStep === "splash" && /*#__PURE__*/ (0,jsx_runtime.jsx)(shape_of_you_mobile_SplashScreen, {
                navigateToStep: navigateToStep
            }),
            mobileStep === "walkthrough" && /*#__PURE__*/ (0,jsx_runtime.jsx)(shape_of_you_mobile_WalkthroughScreen, {
                navigateToStep: navigateToStep,
                isAuthenticated: !!authState.user
            }),
            mobileStep === "about" && /*#__PURE__*/ (0,jsx_runtime.jsx)(shape_of_you_mobile_AboutScreen, {
                navigateToStep: navigateToStep,
                isAuthenticated: !!authState.user
            }),
            mobileStep === "tc" && /*#__PURE__*/ (0,jsx_runtime.jsx)(shape_of_you_mobile_TermsConditionsScreen, {
                navigateToStep: navigateToStep,
                isAuthenticated: !!authState.user,
                logStep: logShapeOfYouStep
            }),
            mobileStep === "welcome" && /*#__PURE__*/ (0,jsx_runtime.jsx)(shape_of_you_mobile_WelcomeScreen, {
                navigateToStep: navigateToStep
            }),
            (mobileStep === "uploadOrScan" || mobileStep === "galleryPermission" || mobileStep === "cameraPermission" || mobileStep === "faceScanning" || mobileStep === "permissionDenied" || mobileStep === "faceResult") && /*#__PURE__*/ (0,jsx_runtime.jsx)(shape_of_you_mobile_PhotoCaptureFlow, {
                initialStep: mobileStep,
                isAuthenticated: !!authState.user,
                logStep: logShapeOfYouStep,
                onComplete: function(data) {
                    ;
                    // Navigate based on authentication status
                    if (authState.user) {
                        setMobileStep("productView");
                    } else {
                        setMobileStep("login");
                    }
                },
                onExit: function() {
                    // User exited the flow
                    setMobileStep("splash");
                }
            }),
            (mobileStep === "login" || mobileStep === "signup" || mobileStep === "verifyOtp") && !authState.user && /*#__PURE__*/ (0,jsx_runtime.jsx)(shape_of_you_mobile_AuthenticationFlow, {
                initialStep: mobileStep,
                logStep: logShapeOfYouStep,
                onComplete: function() {
                    // User completed authentication successfully
                    setMobileStep("productView");
                },
                onExit: function() {
                    // User exited authentication flow
                    setMobileStep("splash");
                }
            }),
            mobileStep === "filterView" && /*#__PURE__*/ (0,jsx_runtime.jsx)(shape_of_you_mobile_FilterViewScreen, {
                navigateToStep: navigateToStep,
                filter: mobileFilter,
                setFilter: setMobileFilter,
                activeTab: activeTab
            }),
            mobileStep === "productView" && /*#__PURE__*/ (0,jsx_runtime.jsx)(shape_of_you_mobile_ProductViewScreen, {
                navigateToStep: navigateToStep,
                filter: mobileFilter,
                setFilter: setMobileFilter,
                activeTab: activeTab,
                setActiveTab: setActiveTab,
                selected: selected,
                setSelected: setSelected,
                logStep: logShapeOfYouStep
            }),
            mobileStep === "shareView" && function() {
                ;
                ;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(shape_of_you_mobile_ShareViewScreen, {
                    navigateToStep: navigateToStep,
                    virtualTryOnImage: shapeOfYouState.virtualTryOnImage,
                    capturedImage: shapeOfYouState.capturedImage
                });
            }()
        ]
    });
};
/* harmony default export */ var shape_of_you = (ShapOfYou);


/***/ }),

/***/ 13135:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ BRAND_NAME; }
/* harmony export */ });
var BRAND_NAME = "Senco";


/***/ }),

/***/ 1233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ phoneRegExp; }
/* harmony export */ });
var phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;


/***/ }),

/***/ 53084:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"custom_backdrop":"shap_of_you_custom_backdrop__CzN6u","modal-content":"shap_of_you_modal-content__QV_w7","hero_center":"shap_of_you_hero_center__4ez_P","fullscreen_modal":"shap_of_you_fullscreen_modal__d3mvm","modalBodyFullscreen":"shap_of_you_modalBodyFullscreen__uoz3q","introContainer":"shap_of_you_introContainer__YDwc_","main_slider_section":"shap_of_you_main_slider_section__UW9s5","experienceSection":"shap_of_you_experienceSection__w1PV1","brandLogo":"shap_of_you_brandLogo__TJaV2","experienceCard":"shap_of_you_experienceCard__IMB_g","ctaButton":"shap_of_you_ctaButton__suQw_","product_slider_container":"shap_of_you_product_slider_container__s7ctu","main_slider":"shap_of_you_main_slider__Wi2Py","swiper-slide":"shap_of_you_swiper-slide__yQOJp","slide_image_container":"shap_of_you_slide_image_container__a_ZvB","thumbnail_slider":"shap_of_you_thumbnail_slider__wS0Zh","swiper-slide-thumb-active":"shap_of_you_swiper-slide-thumb-active__A6Ntd","thumbnail_container":"shap_of_you_thumbnail_container__uZQ_m","slider_loading":"shap_of_you_slider_loading__TOCBz","slider_error_notice":"shap_of_you_slider_error_notice__H5PX3","swiperitem":"shap_of_you_swiperitem__sKi_g","swaperitemcontant":"shap_of_you_swaperitemcontant__U4x4p","banner":"shap_of_you_banner__QPSCg","banner1":"shap_of_you_banner1__QxSdZ","hero__contant":"shap_of_you_hero__contant__N1yyC","slide":"shap_of_you_slide__hmalq","title":"shap_of_you_title__MwgnO","desc":"shap_of_you_desc__AO4rW","divider":"shap_of_you_divider__MvEmU","knowMore":"shap_of_you_knowMore__QiHKq","getStarted":"shap_of_you_getStarted__2EFLy","hero":"shap_of_you_hero__9q9rB","heroimg":"shap_of_you_heroimg__iGpo5","content":"shap_of_you_content__itLGC","content_new":"shap_of_you_content_new__kexJR","logo":"shap_of_you_logo__7X2QD","exitapp":"shap_of_you_exitapp__Wjhvn","cta":"shap_of_you_cta__y9mEP","custom_modal":"shap_of_you_custom_modal__5IlvS","overlay":"shap_of_you_overlay__sAUxJ","modal":"shap_of_you_modal__5lDYS","close":"shap_of_you_close__ZxM2Y","checkbox":"shap_of_you_checkbox__b6V9X","actions":"shap_of_you_actions__DggH4","primary":"shap_of_you_primary__GEXKC","secondary":"shap_of_you_secondary__3EnG1","modal_intro_steps":"shap_of_you_modal_intro_steps__4lbic","illustration":"shap_of_you_illustration__qFdLq","link":"shap_of_you_link__WfJfn","wrapper":"shap_of_you_wrapper__gATK5","modal_intro_steps1":"shap_of_you_modal_intro_steps1__qgt4K","custom_modal_need_camera":"shap_of_you_custom_modal_need_camera__4VYB9","custom_modal_face_camera":"shap_of_you_custom_modal_face_camera__ls6QY","FaceScannerContainer":"shap_of_you_FaceScannerContainer__SXSeT","FaceScannerContainer_img":"shap_of_you_FaceScannerContainer_img__DuxQe","btn_Container":"shap_of_you_btn_Container__CqeFg","btn_upload":"shap_of_you_btn_upload__K6T0_","facescan":"shap_of_you_facescan__Q0Oge","modal_new":"shap_of_you_modal_new__pyrjC","custom_modal_product":"shap_of_you_custom_modal_product__5mYYE","product_image_full_model":"shap_of_you_product_image_full_model__qeGnv","addtocart":"shap_of_you_addtocart__Lwqn7","nub":"shap_of_you_nub__hNif3","img":"shap_of_you_img__ll8Jf","product_image_full_model_only":"shap_of_you_product_image_full_model_only__7SEIY","img_img":"shap_of_you_img_img__fQ1ne","card":"shap_of_you_card__TyyMr","filter_full":"shap_of_you_filter_full__SX_tC","tabs":"shap_of_you_tabs___wx9D","active":"shap_of_you_active__Mw5oo","filter":"shap_of_you_filter__9VzVO","grid":"shap_of_you_grid__BOXDj","item":"shap_of_you_item__nrAsR","selected":"shap_of_you_selected__D0StF","details":"shap_of_you_details__zRtn5","label":"shap_of_you_label__NGMFO","name":"shap_of_you_name__Cs_Wr","footer":"shap_of_you_footer__Wy_kq","price":"shap_of_you_price__0waXC","buy":"shap_of_you_buy__5H7bb","cart":"shap_of_you_cart__h09zB","sheet":"shap_of_you_sheet__OvlLl","header":"shap_of_you_header__9bB_P","option":"shap_of_you_option__ENIow","radio":"shap_of_you_radio__TGl2p","clear":"shap_of_you_clear__3a2zM","apply":"shap_of_you_apply__yPxK4","close_nfilter":"shap_of_you_close_nfilter__ieq7t","custom_modal_signup":"shap_of_you_custom_modal_signup__QBT84","full_page":"shap_of_you_full_page__OuGvQ","full_page1":"shap_of_you_full_page1__EVOEj","subtitle":"shap_of_you_subtitle__r__nK","field":"shap_of_you_field__BhkCt","submit":"shap_of_you_submit__D2ZnR","otpBox":"shap_of_you_otpBox__j2a6n","editRow":"shap_of_you_editRow__0Rld9","icon":"shap_of_you_icon__l6jK0","cap_secondary":"shap_of_you_cap_secondary__LkXrR","select_container_main_topright":"shap_of_you_select_container_main_topright__sEB4B","face_select_main":"shap_of_you_face_select_main__eyXy4","heroimgmobile":"shap_of_you_heroimgmobile__QO_9A","hero_img_mobile":"shap_of_you_hero_img_mobile__frHmI","hero_img_desktop":"shap_of_you_hero_img_desktop__ofwBk","videoContainer":"shap_of_you_videoContainer__4CwOF","videoThumbnail":"shap_of_you_videoThumbnail__DwMF_","playIcon":"shap_of_you_playIcon__wk64W","textContent":"shap_of_you_textContent__uJt1r","face_scan_mobile":"shap_of_you_face_scan_mobile__uO1cJ","face_scan_desktop":"shap_of_you_face_scan_desktop__hLHRh","hamburger":"shap_of_you_hamburger__jyW0M","menu":"shap_of_you_menu__ky4ug","close_bt":"shap_of_you_close_bt__BKBBy","content1":"shap_of_you_content1__ekbP8","h4":"shap_of_you_h4__wrwLC","h2":"shap_of_you_h2__rxaPY","btn":"shap_of_you_btn__rJddR","shape_cart":"shap_of_you_shape_cart__9meOw","top_card_card":"shap_of_you_top_card_card__98OxY","desktop_view":"shap_of_you_desktop_view___dhUp","mobile_view_shap":"shap_of_you_mobile_view_shap__kArzT","shapeOfYou":"shap_of_you_shapeOfYou__3qzjr","cut":"shap_of_you_cut__pOkm1","lowerLine":"shap_of_you_lowerLine__MLPqQ","of":"shap_of_you_of__vw0c7","byLine":"shap_of_you_byLine__NdIgn","wrapper_slider":"shap_of_you_wrapper_slider__Oy_a1","bgImage":"shap_of_you_bgImage__j_pai","overlay_n":"shap_of_you_overlay_n__b7_vT","dots":"shap_of_you_dots__TWgU1","dot":"shap_of_you_dot__phM3B","primaryBtn":"shap_of_you_primaryBtn__ebbFX","secondaryBtn":"shap_of_you_secondaryBtn__nFtJR","wrapper_about":"shap_of_you_wrapper_about__yCwWG","wrapper_sec":"shap_of_you_wrapper_sec__xdzYF","cta_btn_container":"shap_of_you_cta_btn_container__Po5r_","videoCard":"shap_of_you_videoCard__jT4qg","playBtn":"shap_of_you_playBtn__N2lWF","ctaBtn":"shap_of_you_ctaBtn__q0P0S","wrapper_tc":"shap_of_you_wrapper_tc__PhJmN","heading":"shap_of_you_heading__e6e32","list_two_liv":"shap_of_you_list_two_liv__sTsT5","ctaBtn1":"shap_of_you_ctaBtn1__eKiTn","mobile_view_shap_welcome":"shap_of_you_mobile_view_shap_welcome__grYYU","mobile_view_shap_welcome_one":"shap_of_you_mobile_view_shap_welcome_one__5Uyeg","or":"shap_of_you_or__lV_Vx","wrapper_Permission":"shap_of_you_wrapper_Permission__N57PD","image":"shap_of_you_image__IFdiR","restartBtn":"shap_of_you_restartBtn__HSK9D","closeBtn":"shap_of_you_closeBtn__M9tqj","wrapper_reupload":"shap_of_you_wrapper_reupload__aTqHw","bg":"shap_of_you_bg__wZkp3","badge":"shap_of_you_badge__DNDAd","faceInfoCard":"shap_of_you_faceInfoCard__sCrhK","toggleButton":"shap_of_you_toggleButton__j_y8z","svg_mark":"shap_of_you_svg_mark__11SS3","faceInfoContentContainer":"shap_of_you_faceInfoContentContainer__FeCkj","collapsed":"shap_of_you_collapsed__g6ijO","expanded":"shap_of_you_expanded__c0uMm","faceInfoContent":"shap_of_you_faceInfoContent__3kqxI","faceInfoLeft":"shap_of_you_faceInfoLeft__9YHaI","faceInfoDivider":"shap_of_you_faceInfoDivider__AROef","faceInfoRight":"shap_of_you_faceInfoRight__ATe0T","faceTypeValue":"shap_of_you_faceTypeValue__Ww5gi","skinToneValue":"shap_of_you_skinToneValue__WwYXq","faceTypeLabel":"shap_of_you_faceTypeLabel__SuokM","skinToneLabel":"shap_of_you_skinToneLabel__ucWbV","faceTypeDescription":"shap_of_you_faceTypeDescription__KjMYU","reupload":"shap_of_you_reupload__YRhoD","explore":"shap_of_you_explore__fvcjm","wrapper_reupload_desktop":"shap_of_you_wrapper_reupload_desktop__G64Sm","wrapper_face":"shap_of_you_wrapper_face___p2qO","loading":"shap_of_you_loading__Xp_YG","scanBtn":"shap_of_you_scanBtn__DLRf_","scanning":"shap_of_you_scanning__naQ19","scanMove":"shap_of_you_scanMove__U_aBX","loginWrapper":"shap_of_you_loginWrapper__k2Xn4","inputBox":"shap_of_you_inputBox__xWEbN","wrappersignup":"shap_of_you_wrappersignup__hrCan","form":"shap_of_you_form__Qc7K1","disabled":"shap_of_you_disabled__2FOk3","filterWrapper":"shap_of_you_filterWrapper__rz348","backArrow":"shap_of_you_backArrow__TfTDM","tab":"shap_of_you_tab__J1W8L","options":"shap_of_you_options__xehfs","optionItem":"shap_of_you_optionItem__Ffq5q","checked":"shap_of_you_checked__gW_gq","clearBtn":"shap_of_you_clearBtn__vQRFQ","applyBtn":"shap_of_you_applyBtn__veOHF","card_share":"shap_of_you_card_share__DbFT7","image_sh":"shap_of_you_image_sh__BnptV","backshare":"shap_of_you_backshare__Rqw01","topLeft":"shap_of_you_topLeft__RL84x","bottom_sharre":"shap_of_you_bottom_sharre__SfGLX","dwn":"shap_of_you_dwn__FU_ux","retake":"shap_of_you_retake__MNmrW","shape":"shap_of_you_shape__HSg_W","you":"shap_of_you_you__b1aGN","by":"shap_of_you_by__faz8r","brand":"shap_of_you_brand__QP8Cd","shareWrapper":"shap_of_you_shareWrapper__RFGqC","shareBtn":"shap_of_you_shareBtn__s0SWL","container":"shap_of_you_container__EyjlM","image_main":"shap_of_you_image_main__uJMqk","image_gradient":"shap_of_you_image_gradient__cWaOR","topSwitch":"shap_of_you_topSwitch___i5PP","back_page":"shap_of_you_back_page__S4FL_","switch":"shap_of_you_switch__YshzJ","live":"shap_of_you_live__UjaWR","cartIcon":"shap_of_you_cartIcon__aSi12","imageWrapper":"shap_of_you_imageWrapper__rC4BY","mainImage":"shap_of_you_mainImage__HXRy4","priceRow":"shap_of_you_priceRow__yBF1J","tran_btn":"shap_of_you_tran_btn__hnfQw","price_col_s":"shap_of_you_price_col_s__1xhzo","thumbnailRow":"shap_of_you_thumbnailRow__ny6U4","thumb":"shap_of_you_thumb__HoSAt","activeThumb":"shap_of_you_activeThumb__UxJsT","categoryTabs":"shap_of_you_categoryTabs__uUFte","activeCategory":"shap_of_you_activeCategory___VrAa","bottomBar":"shap_of_you_bottomBar__CcIji","cartBtn":"shap_of_you_cartBtn__bmff_","share":"shap_of_you_share__yTW3d","sliderWrapper":"shap_of_you_sliderWrapper__jQdqn","mySwiper":"shap_of_you_mySwiper__qFHyF","slideItem":"shap_of_you_slideItem__Rkdh8","sliderWrapper_one":"shap_of_you_sliderWrapper_one___11SF","swiper-slide-active":"shap_of_you_swiper-slide-active__aXKm2","sliderWrapper_two":"shap_of_you_sliderWrapper_two__tyIaT","wrappersignup_otp":"shap_of_you_wrappersignup_otp__LpAR8","btn_nn":"shap_of_you_btn_nn__MCWcI","max_h":"shap_of_you_max_h__ARVfj","show":"shap_of_you_show__VnBDj","modal_pro":"shap_of_you_modal_pro__m84Tu","open":"shap_of_you_open__uG1Ro","dragBar":"shap_of_you_dragBar__YV0WI","contentn":"shap_of_you_contentn__UjlhW","imageWrapper_n":"shap_of_you_imageWrapper_n__tzUeY","description":"shap_of_you_description__ceoYe","certificate":"shap_of_you_certificate__VwnUC","price_brackup":"shap_of_you_price_brackup__Zn9pd","details_product":"shap_of_you_details_product__AS2YM","tooltip_icon_tooltip":"shap_of_you_tooltip_icon_tooltip__YgIIH","tooltip_icon_tooltip_icon":"shap_of_you_tooltip_icon_tooltip_icon__tVala","tooltip_container_main":"shap_of_you_tooltip_container_main__bPVhI","desktop_view_shap":"shap_of_you_desktop_view_shap__gCfVC","wrapper_slider_desktop":"shap_of_you_wrapper_slider_desktop__v4pr8","btn_conta":"shap_of_you_btn_conta__0mAiH","buttonGroup":"shap_of_you_buttonGroup__pv6xc","experienceSectionDesktop":"shap_of_you_experienceSectionDesktop__m62cY","experienceContent":"shap_of_you_experienceContent__1Mqd3","wrapper_tc_desktop":"shap_of_you_wrapper_tc_desktop___QetP","btn_act":"shap_of_you_btn_act__psbhh","desktop_view_shap_welcome":"shap_of_you_desktop_view_shap_welcome__TC3FB","button_cont":"shap_of_you_button_cont__6o5FV","wrapper_denied_camera_access":"shap_of_you_wrapper_denied_camera_access__hDWrk","ctaBtnp":"shap_of_you_ctaBtnp__4G0MV","wrapper_image_not_permitted":"shap_of_you_wrapper_image_not_permitted__GICzc","image_error_screen":"shap_of_you_image_error_screen__UBu8B","placeholder_text":"shap_of_you_placeholder_text__OG0VM","error_content":"shap_of_you_error_content__1YV6s","error_box":"shap_of_you_error_box__Krp_h","warning_icon":"shap_of_you_warning_icon__00xQg","error_title":"shap_of_you_error_title__ngsE2","error_message":"shap_of_you_error_message__jmvpP","reupload_btn":"shap_of_you_reupload_btn__g531L","reupload_view_shap_welcome":"shap_of_you_reupload_view_shap_welcome__PWNOc","content_bg":"shap_of_you_content_bg__VHTsj","contant_text":"shap_of_you_contant_text__lWd6M","scan_face_desktop":"shap_of_you_scan_face_desktop__62_wu","Login_face_desktop":"shap_of_you_Login_face_desktop__yy_i8","Login_container_form":"shap_of_you_Login_container_form__Z0xgG","title_m":"shap_of_you_title_m__0XQ4o","code":"shap_of_you_code__wKlrW","input":"shap_of_you_input__fOf_r","button":"shap_of_you_button__l_TWE","signup_face_desktop":"shap_of_you_signup_face_desktop__Jhssa","otp_face_desktop":"shap_of_you_otp_face_desktop__JTosG","otpContainer":"shap_of_you_otpContainer__cldnF","otpInput":"shap_of_you_otpInput__MGlHx","timer":"shap_of_you_timer__JrXqZ","resendRow":"shap_of_you_resendRow__dcHwj","resendBtn":"shap_of_you_resendBtn__28cLG","submitBtn":"shap_of_you_submitBtn__I09gV","editNumber":"shap_of_you_editNumber__evIyz","SharePage_desktop":"shap_of_you_SharePage_desktop__VeTXu","image_center":"shap_of_you_image_center__XQpjZ","bottom_container":"shap_of_you_bottom_container__Ao60d","container_btn":"shap_of_you_container_btn__6LrDG","logo_left":"shap_of_you_logo_left__ZXoCp","text_right":"shap_of_you_text_right__74fIh","submitBtn1":"shap_of_you_submitBtn1__lwi59","back_arrow":"shap_of_you_back_arrow__OZYNH","container_desktop":"shap_of_you_container_desktop__ifrD7","filter_top_cta":"shap_of_you_filter_top_cta__Wn2Hi","details_open":"shap_of_you_details_open__nuCKd","thumbnailRow_container":"shap_of_you_thumbnailRow_container__8Ye62","overlay_desktop":"shap_of_you_overlay_desktop__Fm1ny","modal_pro_desktop_product":"shap_of_you_modal_pro_desktop_product__RbmHn","product_details_container":"shap_of_you_product_details_container__KU9W8","product_details_image":"shap_of_you_product_details_image__2Nep7","product_certificate_desktop":"shap_of_you_product_certificate_desktop__QaGeH","product_certificate_mobile":"shap_of_you_product_certificate_mobile__Y0ce_","certificate_badges":"shap_of_you_certificate_badges__PZ2Js","product_content":"shap_of_you_product_content__bz0xj","discount":"shap_of_you_discount__DlAif","mrp_text":"shap_of_you_mrp_text__yDU2A","product_filters":"shap_of_you_product_filters__gRkhH","filter_section":"shap_of_you_filter_section__5iJiO","filter_options":"shap_of_you_filter_options__A4QPh","filter_badge":"shap_of_you_filter_badge__x1X5k","mark_h":"shap_of_you_mark_h__jLMsZ","biscareapp":"shap_of_you_biscareapp__jC03W","certificate_info":"shap_of_you_certificate_info__Q0o7B","certificate_text":"shap_of_you_certificate_text__8X6h4","delivery_section":"shap_of_you_delivery_section__BPtoZ","delivery_item":"shap_of_you_delivery_item__4_9Rb","product_tabs":"shap_of_you_product_tabs__hjV6M","tab_content":"shap_of_you_tab_content__K0NcQ","product_badges":"shap_of_you_product_badges__j_IOX","badge_green":"shap_of_you_badge_green__5YiJv","badge_yellow":"shap_of_you_badge_yellow__xYHfB","badge_purple":"shap_of_you_badge_purple__z7Rzn","badge_blue":"shap_of_you_badge_blue__8jjTc","disclaimer":"shap_of_you_disclaimer__SuGJf","modal_pro_desktop_filter":"shap_of_you_modal_pro_desktop_filter__HSLf5","button_cont_scan":"shap_of_you_button_cont_scan__YCHOk","svg_ab":"shap_of_you_svg_ab___jLuU","wrapper_card_desktop":"shap_of_you_wrapper_card_desktop__ydj2T","empty":"shap_of_you_empty__u0ftV","row":"shap_of_you_row__hhy0F","imageBox":"shap_of_you_imageBox__lppoa","imagePlaceholder":"shap_of_you_imagePlaceholder__rSoZz","meta":"shap_of_you_meta__W3Uwr","heart":"shap_of_you_heart__Ac8Rq","addBtn":"shap_of_you_addBtn__kR4F9","removeBtn":"shap_of_you_removeBtn__XfVRs","modal_pro_desktop_cart":"shap_of_you_modal_pro_desktop_cart__5IBPw","footer1":"shap_of_you_footer1__h13iU","continueBtn":"shap_of_you_continueBtn__S3fnE","checkoutBtn":"shap_of_you_checkoutBtn__D4Iaj","modal_pro_mobile_cart":"shap_of_you_modal_pro_mobile_cart__8K5gV","mobile_actions_row":"shap_of_you_mobile_actions_row__ILjke","mobile_icon_btn":"shap_of_you_mobile_icon_btn__4jo9Y","mobile_remove_btn":"shap_of_you_mobile_remove_btn__Avsc4","mobile_add_btn":"shap_of_you_mobile_add_btn__DZi_X"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,5675,9915,2640,536,3885,3382,9774,2888,179], function() { return __webpack_exec__(71913); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);